webpackJsonp([1],Array(19).concat([
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var APIBASE =  false ? 'http://localhost:8000' : window.location.origin;
console.log('window.location', window.location);

/* harmony default export */ __webpack_exports__["a"] = ({
   INITIAL_PASSWORD: "usuallyencrypted",

   MEAL_TYPE_LIST: [0, 1, 2, 3, 4, 5, 6],
   MEAL_TYPES: {
      0: { name: "Petit-déjeuner", index: 0, default: true },
      1: { name: "Collation du matin", index: 1, default: false },
      2: { name: "Déjeuner", index: 2, default: true },
      3: { name: "Collation de l'après-midi", index: 3, default: false },
      4: { name: "Dîner", index: 4, default: true },
      5: { name: "Collation du soir", index: 5, default: false },
      6: { name: "Nuit", index: 6, default: false }
   },
   MEAL_SURVEY_LIST: [0, 1, 2],
   MEAL_SURVEYS: {
      0: { name: "Relevé de début de suivi", index: 0 },
      1: { name: "Relevé de suivi intermédiaire", index: 1 },
      2: { name: "Relevé de fin de suivi", index: 2 }
   },

   APIBASE: APIBASE,

   PUBLIC_KEY_URL: APIBASE + '/api/get-public-key',
   TOKEN_URL: APIBASE + '/api/api-token-auth',
   ACTIVATE_ACCOUNT_MAIL_URL: APIBASE + '/api/activate-account-mail',
   RESET_PASSWORD_MAIL_URL: APIBASE + '/api/reset-password-mail',
   CREATE_USER_URL: APIBASE + '/api/create-user',
   ACTIVATE_USER_URL: APIBASE + '/api/activate-user',
   INVITE_CAREGIVER_URL: APIBASE + '/api/invite-caregiver',
   ACCEPT_INVITATION_URL: APIBASE + '/api/accept-invitation',

   FITBIT_CLIENT_ID_URL: APIBASE + '/api/fitbit-clientid',
   FITBIT_IS_AUTHORIZED_URL: APIBASE + '/api/fitbit-is-authorized',
   FITBIT_ACCESS_TOKEN_URL: APIBASE + '/api/fitbit-access-token',
   FITBIT_USER_TIME_SERIES_URL: APIBASE + '/api/fitbit-user-time-series',

   HTTP_REFERER_URL: APIBASE + '/api/get-http-referer',
   REALMS_URL: APIBASE + '/api/realms/',
   ROLES_URL: APIBASE + '/api/roles/',
   USERS_URL: APIBASE + '/api/users/',
   TEAMS_URL: APIBASE + '/api/teams/',
   COACHED_USERS_URL: APIBASE + '/api/patients/',

   FOODS_URL: APIBASE + '/api/foods/',
   MEALS_URL: APIBASE + '/api/meals/',
   MEAL_ELEMENTS_URL: APIBASE + '/api/meal-elements/',
   FAVORITES_URL: APIBASE + '/api/favorites/',
   FOOD_PORTIONS_URL: APIBASE + '/api/foodportions/',
   FRACTIONNINGS_URL: APIBASE + '/api/fractionnings/',
   NUTRIENTS_URL: APIBASE + '/api/nutrients/',
   NUTDATA_URL: APIBASE + '/api/nutdata/',

   USER_ATTRIBUTES_URL: APIBASE + '/api/user-attributes/',
   USER_ATTRIBUTE_DATED_VALUES_URL: APIBASE + '/api/user-attribute-dated-values/',

   MESSAGES_URL: APIBASE + '/api/messages/',
   HISTORY_EVENT_URL: APIBASE + '/api/history-events/',

   SHDL_MODULES_URL: APIBASE + '/api/shdl-modules/',
   CRAPS_MODULES_URL: APIBASE + '/api/craps-modules/',

   SURVEYS_URL: APIBASE + '/api/surveys/',
   USER_SURVEYS_URL: APIBASE + '/api/user-surveys/',

   QCU_QUESTIONS_URL: APIBASE + '/api/qcuquestions/',
   QCU_IMAGES_URL: APIBASE + '/api/qcuimages/',
   QCU_ITEMS_URL: APIBASE + '/api/qcuitems/'
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


var _ = __webpack_require__(13);

module.exports = function () {

   function opposite(bin, n) {
      var result = '';
      var found1 = false;
      for (var i = n - 1; i >= 0; i--) {
         var c = parseInt(bin.charAt(i));
         result = (found1 ? 1 - c : c) + result;
         if (c === 1) found1 = true;
      }
      return result;
   }

   function opposite13(bin13) {
      var result = '';
      var found1 = false;
      for (var i = 12; i >= 0; i--) {
         var c = parseInt(bin32.charAt(i));
         result = (found1 ? 1 - c : c) + result;
         if (c === 1) found1 = true;
      }
      return result;
   }

   function add32(bin32a, bin32b) {
      var result = '';
      var carry = false;
      var a = void 0,
          b = void 0,
          sum = void 0;
      for (var i = 31; i >= 0; i--) {
         a = bin32a.charAt(i);
         b = bin32b.charAt(i);
         sum = a === b ? 0 : 1;
         sum = carry ? 1 - sum : sum;
         result = sum + result;
         carry = a === '1' && b === '1' || (a === '1' && carry || b === '1') && carry;
      }
      var V = a === '1' && b === '1' && sum === 0 || a === '0' && b === '0' && sum === 1;
      return { result: result, V: V, C: carry };
   }

   function sub32(bin32a, bin32b) {
      var _add = add32(bin32a, opposite(bin32b, 32)),
          res = _add.result,
          V = _add.V,
          C = _add.C;

      return { result: res, V: V, C: !C };
   }

   function and32(bin32a, bin32b) {
      var result = '';
      for (var i = 0; i < 32; i++) {
         var on = bin32a.charAt(i) === '1' && bin32b.charAt(i) === '1';
         result += on ? '1' : '0';
      }
      console.log('and32 bin32a', bin32a, 'bin32b', bin32b, 'result', result);
      return result;
   }

   function or32(bin32a, bin32b) {
      var result = '';
      for (var i = 0; i < 32; i++) {
         var on = bin32a.charAt(i) === '1' || bin32b.charAt(i) === '1';
         result += on ? '1' : '0';
      }
      return result;
   }

   function xor32(bin32a, bin32b) {
      var result = '';
      for (var i = 0; i < 32; i++) {
         var on = bin32a.charAt(i) !== bin32b.charAt(i);
         result += on ? '1' : '0';
      }
      return result;
   }

   function slr32(bin32a, bin5b) {
      var n = parseInt(bin5b, 2);
      return _.padStart(bin32a.substring(0, 32 - n), 32, '0');
   }

   function sll32(bin32a, bin5b) {
      var n = parseInt(bin5b, 2);
      return _.padEnd(bin32a.substring(n), 32, '0');
   }

   function bin32ToUnsigned(bin32) {
      return parseInt(bin32, 2);
   }

   function bin16ToUnsigned(bin16) {
      return parseInt(bin16, 2);
   }

   function bin32ToSigned(bin32) {
      if (bin32.charAt(0) === '1') {
         // negative
         return -bin32ToUnsigned(opposite(bin32, 32));
      } else {
         // positive or zero
         return parseInt(bin32, 2);
      }
   }

   function unsignedToBin32(unsignedInt) {
      return _.padStart(Number(unsignedInt).toString(2), 32, '0');
   }

   function signedToBin32(signedInt) {
      if (signedInt >= 0) {
         return unsignedToBin32(signedInt);
      } else {
         var abs32 = _.padStart(Number(-signedInt).toString(2), 32, '0');
         return opposite(abs32, 32);
      }
   }

   function signedToBin13(signedInt) {
      if (signedInt >= 0) {
         return _.padStart(Number(signedInt).toString(2), 13, '0');
      } else {
         var abs13 = _.padStart(Number(-signedInt).toString(2), 13, '0');
         return opposite(abs13, 13);
      }
   }

   function unsignedToHex8(unsignedInt) {
      return _.padStart(Number(unsignedInt).toString(16), 8, '0');
   }

   function bin4ToHex(bin4str) {
      var i = parseInt(bin4str, 2);
      return i.toString(16);
   }

   function bin32ToHex8(bin32str) {
      var result = '';
      for (var i = 0; i < 8; i++) {
         var bin4str = bin32str.substring(i * 4, i * 4 + 4);
         result += bin4ToHex(bin4str);
      }
      return result;
   }

   // "101", 8 => "00000101", "0x8490 a005", 32 => "10000100100100001010000000000101"
   function strToBin(str, length) {
      str = str.replace(' ', '').toLowerCase();
      var bin32 = str.startsWith('0x') ? parseInt(str, 16).toString(2).padStart(length, '0') : str;
      return bin32;
   }

   return {
      add32: add32,
      sub32: sub32,
      and32: and32,
      or32: or32,
      xor32: xor32,
      slr32: slr32,
      sll32: sll32,
      bin32ToSigned: bin32ToSigned,
      bin16ToUnsigned: bin16ToUnsigned,
      bin32ToUnsigned: bin32ToUnsigned,
      signedToBin32: signedToBin32,
      signedToBin13: signedToBin13,
      unsignedToBin32: unsignedToBin32,
      unsignedToHex8: unsignedToHex8,
      bin32ToHex8: bin32ToHex8,
      bin4ToHex: bin4ToHex,
      strToBin: strToBin
   };
}();

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

   return {
      add: add,
      multiplyByScalar: multiplyByScalar,
      multiply: multiply,
      divide: divide,
      middleValue: middleValue,
      format: format,
      parse: parse,
      possibility: possibility,
      necessity: necessity
   };

   function add(f1, f2) {
      return {
         d1: f1.d1 + f2.d1,
         d2: f1.d2 + f2.d2,
         dt1: f1.dt1 + f2.dt1,
         dt2: f1.dt2 + f2.dt2,
         h: Math.max(f1.h, f2.h)
      };
   }

   function multiplyByScalar(f, c) {
      return {
         d1: f.d1 * c,
         d2: f.d2 * c,
         dt1: f.dt1 * c,
         dt2: f.dt2 * c,
         h: f.h
      };
   }

   function divide(f1, f2) {
      return {
         d1: f1.d1 / f2.d1,
         d2: f1[1] / f2.d2,
         dt1: (f1.d1 * f2.dt2 + f1.dt1 * f2.d2) / (f2.d2 * (f2.dt2 + f2.d2)),
         dt2: (f2.d1 * f1.dt2 + f1[1] * f2.dt1) / (f2.d1 * (f2.d1 - f2.dt1)),
         h: Math.max(f1.h, f2.h)
      };
   }

   function multiply(f1, f2) {
      return {
         d1: f1.d1 * f2.d1,
         d2: f1.d2 * f2.d2,
         dt1: f2.dt1 * (f1.d1 - f1.dt1) + f1.dt1 * f2.d1,
         dt2: f1.dt2 * f2.dt2 + (f1.d2 + f1.dt2) * f2.dt2,
         h: Math.max(f1.h, f2.h)
      };
   }

   function middleValue(f) {
      return (f.d1 + f.d2) / 2.0;
   }

   function format(f) {
      var mid = middleValue(f);
      var s1 = f.d1 - f.dt1;
      var s2 = f.d2 + f.dt2;
      s1 = Math.max(s1, 0.0);
      s2 = Math.max(s2, 0.0);

      var mval = Math.min(Math.abs(f.d1), Math.abs(f.d2));
      var df = void 0;
      if (mval >= 10) {
         df = function df(x) {
            return Math.round(x) + '';
         };
      } else {
         df = function df(x) {
            return x.toFixed(1);
         };
      }

      if (s2 >= Infinity && s1 <= -Infinity) {
         return "?";
      }
      if (s2 >= Infinity) {
         if (s1 < Infinity) {
            return ">" + df(s1);
         } else {
            return "+infini";
         }
      }
      if (s1 <= -Infinity) {
         if (s2 > -Infinity) {
            return "<" + df(s2);
         } else {
            return "-infini";
         }
      }
      if (f.d2 - f.d1 <= 0.041 * mid && s2 - s1 <= 0.11 * mid) {
         return df(mid);
      }
      if (f.d2 - f.d1 <= 0.11 * mid && s2 - s1 <= 0.21 * mid) {
         return "~" + df(mid);
      }
      if (f.d2 - f.d1 <= 0.21 * mid && s2 - s1 <= 0.41 * mid) {
         return "~~" + df(mid);
      }
      return "~" + df(f.d1) + "-" + df(f.d2);
   }

   // parse string into fuzzy number
   // return null when not parsable
   // ex: "~120" -> [114.0, 126.0, 6.0, 6.0, 0]

   function parse(text) {
      text = text.trim();
      var d1 = void 0;
      var d2 = void 0;
      var s1 = void 0;
      var s2 = void 0;
      var q = void 0;
      try {
         if (text === '?') {
            return { d1: 0, d2: Infinity, dt1: Infinity, dt2: Infinity, h: 0 };
         } else if (text[0] === '~') {
            if (text[1] === '~') {
               // ex: ~~125
               q = parseFloat(text.substring(2));
               if (isNaN(q)) {
                  throw new Error("Not a number");
               }
               d1 = q * 0.9;
               d2 = q * 1.1;
               s1 = q * 0.8;
               s2 = q * 1.2;
               return { d1: d1, d2: d2, dt1: d1 - s1, dt2: s2 - d2, h: 0 };
            } else if (text.substring(1).indexOf('-') !== -1) {
               // ex: ~100-150
               var ind = text.indexOf('-');
               var str1 = text.substring(1, ind);
               var str2 = text.substring(ind + 1);
               d1 = parseFloat(str1);
               if (isNaN(d1)) {
                  throw new Error("Not a number");
               }
               d2 = parseFloat(str2);
               if (isNaN(d2)) {
                  throw new Error("Not a number");
               }
               var mid = (d1 + d2) / 2;
               return { d1: d1, d2: d2, dt1: mid * 0.1, dt2: mid * 0.1, h: 0 };
            } else {
               // ex: ~125
               q = parseFloat(text.substring(1));
               if (isNaN(q)) {
                  throw new Error("Not a number");
               }
               d1 = q * 0.95;
               d2 = q * 1.05;
               s1 = q * 0.90;
               s2 = q * 1.1;
               if (Math.abs(q) < 0.01) {
                  d1 = 0.0;
                  d2 = 0.01;
                  s1 = 0.0;
                  s2 = 0.02;
               }
               var dt1 = d1 - s1;
               var dt2 = s2 - d2;
               return { d1: d1, d2: d2, dt1: dt1, dt2: dt2, h: 0 };
            }
         } else if (text[0] === '>') {
            // ex: >125
            q = parseFloat(text.substring(1));
            if (isNaN(q)) {
               throw new Error("Not a number");
            }
            if (Math.abs(q) < 0.01) {
               q = 0.01;
            }
            return { d1: q, d2: Infinity, dt1: 0, dt2: 0, h: 0 };
         } else if (text[0] === '<') {
            // ex: <125
            q = parseFloat(text.substring(1));
            if (isNaN(q)) {
               throw new Error("Not a number");
            }
            return { d1: 0, d2: q, dt1: 0, dt2: 0, h: 0 };
         } else {
            // ex: 125
            q = parseFloat(text);
            if (isNaN(q)) {
               throw new Error("Not a number");
            }
            return { d1: q, d2: q, dt1: 0, dt2: 0, h: 0 };
         }
      } catch (err) {
         return null;
      }
   }

   function possibility(P, D) {
      if (P.d1 > D.d2) {
         var interm = D;
         D = P;
         P = interm;
      } else if (D.d1 <= P.d2) {
         return 1;
      }
      if (test1(P.h, D.h, D.d1, D.dt1, P.d2, P.dt2)) {
         return Math.max(P.h, D.h);
      }
      return inters1(P.h, D.h, D.d1, D.dt1, P.d2, P.dt2);
   }

   function necessity(P, D) {
      if (1. - P.h <= D.h) {
         return P.h;
      }
      var alph1 = alpha1(P.h, D.h, P.d1, D.d1, P.dt1, D.dt1);
      if (alph1 == 1. - P.h) {
         return P.h;
      }
      var alph2 = alpha2(P.h, D.h, P.d2, D.d2, P.dt2, D.dt2);
      return 1. - Math.max(alph1, alph2);
   }

   function test1(h, h_, d1_, dt1_, d2, dt2) {
      return (1. - h) * (d1_ - dt1_ - d2) - (1. - h_) * dt2 >= 0;
   }

   function inters1(h, h_, d1_, dt1_, d2, dt2) {
      return 1. - (1. - h) * (1. - h_) * (d1_ - d2) / ((1. - h) * dt1_ + (1. - h_) * dt2);
   }

   function test2(h, h_, d1, d1_, dt1, dt1_) {
      return (1. - h) * (d1_ - dt1_ - d1) + dt1 * h_ >= 0;
   }

   function test3(h, h_, d1, d1_, dt1, dt1_) {
      return (1. - h_) * (d1_ - d1 + dt1) - dt1_ * h >= 0;
   }

   function inters2(h, h_, d1, d1_, dt1, dt1_) {
      return (1. - h) * ((1. - h_) * (d1 - d1_) + dt1_) / ((1. - h) * dt1_ + (1. - h) * dt1);
   }

   function test4(h, h_, d2, d2_, dt2, dt2_) {
      return (1. - h_) * (d2 + dt2 - d2_) - dt2_ * h_ < 0;
   }

   function test5(h, h_, d2, d2_, dt2, dt2_) {
      return (1. - h) * (d2 - d2_ - dt2_) + h_ * dt2 >= 0;
   }

   function inters3(h, h_, d2, d2_, dt2, dt2_) {
      return (1. - h) * ((1. - h_) * (d2_ - d2) + dt2_) / ((1. - h_) * dt2 + (1. - h) * dt2_);
   }

   function alpha1(h, h_, d1, d1_, dt1, dt1_) {
      if (test2(h, h_, d1, d1_, dt1, dt1_)) {
         return h_;
      }
      if (test3(h, h_, d1, d1_, dt1, dt1_)) {
         return inters2(h, h_, d1, d1_, dt1, dt1_);
      }
      return 1. - h;
   }

   function alpha2(h, h_, d2, d2_, dt2, dt2_) {
      if (test4(h, h_, d2, d2_, dt2, dt2_)) {
         return 1. - h;
      }
      if (test5(h, h_, d2, d2_, dt2, dt2_)) {
         return h_;
      }
      return inters3(h, h_, d2, d2_, dt2, dt2_);
   }
}();

/***/ }),
/* 95 */
/***/ (function(module, exports) {


module.exports = function () {

   return {
      createEquipotential: createEquipotential,
      addEquipotential: addEquipotential,
      equipotentialCount: equipotentialCount,
      getEquipotentialNames: getEquipotentialNames,
      unusedEquipotentialCount: unusedEquipotentialCount,

      signalCompoundArity: signalCompoundArity,
      sumOfTermsCompoundArity: sumOfTermsCompoundArity,
      sumOfTermsArity: sumOfTermsArity,
      termArity: termArity,
      factorArity: factorArity,
      signalArity: signalArity,
      signalCompoundAtIndex: signalCompoundAtIndex,
      sumoftermsCompoundAtIndex: sumoftermsCompoundAtIndex,
      simplifyFormula: simplifyFormula,
      parameterArity: parameterArity,
      parameterNameAtIndex: parameterNameAtIndex,
      parametersArity: parametersArity,
      parametersNameAtIndex: parametersNameAtIndex,
      argumentsArity: argumentsArity,
      argumentArity: argumentArity,
      argumentAtIndex: argumentAtIndex,
      argumentAt: argumentAt,
      getOriginalEquipotentialIndex: getOriginalEquipotentialIndex,
      getOriginalEquipotential: getOriginalEquipotential,
      replaceAliases: replaceAliases,
      updateFormulaIndexes: updateFormulaIndexes,
      addUsedBy: addUsedBy,
      addUnused: addUnused

      // equipotentials is both an array and a mapping
   };function createEquipotential(name, equipotentials) {
      var index = equipotentials.length;
      var equipotential = {
         name: name,
         index: index
      };
      addEquipotential(equipotential, equipotentials);
      return equipotential;
   }

   // equipotentials is both an array and a mapping
   function addEquipotential(equipotential, equipotentials) {
      var index = equipotentials.length;
      equipotential.index = index;
      // add equipotential as an array element
      equipotentials.push(equipotential);
      // add mapping name -> equipotential
      if (equipotential.name !== null) {
         equipotentials["__" + equipotential.name] = index;
      }
      return index;
   }

   function equipotentialCount(module) {
      return module.equipotentials.reduce(function (accu, equipotential) {
         return accu + 1;
      }, 0);
   }

   function getEquipotentialNames(equipotentials, equipotentialIndex) {
      var result = [];
      for (var key in equipotentials) {
         if (!isNaN(key)) continue;
         if (equipotentials[key] === equipotentialIndex) {
            result.push(key);
         }
      }
      return result;
   }

   function unusedEquipotentialCount(module) {
      return module.equipotentials.reduce(function (accu, equipotential) {
         if (equipotential.isUnused) {
            return accu + 1;
         } else {
            return accu;
         }
      }, 0);
   }

   function signalCompoundArity(signalCompound) {
      return signalCompound.signals.reduce(function (accu, signal) {
         return accu + signalArity(signal);
      }, 0);
   }

   function sumOfTermsCompoundArity(sumOfTermsCompound) {
      return sumOfTermsCompound.sumofterms.reduce(function (accu, term) {
         return accu + sumOfTermsArity(term);
      }, 0);
   }

   function sumOfTermsArity(sumOfTerms) {
      return termArity(sumOfTerms.terms[0]);
   }

   function termArity(term) {
      var arities = term.factors.map(function (factor) {
         return factorArity(factor);
      });
      // return max value (they are supposed to be all 1 or a common value)
      return arities.reduce(function (p, v) {
         return p > v ? p : v;
      });
   }

   function factorArity(factor) {
      if (factor.type === 'bitfield') {
         return factor.value.length;
      } else if (factor.type === 'maxterm') {
         return signalArity(factor.signal);
      } else if (factor.type === 'sumofterms') {
         return sumOfTermsArity(factor.sumofterms);
      }
   }

   function signalArity(signal) {
      if (signal.type === 'scalar') {
         return 1;
      } else if (signal.type === 'vector') {
         return signal.start - signal.stop + 1;
      }
   }

   function signalCompoundAtIndex(signalCompound, index) {
      var currIndex = 0;
      for (var i = 0; i < signalCompound.signals.length; i++) {
         var signal = signalCompound.signals[i];
         if (signal.type === 'scalar') {
            if (index === currIndex) {
               return signal.name;
            }
            currIndex += 1;
         } else if (signal.type === 'vector') {
            for (var j = signal.start; j >= signal.stop; j--) {
               if (index === currIndex) {
                  return signal.name + '[' + j + ']';
               }
               currIndex += 1;
            }
         }
      }
   }

   function sumoftermsCompoundAtIndex(sumOfTermsCompound, index) {
      var currIndex = 0;
      for (var i = 0; i < sumOfTermsCompound.sumofterms.length; i++) {
         var sumofterms = sumOfTermsCompound.sumofterms[i];
         var arity = sumOfTermsArity(sumofterms);
         if (index < currIndex + arity) {
            return { sumofterms: sumofterms, localindex: index - currIndex };
         }
         currIndex += arity;
      }
   }

   function simplifyFormula(formula) {
      if (formula.op === 'or' && formula.args.length === 1) {
         return simplifyFormula(formula.args[0]);
      } else if (formula.op === 'and' && formula.args.length === 1) {
         return simplifyFormula(formula.args[0]);
      } else {
         return formula;
      }
   }

   function parameterArity(parameter) {
      if (parameter.type === 'scalar') {
         return 1;
      } else if (parameter.type === 'vector') {
         return parameter.start - parameter.stop + 1;
      }
   }

   function parametersArity(parameterList) {
      return parameterList.reduce(function (accu, parameter) {
         return accu + parameterArity(parameter);
      }, 0);
   }

   function parameterNameAtIndex(parameter, index) {
      if (parameter.type === 'scalar') {
         return parameter.name;
      } else if (parameter.type === 'vector') {
         return parameter.name + '[' + (parameter.start - index) + ']';
      }
   }

   function parametersNameAtIndex(parameterList, index) {
      var currIndex = 0;
      for (var i = 0; i < parameterList.length; i++) {
         var parameter = parameterList[i];
         if (parameter.type === 'scalar') {
            if (index === currIndex) return parameter.name;
            currIndex += 1;
         } else if (parameter.type === 'vector') {
            for (var k = 0; k < parameter.start - parameter.stop + 1; k++) {
               if (index === currIndex) return parameter.name + '[' + (parameter.start - k) + ']';
               currIndex += 1;
            }
         }
      }
   }

   function argumentsArity(argumentList) {
      return argumentList.reduce(function (accu, argument) {
         return accu + argumentArity(argument);
      }, 0);
   }

   function argumentArity(argument) {
      return argument.signalorliterals.reduce(function (accu, signalOrLiteral) {
         var arity = signalOrLiteral.type === 'literal' ? signalOrLiteral.value.length : signalArity(signalOrLiteral);
         return accu + arity;
      }, 0);
   }

   // return a scalar signal name (string, such as 'a[2]') or a literal value (string '>0' or '>1')
   function argumentAtIndex(argumentList, index) {
      var currIndex = 0;
      for (var i = 0; i < argumentList.length; i++) {
         var argument = argumentList[i];
         for (var j = 0; j < argument.signalorliterals.length; j++) {
            var signalorliteral = argument.signalorliterals[j];
            if (signalorliteral.type === 'scalar') {
               if (index === currIndex) return signalorliteral.name;
               currIndex += 1;
            } else if (signalorliteral.type === 'vector') {
               for (var k = 0; k < signalorliteral.start - signalorliteral.stop + 1; k++) {
                  if (index === currIndex) return signalorliteral.name + '[' + (signalorliteral.start - k) + ']';
                  currIndex += 1;
               }
            } else {
               // literal
               for (var _k = 0; _k < signalorliteral.value.length; _k++) {
                  if (index === currIndex) {
                     return signalorliteral.value[_k] === '1' ? '>1' : '>0';
                  }
                  currIndex += 1;
               }
            }
         }
      }
   }

   function argumentAt(argument, index) {
      var currIndex = 0;
      for (var j = 0; j < argument.signalorliterals.length; j++) {
         var signalorliteral = argument.signalorliterals[j];
         if (signalorliteral.type === 'scalar') {
            if (index === currIndex) return signalorliteral.name;
            currIndex += 1;
         } else if (signalorliteral.type === 'vector') {
            for (var k = 0; k < signalorliteral.start - signalorliteral.stop + 1; k++) {
               if (index === currIndex) return signalorliteral.name + '[' + (signalorliteral.start - k) + ']';
               currIndex += 1;
            }
         } else {
            // literal
            for (var _k2 = 0; _k2 < signalorliteral.value.length; _k2++) {
               if (index === currIndex) {
                  return signalorliteral.value[_k2] === '1' ? '>1' : '>0';
               }
               currIndex += 1;
            }
         }
      }
   }

   function getOriginalEquipotentialIndex(equipotentialIndex, equipotentials) {
      var equipotential = equipotentials[equipotentialIndex];
      if (equipotential.type === 'alias') {
         return equipotential.aliasIndex;
      }
      return equipotentialIndex;
   }

   function getOriginalEquipotential(equipotential, equipotentials) {
      if (equipotential.type === 'alias') {
         return equipotentials[equipotential.aliasIndex];
      }
      return equipotential;
   }

   function replaceAliases(formula, equipotentials) {
      if (formula.op === 'or' || formula.op === 'and') {
         formula.args.forEach(function (f) {
            replaceAliases(f, equipotentials);
         });
      } else if (formula.op === 'maxterm') {
         formula.equipotentialIndex = getOriginalEquipotentialIndex(formula.equipotentialIndex, equipotentials);
         // let eq = equipotentials[formula.equipotentialIndex]
         // if (eq.type === 'alias') {
         //    formula.equipotentialIndex = eq.aliasIndex
         // }
      }
   }

   function updateFormulaIndexes(formula, mapping) {
      if (formula.op === 'or' || formula.op === 'and') {
         formula.args.forEach(function (f) {
            updateFormulaIndexes(f, mapping);
         });
      } else if (formula.op === 'maxterm') {
         if (mapping.hasOwnProperty(formula.equipotentialIndex)) {
            formula.equipotentialIndex = mapping[formula.equipotentialIndex];
         }
      }
   }

   function addUsedBy(module) {
      module.equipotentials.forEach(function (equipotential) {
         if (equipotential.type === 'combinatorial') {
            addUsedByFormula(equipotential, equipotential.formula, module.equipotentials);
         } else if (equipotential.type === 'sequential') {
            addUsedByFormula(equipotential, equipotential.formula, module.equipotentials);
            // addUsedByFormula(equipotential, equipotential.clk, module.equipotentials)
            var clkEquipotential = module.equipotentials[equipotential.clk];
            addUsedByEquipotential(equipotential, clkEquipotential);
            if (equipotential.rst) {
               var rstEquipotential = module.equipotentials[equipotential.rst];
               addUsedByEquipotential(equipotential, rstEquipotential);
            }
            if (equipotential.set) {
               var setEquipotential = module.equipotentials[equipotential.set];
               addUsedByEquipotential(equipotential, setEquipotential);
            }
            if (equipotential.en) {
               var enEquipotential = module.equipotentials[equipotential.en];
               addUsedByEquipotential(equipotential, enEquipotential);
            }
         } else if (equipotential.type === 'tri-state') {
            equipotential.sources.forEach(function (source) {
               var srcEquipotential = module.equipotentials[source.srcEquipotential];
               addUsedByEquipotential(equipotential, srcEquipotential);
               var oeEquipotential = module.equipotentials[source.oeEquipotential];
               addUsedByEquipotential(equipotential, oeEquipotential);
            });
         } else if (equipotential.type === 'ram_aread_swrite') {
            addUsedByEquipotential(equipotential, module.equipotentials[equipotential.clk]);
            addUsedByEquipotential(equipotential, module.equipotentials[equipotential.wr]);
            addUsedByEquipotential(equipotential, module.equipotentials[equipotential.din]);
            equipotential.addrs.forEach(function (addr) {
               addUsedByEquipotential(equipotential, module.equipotentials[addr]);
            });
         }
      });
   }

   function addUsedByFormula(targetEquipotential, formula, equipotentials) {
      if (formula.op === 'or' || formula.op === 'and') {
         formula.args.forEach(function (f) {
            addUsedByFormula(targetEquipotential, f, equipotentials);
         });
      } else if (formula.op === 'maxterm') {
         var usedEquipotential = equipotentials[formula.equipotentialIndex];
         addUsedByEquipotential(targetEquipotential, usedEquipotential);
      }
   }

   function addUsedByEquipotential(targetEquipotential, usedEquipotential) {
      if (usedEquipotential['usedBy'] === undefined) usedEquipotential.usedBy = [];
      if (targetEquipotential['uses'] === undefined) targetEquipotential.uses = [];
      if (usedEquipotential.usedBy.indexOf(targetEquipotential.index) === -1) usedEquipotential.usedBy.push(targetEquipotential.index);
      if (targetEquipotential.uses.indexOf(usedEquipotential.index) === -1) targetEquipotential.uses.push(usedEquipotential.index);
   }

   function addUnused(module) {
      var modified = true;
      while (modified) {
         modified = false;
         for (var i = 0; i < module.equipotentials.length; i++) {
            var equipotential = module.equipotentials[i];
            if (equipotential === undefined) continue; // empty slot
            if (equipotential['isUnused'] !== undefined) continue; // already qualified
            if (equipotential.isInput || equipotential.isOutput) {
               equipotential.isUnused = false;
               modified = true;
               continue;
            }
            if (equipotential['usedBy'] === undefined || equipotential.usedBy.length === 0) {
               // an equipotential with no input/output status and with an undefined or empty 'usedBy' attribute is unused
               equipotential.isUnused = true;
               modified = true;
               continue;
            }
            if (equipotential.usedBy.every(function (index) {
               var eq = module.equipotentials[index];
               return eq['isUnused'];
            })) {
               // an equipotential whose all members of its 'usedBy' attribute are unused, is unused
               equipotential.isUnused = true;
               modified = true;
               continue;
            }
         }
      }
   }
}();

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_Login__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_Logout__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_login_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_ActivateUser__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_ActivateUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_login_ActivateUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login_AcceptInvitation__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login_AcceptInvitation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_login_AcceptInvitation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_news_News__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_news_News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_news_News__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_news_NutrieducNews__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_news_NutrieducNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_news_NutrieducNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_news_SHDLNews__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_news_SHDLNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_news_SHDLNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_nutrikiosk_NutriKiosk__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_nutrikiosk_NutriKiosk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_nutrikiosk_NutriKiosk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tools_Tools__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tools_Tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_tools_Tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tools_IMC__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tools_IMC___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_tools_IMC__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_tools_IMCWeightLossCalc__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_tools_IMCWeightLossCalc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_tools_IMCWeightLossCalc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_users_UsersManager__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_users_UsersManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_users_UsersManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_users_User__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_users_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_users_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_users_UserHistory__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_users_UserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_users_UserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_users_UserAttributeCharts__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_users_UserAttributeCharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_users_UserAttributeCharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_fitbit_FitbitAuthorized__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_fitbit_FitbitAuthorized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_fitbit_FitbitAuthorized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_meals_UserMealSurveys__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_meals_UserMealSurveys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_meals_UserMealSurveys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_meals_UserMealElements__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_meals_UserMealElements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_meals_UserMealElements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_nutrieduc_NutriEduc__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_nutrieduc_NutriEduc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_nutrieduc_NutriEduc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_nutrieduc_MealAssessment__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_nutrieduc_MealAssessment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_nutrieduc_MealAssessment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_nutrieduc_Favorites__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_nutrieduc_Favorites___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_nutrieduc_Favorites__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_coaching_Coaching__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_coaching_Coaching___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_coaching_Coaching__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_coaching_CoachedUserWorkspace__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_coaching_CoachedUserWorkspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_coaching_CoachedUserWorkspace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_shdl_ShdlUserModules__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_shdl_ShdlUserModules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_shdl_ShdlUserModules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_shdl_ShdlModule__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_shdl_ShdlModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_shdl_ShdlModule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_shdl_ShdlEditor__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_shdl_ShdlEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_shdl_ShdlEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_shdl_ShdlSimulator__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_shdl_ShdlSimulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_shdl_ShdlSimulator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_shdl_ShdlDoc__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_shdl_ShdlDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_shdl_ShdlDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_craps_CrapsUserModules__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_craps_CrapsUserModules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_craps_CrapsUserModules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_craps_CrapsModule__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_craps_CrapsModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_craps_CrapsModule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_craps_CrapsEditor__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_craps_CrapsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_craps_CrapsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_craps_CrapsSimulator__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_craps_CrapsSimulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_craps_CrapsSimulator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_craps_CrapsDoc__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_craps_CrapsDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_craps_CrapsDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_messages_Messages__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_messages_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_messages_Messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_salutance_SalutanceNews__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_salutance_SalutanceNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_salutance_SalutanceNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_surveys_UserSurveys__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_surveys_UserSurveys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_surveys_UserSurveys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_surveys_SurveyAnswers__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_surveys_SurveyAnswers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_surveys_SurveyAnswers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_nutrikiosk_QCUEditor__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_nutrikiosk_QCUEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_nutrikiosk_QCUEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_nutrikiosk_QCUQuestion__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_nutrikiosk_QCUQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_nutrikiosk_QCUQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__utilities_jwtToken_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__utilities_jwtToken_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__utilities_jwtToken_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__store_index_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__config__ = __webpack_require__(19);






























































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
   mode: 'hash',
   base: '/',
   routes: [
   // path='/': see navigation guard at end of file
   {
      path: '/news',
      name: 'news',
      component: __WEBPACK_IMPORTED_MODULE_6__components_news_News___default.a,
      children: [{
         path: 'nutrieduc',
         name: 'nutrieduc-news',
         component: __WEBPACK_IMPORTED_MODULE_7__components_news_NutrieducNews___default.a
      }, {
         path: 'shdl',
         name: 'shdl-news',
         component: __WEBPACK_IMPORTED_MODULE_8__components_news_SHDLNews___default.a
      }]
   }, {
      path: '/login',
      name: 'login',
      component: __WEBPACK_IMPORTED_MODULE_2__components_login_Login___default.a
   }, {
      path: '/logout',
      name: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_3__components_login_Logout___default.a
   }, {
      path: '/fitbit-authorized',
      name: '/fitbit-authorized',
      component: __WEBPACK_IMPORTED_MODULE_17__components_fitbit_FitbitAuthorized___default.a
   }, {
      path: '/activate-user',
      name: 'ActivateUser',
      component: __WEBPACK_IMPORTED_MODULE_4__components_login_ActivateUser___default.a
   }, {
      path: '/accept-invitation',
      name: 'AcceptInvitation',
      component: __WEBPACK_IMPORTED_MODULE_5__components_login_AcceptInvitation___default.a,
      props: function props(route) {
         return {
            acceptInvitationUrl: __WEBPACK_IMPORTED_MODULE_43__config__["a" /* default */].ACCEPT_INVITATION_URL,
            token: route.query.token
         };
      }
   }, {
      path: '/nutrikiosk',
      name: 'nutrikiosk',
      component: __WEBPACK_IMPORTED_MODULE_9__components_nutrikiosk_NutriKiosk___default.a
   }, {
      path: '/tools',
      name: 'tools',
      component: __WEBPACK_IMPORTED_MODULE_10__components_tools_Tools___default.a
   }, {
      path: '/imc',
      name: 'imc',
      component: __WEBPACK_IMPORTED_MODULE_11__components_tools_IMC___default.a
   }, {
      path: '/imc-weightloss-calc',
      name: 'imc-weightloss-calc',
      component: __WEBPACK_IMPORTED_MODULE_12__components_tools_IMCWeightLossCalc___default.a
   }, {
      path: '/qcu-editor',
      name: 'qcu-editor',
      component: __WEBPACK_IMPORTED_MODULE_39__components_nutrikiosk_QCUEditor___default.a,
      props: function props(route) {
         return {
            baseRoute: '/qcu-editor/'
         };
      },
      children: [{
         path: 'question/:questionId',
         name: 'question-detail',
         component: __WEBPACK_IMPORTED_MODULE_40__components_nutrikiosk_QCUQuestion___default.a,
         // props: true wouldn't convert userId string into int
         props: function props(route) {
            return {
               questionId: parseInt(route.params.questionId)
            };
         }
      }, {
         path: 'create',
         name: 'question-create',
         component: __WEBPACK_IMPORTED_MODULE_40__components_nutrikiosk_QCUQuestion___default.a,
         props: function props(route) {
            return {
               questionId: 0
            };
         }
      }]
   },

   //////////////////////////////////     USER MANAGEMENT     //////////////////////////////////

   {
      path: '/user-manager',
      name: 'UsersManager',
      component: __WEBPACK_IMPORTED_MODULE_13__components_users_UsersManager___default.a,
      children: [{
         path: 'user/:userId',
         name: 'user-detail',
         component: __WEBPACK_IMPORTED_MODULE_14__components_users_User___default.a,
         // props: true wouldn't convert userId string into int
         props: function props(route) {
            return {
               userId: parseInt(route.params.userId)
            };
         }
      }, {
         path: 'create',
         name: 'UserCreate',
         component: __WEBPACK_IMPORTED_MODULE_14__components_users_User___default.a,
         props: function props(route) {
            return {
               userId: 0,
               message: route.query.message
            };
         }
      }]
   },

   //////////////////////////////////     SALUTANCE & DIAMOND COACHING      //////////////////////////////////

   {
      path: '/nutritional-coaching/:realm',
      name: 'nutritional-coaching',
      component: __WEBPACK_IMPORTED_MODULE_23__components_coaching_Coaching___default.a,
      props: function props(route) {
         return {
            title: "Patients",
            baseRoute: '/nutritional-coaching/' + route.params.realm + '/'
         };
      },
      children: [{
         path: ':userId',
         name: 'nutritional-user-workspace',
         component: __WEBPACK_IMPORTED_MODULE_24__components_coaching_CoachedUserWorkspace___default.a,
         props: function props(route) {
            return {
               userId: parseInt(route.params.userId),
               realm: route.params.realm,
               items: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].getters.authorized[route.params.realm + '-coaching']['items'],
               baseRoute: '/nutritional-coaching/' + route.params.realm + '/' + route.params.userId + '/'
            };
         },
         children: [{
            path: 'food-surveys',
            name: 'nutritional-coaching-surveys',
            component: __WEBPACK_IMPORTED_MODULE_18__components_meals_UserMealSurveys___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId),
                  baseRoute: '/nutritional-coaching/' + route.params.realm + '/' + route.params.userId + '/food-surveys/'
               };
            },

            children: [{
               path: ':date/:index',
               name: 'nutritional-coaching-surveys-meal',
               components: {
                  mealElements: __WEBPACK_IMPORTED_MODULE_19__components_meals_UserMealElements___default.a,
                  favorites: __WEBPACK_IMPORTED_MODULE_22__components_nutrieduc_Favorites___default.a
               },
               props: {
                  mealElements: function mealElements(route) {
                     return {
                        userId: parseInt(route.params.userId),
                        date: route.params.date,
                        index: parseInt(route.params.index)
                     };
                  },
                  favorites: function favorites(route) {
                     return {
                        userId: parseInt(route.params.userId),
                        index: parseInt(route.params.index)
                     };
                  }
               }
            }]

         }, {
            path: 'nutrieduc',
            name: 'nutritional-nutrieduc',
            component: __WEBPACK_IMPORTED_MODULE_20__components_nutrieduc_NutriEduc___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId),
                  baseRoute: '/nutritional-coaching/' + route.params.realm + '/' + route.params.userId + '/nutrieduc/'
               };
            },
            children: [{
               path: ':date/:index',
               name: 'nutritional-nutrieduc-meal',
               components: {
                  mealElements: __WEBPACK_IMPORTED_MODULE_19__components_meals_UserMealElements___default.a,
                  favorites: __WEBPACK_IMPORTED_MODULE_22__components_nutrieduc_Favorites___default.a,
                  mealAssessment: __WEBPACK_IMPORTED_MODULE_21__components_nutrieduc_MealAssessment___default.a
               },
               props: {
                  mealElements: function mealElements(route) {
                     return {
                        userId: parseInt(route.params.userId),
                        date: route.params.date,
                        index: parseInt(route.params.index)
                     };
                  },
                  favorites: function favorites(route) {
                     return {
                        userId: parseInt(route.params.userId),
                        index: parseInt(route.params.index)
                     };
                  },
                  mealAssessment: function mealAssessment(route) {
                     return {
                        userId: parseInt(route.params.userId),
                        date: route.params.date,
                        index: parseInt(route.params.index)
                     };
                  }
               }
            }]
         }, {
            path: 'surveys',
            name: 'nutritional-surveys',
            component: __WEBPACK_IMPORTED_MODULE_37__components_surveys_UserSurveys___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId),
                  baseRoute: '/nutritional-coaching/' + route.params.realm + '/' + route.params.userId + '/surveys/',
                  mode: 'caregiver'
               };
            },
            children: [{
               path: ':userSurveyId',
               name: 'nutritional-survey-answers',
               component: __WEBPACK_IMPORTED_MODULE_38__components_surveys_SurveyAnswers___default.a,
               props: function props(route) {
                  return {
                     userSurveyId: parseInt(route.params.userSurveyId),
                     baseRoute: '/nutritional-coaching/' + route.params.realm + '/' + route.params.userId + '/surveys/' + route.params.userSurveyId + '/',
                     mode: 'caregiver'
                  };
               }
            }]
         }, {
            path: 'indicators',
            name: 'nutritional-indicators',
            component: __WEBPACK_IMPORTED_MODULE_16__components_users_UserAttributeCharts___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId)
               };
            }
         }, {
            path: 'messages',
            name: 'nutritional-messages',
            component: __WEBPACK_IMPORTED_MODULE_35__components_messages_Messages___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId)
               };
            }
         }]
      }]
   },

   //////////////////////////////////     USER FOOD SURVEYS (Salutance, Diamond)     //////////////////////////////////

   {
      path: '/food-surveys',
      name: 'food-surveys',
      component: __WEBPACK_IMPORTED_MODULE_18__components_meals_UserMealSurveys___default.a,
      // props: true wouldn't convert userId string into int
      props: function props(route) {
         return {
            userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
            baseRoute: '/food-surveys/'
         };
      },

      children: [{
         path: ':date/:index',
         name: 'food-surveys-meal',
         components: {
            mealElements: __WEBPACK_IMPORTED_MODULE_19__components_meals_UserMealElements___default.a,
            favorites: __WEBPACK_IMPORTED_MODULE_22__components_nutrieduc_Favorites___default.a
         },
         props: {
            mealElements: function mealElements(route) {
               return {
                  userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
                  date: route.params.date,
                  index: parseInt(route.params.index)
               };
            },
            favorites: function favorites(route) {
               return {
                  userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
                  index: parseInt(route.params.index)
               };
            }
         }
      }]
   },

   //////////////////////////////////     MY PROFILE (Salutance)     //////////////////////////////////

   {
      path: '/my-profile',
      name: 'my-profile',
      component: __WEBPACK_IMPORTED_MODULE_14__components_users_User___default.a,
      props: function props(route) {
         return {
            userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId
         };
      }
   },

   //////////////////////////////////     USER ATTRIBUTES (Salutance, Diamond)     //////////////////////////////////

   {
      path: '/user-attributes',
      name: 'user-attributes',
      component: __WEBPACK_IMPORTED_MODULE_16__components_users_UserAttributeCharts___default.a,
      props: function props(route) {
         return {
            userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId
         };
      }
   },

   //////////////////////////////////     NUTRI-EDUC (Salutance)     //////////////////////////////////

   {
      path: '/nutrieduc',
      name: 'nutrieduc',
      component: __WEBPACK_IMPORTED_MODULE_20__components_nutrieduc_NutriEduc___default.a,
      props: function props(route) {
         return {
            userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
            baseRoute: '/nutrieduc'
         };
      },
      children: [{
         path: ':date/:index',
         name: 'nutrieduc-date-index',
         components: {
            mealElements: __WEBPACK_IMPORTED_MODULE_19__components_meals_UserMealElements___default.a,
            mealAssessment: __WEBPACK_IMPORTED_MODULE_21__components_nutrieduc_MealAssessment___default.a,
            favorites: __WEBPACK_IMPORTED_MODULE_22__components_nutrieduc_Favorites___default.a
         },
         props: {
            mealElements: function mealElements(route) {
               return {
                  userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
                  date: route.params.date,
                  index: parseInt(route.params.index)
               };
            },
            favorites: function favorites(route) {
               return {
                  userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
                  index: parseInt(route.params.index)
               };
            },
            mealAssessment: function mealAssessment(route) {
               return {
                  userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
                  date: route.params.date,
                  index: parseInt(route.params.index)
               };
            }
         }
      }]
   },

   //////////////////////////////////     NUTRITION QUESTION SURVEYS      //////////////////////////////////

   {
      path: '/survey-coaching',
      name: 'survey-coaching',
      component: __WEBPACK_IMPORTED_MODULE_23__components_coaching_Coaching___default.a,
      props: function props(route) {
         return {
            title: "Patients",
            baseRoute: '/survey-coaching/'
         };
      },
      children: [{
         path: ':userId',
         name: 'survey-user-workspace',
         component: __WEBPACK_IMPORTED_MODULE_24__components_coaching_CoachedUserWorkspace___default.a,
         props: function props(route) {
            return {
               userId: parseInt(route.params.userId),
               items: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].getters.authorized['survey-coaching']['items'],
               baseRoute: '/survey-coaching/' + route.params.userId + '/'
            };
         },
         children: [{
            path: 'surveys',
            name: 'ritz-surveys',
            component: __WEBPACK_IMPORTED_MODULE_37__components_surveys_UserSurveys___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId),
                  baseRoute: '/survey-coaching/' + route.params.userId + '/surveys/',
                  mode: 'caregiver'
               };
            },
            children: [{
               path: ':userSurveyId',
               name: 'ritz-survey-answers',
               component: __WEBPACK_IMPORTED_MODULE_38__components_surveys_SurveyAnswers___default.a,
               props: function props(route) {
                  return {
                     userSurveyId: parseInt(route.params.userSurveyId),
                     baseRoute: '/survey-coaching/' + route.params.userId + '/surveys/' + route.params.userSurveyId + '/',
                     mode: 'caregiver'
                  };
               }
            }]
         }, {
            path: 'messages',
            name: 'survey-messages',
            component: __WEBPACK_IMPORTED_MODULE_35__components_messages_Messages___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId)
               };
            }
         }]
      }]
   }, {
      path: '/user-surveys',
      name: 'user-surveys',
      component: __WEBPACK_IMPORTED_MODULE_37__components_surveys_UserSurveys___default.a,
      // props: true wouldn't convert userId string into int
      props: function props(route) {
         return {
            userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
            baseRoute: '/user-surveys/',
            mode: 'patient'
         };
      },
      children: [{
         path: ':userSurveyId',
         name: 'user-survey',
         component: __WEBPACK_IMPORTED_MODULE_38__components_surveys_SurveyAnswers___default.a,
         props: function props(route) {
            return {
               userSurveyId: parseInt(route.params.userSurveyId),
               baseRoute: '/user-surveys/' + route.params.userSurveyId + '/',
               mode: 'patient'
            };
         }
      }]
   },

   //////////////////////////////////     MESSAGES     //////////////////////////////////

   {
      path: '/messages',
      name: 'messages',
      component: __WEBPACK_IMPORTED_MODULE_35__components_messages_Messages___default.a,
      // props: true wouldn't convert userId string into int
      props: function props(route) {
         return { userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId };
      }
   },

   //////////////////////////////////     SHDL     //////////////////////////////////

   {
      path: '/shdl-doc',
      name: 'ShdlDoc',
      component: __WEBPACK_IMPORTED_MODULE_29__components_shdl_ShdlDoc___default.a
   }, {
      path: '/shdl-user-coaching',
      name: 'shdl-user-coaching',
      component: __WEBPACK_IMPORTED_MODULE_23__components_coaching_Coaching___default.a,
      props: function props(route) {
         return {
            title: "Élèves",
            baseRoute: '/shdl-user-coaching/'
         };
      },
      children: [{
         path: ':userId',
         name: 'shdl-user-workspace',
         component: __WEBPACK_IMPORTED_MODULE_24__components_coaching_CoachedUserWorkspace___default.a,
         props: function props(route) {
            return {
               userId: parseInt(route.params.userId),
               items: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].getters.authorized['shdl-user-coaching']['items'],
               baseRoute: '/shdl-user-coaching/' + route.params.userId + '/'
            };
         },
         children: [{
            path: 'shdl-sandbox',
            name: 'user-shdl-modules',
            component: __WEBPACK_IMPORTED_MODULE_25__components_shdl_ShdlUserModules___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId),
                  baseRoute: '/shdl-user-coaching/' + route.params.userId + '/shdl-sandbox/'
               };
            },
            children: [{
               path: 'module/:moduleId',
               name: 'user-shdl-module',
               component: __WEBPACK_IMPORTED_MODULE_26__components_shdl_ShdlModule___default.a,
               props: function props(route) {
                  return {
                     moduleId: parseInt(route.params.moduleId),
                     baseRoute: '/shdl-user-coaching/' + route.params.userId + '/shdl-sandbox/module/' + route.params.moduleId + '/'
                  };
               },
               children: [{
                  path: 'editor',
                  name: 'user-shdl-module-editor',
                  component: __WEBPACK_IMPORTED_MODULE_27__components_shdl_ShdlEditor___default.a,
                  props: function props(route) {
                     return {
                        module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.shdl.modules[route.params.moduleId]
                     };
                  }
               }, {
                  path: 'simulator',
                  name: 'user-shdl-module-simulator',
                  component: __WEBPACK_IMPORTED_MODULE_28__components_shdl_ShdlSimulator___default.a,
                  props: function props(route) {
                     return {
                        module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.shdl.modules[route.params.moduleId]
                     };
                  }
               }]
            }]
         }, {
            path: 'messages',
            name: 'shdl-coaching-messages',
            component: __WEBPACK_IMPORTED_MODULE_35__components_messages_Messages___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId)
               };
            }
         }, {
            path: 'history',
            name: 'shdl-coaching-history',
            component: __WEBPACK_IMPORTED_MODULE_15__components_users_UserHistory___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId)
               };
            }
         }]
      }]
   }, {
      path: '/shdl-sandbox',
      name: 'shdl-sandbox',
      component: __WEBPACK_IMPORTED_MODULE_25__components_shdl_ShdlUserModules___default.a,
      props: function props(route) {
         return {
            userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
            baseRoute: '/shdl-sandbox/'
         };
      },
      children: [{
         path: 'module/:moduleId',
         name: 'shdl-sandbox-module',
         component: __WEBPACK_IMPORTED_MODULE_26__components_shdl_ShdlModule___default.a,
         props: function props(route) {
            return {
               moduleId: parseInt(route.params.moduleId),
               baseRoute: '/shdl-sandbox/module/' + route.params.moduleId + '/'
            };
         },
         children: [{
            path: 'editor',
            name: 'shdl-sandbox-module-editor',
            component: __WEBPACK_IMPORTED_MODULE_27__components_shdl_ShdlEditor___default.a,
            props: function props(route) {
               return {
                  module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.shdl.modules[route.params.moduleId]
               };
            }
         }, {
            path: 'simulator',
            name: 'shdl-sandbox-module-simulator',
            component: __WEBPACK_IMPORTED_MODULE_28__components_shdl_ShdlSimulator___default.a,
            props: function props(route) {
               return {
                  module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.shdl.modules[route.params.moduleId]
               };
            }
         }]
      }]
   },

   //////////////////////////////////     CRAPS     //////////////////////////////////

   {
      path: '/craps-doc',
      name: 'craps-doc',
      component: __WEBPACK_IMPORTED_MODULE_34__components_craps_CrapsDoc___default.a
   }, {
      path: '/craps-user-coaching',
      name: 'craps-user-coaching',
      component: __WEBPACK_IMPORTED_MODULE_23__components_coaching_Coaching___default.a,
      props: function props(route) {
         return {
            title: "Élèves",
            baseRoute: '/craps-user-coaching/'
         };
      },
      children: [{
         path: ':userId',
         name: 'craps-user-workspace',
         component: __WEBPACK_IMPORTED_MODULE_24__components_coaching_CoachedUserWorkspace___default.a,
         props: function props(route) {
            return {
               userId: parseInt(route.params.userId),
               items: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].getters.authorized['craps-user-coaching']['items'],
               baseRoute: '/craps-user-coaching/' + route.params.userId + '/'
            };
         },
         children: [{
            path: 'craps-sandbox',
            name: 'user-craps-modules',
            component: __WEBPACK_IMPORTED_MODULE_30__components_craps_CrapsUserModules___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId),
                  baseRoute: '/craps-user-coaching/' + route.params.userId + '/craps-sandbox/'
               };
            },
            children: [{
               path: 'module/:moduleId',
               name: 'user-craps-module',
               component: __WEBPACK_IMPORTED_MODULE_31__components_craps_CrapsModule___default.a,
               props: function props(route) {
                  return {
                     moduleId: parseInt(route.params.moduleId),
                     baseRoute: '/craps-user-coaching/' + route.params.userId + '/craps-sandbox/module/' + route.params.moduleId + '/'
                  };
               },
               children: [{
                  path: 'editor',
                  name: 'user-craps-module-editor',
                  component: __WEBPACK_IMPORTED_MODULE_32__components_craps_CrapsEditor___default.a,
                  props: function props(route) {
                     return {
                        module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.craps.modules[route.params.moduleId]
                     };
                  }
               }, {
                  path: 'simulator',
                  name: 'user-craps-module-simulator',
                  component: __WEBPACK_IMPORTED_MODULE_33__components_craps_CrapsSimulator___default.a,
                  props: function props(route) {
                     return {
                        module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.craps.modules[route.params.moduleId]
                     };
                  }
               }]
            }]
         }, {
            path: 'messages',
            name: 'craps-coaching-messages',
            component: __WEBPACK_IMPORTED_MODULE_35__components_messages_Messages___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId)
               };
            }
         }, {
            path: 'history',
            name: 'craps-coaching-history',
            component: __WEBPACK_IMPORTED_MODULE_15__components_users_UserHistory___default.a,
            props: function props(route) {
               return {
                  userId: parseInt(route.params.userId)
               };
            }
         }]
      }]
   }, {
      path: '/craps-sandbox',
      name: 'craps-sandbox',
      component: __WEBPACK_IMPORTED_MODULE_30__components_craps_CrapsUserModules___default.a,
      props: function props(route) {
         return {
            userId: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.loggedUserId,
            baseRoute: '/craps-sandbox/'
         };
      },
      children: [{
         path: 'module/:moduleId',
         name: 'craps-sandbox-module',
         component: __WEBPACK_IMPORTED_MODULE_31__components_craps_CrapsModule___default.a,
         props: function props(route) {
            return {
               moduleId: parseInt(route.params.moduleId),
               baseRoute: '/craps-sandbox/module/' + route.params.moduleId + '/'
            };
         },
         children: [{
            path: 'editor',
            name: 'craps-sandbox-module-editor',
            component: __WEBPACK_IMPORTED_MODULE_32__components_craps_CrapsEditor___default.a,
            props: function props(route) {
               return {
                  module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.craps.modules[route.params.moduleId]
               };
            }
         }, {
            path: 'simulator',
            name: 'craps-sandbox-module-simulator',
            component: __WEBPACK_IMPORTED_MODULE_33__components_craps_CrapsSimulator___default.a,
            props: function props(route) {
               return {
                  module: __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.craps.modules[route.params.moduleId]
               };
            }
         }]
      }]
   }]
});

var noAuthRouteNames = ['news', 'nutrieduc-news', 'shdl-news', 'login', 'logout', 'ActivateUser', 'AcceptInvitation', 'fitbit-authorized', 'tools', 'imc', 'imc-weightloss-calc', 'salutance-news', 'nutrikiosk'];

router.beforeEach(function (to, from, next) {
   if (to.path === '/') {
      next('/news');
   } else if (noAuthRouteNames.indexOf(to.name) !== -1) {
      // theses routes don't need authentication
      next();
   } else {
      // these routes need valid authentication
      if (__WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.authenticationData) {
         try {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__utilities_jwtToken_js__["verifyToken"])(__WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.authenticationData.token, __WEBPACK_IMPORTED_MODULE_42__store_index_js__["a" /* default */].state.authenticationData.publicKey);
            next();
         } catch (e) {
            // JWT probably expired, go to login page
            next('/login');
         }
      } else {
         console.log('JCB2 to', to, 'from', from);
         next(false);
      }
   }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


var jwt = __webpack_require__(1056);

module.exports = function () {

   function verifyToken(token, key) {
      // JCB: marche aléatoirement sur le serveur avec RS256 PUBLIC_KEY/PRIVATE_KEY
      //return jwt.verify(token, key, 'RS256')
      return jwt.verify(token, "MYSECRET", 'HS256');
   }

   // should never be used
   function decodeToken(token) {
      return jwt.decode(token);
   }

   return {
      verifyToken: verifyToken,
      decodeToken: decodeToken
   };
}();

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1038)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1208),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_persist__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__confirmer__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__teams__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__meals__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nutrikiosk__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shdl__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__craps__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__surveys__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(19);
















var axios = __webpack_require__(24);



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

// persist vuex state into localStorage
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_5_vuex_persist___default.a({
   strictMode: true, // This **MUST** be set to true
   key: 'vuex', // The key to store the state on in the storage provider.
   storage: window.localStorage // or window.sessionStorage or localForage
   // Function that passes the state and returns the state with only the objects you want to store.
   // reducer: state => state,
   // Function that passes a mutation and lets you decide if it should update the state in localStorage.
   // filter: mutation => (true)
});

function resetState(state) {
   __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(state, {
      appHeight: 0,

      authenticationData: null,
      loggedUserId: null,
      waiting: false,
      snackbar: false,
      snackbarOptions: {},

      realms: {},
      roles: {},

      users: {},
      user2coachedUserList: {}, // userId -> list of coachedUser ids

      userAttributes: {},
      user2userAttributeList: {},
      user2attribute2datedValues: {},

      messages: {},
      user2messageList: {},
      user2unreadMessageCount: {},

      events: {},
      user2eventList: {},
      team2eventList: {}
   });
}

var state = {
   // unresettable part of state
   httpReferer: null // 'nutrieduc', 'shdl'
};
resetState(state);

/*
// from https://github.com/axios/axios/issues/960
axios.interceptors.response.use((response) => {
   return response
}, function (error) {
   console.log(error.response)
   // Do something with response error
   if (error.response.status === 401) {
       console.log('unauthorized, logging out ...')
       auth.logout();
       router.replace('/auth/login');
   }
   return Promise.reject(error.response);
})
*/

var mutations = {

   RESTORE_MUTATION: vuexLocalStorage.RESTORE_MUTATION, // this mutation **MUST** be named "RESTORE_MUTATION"

   RESET_STATE: function RESET_STATE(state) {
      console.log('RESET_STATE');
      // reset root state
      resetState(state);
      // reset other modules states
      this.commit('teams/RESET_STATE');
      this.commit('meals/RESET_STATE');
      this.commit('nutrikiosk/RESET_STATE');
      this.commit('shdl/RESET_STATE');
      this.commit('craps/RESET_STATE');
      this.commit('surveys/RESET_STATE');
   },
   SET_APP_HEIGHT: function SET_APP_HEIGHT(state, height) {
      state.appHeight = height;
   },
   WAITING: function WAITING(state, value) {
      state.waiting = value;
   },
   SNACKBAR: function SNACKBAR(state, options) {
      state.snackbar = true;
      state.snackbarOptions = options;
   },
   SNACKBAR_SET: function SNACKBAR_SET(state, value) {
      state.snackbar = value;
   },
   SET_HTTP_REFERER: function SET_HTTP_REFERER(state, httpReferer) {
      state.httpReferer = httpReferer;
   },
   SET_AUTHENTICATION_DATA: function SET_AUTHENTICATION_DATA(state, authenticationData) {
      state.authenticationData = authenticationData;
   },
   SET_LOGGED_USER: function SET_LOGGED_USER(state, user) {
      state.users[user.id] = user;
      state.loggedUserId = user.id;
   },
   UPDATE_AUTHENTICATION_STATUS: function UPDATE_AUTHENTICATION_STATUS(state) {
      try {
         verifyToken(state.authenticationData.token, state.authenticationData.publicKey);
      } catch (e) {
         this.commit('RESET_STATE');
      }
   },
   SET_REALMS: function SET_REALMS(state, realms) {
      realms.forEach(function (realm) {
         __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.realms, realm.id, realm);
      });
   },
   SET_ROLES: function SET_ROLES(state, roles) {
      roles.forEach(function (role) {
         __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.roles, role.id, role);
      });
   },
   ADD_USER: function ADD_USER(state, user) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.users, user.id, user);
   },
   SET_USER: function SET_USER(state, user) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.users, user.id, user);
   },
   REMOVE_USER: function REMOVE_USER(state, userId) {
      // remove it from state.user2coachedUserList (in case it is a caregiver)
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(state.user2coachedUserList, userId);
      // remove it also from all coachedUserList (in case it is a coached user)
      for (var caregiverId in state.user2coachedUserList) {
         var coachedUserList = state.user2coachedUserList[caregiverId];
         var index = coachedUserList.indexOf(userId);
         if (index !== -1) {
            var clonedPatientList = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.clone(coachedUserList);
            clonedPatientList.slice(index, 1);
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2coachedUserList, caregiverId, clonedPatientList);
         }
      }

      // À COMPLÉTER

      // remove it from state.user2mealList
      //Vue.delete(state.user2mealList, userId)
      // remove it from state.user2moduleList
      //Vue.delete(state.user2moduleList, userId)


      // remove it from state.user2messageList
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(state.user2messageList, userId);
      // remove it from state.users
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(state.users, userId);
   },


   // make sure users are all registered in state
   CREATE_OR_SET_EACH_USER: function CREATE_OR_SET_EACH_USER(state, users) {
      users.forEach(function (user) {
         __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.users, user.id, user);
      });
   },


   // set coached users of the (coach) logged-in user
   SET_COACHED_USERS: function SET_COACHED_USERS(state, coachedUserList) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2coachedUserList, state.loggedUserId, coachedUserList.map(function (coachedUser) {
         return coachedUser.id;
      }));
   },
   SET_USER_MESSAGES: function SET_USER_MESSAGES(state, _ref) {
      var userId = _ref.userId,
          messages = _ref.messages;

      messages.forEach(function (message) {
         state.messages[message.id] = message;
      });
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2messageList, userId, messages.map(function (message) {
         return message.id;
      }));
   },
   ADD_USER_MESSAGE: function ADD_USER_MESSAGE(state, message) {
      // add message to state.messages
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.messages, message.id, message);
      // add message to state.user2messageList
      if (!state.user2messageList.hasOwnProperty(message.user)) state.user2messageList[message.user] = [];
      state.user2messageList[message.user].push(message.id);
   },
   UPDATE_USER_MESSAGE: function UPDATE_USER_MESSAGE(state, message) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.messages, message.id, message);
   },
   SET_UNREAD_MESSAGES_COUNT: function SET_UNREAD_MESSAGES_COUNT(state, _ref2) {
      var userId = _ref2.userId,
          count = _ref2.count;

      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2unreadMessageCount, userId, count);
   },
   SET_USER_HISTORY_EVENTS: function SET_USER_HISTORY_EVENTS(state, _ref3) {
      var userId = _ref3.userId,
          events = _ref3.events;

      events.forEach(function (event) {
         state.events[event.id] = event;
      });
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2eventList, userId, events.map(function (event) {
         return event.id;
      }));
   },
   ADD_USER_HISTORY_EVENT: function ADD_USER_HISTORY_EVENT(state, event) {
      // add event to state.events
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.events, event.id, event);
      // add event to state.user2eventList
      if (!state.user2eventList.hasOwnProperty(event.user)) state.user2eventList[event.user] = [];
      state.user2eventList[event.user].push(event.id);
   },
   SET_TEAM_HISTORY_EVENTS: function SET_TEAM_HISTORY_EVENTS(state, _ref4) {
      var teamId = _ref4.teamId,
          events = _ref4.events;

      events.forEach(function (event) {
         state.events[event.id] = event;
      });
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.team2eventList, teamId, events.map(function (event) {
         return event.id;
      }));
   },
   ADD_TEAM_HISTORY_EVENT: function ADD_TEAM_HISTORY_EVENT(state, event) {
      // add event to state.events
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.events, event.id, event);
      // add event to state.team2eventList
      if (!state.team2eventList.hasOwnProperty(event.user)) state.team2eventList[event.user] = [];
      state.team2eventList[event.team].push(event.id);
   },
   SET_USER_ATTRIBUTES: function SET_USER_ATTRIBUTES(state, _ref5) {
      var userId = _ref5.userId,
          attributes = _ref5.attributes;

      attributes.forEach(function (attribute) {
         state.userAttributes[attribute.id] = attribute;
      });
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2userAttributeList, userId, attributes.map(function (attribute) {
         return attribute.id;
      }));
   },
   SET_USER_ATTRIBUTE_DATED_VALUES: function SET_USER_ATTRIBUTE_DATED_VALUES(state, _ref6) {
      var userId = _ref6.userId,
          attributeId = _ref6.attributeId,
          datedValues = _ref6.datedValues;

      if (!state.user2attribute2datedValues.hasOwnProperty(userId)) state.user2attribute2datedValues[userId] = {};
      if (!state.user2attribute2datedValues[userId].hasOwnProperty(attributeId)) state.user2attribute2datedValues[userId][attributeId] = {};
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2attribute2datedValues[userId], attributeId, datedValues);
   },
   ADD_USER_ATTRIBUTE_DATED_VALUE: function ADD_USER_ATTRIBUTE_DATED_VALUE(state, datedValue) {
      var userId = datedValue.user;
      var attributeId = datedValue.attribute;
      var datedValues = state.user2attribute2datedValues[userId][attributeId];
      datedValues.push(datedValue);
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2attribute2datedValues[userId], attributeId, datedValues);
   },
   REMOVE_USER_ATTRIBUTE_DATED_VALUE: function REMOVE_USER_ATTRIBUTE_DATED_VALUE(state, datedValue) {
      var userId = datedValue.user;
      var attributeId = datedValue.attribute;
      var datedValues = state.user2attribute2datedValues[userId][attributeId];
      datedValues = datedValues.filter(function (dv) {
         return dv.id !== datedValue.id;
      });
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.user2attribute2datedValues[userId], attributeId, datedValues);
   }
};

var actions = {
   GET_HTTP_REFERER: function GET_HTTP_REFERER(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].HTTP_REFERER_URL
      }).then(function (response) {
         commit('SET_HTTP_REFERER', response.data);
         return response.data;
      });
   },
   GET_REALMS: function GET_REALMS(_ref8) {
      var commit = _ref8.commit,
          state = _ref8.state;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].REALMS_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         commit('SET_REALMS', response.data);
         return response.data;
      });
   },
   GET_ROLES: function GET_ROLES(_ref9) {
      var commit = _ref9.commit,
          state = _ref9.state;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].ROLES_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         commit('SET_ROLES', response.data);
         return response.data;
      });
   },
   IS_USERNAME_AVAILABLE: function IS_USERNAME_AVAILABLE(_ref10, username) {
      var commit = _ref10.commit,
          state = _ref10.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USERS_URL + '?username=' + username,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         return response.data.length === 0;
      });
   },
   GET_USERS: function GET_USERS(_ref11) {
      var commit = _ref11.commit,
          state = _ref11.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USERS_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         commit('CREATE_OR_SET_EACH_USER', response.data);
         return response.data;
      });
   },
   GET_USER: function GET_USER(_ref12, userId) {
      var commit = _ref12.commit,
          state = _ref12.state;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USERS_URL + userId + '/',
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         commit('SET_USER', response.data);
         return response.data;
      });
   },


   // used when creating user from sign-up form, doesn't need to be authenticated
   // user is not active until having been activated
   CREATE_USER: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref14, data) {
         var commit = _ref14.commit,
             state = _ref14.state;
         var userId;
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     _context.next = 2;
                     return axios({
                        method: 'post',
                        url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].CREATE_USER_URL,
                        data: data
                     });

                  case 2:
                     userId = _context.sent;
                     return _context.abrupt('return', userId);

                  case 4:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function CREATE_USER(_x, _x2) {
         return _ref13.apply(this, arguments);
      }

      return CREATE_USER;
   }(),

   SEND_ACTIVATE_ACCOUNT_MAIL: function SEND_ACTIVATE_ACCOUNT_MAIL(_ref15, userId) {
      var commit = _ref15.commit,
          state = _ref15.state;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].ACTIVATE_ACCOUNT_MAIL_URL,
         data: { "userId": userId },
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      });
   },


   // used when creating user from user-management module ; needs authentication
   POST_USER: function POST_USER(_ref16, user) {
      var commit = _ref16.commit,
          state = _ref16.state;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USERS_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token },
         data: user
      }).then(function (response) {
         commit('ADD_USER', response.data);
         return response.data;
      }).catch(function (error) {
         throw new Error(error.response.status);
      });
   },
   PUT_USER: function PUT_USER(_ref17, user) {
      var commit = _ref17.commit,
          state = _ref17.state;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USERS_URL + user.id + '/',
         headers: { "Authorization": 'JWT ' + state.authenticationData.token },
         data: user
      }).then(function (response) {
         commit('SET_USER', response.data);
         return response.data;
      });
   },
   DELETE_USER: function DELETE_USER(_ref18, userId) {
      var commit = _ref18.commit,
          state = _ref18.state;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USERS_URL + userId + '/',
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_USER', userId);
         return userId;
      });
   },


   // fetch coachedUserList associated to current (coach) user
   GET_COACHED_USERS: function GET_COACHED_USERS(_ref19) {
      var commit = _ref19.commit,
          state = _ref19.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].COACHED_USERS_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         commit('CREATE_OR_SET_EACH_USER', response.data);
         commit('SET_COACHED_USERS', response.data);
         return response.data;
      });
   },
   GET_USER_MESSAGES: function GET_USER_MESSAGES(_ref20, userId) {
      var commit = _ref20.commit,
          state = _ref20.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].MESSAGES_URL + '?user=' + userId,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         var userMessagesDict = { userId: userId, messages: response.data };
         commit('SET_USER_MESSAGES', userMessagesDict);
         return response.data;
      });
   },
   PUT_USER_MESSAGE: function PUT_USER_MESSAGE(_ref21, message) {
      var commit = _ref21.commit,
          state = _ref21.state;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].MESSAGES_URL + message.id + '/',
         headers: { "Authorization": 'JWT ' + state.authenticationData.token },
         data: message
      }).then(function (response) {
         commit('UPDATE_USER_MESSAGE', response.data);
         return response.data;
      });
   },
   POST_USER_MESSAGE: function POST_USER_MESSAGE(_ref22, message) {
      var commit = _ref22.commit,
          state = _ref22.state;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].MESSAGES_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token },
         data: message
      }).then(function (response) {
         commit('ADD_USER_MESSAGE', response.data);
         return response.data;
      });
   },
   COUNT_UNREAD_MESSAGES: function COUNT_UNREAD_MESSAGES(_ref23, userId) {
      var commit = _ref23.commit,
          state = _ref23.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].MESSAGES_URL + '?user=' + userId + '&visible_by=' + state.loggedUserId + '&unread_by=' + state.loggedUserId,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         var dict = { userId: userId, count: response.data.length };
         commit('SET_UNREAD_MESSAGES_COUNT', dict);
         return response.data.length;
      });
   },
   GET_USER_HISTORY_EVENTS: function GET_USER_HISTORY_EVENTS(_ref24, userId) {
      var commit = _ref24.commit,
          state = _ref24.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].HISTORY_EVENT_URL + '?user=' + userId,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         var userHistoryDict = { userId: userId, events: response.data };
         commit('SET_USER_HISTORY_EVENTS', userHistoryDict);
         return response.data;
      });
   },
   GET_TEAM_HISTORY_EVENTS: function GET_TEAM_HISTORY_EVENTS(_ref25, teamId) {
      var commit = _ref25.commit,
          state = _ref25.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].HISTORY_EVENT_URL + '?team=' + teamId,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         var teamHistoryDict = { teamId: teamId, events: response.data };
         commit('SET_TEAM_HISTORY_EVENTS', teamHistoryDict);
         return response.data;
      });
   },
   POST_HISTORY_EVENT: function POST_HISTORY_EVENT(_ref26, event) {
      var commit = _ref26.commit,
          state = _ref26.state;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].HISTORY_EVENT_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token },
         data: event
      }).then(function (response) {
         if (event.user) {
            commit('ADD_USER_HISTORY_EVENT', response.data);
         } else if (event.team) {
            commit('ADD_TEAM_HISTORY_EVENT', response.data);
         }
         return response.data;
      });
   },
   GET_USER_ATTRIBUTES: function GET_USER_ATTRIBUTES(_ref27, userId) {
      var commit = _ref27.commit,
          state = _ref27.state;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USER_ATTRIBUTES_URL + '?user=' + userId,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         var userAttributesDict = { userId: userId, attributes: response.data };
         commit('SET_USER_ATTRIBUTES', userAttributesDict);
         return response.data;
      });
   },
   GET_USER_ATTRIBUTE_DATED_VALUES: function GET_USER_ATTRIBUTE_DATED_VALUES(_ref28, _ref29) {
      var commit = _ref28.commit,
          state = _ref28.state;
      var userId = _ref29.userId,
          attributeId = _ref29.attributeId,
          start = _ref29.start,
          end = _ref29.end;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USER_ATTRIBUTE_DATED_VALUES_URL + '?user=' + userId + '&attribute=' + attributeId + '&start=' + start + '&end=' + end,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         var responseDict = { userId: userId, attributeId: attributeId, datedValues: response.data };
         commit('SET_USER_ATTRIBUTE_DATED_VALUES', responseDict);
         return response.data;
      });
   },
   POST_USER_ATTRIBUTE_DATED_VALUE: function POST_USER_ATTRIBUTE_DATED_VALUE(_ref30, datedValue) {
      var commit = _ref30.commit,
          state = _ref30.state;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USER_ATTRIBUTE_DATED_VALUES_URL,
         headers: { "Authorization": 'JWT ' + state.authenticationData.token },
         data: datedValue
      }).then(function (response) {
         commit('ADD_USER_ATTRIBUTE_DATED_VALUE', response.data);
         return response.data;
      });
   },
   DELETE_USER_ATTRIBUTE_DATED_VALUE: function DELETE_USER_ATTRIBUTE_DATED_VALUE(_ref31, datedValue) {
      var commit = _ref31.commit,
          state = _ref31.state;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].USER_ATTRIBUTE_DATED_VALUES_URL + datedValue.id + '/',
         headers: { "Authorization": 'JWT ' + state.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_USER_ATTRIBUTE_DATED_VALUE', datedValue);
      });
   }
};

var getters = {

   platform: function platform(state) {
      if (state.httpReferer) {
         if (state.httpReferer.indexOf('shdl') !== -1) {
            return 'shdl';
         } else {
            return 'nutrieduc';
         }
      } else {
         return null;
      }
   },

   // authenticated user
   loggedInUser: function loggedInUser(state) {
      return state.users[state.loggedUserId];
   },

   // roles of authenticated user
   loggedInUserRoles: function loggedInUserRoles(state, getters) {
      var roles = {};
      try {
         var roleIds = getters.loggedInUser.roles;
         for (var i = 0; i < roleIds.length; i++) {
            var roleId = roleIds[i];
            if (state.roles.hasOwnProperty(roleId)) {
               var role = state.roles[roleId];
               roles[role.uid] = role;
            }
         }
      } catch (e) {}
      return roles;
   },

   firstGroup: function firstGroup(state, getters) {
      if (state.loggedInUserId) {
         var roleIds = getters.loggedInUser.roles;
         return state.roles[roleIds[0]];
      } else {
         return undefined;
      }
   },

   loggedInUserRealms: function loggedInUserRealms(state, getters) {
      var realm_ids = [];
      for (var roleUid in getters.loggedInUserRoles) {
         var role = getters.loggedInUserRoles[roleUid];
         if (role.realm !== null && realm_ids.indexOf(role.realm) === -1) {
            realm_ids.push(role.realm);
         }
      }
      return realm_ids.map(function (realm_id) {
         return state.realms[realm_id];
      });
   },

   appParams: function appParams(state, getters) {
      if (getters.firstGroup) {
         return getters.firstGroup.params;
      } else {
         return {};
      }
   },

   // authorizations of authenticated user
   authorized: function authorized(state, getters) {
      var authorized = {};
      for (var roleUid in getters.loggedInUserRoles) {
         var role = getters.loggedInUserRoles[roleUid];
         for (var i = 0; i < role.authorizations.length; i++) {
            var activity = role.authorizations[i];
            if (!authorized.hasOwnProperty(activity.uid)) authorized[activity.uid] = activity;
         }
      }
      return authorized;
   },

   // list of authorization uid's
   authorizedList: function authorizedList(state, getters) {
      var list = [];
      for (var roleUid in getters.loggedInUserRoles) {
         var role = getters.loggedInUserRoles[roleUid];
         for (var i = 0; i < role.authorizations.length; i++) {
            var activity = role.authorizations[i];
            if (list.indexOf(activity.uid) === -1) list.push(activity.uid);
         }
      }
      return list;
   },

   // coached users of the (coach) authenticated user
   coachedUsers: function coachedUsers(state) {
      return state.user2coachedUserList.hasOwnProperty(state.loggedUserId) ? state.user2coachedUserList[state.loggedUserId].map(function (userId) {
         return state.users[userId];
      }) : [];
   }

};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
   //strict: process.env.NODE_ENV !== 'production',
   strict: true, // This makes the Vuex store strict
   state: state,
   modules: {
      confirmer: __WEBPACK_IMPORTED_MODULE_6__confirmer__["a" /* default */],
      teams: __WEBPACK_IMPORTED_MODULE_7__teams__["a" /* default */],
      meals: __WEBPACK_IMPORTED_MODULE_8__meals__["a" /* default */],
      nutrikiosk: __WEBPACK_IMPORTED_MODULE_9__nutrikiosk__["a" /* default */],
      shdl: __WEBPACK_IMPORTED_MODULE_10__shdl__["a" /* default */],
      craps: __WEBPACK_IMPORTED_MODULE_11__craps__["a" /* default */],
      surveys: __WEBPACK_IMPORTED_MODULE_12__surveys__["a" /* default */]
   },
   mutations: mutations,
   getters: getters,
   actions: actions,
   plugins: [vuexLocalStorage.plugin]
}));

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



function formatDate(date) {
   var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
   var then = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date);
   var daysDifference = now.diff(then, 'days');
   if (daysDifference < 7) {
      var daysNumberDifference = now.dayOfYear() - then.dayOfYear();
      if (daysNumberDifference < 1) {
         return 'Aujourd\'hui, ' + then.format('HH:mm');
      } else if (daysNumberDifference < 2) {
         return 'Hier, ' + then.format('HH:mm');
      } else {
         return then.format('dddd, HH:mm');
      }
   } else {
      return then.format('Do MMMM YYYY, HH:mm');
   }

   if (daysDifference < 1) {
      return 'Aujourd\'hui, ' + then.format('HH:mm');
   } else if (daysDifference < 2) {
      return 'Hier, ' + then.format('HH:mm');
   } else if (daysDifference < 7) {
      return then.format('dddd, HH:mm');
   } else {
      return then.format('Do MMMM YYYY, HH:mm');
   }
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({

   types: {
      truefalse: { uid: 'truefalse', name: "Vrai ou Faux ?", short: "vrai/faux", icon: 'extension' },
      intruder: { uid: 'intruder', name: "Trouvez l'intrus", short: "intrus", icon: 'cancel' },
      findadish: { uid: 'findadish', name: "Dans quoi y a-t-il ?", short: "dans quoi?", icon: 'search' }
   },
   typeList: ['truefalse', 'intruder', 'findadish'],

   levels: {
      easy: { uid: 'easy', name: "Facile", points: "1 point" },
      medium: { uid: 'medium', name: "Moyen", points: "2 points" },
      expert: { uid: 'expert', name: "Expert", points: "3 points" }
   },
   levelList: ['easy', 'medium', 'expert'],

   diabetes: {
      nodiabetes: { uid: 'nodiabetes', name: "Non diabétique", short: "Non" },
      type1: { uid: 'type1', name: "Type 1", short: "Type 1" },
      type2: { uid: 'type2', name: "Type 2", short: "Type 2" }
   },
   diabetesList: ['nodiabetes', 'type1', 'type2'],

   cholesterols: {
      no: { uid: 'no', name: "Non-hypercholestérolémique", short: "Non hyper" },
      yes: { uid: 'yes', name: "Hypercholestérolémique", short: "Hyper" }
   },
   cholesterolList: ['no', 'yes'],

   sssels: {
      noss: { uid: 'noss', name: "Pas de régime sans sel", short: "Non" },
      ss2g: { uid: 'ss2g', name: "Moins de 2g/j", short: "2g/j" },
      ss4g: { uid: 'ss4g', name: "Moins de 4g/j", short: "4g/j" },
      ss6g: { uid: 'ss6g', name: "Moins de 6g/j", short: "6g/j" }
   },
   ssselList: ['noss', 'ss2g', 'ss4g', 'ss6g']

});

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


var shdlSyntax = __webpack_require__(665);
var shdlSemantic = __webpack_require__(664);
var utilities = __webpack_require__(95);
var _ = __webpack_require__(13);

module.exports = function () {

   return {
      checkModule: checkModule
   };

   function isCircular(moduleName, name2module) {
      var toDevelop = [moduleName];
      while (toDevelop.length > 0) {
         var head = toDevelop[0];
         toDevelop.splice(0, 1);
         var submodule = name2module[head];
         if (submodule.submoduleNames.indexOf(moduleName) !== -1) {
            // circularity!
            return submodule.name;
         }
         toDevelop = toDevelop.concat(submodule.submoduleNames);
      }
      return false;
   }

   function checkModule(moduleName, name2module) {

      // peg parse of `module` and all its submodules
      var _shdlSyntax$pegParseD = shdlSyntax.pegParseDeep(moduleName, name2module),
          moduleList = _shdlSyntax$pegParseD.moduleList,
          pegError = _shdlSyntax$pegParseD.err;

      if (pegError) {
         return {
            err: {
               module: moduleName,
               message: pegError.message,
               location: pegError.location
            },
            moduleList: moduleList
         };
      }

      // add to each module a .submoduleNames attribute
      moduleList.forEach(function (module) {
         module.submoduleNames = module.structure.instances.reduce(function (accu, instance) {
            return instance.type === 'module_instance' && accu.indexOf(instance.name) === -1 ? accu.concat([instance.name]) : accu;
         }, []);
      });

      // check for circularities
      var circular = isCircular(moduleName, name2module);
      if (circular) {
         return {
            err: {
               module: moduleName,
               message: 'Circularity issue with module: \'' + circular + '\'',
               location: null
            },
            moduleList: moduleList
         };
      }

      // re-order moduleList, deepest modules first

      // start with leaves
      var orderedModuleNames = moduleList.filter(function (module) {
         return module.submoduleNames.length === 0;
      }).map(function (module) {
         return module.name;
      });
      moduleList = moduleList.filter(function (module) {
         return orderedModuleNames.indexOf(module.name) === -1;
      });
      // append to the end of orderedModuleNames the modules of moduleList for which all submodules are already in orderedModuleNames
      while (moduleList.length > 0) {
         moduleList.forEach(function (module) {
            if (module.submoduleNames.every(function (name) {
               return orderedModuleNames.indexOf(name) !== -1;
            })) {
               orderedModuleNames.push(module.name);
            }
         });
         var l = moduleList.length;
         moduleList = moduleList.filter(function (module) {
            return orderedModuleNames.indexOf(module.name) === -1;
         });
         if (moduleList.length === l) {
            // should never happen
            console.log("*** error when ordering modules");
            break;
         }
      }

      //console.log(orderedModuleNames)
      moduleList = orderedModuleNames.map(function (moduleName) {
         return name2module[moduleName];
      });

      // further syntax checking, using peg-parsed structure
      var syntaxError = shdlSyntax.checkStructure(moduleName, name2module);
      if (syntaxError) {
         return {
            err: {
               module: moduleName,
               message: syntaxError.message,
               location: syntaxError.location
            },
            moduleList: moduleList
         };
      }

      // extract equipotentials, starting with deepest submodules
      for (var i = 0; i < moduleList.length; i++) {
         var submodule = moduleList[i];
         //console.log('collecting', submodule)

         // create module.equipotentials, which is both an array (iterable) and a map: name -> equipotential index
         var instanceError = shdlSemantic.collectEquipotentials(submodule.name, name2module);
         if (instanceError) {
            return { err: instanceError, moduleList: moduleList };
         }
         // check or set the type of all equipotentials and parameters
         var typeError = shdlSemantic.checkIOStatus(submodule);
         if (typeError) {
            return {
               err: {
                  module: submodule.name,
                  message: typeError.message,
                  location: typeError.location
               },
               moduleList: moduleList
            };
         }
         // add usedBy attributes
         utilities.addUsedBy(submodule);
         // add isUnused attributes
         utilities.addUnused(submodule);
         //console.log(submodule.name, submodule.equipotentials)
      }

      //console.log('module', name2module[moduleName])

      // return all module list (module and submodules) in order for ShdlEditor to update their status
      return { err: null, moduleList: moduleList };
   }
}();

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-917d08d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1193),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58783348",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_css_all_css__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_css_all_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_css_all_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_typeface_roboto_index_css__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_typeface_roboto_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_typeface_roboto_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_css__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuelidate___default.a);





__WEBPACK_IMPORTED_MODULE_9_moment___default.a.locale('fr');

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_10__App___default.a }
});

/***/ }),
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmDialog_vue__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmDialog_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var axios = __webpack_require__(24);



/* harmony default export */ __webpack_exports__["default"] = ({
   components: {
      ConfirmDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmDialog_vue___default.a
   },
   data: function data() {
      return {
         currentTab: null,
         authorizedDefined: false,
         shrink: false,
         interval: null,
         invitationDialog: false,
         valid: false,
         email: '',
         emailRules: [function (v) {
            return !!v || "L'e-mail est obligatoire";
         }, function (v) {
            return (/^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/.test(v) || "l'email doit être valide"
            );
         }]
      };
   },

   computed: {
      // 'nutrieduc', 'shdl'
      platform: function platform() {
         return this.$store.getters.platform;
      },
      title: function title() {
         if (this.isAuthenticated) {
            return this.$store.getters.loggedInUserRealms.map(function (realm) {
               return realm.params.style.title;
            }).join(' - ');
         } else {
            if (this.platform === 'shdl') {
               return "Simple Hardware Description Language";
            } else {
               return "Diabétologie, Nutrition et Hygiène de vie";
            }
         }
      },
      isWaiting: function isWaiting() {
         return this.$store.state.waiting;
      },

      snackbar: {
         get: function get() {
            return this.$store.state.snackbar;
         },
         set: function set(newValue) {
            this.$store.commit('SNACKBAR_SET', newValue);
         }
      },
      snackbarOptions: function snackbarOptions() {
         return this.$store.state.snackbarOptions;
      },
      loggedInUser: function loggedInUser() {
         return this.$store.getters.loggedInUser;
      },
      authorized: function authorized() {
         return this.$store.getters.authorized;
      },
      authorizedActivities: function authorizedActivities() {
         var _this = this;

         return this.$store.getters.authorizedList.map(function (uid) {
            return _this.authorized[uid];
         });
      },
      loggedInUserRealms: function loggedInUserRealms() {
         return this.$store.getters.loggedInUserRealms;
      },
      mainColor: function mainColor() {
         var color = 'brown darken-1';
         if (this.loggedInUserRealms && this.loggedInUserRealms.length >= 0) {
            var firstRealm = this.loggedInUserRealms[0];
            if (firstRealm && firstRealm.params && firstRealm.params.style) {
               color = firstRealm.params.style.mainColor;
            }
         }
         return color;
      },
      isAuthenticated: function isAuthenticated() {
         return this.$store.state.authenticationData;
      },
      loggedInUserDescription: function loggedInUserDescription() {
         if (this.loggedInUser) {
            if (this.loggedInUser.first_name + this.loggedInUser.last_name) {
               return this.loggedInUser.first_name + ' ' + this.loggedInUser.last_name;
            } else if (this.loggedInUser.extra.fullname) {
               return this.loggedInUser.extra.fullname;
            } else {
               return this.loggedInUser.username;
            }
         } else {
            return '';
         }
      },
      isToolbarVisible: function isToolbarVisible() {
         if (this.$route.path === "/activate-user") return false;
         if (this.$route.path === "/login") return false;
         if (this.$route.path === "/accept-invitation") return false;
         if (this.$route.path === "/fitbit-authorized") return false;
         if (this.$route.path === "/salutance-news") return false;
         if (this.$route.path === "/nutrikiosk") return false;
         return true;
      },
      unreadMessageCount: function unreadMessageCount() {
         return this.$store.state.user2unreadMessageCount[this.loggedInUser.id];
      }
   },

   methods: {
      home: function home() {
         this.$router.push('/');
      },
      isMemberOf: function isMemberOf(groupUid) {
         try {
            return this.loggedInUser.group_uids.indexOf(groupUid) !== -1;
         } catch (err) {
            return false;
         }
      },
      login: function login() {
         this.$router.push('/login');
      },
      logout: function logout() {
         // go to logout screen
         this.$router.push('/logout');
      },


      // called after Login component has found the route to go to
      onLogin: function onLogin(url) {
         //console.log('onLogin')
         this.$router.push(url);

         // count unread message to update badge reactively
         this.$store.dispatch('COUNT_UNREAD_MESSAGES', this.loggedInUser.id);

         /*
         // setup a timer to check authentication status regularly after having been logged
         let self = this
         this.interval = setInterval(function () {
            self.$store.commit('UPDATE_AUTHENTICATION_STATUS')
            if (!self.isAuthenticated) {
               self.onLogout()
            }
         }, 180000)
         */
      },
      onLogout: function onLogout() {
         //console.log('onLogout')
         clearInterval(this.interval);
         this.interval = null; // necessary - why ?
      },
      clearInvitationForm: function clearInvitationForm() {
         this.email = '';
      },
      inviteCoach: function inviteCoach() {
         var _this2 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var authData;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        authData = _this2.$store.state.authenticationData;

                        _this2.$store.commit('WAITING', true);
                        _context.prev = 2;
                        _context.next = 5;
                        return axios({
                           method: 'post',
                           url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].INVITE_CAREGIVER_URL,
                           headers: { "Authorization": 'JWT ' + authData.token },
                           data: { user_id: _this2.loggedInUser.id, coach_email: _this2.email }
                        });

                     case 5:
                        _this2.$emit('snackbar', {
                           timeout: 3500,
                           text: 'Un mail d\'invitation vient d\'\xEAtre envoy\xE9 \xE0 ' + _this2.email,
                           color: 'green'
                        });
                        _context.next = 11;
                        break;

                     case 8:
                        _context.prev = 8;
                        _context.t0 = _context['catch'](2);

                        _this2.$emit('snackbar', {
                           timeout: 3500,
                           text: 'Une erreur s\'est produite lors de l\'envoi du mail d\'invitation',
                           color: 'red'
                        });

                     case 11:
                        _context.prev = 11;

                        _this2.$store.commit('WAITING', false);
                        return _context.finish(11);

                     case 14:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, _this2, [[2, 8, 11, 14]]);
         }))();
      }
   },

   mounted: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
               switch (_context2.prev = _context2.next) {
                  case 0:
                     // print node env (see client/src/config/index.js)
                     console.log('process.env.NODE_ENV =', "production");
                     // start shrinking background image
                     this.shrink = true;
                     // store app height in state
                     this.$store.commit('SET_APP_HEIGHT', this.$refs.app.clientHeight);
                     // get HTTP_REFERER: unlocks computed properties 'platform' & 'title'
                     _context2.next = 5;
                     return this.$store.dispatch('GET_HTTP_REFERER');

                  case 5:
                     console.log('httpReferer', this.$store.state.httpReferer);
                     // reset state
                     this.$store.commit('RESET_STATE');

                  case 7:
                  case 'end':
                     return _context2.stop();
               }
            }
         }, _callee2, this);
      }));

      function mounted() {
         return _ref.apply(this, arguments);
      }

      return mounted;
   }()
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      realm: String,
      items: Array,
      baseRoute: String
   },

   mounted: function mounted() {
      // used for selecting user in cousin user list
      this.$emit('userIdChanged', this.userId);
   },


   updated: function updated() {
      // used for selecting user in cousin user list
      this.$emit('userIdChanged', this.userId);
   },

   data: function data() {
      return {
         drawer: true,
         clipped: false,
         activeItem: null
      };
   },


   computed: {
      user: function user() {
         return this.$store.state.users[this.userId];
      },
      unreadMessageCount: function unreadMessageCount() {
         return this.$store.state.user2unreadMessageCount[this.userId];
      }
   }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_users_UserList__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_users_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_users_UserList__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import _ from 'lodash'
var axios = __webpack_require__(24);



/* harmony default export */ __webpack_exports__["default"] = ({

   components: {
      UserList: __WEBPACK_IMPORTED_MODULE_3__components_users_UserList___default.a
   },

   props: {
      title: String,
      baseRoute: String
   },

   mounted: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
         var self;
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     _context.next = 2;
                     return this.$store.dispatch('GET_COACHED_USERS');

                  case 2:
                     self = this;

                     this.$store.getters.coachedUsers.forEach(function (user) {
                        self.$store.dispatch('COUNT_UNREAD_MESSAGES', user.id);
                     });

                  case 4:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function mounted() {
         return _ref.apply(this, arguments);
      }

      return mounted;
   }(),

   data: function data() {
      return {
         selectedUserId: null,
         addUserDialog: false,
         userToAddId: null,
         valid: false,
         items: [],
         search: null,
         select: [],
         loading: false
      };
   },


   computed: {
      listCss: function listCss() {
         //return { xs12: true, sm2: this.selectedUserId, sm4: !this.selectedUserId }
         return { xs12: true, sm3: true };
      },
      detailCss: function detailCss() {
         //return { xs12: true, sm10: this.selectedUserId, sm8: !this.selectedUserId }
         return { xs12: true, sm9: true };
      },


      coachedUsers: function coachedUsers() {
         return this.$store.getters.coachedUsers;
      }
   },

   watch: {
      search: function search(val) {
         val && this.querySelections(val);
      }
   },

   methods: {
      userIdChanged: function userIdChanged(userId) {
         this.selectedUserId = userId;
      },
      userSelected: function userSelected(userId) {
         // fetch user's profile
         this.$store.dispatch('GET_USER', userId);
         // change route
         this.$router.push(this.baseRoute + userId);
      },
      userMealsUpdated: function userMealsUpdated(userId) {
         console.log('selectedUserId', this.selectedUserId);
         this.selectedUserId = userId;
      },


      // add `userToAddId` to the list of users coached by `loggedInUser`
      addUser: function () {
         var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var user, userCopy;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return this.$store.dispatch('GET_USER', this.userToAddId);

                     case 3:
                        user = _context2.sent;

                        if (!(user.coaches.indexOf(this.$store.state.loggedUserId) === -1)) {
                           _context2.next = 12;
                           break;
                        }

                        // logged-in user is not in the list of coaches of `user` : adds it
                        // we use a copy to not update vuex state directly
                        userCopy = _.cloneDeep(user);

                        userCopy.coaches.push(this.$store.state.loggedUserId);
                        // update user's record
                        _context2.next = 9;
                        return this.$store.dispatch('PUT_USER', userCopy);

                     case 9:
                        // ask again the user list: reactivity will update list view
                        this.$store.dispatch('GET_COACHED_USERS');
                        _context2.next = 13;
                        break;

                     case 12:
                        this.$store.commit('SNACKBAR', { timeout: 2500, text: "Cet utilisateur est déjà dans la liste", color: 'red' });

                     case 13:
                        _context2.next = 18;
                        break;

                     case 15:
                        _context2.prev = 15;
                        _context2.t0 = _context2['catch'](0);

                        this.$store.commit('SNACKBAR', { timeout: 2500, text: "Erreur inconnue lors de l'ajout", color: 'red' });

                     case 18:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, this, [[0, 15]]);
         }));

         function addUser() {
            return _ref2.apply(this, arguments);
         }

         return addUser;
      }(),

      deleteUser: function () {
         var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(userId) {
            var user, index, userCopy;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return this.$store.dispatch('GET_USER', userId);

                     case 3:
                        user = _context3.sent;

                        // delete logged user caregiver to the list of doctors of `user`
                        index = user.coaches.indexOf(this.$store.state.loggedUserId);
                        // we use a copy to not update vuex state directly

                        userCopy = _.cloneDeep(user);

                        userCopy.coaches.splice(index, 1);
                        // update user's record
                        _context3.next = 9;
                        return this.$store.dispatch('PUT_USER', userCopy);

                     case 9:
                        // ask again the user list: reactivity will update list view
                        this.$store.dispatch('GET_COACHED_USERS');
                        _context3.next = 15;
                        break;

                     case 12:
                        _context3.prev = 12;
                        _context3.t0 = _context3['catch'](0);

                        console.log(_context3.t0);

                     case 15:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, this, [[0, 12]]);
         }));

         function deleteUser(_x) {
            return _ref3.apply(this, arguments);
         }

         return deleteUser;
      }(),

      querySelections: function querySelections(text) {
         var _this = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var authData, response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
               while (1) {
                  switch (_context4.prev = _context4.next) {
                     case 0:
                        authData = _this.$store.state.authenticationData;
                        _context4.next = 3;
                        return axios({
                           method: 'get',
                           url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].USERS_URL + '?search=' + text,
                           headers: { "Authorization": 'JWT ' + authData.token }
                        });

                     case 3:
                        response = _context4.sent;

                        _this.items = response.data;

                     case 5:
                     case 'end':
                        return _context4.stop();
                  }
               }
            }, _callee4, _this);
         }))();
      }
   }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//

// adapted from https://www.npmjs.com/package/vue-codemirror-lite

var CodeMirror = __webpack_require__(102);
/*require('codemirror/lib/codemirror.css')
require('codemirror/addon/selection/active-line.js')
require('codemirror/addon/mode/simple.js')*/

/* harmony default export */ __webpack_exports__["default"] = ({
   props: {
      value: String,
      selectedline: Number,
      styleactiveline: Boolean,
      options: {
         type: Object,
         default: function _default() {
            return {
               styleActiveLine: true,
               lineNumbers: true,
               lineWrapping: true,
               tabSize: 3,
               //styleSelectedText: true,
               firstLineNumber: 1
            };
         }
      }
   },
   created: function created() {
      // adapted from https://github.com/codemirror/CodeMirror/blob/master/demo/simplemode.html
      CodeMirror.defineSimpleMode("simplemode", {
         // The start state contains the rules that are intially used
         start: [
         // The regex matches the token, the token property contains the type
         //{regex: /"(?:[^\\]|\\.)*?(?:"|$)/, token: "string"},
         // You can match multiple tokens at once. Note that the captured
         // groups must span the whole string in this case
         //{regex: /(function)(\s+)([a-z$][\w$]*)/, token: ["keyword", null, "variable-2"]},
         // Rules are matched in the order in which they appear, so there is
         // no ambiguity between this one and the one above
         //{regex: /(?:function|var|return|if|for|while|else|do|this)\b/, token: "keyword"},

         { regex: /(?:word|org)\b/, token: "keyword" }, { regex: /(?:clr|mov|dec|deccc|inc|inccc|set|setq|cmp|tst|negcc|nop|call|rcall|ret|push|pop)\b/, token: "keyword" }, { regex: /(?:add|addcc|sub|subcc|xor|xorcc|or|orcc|and|andcc|umulcc|ld|reti|slr|sll|st|sethi|ba|beq|be|bz|bne|bnz|bneg|bn|bpos|bnn|bcs|blu|bcc|bgeu|bvs|bvc|bg|bgt|bge|bl|blt|ble|bgu|bleu)\b/, token: "keyword" }, { regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i, token: "number" }, { regex: /\/\/.*/, token: "comment" },
         //{regex: /\/(?:[^\\]|\\.)*?\//, token: "variable-3"},
         // A next property will cause the mode to move to a different state
         { regex: /\/\*/, token: "comment", next: "comment" }, { regex: /[-+/*=<>!]+/, token: "operator" }],
         // The multi-line comment state.
         comment: [{ regex: /.*?\*\//, token: "comment", next: "start" }, { regex: /.*/, token: "comment" }],
         // The meta property contains global information about the mode. It
         // can contain properties like lineComment, which are supported by
         // all modes, and also directives like dontIndentStates, which are
         // specific to simple modes.
         meta: {
            dontIndentStates: ["comment"],
            lineComment: "//"
         }

      });
   },
   mounted: function mounted() {
      var self = this;
      this.editor = CodeMirror.fromTextArea(this.$el, this.options);
      this.editor.setValue(this.value);
      this.editor.setOption('styleActiveLine', this.styleactiveline);
      this.editor.on('change', function (cm) {
         if (self.$emit) {
            self.$emit('change', cm.getValue());
            self.$emit('input', cm.getValue());
         }
      });

      this.editor.setOption('mode', 'simplemode');

      // handling of 'Tab' key
      this.editor.setOption("extraKeys", {
         Tab: function Tab(cm) {
            var spaces = Array(cm.getOption("indentUnit") + 1).join(" ");
            //console.log('cm.getSelection()', cm.getSelection())
            cm.replaceSelection(spaces);
         }
      });
   },
   watch: {
      'value': function value(newVal, oldVal) {
         var editorValue = this.editor.getValue();
         if (newVal !== editorValue) {
            this.editor.removeLineClass(oldVal, "background", "styled-background");
            var scrollInfo = this.editor.getScrollInfo();
            this.editor.setValue(newVal);
            this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
         }
      },
      'selectedline': function selectedline(newVal, oldVal) {
         if (typeof oldVal === 'number') this.editor.removeLineClass(oldVal, "background", "styled-background");
         if (typeof newVal === 'number') this.editor.addLineClass(newVal, "background", "styled-background");
      },
      'styleactiveline': function styleactiveline(newVal, oldVal) {
         this.editor.setOption('styleActiveLine', newVal);
      },
      'options': function options(newOptions, oldVal) {
         if ((typeof newOptions === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(newOptions)) === 'object') {
            for (var optionName in newOptions) {
               if (newOptions.hasOwnProperty(optionName)) {
                  this.editor.setOption(optionName, newOptions[optionName]);
               }
            }
         }
      }
   },
   beforeDestroy: function beforeDestroy() {
      if (this.editor) {
         this.editor.toTextArea();
      }
   }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__craps_doc_txt__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__craps_doc_txt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__craps_doc_txt__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
   computed: {
      compiledMarkdown: function compiledMarkdown() {
         return __WEBPACK_IMPORTED_MODULE_0_marked___default()(__WEBPACK_IMPORTED_MODULE_1__craps_doc_txt___default.a, { sanitize: true });
      }
   }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_craps_CrapsCodeMirror__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_craps_CrapsCodeMirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_craps_CrapsCodeMirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_craps_crapsChecker_js__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_craps_crapsChecker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utilities_craps_crapsChecker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* Voir Pegjs.org pour un Codemirror ajusté à la taille de l'écran :
function doLayout() {
    $("#left-column").height("0px");    // needed for IE
    $("#right-column").height("0px");   // needed for IE
    $(".CodeMirror").height("0px");
    $("#input").height("0px");

    $("#left-column").height(($("#left-column").parent().innerHeight() - 2) + "px");     // needed for IE
    $("#right-column").height(($("#right-column").parent().innerHeight() - 2) + "px");   // needed for IE
    $(".CodeMirror").height(($(".CodeMirror").parent().parent().innerHeight() - 14) + "px");
    $("#input").height(($("#input").parent().parent().innerHeight() - 14) + "px");
  }
*/






/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      module: Object
   },

   components: {
      CrapsCodeMirror: __WEBPACK_IMPORTED_MODULE_1__components_craps_CrapsCodeMirror___default.a
   },

   data: function data() {
      return {
         moduleCopy: { text: '' },
         selectedline: 0,
         styleactiveline: null,
         errorMsg: null,
         footerMsg: null
      };
   },


   mounted: function mounted() {
      // we work with a copy of the Vuex object, which cannot be changed directly
      this.moduleCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.craps.modules[this.module.id]);
      this.parseModule();
      // set editor height dynamically
      var element = this.$refs.editor.$el.parentElement;
      element.style.height = this.$store.state.appHeight - 233 + 'px';
   },

   beforeDestroy: function beforeDestroy() {
      console.log('beforeDestroy...');
      this.saveCurrentIfModified();
   },

   watch: {
      'module.id': function moduleId(newVal, oldVal) {
         //console.log('module.id changed from/to', oldVal, newVal)
         if (newVal) {
            // newVal is not undefined (happens when deleting a module)
            // previous module is still this.moduleCopy
            this.saveCurrentIfModified();
            // we work with a copy of the Vuex object, which cannot be changed directly
            // the change of moduleCopy.text will trigger a 'codeChanged' event
            this.moduleCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.craps.modules[newVal]);
         }
      }
   },

   computed: {
      userOrTeamModuleIds: function userOrTeamModuleIds() {
         return this.module.user ? this.$store.state.craps.user2moduleList[this.module.user] : this.$store.state.craps.team2moduleList[this.module.team];
      },
      isOk: function isOk() {
         return this.errorMsg === null;
      }
   },

   methods: {
      testHeight: function testHeight() {
         var element = this.$refs.editor.$el.parentElement;
         console.log(element.style);
         element.style.height = '550px';
      },
      save: function save(module) {
         console.log('saving', module.name);
         module.update_author = this.$store.state.loggedUserId;
         try {
            return this.$store.dispatch('craps/PUT_CRAPS_MODULE', module);
         } catch (e) {
            this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'enregistrement", color: 'red' });
         }
      },
      saveCurrentIfModified: function saveCurrentIfModified() {
         var vuexModule = this.$store.state.craps.modules[this.moduleCopy.id];
         if (vuexModule && vuexModule.text != this.moduleCopy.text) {
            this.save(this.moduleCopy);
         }
      },


      // triggered when user edits text, or when this.module.id is changed
      codeChanged: function codeChanged(text) {
         //console.log("code changed")
         this.moduleCopy.text = text;
         this.parseModuleDebounced();
         this.autoSaveProgram();
      },


      parseModule: function parseModule() {
         var errorMsg = void 0,
             lines = void 0,
             symbols = void 0,
             memory = void 0;

         var _checkModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utilities_craps_crapsChecker_js__["checkModule"])(this.moduleCopy);

         errorMsg = _checkModule.errorMsg;
         lines = _checkModule.lines;
         symbols = _checkModule.symbols;
         memory = _checkModule.memory;

         if (errorMsg) {
            this.errorMsg = errorMsg;
            this.footerMsg = errorMsg;
         } else {
            this.errorMsg = null;
            this.footerMsg = "Program OK";
         }
         console.log('memory', memory, 'symbols', symbols);

         // commit checking info in Vuex (even in error, to update isOK)
         this.$store.commit('craps/UPDATE_MODULE_PARSE_INFO', {
            moduleId: this.moduleCopy.id,
            memory: memory,
            symbols: symbols,
            isOk: this.isOk
         });

         this.$forceUpdate();
      },

      parseModuleDebounced: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
         this.parseModule();
      }, 500),

      // note the use of lodash's debounce function to prevent immediate and too frequent saving
      autoSaveProgram: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
         this.saveCurrentIfModified();
      }, 3000)
   }

});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//


var CodeMirror = __webpack_require__(102);
var binutils = __webpack_require__(93);

function makeMarker() {
   var marker = document.createElement("div");
   marker.style.color = "#822";
   marker.innerHTML = "●";
   return marker;
}

/* harmony default export */ __webpack_exports__["default"] = ({
   props: {
      title: String,
      memorydict: Object,
      currentaddress: Number,
      breakpoints: Array,
      versionNo: Number // change it when view needs refresh
   },

   data: function data() {
      return {
         editor: null,
         textContent: '',
         options: {
            styleActiveLine: true,
            lineNumbers: false,
            firstLineNumber: 1,
            lineWrapping: false,
            readOnly: true,
            gutter: true,
            fixedGutter: true,
            gutters: ["breakpoints"]
         },
         selectedline: -1,
         breakpointsOldVal: []
      };
   },


   created: function created() {
      // adapted from https://github.com/codemirror/CodeMirror/blob/master/demo/simplemode.html
      CodeMirror.defineSimpleMode("simplemode", {
         // The start state contains the rules that are intially used
         start: [
         // The regex matches the token, the token property contains the type
         //{regex: /"(?:[^\\]|\\.)*?(?:"|$)/, token: "string"},
         // You can match multiple tokens at once. Note that the captured
         // groups must span the whole string in this case
         //{regex: /(function)(\s+)([a-z$][\w$]*)/, token: ["keyword", null, "variable-2"]},
         // Rules are matched in the order in which they appear, so there is
         // no ambiguity between this one and the one above
         //{regex: /(?:function|var|return|if|for|while|else|do|this)\b/, token: "keyword"},

         { regex: /(?:word|org)\b/, token: "keyword" }, { regex: /(?:clr|mov|dec|deccc|inc|inccc|set|setq|cmp|tst|negcc|nop|call|rcall|ret|push|pop)\b/, token: "keyword" }, { regex: /(?:add|addcc|sub|subcc|xor|xorcc|or|orcc|and|andcc|umulcc|ld|st|sethi|ba|beq|be|bz|bne|bnz|bneg|bn|bpos|bnn|bcs|blu|bcc|bgeu|bvs|bvc|bg|bgt|bge|bl|blt|ble|bgu|bleu)\b/, token: "keyword" }, { regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i, token: "number" }, { regex: /\/\/.*/, token: "comment" },
         //{regex: /\/(?:[^\\]|\\.)*?\//, token: "variable-3"},
         // A next property will cause the mode to move to a different state
         { regex: /\/\*/, token: "comment", next: "comment" }, { regex: /[-+/*=<>!]+/, token: "operator" }],
         // The multi-line comment state.
         comment: [{ regex: /.*?\*\//, token: "comment", next: "start" }, { regex: /.*/, token: "comment" }],
         // The meta property contains global information about the mode. It
         // can contain properties like lineComment, which are supported by
         // all modes, and also directives like dontIndentStates, which are
         // specific to simple modes.
         meta: {
            dontIndentStates: ["comment"],
            lineComment: "//"
         }

      });
   },

   mounted: function mounted() {
      var self = this;
      this.editor = CodeMirror.fromTextArea(this.$el, this.options);
      this.editor.setOption('styleActiveLine', this.styleactiveline);
      this.editor.setValue(this.textContent);
      this.editor.on('gutterClick', function (cm, n) {
         var info = cm.lineInfo(n);
         //cm.setGutterMarker(n, "breakpoints", info.gutterMarkers ? null : makeMarker());
         self.$emit('breakpoint', info.line + 1, info.gutterMarkers ? false : true);
      });
      this.editor.setOption('mode', 'simplemode');
   },

   methods: {
      formatMemoryValue: function formatMemoryValue(bin32str) {
         return binutils.bin32ToHex8(bin32str);
      },
      formatAddress: function formatAddress(address) {
         return binutils.unsignedToHex8(address);
      },

      getTextContent: function getTextContent() {
         var lineno = 0;
         var address2line = this.memorydict;
         var result = '';
         var previousAddress = void 0;
         for (var addressKey in address2line) {
            var line = address2line[addressKey];
            var address = parseInt(addressKey);
            line.address = address;
            if (result.length > 0 && address > previousAddress + 1) {
               result += '---\n';
               lineno++;
            }
            line.lineno = lineno++;
            var formattedAddress = this.formatAddress(address);
            var formattedValue = this.formatMemoryValue(line.value);
            var label = line.label ? line.label + ':' : '';
            var text = line.instruction ? line.instruction.text : line.synthetic ? line.synthetic.text : '';
            result += formattedAddress + ' : ' + formattedValue + ' ' + __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.padStart(label, 10, ' ') + '  ' + text + '\n';
            previousAddress = address;
         }
         return result;
      }
   },
   watch: {
      'currentaddress': function currentaddress(newVal, oldVal) {
         var line = this.memorydict[newVal];
         // hack: line.lineno is undefined initially (? why)
         this.selectedline = typeof line.lineno === 'undefined' ? 0 : line.lineno;
      },
      versionNo: function versionNo(newVal, oldVal) {
         this.textContent = this.getTextContent();
      },

      'textContent': function textContent(newVal, oldVal) {
         var editorValue = this.editor.getValue();
         if (newVal !== editorValue) {
            this.editor.removeLineClass(oldVal, "background", "styled-background");
            var scrollInfo = this.editor.getScrollInfo();
            this.editor.setValue(newVal);
            this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
         }
      },
      'selectedline': function selectedline(newVal, oldVal) {
         if (typeof oldVal === 'number') this.editor.removeLineClass(oldVal, "background", "styled-background");
         if (typeof newVal === 'number') this.editor.addLineClass(newVal, "background", "styled-background");
      },
      'styleactiveline': function styleactiveline(newVal, oldVal) {
         this.editor.setOption('styleActiveLine', newVal);
      },
      'options': function options(newOptions, oldVal) {
         if ((typeof newOptions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(newOptions)) === 'object') {
            for (var optionName in newOptions) {
               if (newOptions.hasOwnProperty(optionName)) {
                  this.editor.setOption(optionName, newOptions[optionName]);
               }
            }
         }
      },
      'breakpoints': function breakpoints(newVal, oldVal) {
         //?? oldVal uncorrect, supply it with breakpointsOldVal
         var self = this;
         this.breakpointsOldVal.forEach(function (breakAddress) {
            var lineno = self.memorydict[breakAddress].lineno;
            self.editor.removeLineClass(lineno, "color", "breakpoint-background");
         });
         newVal.forEach(function (breakAddress) {
            var lineno = self.memorydict[breakAddress].lineno;
            self.editor.addLineClass(lineno, "color", "breakpoint-background");
         });
         this.breakpointsOldVal = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(newVal);
      }
   },

   beforeDestroy: function beforeDestroy() {
      if (this.editor) {
         this.editor.toTextArea();
      }
   }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      moduleId: Number,
      baseRoute: String
   },

   data: function data() {
      return {
         currentTab: null
      };
   },


   computed: {
      parseInfo: function parseInfo() {
         return this.$store.state.craps.module2parseInfo[this.moduleId];
      },
      appParams: function appParams() {
         return this.$store.getters.appParams;
      }
   },

   mounted: function mounted() {
      this.$emit('userModuleUpdated', this.moduleId);
   },

   updated: function updated() {
      this.$emit('userModuleUpdated', this.moduleId);
   },

   methods: {}
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      user: Object,
      teams: Array,
      selectedModuleId: Number
   },

   data: function data() {
      return {
         addDialog: false,
         lockDialog: false,
         deleteDialog: false,
         moduleToDelete: {},
         moduleToLock: {},
         moduleToAddName: null,
         moduleToAddType: 'personal',
         moduleToAddTeam: null,
         moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a
      };
   },


   computed: {
      userModules: function userModules() {
         var _this = this;

         return this.$store.state.craps.user2moduleList.hasOwnProperty(this.user.id) ? this.$store.state.craps.user2moduleList[this.user.id].map(function (moduleId) {
            return _this.$store.state.craps.modules[moduleId];
         }) : [];
      },
      teamModulesDict: function teamModulesDict() {
         var dict = {};
         var self = this;
         this.teams.forEach(function (team) {
            if (self.$store.state.craps.team2moduleList.hasOwnProperty(team.id)) {
               dict[team.id] = self.$store.state.craps.team2moduleList[team.id].map(function (moduleId) {
                  return self.$store.state.craps.modules[moduleId];
               });
            }
         });
         return dict;
      },
      formValid: function formValid() {
         if (this.$v.moduleToAddName.$error) return false;
         if (this.moduleToAddType === 'team' && this.moduleToAddTeam === null) return false;
         return true;
      },
      nameErrors: function nameErrors() {
         var errors = [];
         if (!this.$v.moduleToAddName.$dirty) return errors;
         !this.$v.moduleToAddName.required && errors.push("Le nom est obligatoire");
         return errors;
      }
   },

   methods: {
      clone: function clone(module) {
         return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(module);
      },
      sorted: function sorted(moduleList) {
         return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(moduleList, [function (o) {
            return o.name;
         }]);
      },
      selectModule: function selectModule(moduleId) {
         this.$emit('moduleSelected', moduleId);
      },
      addModule: function addModule() {
         this.$emit('addModule', this.moduleToAddName, this.moduleToAddType === 'personal' ? null : this.moduleToAddTeam);
      },
      deleteModule: function deleteModule(module) {
         this.$emit('deleteModule', module);
      },
      lockModule: function lockModule(module) {
         this.$emit('lockModule', module);
      },
      parseInfo: function parseInfo(module) {
         return this.$store.state.craps.module2parseInfo[module.id];
      },
      isModuleOk: function isModuleOk(module) {
         if (this.$store.state.craps.module2parseInfo.hasOwnProperty(module.id)) {
            var parseInfo = this.$store.state.craps.module2parseInfo[module.id];
            return parseInfo.isOk;
         } else {
            return null;
         }
      },
      teamDescription: function teamDescription(teamId) {
         var team = this.$store.state.teams.teams[teamId];
         var self = this;
         var memberNames = team.members.map(function (userId) {
            var user = self.$store.state.users[userId];
            return user ? user.last_name : '--';
         });
         return team.name + ' (' + memberNames.join(', ') + ')';
      },
      iconName: function iconName(module) {
         var isOk = this.isModuleOk(module);
         if (isOk === null) {
            return 'more_horiz';
         } else if (isOk) {
            return 'check_circle';
         } else {
            return 'error_outline';
         }
      },
      iconColor: function iconColor(module) {
         var isOk = this.isModuleOk(module);
         if (isOk === null) {
            return 'gray';
         } else if (isOk) {
            return 'green';
         } else {
            return 'pink';
         }
      }
   },

   validations: {
      moduleToAddName: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] }
   }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_craps_CrapsCodeMirror__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_craps_CrapsCodeMirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_craps_CrapsCodeMirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var binutils = __webpack_require__(93);

/* harmony default export */ __webpack_exports__["default"] = ({
   components: {
      CodeMirror: __WEBPACK_IMPORTED_MODULE_0__components_craps_CrapsCodeMirror___default.a
   },
   props: {
      title: String,
      registerValues: Array
   },
   data: function data() {
      return {
         editorOptions: {
            mode: "text/BIDON",
            lineWrapping: false,
            readOnly: true,
            tabSize: 3,
            lineNumbers: false,
            firstLineNumber: 0
         },
         textContent: '',
         bases: ['binary', 'hexadecimal', 'signed decimal', 'unsigned decimal'],
         base: 'hexadecimal'
      };
   },

   methods: {
      update: function update() {
         var result = '';
         var base = this.base;
         this.registerValues.forEach(function (bin32value, index) {
            var value = void 0;
            if (base === 'binary') {
               value = bin32value;
            } else if (base === 'hexadecimal') {
               value = binutils.bin32ToHex8(bin32value);
            } else if (base === 'signed decimal') {
               value = binutils.bin32ToSigned(bin32value);
            } else if (base === 'unsigned decimal') {
               value = binutils.bin32ToUnsigned(bin32value);
            }
            result += __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.padStart('%r' + index, 5, ' ') + ' ' + value + '\n';
         });
         this.textContent = result;
      }
   },
   watch: {
      'registerValues': function registerValues(newVal, oldVal) {
         this.update();
      }
   }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_craps_CrapsMemoryEditor__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_craps_CrapsMemoryEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_craps_CrapsMemoryEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_craps_CrapsRegistersEditor__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_craps_CrapsRegistersEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_craps_CrapsRegistersEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_craps_CrapsCodeMirror__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_craps_CrapsCodeMirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_craps_CrapsCodeMirror__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var binutils = __webpack_require__(93);

function sleep(ms) {
   return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      return setTimeout(resolve, ms);
   });
}

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      moduleId: Number
   },

   components: {
      CrapsMemoryEditor: __WEBPACK_IMPORTED_MODULE_5__components_craps_CrapsMemoryEditor___default.a, CrapsRegistersEditor: __WEBPACK_IMPORTED_MODULE_6__components_craps_CrapsRegistersEditor___default.a, CodeMirror: __WEBPACK_IMPORTED_MODULE_7__components_craps_CrapsCodeMirror___default.a
   },

   data: function data() {
      return {
         // À FAIRE: SUPPRIMER currentAddress QUI FAIT DOUBLE-EMPLOI AVEC registerValues[30]
         currentAddress: -1,
         memoryDict: null,
         registerValues: [],
         flagArray: [],
         switches: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
         leds: [],

         showIO: true,
         errorMsg: null,
         stop: true,
         cycleCount: 0,
         versionNo: 0,

         itFlipFlop: 0,

         breakpoints: []
      };
   },


   computed: {
      module: function module() {
         return this.$store.state.craps.modules[this.moduleId];
      },
      parseInfo: function parseInfo() {
         return this.$store.state.craps.module2parseInfo[this.moduleId];
      },
      inError: function inError() {
         return this.errorMsg !== null;
      }
   },

   mounted: function mounted() {
      this.reset();
   },


   methods: {
      onBreakpointChange: function onBreakpointChange(line) {
         for (var address in this.memoryDict) {
            var memorySlot = this.memoryDict[address];
            if (memorySlot.lineno === line - 1) {
               if (memorySlot.instruction || memorySlot.synthetic) {
                  address = parseInt(address);
                  var index = this.breakpoints.indexOf(address);
                  if (index === -1) {
                     this.breakpoints.push(address);
                  } else {
                     this.breakpoints.splice(index, 1);
                  }
               }
               break;
            }
         }
      },
      reset: function reset() {
         this.errorMsg = null;
         this.stop = true;
         this.cycleCount = 0;
         this.currentAddress = 0;
         this.memoryDict = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.parseInfo.memory);
         this.registerValues[0] = '00000000000000000000000000000000';
         for (var i = 1; i < 32; i++) {
            this.setRegisterValue(i, '00000000000000000000000000000000');
         }
         this.flagArray = [];
         for (var _i = 0; _i < 16; _i++) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.leds, _i, false);
         }
         // update memory view
         this.versionNo += 1;
      },

      runStop: function () {
         var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        this.stop = !this.stop;

                     case 1:
                        if (this.stop) {
                           _context.next = 8;
                           break;
                        }

                        this.step();
                        this.stop = this.breakpoints.indexOf(this.currentAddress) !== -1;
                        _context.next = 6;
                        return sleep(10);

                     case 6:
                        _context.next = 1;
                        break;

                     case 8:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, this);
         }));

         function runStop() {
            return _ref.apply(this, arguments);
         }

         return runStop;
      }(),
      step: function step() {
         try {
            this.cycleCount += 1;
            if (this.itFlipFlop === 1) {
               // interrupt
               // clear IT bit
               this.itFlipFlop = 0;
               // push %pc
               var sp32 = binutils.sub32(this.getRegisterValue(29), '00000000000000000000000000000001').result;
               this.setRegisterValue(29, sp32);
               var sp = binutils.bin32ToUnsigned(sp32);
               this.setMemoryContent(sp, this.getRegisterValue(30));
               // push NZVC
               sp32 = binutils.sub32(this.getRegisterValue(29), '00000000000000000000000000000001').result;
               this.setRegisterValue(29, sp32);
               sp = binutils.bin32ToUnsigned(sp32);
               this.setMemoryContent(sp, '0000000000000000000000000000' + (this.flagArray[0] ? '1' : '0') + (this.flagArray[1] ? '1' : '0') + (this.flagArray[2] ? '1' : '0') + (this.flagArray[3] ? '1' : '0'));
               // goto 1
               this.setRegisterValue(30, '00000000000000000000000000000001');
               this.currentAddress = 1;
            } else {
               // no interrupt - execute next instruction
               var currentLine = this.memoryDict[this.currentAddress];
               //console.log('currentLine', currentLine)
               // set %r31 = instruction code
               this.setRegisterValue(31, this.memoryDict[this.currentAddress].value);
               if (currentLine.instruction) {
                  // execute instruction
                  if (currentLine.instruction.type === 'instructionBcc') {
                     if (this.evalCondition(currentLine.instruction)) {
                        this.setCurrentAddress(this.currentAddress + currentLine.instruction.disp);
                     } else {
                        this.setCurrentAddress(this.currentAddress + 1);
                     }
                  } else if (currentLine.instruction.type === 'instructionArithLog1a') {
                     var rs1Value = this.getRegisterValue(currentLine.instruction.rs1);
                     var rs2Value = this.getRegisterValue(currentLine.instruction.rs2);
                     var result = this.compute(currentLine.instruction.codeop, rs1Value, rs2Value);
                     this.setRegisterValue(currentLine.instruction.rd, result);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.instruction.type === 'instructionArithLog1b') {
                     var _rs1Value = this.getRegisterValue(currentLine.instruction.rs1);
                     var simm13Value = binutils.signedToBin32(currentLine.instruction.simm13);
                     var _result = this.compute(currentLine.instruction.codeop, _rs1Value, simm13Value);
                     this.setRegisterValue(currentLine.instruction.rd, _result);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.instruction.type === 'instructionLoad1a') {
                     var address32 = binutils.add32(this.getRegisterValue(currentLine.instruction.rs1), this.getRegisterValue(currentLine.instruction.rs2));
                     var address = binutils.bin32ToUnsigned(address32.result);
                     var content = this.getMemoryContent(address);
                     this.setRegisterValue(currentLine.instruction.rd, content);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.instruction.type === 'instructionLoad1b') {
                     var simm13 = currentLine.instruction.plusMinus === '+' ? currentLine.instruction.simm13 : -currentLine.instruction.simm13;
                     var simm13_32 = binutils.signedToBin32(simm13);
                     var _address = binutils.add32(this.getRegisterValue(currentLine.instruction.rs1), simm13_32);
                     var _address2 = binutils.bin32ToUnsigned(_address.result);
                     var _content = this.getMemoryContent(_address2);
                     this.setRegisterValue(currentLine.instruction.rd, _content);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.instruction.type === 'instructionStore1a') {
                     var _address3 = binutils.add32(this.getRegisterValue(currentLine.instruction.rs1), this.getRegisterValue(currentLine.instruction.rs2));
                     var _address4 = binutils.bin32ToUnsigned(_address3.result);
                     var _content2 = this.getRegisterValue(currentLine.instruction.rd);
                     this.setMemoryContent(_address4, _content2);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.instruction.type === 'instructionStore1b') {
                     var _simm = currentLine.instruction.plusMinus === '+' ? currentLine.instruction.simm13 : -currentLine.instruction.simm13;
                     var _simm13_ = binutils.signedToBin32(_simm);
                     var _address5 = binutils.add32(this.getRegisterValue(currentLine.instruction.rs1), _simm13_);
                     var _address6 = binutils.bin32ToUnsigned(_address5.result);
                     var _content3 = this.getRegisterValue(currentLine.instruction.rd);
                     this.setMemoryContent(_address6, _content3);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.instruction.type === 'instructionSethi') {
                     var imm24Value = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.padStart(parseInt(currentLine.instruction.imm24, 10).toString(2), 24, '0');
                     this.setRegisterValue(currentLine.instruction.rd, imm24Value + '00000000');
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.instruction.type === 'instructionReti') {
                     // pop NZVC
                     var _sp = this.getRegisterValue(29);
                     var _sp2 = binutils.bin32ToUnsigned(_sp);
                     var data = this.getMemoryContent(_sp2);
                     for (var i = 0; i < 4; i++) {
                        this.flagArray[i] = data[28 + i] === '1';
                     }
                     _sp = binutils.add32(_sp, '00000000000000000000000000000001').result;
                     this.setRegisterValue(29, _sp);
                     // pop %pc
                     _sp = this.getRegisterValue(29);
                     _sp2 = binutils.bin32ToUnsigned(_sp);
                     var pcBin32 = this.getMemoryContent(_sp2);
                     this.setRegisterValue(30, pcBin32);
                     _sp = binutils.add32(_sp, '00000000000000000000000000000001').result;
                     this.setRegisterValue(29, _sp);
                     this.setCurrentAddress(binutils.bin32ToUnsigned(pcBin32));
                  }
               } else if (currentLine.synthetic) {
                  if (currentLine.synthetic.type === 'clr') {
                     this.setRegisterValue(currentLine.synthetic.rd, '00000000000000000000000000000000');
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'mov') {
                     this.setRegisterValue(currentLine.synthetic.rd, this.getRegisterValue(currentLine.synthetic.rs));
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'inc') {
                     var rdContent = this.getRegisterValue(currentLine.synthetic.rd);
                     var rdValue = binutils.bin32ToSigned(rdContent);
                     this.setRegisterValue(currentLine.synthetic.rd, binutils.signedToBin32(rdValue + 1));
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'inccc') {
                     var _rdContent = this.getRegisterValue(currentLine.synthetic.rd);
                     var _rdValue = binutils.bin32ToSigned(_rdContent);
                     this.setRegisterValue(currentLine.synthetic.rd, binutils.signedToBin32(_rdValue + 1));
                     this.setFlag(0, _rdValue + 1 < 0);
                     this.setFlag(1, _rdValue + 1 === 0);
                     this.setFlag(2, _rdValue === 2147483647);
                     this.setFlag(3, _rdValue === 4294967295);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'dec') {
                     var _rdContent2 = this.getRegisterValue(currentLine.synthetic.rd);
                     var _rdValue2 = binutils.bin32ToSigned(_rdContent2);
                     this.setRegisterValue(currentLine.synthetic.rd, binutils.signedToBin32(_rdValue2 - 1));
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'deccc') {
                     var _rdContent3 = this.getRegisterValue(currentLine.synthetic.rd);
                     var _rdValue3 = binutils.bin32ToSigned(_rdContent3);
                     this.setRegisterValue(currentLine.synthetic.rd, binutils.signedToBin32(_rdValue3 - 1));
                     this.setFlag(0, _rdValue3 - 1 < 0);
                     this.setFlag(1, _rdValue3 - 1 === 0);
                     this.setFlag(2, _rdValue3 === -2147483648);
                     this.setFlag(3, _rdValue3 === -4294967296);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'setq') {
                     var _simm13Value = binutils.signedToBin32(currentLine.synthetic.simm13);
                     this.setRegisterValue(currentLine.synthetic.rd, _simm13Value);
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'set') {
                     var simm32Value = binutils.signedToBin32(currentLine.synthetic.simm32);
                     this.setRegisterValue(currentLine.synthetic.rd, simm32Value);
                     this.setCurrentAddress(this.currentAddress + 2);
                  } else if (currentLine.synthetic.type === 'cmp') {
                     var rsValueSigned = binutils.bin32ToSigned(this.getRegisterValue(currentLine.synthetic.rs));
                     var rsValueUnsigned = binutils.bin32ToUnsigned(this.getRegisterValue(currentLine.synthetic.rs));
                     if (currentLine.synthetic.rd !== undefined) {
                        var rdValueSigned = binutils.bin32ToSigned(this.getRegisterValue(currentLine.synthetic.rd));
                        var rdValueUnsigned = binutils.bin32ToUnsigned(this.getRegisterValue(currentLine.synthetic.rd));
                        //console.log('rdValueSigned', rdValueSigned, 'rsValueSigned', rsValueSigned)
                        var diffSigned = rsValueSigned - rdValueSigned;
                        this.setFlag(0, diffSigned < 0); // N
                        this.setFlag(1, diffSigned === 0); // Z
                        this.setFlag(2, rsValueSigned < 0 && rdValueSigned >= 0 && diffSigned >= 0 || rsValueSigned >= 0 && rdValueSigned < 0 && diffSigned < 0); // V
                        this.setFlag(3, rsValueUnsigned < rdValueUnsigned); // C
                     } else {
                        var _diffSigned = rsValueSigned - currentLine.synthetic.simm13;
                        this.setFlag(0, _diffSigned < 0); // N
                        this.setFlag(1, _diffSigned === 0); // Z
                        this.setFlag(2, rsValueSigned < 0 && currentLine.synthetic.simm13 >= 0 && _diffSigned >= 0 || rsValueSigned >= 0 && currentLine.synthetic.simm13 < 0 && _diffSigned < 0); // V
                        this.setFlag(3, _diffSigned < 0); // C ????
                     }
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'tst') {
                     var _rsValueSigned = binutils.bin32ToSigned(this.getRegisterValue(currentLine.synthetic.rs));
                     var _rsValueUnsigned = binutils.bin32ToUnsigned(this.getRegisterValue(currentLine.synthetic.rs));
                     this.setFlag(0, _rsValueSigned < 0); // N
                     this.setFlag(1, _rsValueSigned === 0); // Z
                     this.setFlag(2, false); // V
                     this.setFlag(3, false); // C
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'negcc') {
                     var _rdValueSigned = binutils.bin32ToSigned(this.getRegisterValue(currentLine.synthetic.rd));
                     this.setRegisterValue(currentLine.synthetic.rd, binutils.signedToBin32(-_rdValueSigned));
                     this.setFlag(0, -_rdValueSigned < 0); // N
                     this.setFlag(1, _rdValueSigned === 0); // Z
                     this.setFlag(2, false); // V
                     this.setFlag(3, false); // C
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'nop') {
                     this.setCurrentAddress(this.currentAddress + 1);
                  } else if (currentLine.synthetic.type === 'call') {
                     this.setRegisterValue(28, this.getRegisterValue(30));
                     this.setCurrentAddress(this.currentAddress + currentLine.synthetic.disp + 1);
                  } else if (currentLine.synthetic.type === 'ret') {
                     var r28 = binutils.bin32ToUnsigned(this.getRegisterValue(28));
                     var returnAddress = r28 + 2;
                     this.setRegisterValue(30, binutils.unsignedToBin32(returnAddress));
                     this.setCurrentAddress(returnAddress);
                  } else if (currentLine.synthetic.type === 'push') {
                     var _sp3 = binutils.sub32(this.getRegisterValue(29), '00000000000000000000000000000001').result;
                     this.setRegisterValue(29, _sp3);
                     var _sp4 = binutils.bin32ToUnsigned(_sp3);
                     this.setMemoryContent(_sp4, this.getRegisterValue(currentLine.synthetic.rs));
                     this.setCurrentAddress(this.currentAddress + 2);
                  } else if (currentLine.synthetic.type === 'pop') {
                     var _sp5 = this.getRegisterValue(29);
                     var _sp6 = binutils.bin32ToUnsigned(_sp5);
                     this.setRegisterValue(currentLine.synthetic.rd, this.getMemoryContent(_sp6));
                     _sp5 = binutils.add32(_sp5, '00000000000000000000000000000001').result;
                     this.setRegisterValue(29, _sp5);
                     this.setCurrentAddress(this.currentAddress + 2);
                  }
               }
            }
         } catch (error) {
            this.errorMsg = error.message;
            this.stop = true;
         }
      },

      setCurrentAddress: function setCurrentAddress(address) {
         this.setRegisterValue(30, binutils.unsignedToBin32(address));
         var content = this.memoryDict[address];
         if (!content) {
            var message = '*** execution at uninitialized memory location 0x' + address.toString(16);
            throw new Error(message);
         }
         this.currentAddress = address;
      },
      getRegisterValue: function getRegisterValue(regno) {
         if (regno === 0) {
            return '00000000000000000000000000000000';
         } else {
            return this.registerValues[regno];
         }
      },
      setRegisterValue: function setRegisterValue(regno, bin32Value) {
         if (regno > 0) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.registerValues, regno, bin32Value);
         }
      },
      getMemoryContent: function getMemoryContent(address) {
         if (address < 0x10000000) {
            var memoryEntry = this.memoryDict[address];
            if (!memoryEntry) {
               var message = '*** read-access to uninitialized memory location 0x' + address.toString(16);
               throw new Error(message);
            }
            //console.log('getMemoryContent', address, memoryEntry.value)
            return memoryEntry.value;
         } else if (address === 0x90000000) {
            var result = '';
            for (var i = 31; i >= 0; i--) {
               if (i > 16) {
                  result += '0';
               } else {
                  result += this.switches[i] ? '1' : '0';
               }
            }
            return result;
         } else {
            var _message = '*** read-access to unmapped memory location 0x' + address.toString(16);
            throw new Error(_message);
         }
      },
      setMemoryContent: function setMemoryContent(address, content) {
         //console.log('setMemoryContent', address, content)
         if (address < 0x10000000) {
            var memoryEntry = { text: '', label: '', value: content };
            this.memoryDict[address] = memoryEntry;
            // force update of memory text
            this.versionNo += 1;
         } else if (address === 0xB0000000) {
            for (var i = 0; i < 16; i++) {
               var bit = content.charAt(31 - i);
               __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.leds, i, bit === '1');
            }
         } else {
            var message = '*** write-access to unmapped memory location 0x' + address.toString(16);
            throw new Error(message);
         }
      },
      swClick: function swClick(bitno) {
         __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.switches, bitno, !this.switches[bitno]);
      },
      // 0123: NZVC
      getFlag: function getFlag(flagIndex) {
         return this.flagArray.indexOf(flagIndex) !== -1;
      },
      setFlag: function setFlag(flag, value) {
         if (value) {
            if (this.flagArray.indexOf(flag) === -1) {
               this.flagArray.push(flag);
            }
         } else {
            var index = this.flagArray.indexOf(flag);
            if (index !== -1) {
               this.flagArray.splice(index, 1);
            }
         }
      },

      evalCondition: function evalCondition(instruction) {
         if (instruction.cond === 'a') {
            return true;
         } else if (instruction.cond === 'z' || instruction.cond === 'e' || instruction.cond === 'eq') {
            var Z = this.getFlag(1);
            return Z;
         } else if (instruction.cond === 'nz' || instruction.cond === 'ne') {
            var _Z = this.getFlag(1);
            return !_Z;
         } else if (instruction.cond === 'neg' || instruction.cond === 'n') {
            var N = this.getFlag(0);
            return N;
         } else if (instruction.cond === 'pos' || instruction.cond === 'nn') {
            var _N = this.getFlag(0);
            return !_N;
         } else if (instruction.cond === 'cs' || instruction.cond === 'lu') {
            var C = this.getFlag(3);
            return C;
         } else if (instruction.cond === 'cc' || instruction.cond === 'geu') {
            var _C = this.getFlag(3);
            return !_C;
         } else if (instruction.cond === 'g' || instruction.cond === 'gt') {
            var _N2 = this.getFlag(0);
            var _Z2 = this.getFlag(1);
            var V = this.getFlag(2);
            return !(_Z2 || _N2 !== V);
         } else if (instruction.cond === 'ge') {
            var _N3 = this.getFlag(0);
            var _V = this.getFlag(2);
            return _N3 === _V;
         } else if (instruction.cond === 'l' || instruction.cond === 'lt') {
            var _N4 = this.getFlag(0);
            var _V2 = this.getFlag(2);
            return _N4 !== _V2;
         } else if (instruction.cond === 'le') {
            var _N5 = this.getFlag(0);
            var _Z3 = this.getFlag(1);
            var _V3 = this.getFlag(2);
            return _Z3 || _N5 !== _V3;
         } else if (instruction.cond === 'gu') {
            var _Z4 = this.getFlag(1);
            var _C2 = this.getFlag(3);
            return !(_Z4 || _C2);
         } else if (instruction.cond === 'leu') {
            var _Z5 = this.getFlag(1);
            var _C3 = this.getFlag(3);
            return _Z5 || _C3;
         }
      },
      compute: function compute(codeop, arg1, arg2) {
         //console.log('compute codeop', codeop, 'arg1', arg1, 'arg2', arg2)
         var result = void 0;
         if (codeop.startsWith('add') || codeop.startsWith('sub')) {
            var _ref2 = codeop.startsWith('add') ? binutils.add32(arg1, arg2) : binutils.sub32(arg1, arg2),
                res = _ref2.result,
                V = _ref2.V,
                C = _ref2.C;
            //console.log('res', res, 'V', V, 'C', C)


            result = res;
            if (codeop.endsWith('cc')) {
               // set flags
               this.setFlag(0, result.charAt(0) === '1'); // N
               this.setFlag(1, result.indexOf('1') === -1); // Z
               this.setFlag(2, V); // V
               this.setFlag(3, C); // C
            }
         } else if (codeop === 'umulcc') {
            var varg1 = binutils.bin16ToUnsigned(arg1.substring(16));
            var varg2 = binutils.bin16ToUnsigned(arg2.substring(16));
            result = binutils.unsignedToBin32(varg1 * varg2);
            // set N,Z
            this.setFlag(0, result.charAt(0) === '1'); // N
            this.setFlag(1, result.indexOf('1') === -1); // Z
         } else if (codeop.startsWith('and') || codeop.startsWith('or') || codeop.startsWith('xor')) {
            if (codeop.startsWith('and')) {
               result = binutils.and32(arg1, arg2);
            } else if (codeop.startsWith('or')) {
               result = binutils.or32(arg1, arg2);
            } else if (codeop.startsWith('xor')) {
               result = binutils.xor32(arg1, arg2);
            }
            if (codeop.endsWith('cc')) {
               // set N,Z
               this.setFlag(0, result.charAt(0) === '1'); // N
               this.setFlag(1, result.indexOf('1') === -1); // Z
            }
         } else if (codeop === 'slr') {
            result = binutils.slr32(arg1, arg2);
         } else if (codeop === 'sll') {
            result = binutils.sll32(arg1, arg2);
         }
         return result;
      },

      sendIT: function sendIT() {
         console.log('IT!');
         this.itFlipFlop = 1;
      }
   }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_craps_CrapsModuleList__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_craps_CrapsModuleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_craps_CrapsModuleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      baseRoute: String
   },

   components: {
      CrapsModuleList: __WEBPACK_IMPORTED_MODULE_2__components_craps_CrapsModuleList___default.a
   },

   mounted: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
         var teams, self;
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     // fetch user CRAPS modules in central store: reactivity will update the list view
                     this.$store.dispatch('craps/GET_CRAPS_MODULES', { userId: this.userId, teamId: 0 });
                     // fetch teams for which userId is a member
                     _context.next = 3;
                     return this.$store.dispatch('teams/GET_USER_TEAMS', this.userId);

                  case 3:
                     teams = _context.sent;

                     // for each team, fetch members & CRAPS modules: reactivity will update the list view
                     self = this;

                     teams.forEach(function (team) {
                        self.$store.dispatch('craps/GET_CRAPS_MODULES', { userId: 0, teamId: team.id });
                        team.members.forEach(function (userId) {
                           self.$store.dispatch('GET_USER', userId);
                        });
                     });

                  case 6:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function mounted() {
         return _ref.apply(this, arguments);
      }

      return mounted;
   }(),

   data: function data() {
      return {
         selectedModuleId: null
      };
   },


   computed: {
      user: function user() {
         return this.$store.state.users[this.userId];
      },
      teams: function teams() {
         var _this = this;

         if (this.$store.state.teams.user2teamList.hasOwnProperty(this.userId)) {
            return this.$store.state.teams.user2teamList[this.userId].map(function (teamId) {
               return _this.$store.state.teams.teams[teamId];
            });
         } else {
            return [];
         }
      },
      selectedModule: function selectedModule() {
         return this.$store.state.craps.modules[this.selectedModuleId];
      }
   },

   methods: {
      selectModule: function selectModule(moduleId) {
         // make the module selected in CrapsModuleList
         this.selectedModuleId = moduleId;
         // change route
         this.$router.push(this.baseRoute + 'module/' + moduleId + '/editor');
         // post event that module has been accessed
         var module = this.$store.state.craps.modules[moduleId];
         this.$store.dispatch('POST_HISTORY_EVENT', {
            author: this.$store.state.loggedUserId,
            user: this.user.id, // team = null
            message: { "text": "Accès au module " + module.name }
         });
      },
      unselectAll: function unselectAll() {
         this.selectedModuleId = null;
         // change route
         this.$router.push(this.baseRoute);
      },
      userModuleUpdated: function userModuleUpdated(moduleId) {
         this.$emit('userModuleUpdated', moduleId);
         this.selectedModuleId = moduleId;
      },
      addModule: function addModule(name, teamId) {
         var _this2 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var moduleList, addedModule;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        moduleList = teamId ? _this2.$store.state.craps.team2moduleList[teamId] : _this2.$store.state.craps.user2moduleList[_this2.user.id];

                        if (!(moduleList.map(function (moduleId) {
                           return _this2.$store.state.craps.modules[moduleId].name;
                        }).indexOf(name) !== -1)) {
                           _context2.next = 5;
                           break;
                        }

                        _this2.$store.commit('SNACKBAR', { timeout: 3500, text: "Un module de ce nom existe déjà", color: 'red' });
                        _context2.next = 15;
                        break;

                     case 5:
                        _context2.prev = 5;
                        _context2.next = 8;
                        return _this2.$store.dispatch('craps/POST_CRAPS_MODULE', {
                           name: name,
                           user: teamId ? null : _this2.user.id,
                           team: teamId ? teamId : null,
                           update_author: _this2.$store.state.loggedUserId,
                           text: '// write your program here'
                        });

                     case 8:
                        addedModule = _context2.sent;

                        _this2.selectModule(addedModule.id);
                        _context2.next = 15;
                        break;

                     case 12:
                        _context2.prev = 12;
                        _context2.t0 = _context2['catch'](5);

                        _this2.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la création", color: 'red' });

                     case 15:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, _this2, [[5, 12]]);
         }))();
      },
      deleteModule: function deleteModule(module) {
         var _this3 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return _this3.$store.dispatch('craps/DELETE_CRAPS_MODULE', module);

                     case 3:
                        _context3.next = 5;
                        return _this3.$store.dispatch('POST_HISTORY_EVENT', {
                           author: _this3.$store.state.loggedUserId,
                           user: _this3.user.id, // team = null
                           message: { "text": "Suppression du module " + module.name }
                        });

                     case 5:
                        _this3.unselectAll();
                        _context3.next = 11;
                        break;

                     case 8:
                        _context3.prev = 8;
                        _context3.t0 = _context3['catch'](0);

                        _this3.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la suppression", color: 'red' });

                     case 11:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, _this3, [[0, 8]]);
         }))();
      },
      lockModule: function lockModule(module) {
         var _this4 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
               while (1) {
                  switch (_context4.prev = _context4.next) {
                     case 0:
                        console.log("lock module", module);
                        _context4.prev = 1;

                        module.locked_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format();
                        _context4.next = 5;
                        return _this4.$store.dispatch('craps/PUT_CRAPS_MODULE', module);

                     case 5:
                        _context4.next = 11;
                        break;

                     case 7:
                        _context4.prev = 7;
                        _context4.t0 = _context4['catch'](1);

                        console.log('error', _context4.t0);
                        _this4.$store.commit('SNACKBAR', { timeout: 3500, text: "Error while saving", color: 'red' });

                     case 11:
                     case 'end':
                        return _context4.stop();
                  }
               }
            }, _callee4, _this4, [[1, 7]]);
         }))();
      }
   }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
   computed: {
      confirmer: function confirmer() {
         return this.$store.state.confirmer;
      }
   },
   methods: {
      answer: function answer(value) {
         this.confirmer.resolve(value);
         this.$store.commit('confirmer/DEACTIVATE');
      }
   }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

   methods: {
      close: function close() {
         window.close();
      }
   }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__(24);

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      acceptInvitationUrl: String,
      token: String
   },

   mounted: function mounted() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     _context.next = 2;
                     return axios({
                        method: 'post',
                        url: _this.acceptInvitationUrl,
                        data: {
                           token: _this.token
                        }
                     });

                  case 2:
                     _this.msgText = "L'utilisateur vient d'être ajouté à ceux que vous coachez";

                  case 3:
                  case "end":
                     return _context.stop();
               }
            }
         }, _callee, _this);
      }))();
   },
   data: function data() {
      return {
         msgText: ''
      };
   },


   methods: {
      onClick: function onClick() {
         this.$router.push('/');
      }
   }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var axios = __webpack_require__(24);



/* harmony default export */ __webpack_exports__["default"] = ({

   mounted: function mounted() {
      // logout if necessary
      if (this.$store.state.authenticationData) {
         // commit event to vuex store
         this.$store.commit('RESET_STATE');
         // emit 'onLogout' event to App parent component
         this.$emit('onLogout');
      }
   },

   data: function data() {
      return {
         username: '',
         email: '',
         password: '',
         passwordConfirmed: '',
         mode: this.initial_mode,
         hiddenPassword: true,
         errMsg: ''
      };
   },


   validations: {
      password: {
         required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"],
         minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minLength"])(6)
      },
      passwordConfirmed: {
         sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["sameAs"])('password')
      }
   },

   computed: {
      passwordErrors: function passwordErrors() {
         var errors = [];
         if (!this.$v.password.$dirty) return errors;
         !this.$v.password.minLength && errors.push("Le mot de passe doit faire au moins 6 caractères");
         !this.$v.password.required && errors.push("Le mot de passe est obligatoire");
         return errors;
      },
      passwordConfirmedErrors: function passwordConfirmedErrors() {
         var errors = [];
         if (!this.$v.passwordConfirmed.$dirty) return errors;
         !this.$v.passwordConfirmed.sameAsPassword && errors.push("Les deux mots de passe doivent être identiques");
         return errors;
      },

      title: function title() {
         return "Choisissez un mot de passe";
      },
      submitButtonText: function submitButtonText() {
         return "Activer le compte";
      },
      formValid: function formValid() {
         if (this.$v.password.$error) return false;
         if (this.$v.passwordConfirmed.$error) return false;
         return true;
      },
      formDirty: function formDirty() {
         if (this.$v.password.$dirty) return true;
         if (this.$v.passwordConfirmed.$dirty) return true;
         return false;
      },
      formValidAndDirty: function formValidAndDirty() {
         return this.formValid && this.formDirty;
      }
   },

   methods: {
      debouncedSubmit: function debouncedSubmit() {
         var self = this;
         __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function () {
            self.submit();
         }, 300, { 'leading': true, 'trailing': false })();
      },

      isFormInvalid: function isFormInvalid() {
         return false;
      },

      submit: function submit() {
         var _this = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response, publicKey, token, decodedToken, user_id, user;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        _this.$store.commit('WAITING', true);
                        _context.prev = 1;
                        _context.next = 4;
                        return axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].PUBLIC_KEY_URL, {});

                     case 4:
                        response = _context.sent;
                        publicKey = response.data;
                        // then verify the provided token with the public key

                        token = _this.$route.query.token;

                        console.log('token=', token);
                        decodedToken = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js__["verifyToken"])(token, publicKey);

                        console.log('decodedToken', decodedToken);
                        // then activate user with token & password
                        user_id = decodedToken.user_id;
                        _context.next = 13;
                        return axios({
                           method: 'post',
                           url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].ACTIVATE_USER_URL,
                           data: {
                              token: token,
                              password: _this.password
                           }
                        });

                     case 13:
                        response = _context.sent;
                        user = response.data;

                        console.log('user', user);
                        _this.$store.commit('SNACKBAR', { timeout: 1500, text: "Compte activé", color: 'green' });
                        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login?username=' + user.username);
                        _context.next = 23;
                        break;

                     case 20:
                        _context.prev = 20;
                        _context.t0 = _context['catch'](1);

                        _this.errMsg = _context.t0.message;

                     case 23:
                        _context.prev = 23;

                        _this.$store.commit('WAITING', false);
                        return _context.finish(23);

                     case 26:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, _this, [[1, 20, 23, 26]]);
         }))();
      }
   }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var axios = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["default"] = ({
   name: 'login',

   props: {
      // 'connection' or 'sign-up'
      initial_mode: {
         type: String,
         default: 'connection'
      }
   },

   mounted: function mounted() {
      if (this.$route.query.hasOwnProperty('username')) {
         this.username = this.$route.query.username;
      }
   },

   data: function data() {
      return {
         username: '',
         email: '',
         first_name: '',
         last_name: '',
         tag: '',
         password: '',
         valid: false,
         mode: this.initial_mode,
         hiddenPassword: true,
         usernameRules: [function (v) {
            return !!v || "L'identifiant est obligatoire";
         }, function (v) {
            return !!v && v.length >= 3 || "L'identifiant doit comporter au moins 3 caractères";
         }],
         emailRules: [function (v) {
            return !!v || "L'e-mail est obligatoire";
         }, function (v) {
            return (/^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/.test(v) || "l'email doit être valide"
            );
         }],
         passwordRules: [function (v) {
            return !!v || 'Le mot de passe est obligatoire';
         }, function (v) {
            return !!v && v.length >= 6 || 'Le mot de passe doit faire au moins 6 caractères';
         }],
         errMsg: ''
      };
   },


   computed: {
      // 'nutrieduc', 'shdl'
      platform: function platform() {
         return this.$store.getters.platform;
      },
      isProduction: function isProduction() {
         return "production" === 'production';
      },

      title: function title() {
         return this.isConnection ? "Connexion" : "Créer un compte";
      },
      isConnection: function isConnection() {
         return this.mode === 'connection';
      },
      isSignUp: function isSignUp() {
         return this.mode === 'sign-up';
      },
      submitButtonText: function submitButtonText() {
         return this.isConnection ? "Se connecter" : "Créer le compte";
      },
      modeButtonText: function modeButtonText() {
         return this.isConnection ? "Créer un compte" : "Retour à la connexion";
      }
   },

   methods: {
      onModeButtonTap: function onModeButtonTap() {
         this.username = '';
         this.email = '';
         this.password = '';
         if (this.isConnection) {
            this.mode = 'sign-up';
         } else {
            this.mode = 'connection';
         }
      },


      debouncedSubmit: function debouncedSubmit() {
         var self = this;
         __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
            self.submit();
         }, 300, { 'leading': true, 'trailing': false })();
      },

      submit: function submit() {
         if (this.isConnection) {
            this.signIn();
         } else {
            this.signUpAsSelfRegistered();
         }
      },
      signIn: function signIn() {
         var _this = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response, token, publicKey, decodedToken, user_data, url, firstGroup, errorText;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        _this.$store.commit('WAITING', true);
                        _context.prev = 1;
                        response = void 0;
                        // ask server for a token, signed with the private key

                        _context.next = 5;
                        return axios({
                           method: 'post',
                           url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].TOKEN_URL,
                           data: {
                              username: _this.username,
                              password: _this.password
                           }
                        });

                     case 5:
                        response = _context.sent;
                        token = response.data;
                        //console.log('token', token)
                        // then get public key in PEM format (with separate lines, see https://github.com/auth0/node-jsonwebtoken/issues/331)

                        _context.next = 9;
                        return axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].PUBLIC_KEY_URL, {});

                     case 9:
                        response = _context.sent;
                        publicKey = response.data;
                        // then verify the provided token with the public key

                        decodedToken = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_jwtToken_js__["verifyToken"])(token, publicKey);
                        //console.log('decodedToken', decodedToken)
                        // then load user data

                        _context.next = 14;
                        return axios({
                           method: 'get',
                           url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].USERS_URL + decodedToken.user_id + '/',
                           headers: { "Authorization": 'JWT ' + token }
                        });

                     case 14:
                        response = _context.sent;
                        user_data = response.data;
                        //console.log('user_data', user_data)
                        // commit changes in vuex

                        _this.$store.commit('SET_LOGGED_USER', user_data);
                        // commit login in vuex state, with token & public key
                        _this.$store.commit('SET_AUTHENTICATION_DATA', {
                           token: token,
                           decodedToken: decodedToken,
                           publicKey: publicKey
                        });
                        // get realms - necessary for several store.getters
                        _context.next = 20;
                        return _this.$store.dispatch('GET_REALMS');

                     case 20:
                        _context.next = 22;
                        return _this.$store.dispatch('GET_ROLES');

                     case 22:
                        // look for route to go to for App component
                        url = void 0;

                        if (_this.$route.query.next) {
                           // special case when when route is specified in query param
                           url = _this.$route.query.next;
                        } else {
                           // get first user's roles
                           firstGroup = _this.$store.state.roles[user_data.group_ids[0]];
                           // get first authorization's url

                           url = firstGroup.authorizations[0].url;
                           //console.log('url', url)
                        }
                        // then emit 'onLogin' to App parent component
                        _this.$emit('onLogin', url);
                        _context.next = 33;
                        break;

                     case 27:
                        _context.prev = 27;
                        _context.t0 = _context['catch'](1);

                        console.log('login error', _context.t0);
                        errorText = "Erreur inconnue";

                        if (_context.t0.response && _context.t0.response.status && _context.t0.response.status === 400) {
                           errorText = "Identifiant / mot de passe incorrects, ou compte inactivé";
                        }
                        _this.$store.commit('SNACKBAR', { timeout: 3500, text: errorText, color: 'red' });

                     case 33:
                        _context.prev = 33;

                        _this.$store.commit('WAITING', false);
                        return _context.finish(33);

                     case 36:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, _this, [[1, 27, 33, 36]]);
         }))();
      },
      signUpAsSelfRegistered: function signUpAsSelfRegistered() {
         var _this2 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var userId;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        _this2.$store.commit('WAITING', true);
                        _context2.prev = 1;
                        _context2.next = 4;
                        return _this2.$store.dispatch('CREATE_USER', {
                           username: _this2.username,
                           email: _this2.email,
                           first_name: _this2.first_name,
                           last_name: _this2.last_name,
                           tag: _this2.tag
                        });

                     case 4:
                        userId = _context2.sent;

                        // then display message
                        _this2.$store.commit('SNACKBAR', { timeout: 3500, text: 'Compte utilisateur ' + _this2.username + ' cr\xE9\xE9. Un mail d\'activation vient d\'\xEAtre envoy\xE9 \xE0 ' + _this2.email, color: 'green' });
                        // then go in 'connection' mode
                        _this2.mode = 'connection';
                        _context2.next = 13;
                        break;

                     case 9:
                        _context2.prev = 9;
                        _context2.t0 = _context2['catch'](1);

                        _this2.$store.commit('SNACKBAR', { timeout: 3500, text: _context2.t0.message, color: 'red' });
                        _this2.errMsg = _context2.t0.message;

                     case 13:
                        _context2.prev = 13;

                        _this2.$store.commit('WAITING', false);
                        return _context2.finish(13);

                     case 16:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, _this2, [[1, 9, 13, 16]]);
         }))();
      }
   }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(142);
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
   name: 'logout',

   mounted: function mounted() {
      // commit event to vuex store
      this.$store.commit('RESET_STATE');
      // emit 'onLogout' event to App parent component
      this.$emit('onLogout');
      // go to default route
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
   }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      title: String,
      disableDate: { type: Boolean, default: true },
      value: Object // for v-model 2-way binding
   },

   mounted: function mounted() {
      if (this.value.surveyIndex !== null) {
         this.isSurvey = true;
      }
   },
   data: function data() {
      return {
         menu: false,
         pickerDate: this.value.date || new Date(),
         isSurvey: false
      };
   },


   computed: {
      today: function today() {
         return __WEBPACK_IMPORTED_MODULE_2_moment___default()().format();
      },
      formattedEditedDate: function formattedEditedDate() {
         return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.value.date).format("Do MMMM YYYY");
      },
      mealTypes: function mealTypes() {
         return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].MEAL_TYPE_LIST.map(function (index) {
            return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].MEAL_TYPES[index];
         });
      },
      surveyTypes: function surveyTypes() {
         return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].MEAL_SURVEY_LIST.map(function (index) {
            return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].MEAL_SURVEYS[index];
         });
      },
      mealPresenceArrayErrors: function mealPresenceArrayErrors() {
         var errors = [];
         if (!this.$v.value.mealPresenceArray.$dirty) return errors;
         !this.$v.value.mealPresenceArray.required && errors.push("Un repas au moins est obligatoire");
         return errors;
      },
      surveyIndexErrors: function surveyIndexErrors() {
         var errors = [];
         if (!this.$v.value.surveyIndex.$dirty) return errors;
         !this.$v.value.surveyIndex.required && errors.push("Le type du relevé est obligatoire");
         return errors;
      },
      formValid: function formValid() {
         if (!this.$v.value.mealPresenceArray.required) return false;
         if (this.isSurvey && !this.$v.value.surveyIndex.required) return false;
         return true;
      }
   },

   methods: {
      close: function close() {
         this.$emit('close');
      },
      emitValue: function emitValue() {
         // update surveyIndex
         if (!this.isSurvey) this.value.surveyIndex = null;
         // reorder mealPresenceArray
         this.value.mealPresenceArray.sort(function (a, b) {
            return a - b;
         });
         // emit 'input' event for fractionning value
         this.$emit('input', this.value);
      },
      emitCancel: function emitCancel() {
         this.$emit('cancel');
      }
   },

   // vuelidate validators (as a function)
   validations: function validations() {
      var validators = {
         value: {
            mealPresenceArray: {
               required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
            }
         }
      };
      if (this.isSurvey) {
         __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(validators.value, {
            surveyIndex: {
               required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
            }
         });
      }
      return validators;
   }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      date: String,
      index: Number
   },

   data: function data() {
      return {
         create: false,
         editDialog: false,
         deleteDialog: false,

         foodItems: [],
         foodSearchInput: null,
         foodSearchLoading: false,

         mealElementToEdit: {},
         choosenFood: null,
         choosenFoodPortions: null,
         choosenFoodPortion: null,
         choosenFoodPortionCount: null,
         choosenWeight: null,

         mealElementToDelete: {},
         zoomImage: false,
         mealElementToZoomIn: {},

         tickLabels: ['\xBC', '\xBD', '\xBE', '1', '', '', '', '2', '', '', '', '3', '', '', '', '4', '', '', '', '5']
      };
   },


   computed: {
      mealNames: function mealNames() {
         return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].MEAL_TYPE_LIST.map(function (index) {
            return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].MEAL_TYPES[index]['name'];
         });
      },
      mealId: function mealId() {
         if (this.$store.state.meals.user2date2index2meal[this.userId] && this.$store.state.meals.user2date2index2meal[this.userId][this.date] && this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index]) {
            return this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index];
         } else {
            return null;
         }
      },
      meal: function meal() {
         if (this.mealId) {
            return this.$store.state.meals.meals[this.mealId];
         } else {
            return null;
         }
      },
      mealElements: function mealElements() {
         var _this = this;

         if (this.$store.state.meals.meal2mealElementList.hasOwnProperty(this.mealId)) {
            return this.$store.state.meals.meal2mealElementList[this.mealId].map(function (mealElementId) {
               return _this.$store.state.meals.mealElements[mealElementId];
            });
         } else {
            return [];
         }
      },
      displayDate: function displayDate() {
         return __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.date).format("dddd Do MMMM YYYY");
      },
      fuzzyChoosenFoodPortionWeight: function fuzzyChoosenFoodPortionWeight() {
         return __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.parse(this.choosenFoodPortion.qty);
      },
      choosenWeightErrors: function choosenWeightErrors() {
         var errors = [];
         if (!this.$v.choosenWeight.$dirty) return errors;
         !this.$v.choosenWeight.required && errors.push("Le poids est obligatoire");
         !this.$v.choosenWeight.isWeightCorrect && errors.push("Le poids est mal écrit");
         return errors;
      },
      formValid: function formValid() {
         return this.$v.choosenWeight.required && this.$v.choosenWeight.isWeightCorrect;
      }
   },

   validations: {
      choosenWeight: {
         required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
         isWeightCorrect: function isWeightCorrect(value) {
            if (value === '') return true;
            if (value === null) return true;
            return __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.parse(value) !== null;
         }
      }
   },

   watch: {
      foodSearchInput: function foodSearchInput(val) {
         val && this.querySelections(val);
      },

      'choosenFood.id': function () {
         var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(newVal, oldVal) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        if (!newVal) {
                           _context.next = 11;
                           break;
                        }

                        _context.prev = 1;
                        _context.next = 4;
                        return this.$store.dispatch('meals/GET_FOOD_FOODPORTIONS', newVal);

                     case 4:
                        this.choosenFoodPortions = _context.sent;

                        if (this.choosenFoodPortions.length === 1) {
                           this.choosenFoodPortion = this.choosenFoodPortions[0];
                           this.choosenFoodPortionCount = 1.;
                           this.choosenWeight = this.choosenFoodPortion.qty;
                        }
                        _context.next = 11;
                        break;

                     case 8:
                        _context.prev = 8;
                        _context.t0 = _context['catch'](1);

                        console.log(_context.t0);

                     case 11:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, this, [[1, 8]]);
         }));

         function choosenFoodId(_x, _x2) {
            return _ref.apply(this, arguments);
         }

         return choosenFoodId;
      }()
   },

   methods: {
      clone: function clone(meal) {
         return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.clone(meal);
      },
      pictPath: function pictPath(pict) {
         return '/static/media/' + pict;
      },
      addMealElement: function addMealElement() {
         this.mealElementToEdit = {};
         this.choosenFood = null;
         this.choosenFoodPortions = null;
         this.choosenFoodPortion = null;
         this.choosenFoodPortionCount = null;
         this.choosenWeight = null;
         this.create = true;
         this.editDialog = true;
      },
      changeFood: function changeFood() {
         this.choosenFood = null;
         this.choosenFoodPortions = null;
         this.choosenFoodPortion = null;
         this.choosenFoodPortionCount = null;
         this.choosenWeight = null;
      },
      editMealElement: function editMealElement(mealElement) {
         var _this2 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var fuzzyWeight, fuzzyPortionCount;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        _this2.foodSearchLoading = true;
                        _context2.prev = 1;
                        _context2.next = 4;
                        return _this2.$store.dispatch('meals/GET_FOOD', mealElement.food);

                     case 4:
                        _this2.choosenFood = _context2.sent;
                        _context2.next = 7;
                        return _this2.$store.dispatch('meals/GET_FOOD_FOODPORTIONS', mealElement.food);

                     case 7:
                        _this2.choosenFoodPortions = _context2.sent;

                        if (mealElement.portion) {
                           _this2.choosenFoodPortion = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(_this2.choosenFoodPortions, function (portion) {
                              return portion.id === mealElement.portion;
                           });
                           _this2.choosenFoodPortionCount = mealElement.nbportion;
                        } else {
                           if (_this2.choosenFoodPortions.length === 1) {
                              _this2.choosenFoodPortion = _this2.choosenFoodPortions[0];
                              fuzzyWeight = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.parse(mealElement.weight);
                              fuzzyPortionCount = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.multiplyByScalar(fuzzyWeight, 1 / parseFloat(_this2.choosenFoodPortion.qty));

                              _this2.choosenFoodPortionCount = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.middleValue(fuzzyPortionCount);
                           } else {
                              _this2.choosenFoodPortion = null;
                              _this2.choosenFoodPortionCount = null;
                           }
                        }
                        _this2.choosenWeight = mealElement.weight;

                     case 10:
                        _context2.prev = 10;

                        _this2.foodSearchLoading = false;
                        return _context2.finish(10);

                     case 13:
                        _this2.mealElementToEdit = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.clone(mealElement);
                        _this2.create = false;
                        _this2.editDialog = true;

                     case 16:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, _this2, [[1,, 10, 13]]);
         }))();
      },
      changeFoodPortion: function changeFoodPortion() {
         this.choosenFoodPortion = null;
         this.choosenFoodPortionCount = null;
         this.choosenWeight = null;
      },
      chooseFoodPortion: function chooseFoodPortion(foodPortion) {
         this.choosenFoodPortion = foodPortion;
         this.choosenFoodPortionCount = 1;
         this.choosenWeight = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.format(__WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.parse(this.choosenFoodPortion.qty));
      },
      deleteMealElement: function deleteMealElement() {
         var _this3 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return _this3.$store.dispatch('meals/DELETE_MEAL_ELEMENT', _this3.mealElementToDelete);

                     case 3:
                        _context3.next = 8;
                        break;

                     case 5:
                        _context3.prev = 5;
                        _context3.t0 = _context3['catch'](0);

                        console.log(_context3.t0);

                     case 8:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, _this3, [[0, 5]]);
         }))();
      },
      mealElementQuantityDescription: function mealElementQuantityDescription(mealElement) {
         var result = '';
         if (mealElement.portion) {
            if (mealElement.nbportion === '1.00') {
               result += mealElement.portion_name;
            } else if (mealElement.nbportion === '0.25') {
               return '\xBC x ' + mealElement.portion_name;
            } else if (mealElement.nbportion === '0.50') {
               return '\xBD x ' + mealElement.portion_name;
            } else if (mealElement.nbportion === '0.75') {
               return '\xBE x ' + mealElement.portion_name;
            } else {
               var nbPortionStr = parseFloat(mealElement.nbportion).toLocaleString('fr-FR', { maximumFractionDigits: 2 });
               result += nbPortionStr + ' x ' + mealElement.portion_name;
            }
         } else {
            result += mealElement.weight + ' gr';
         }
         return result;
      },
      querySelections: function querySelections(text) {
         var _this4 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var authData;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
               while (1) {
                  switch (_context4.prev = _context4.next) {
                     case 0:
                        //console.log('search text', text)
                        authData = _this4.$store.state.authenticationData;

                        _this4.foodSearchLoading = true;
                        _context4.prev = 2;
                        _context4.next = 5;
                        return _this4.$store.dispatch('meals/GET_FOOD_SEARCH', text);

                     case 5:
                        _this4.foodItems = _context4.sent;

                     case 6:
                        _context4.prev = 6;

                        _this4.foodSearchLoading = false;
                        return _context4.finish(6);

                     case 9:
                     case 'end':
                        return _context4.stop();
                  }
               }
            }, _callee4, _this4, [[2,, 6, 9]]);
         }))();
      },
      onSliderChange: function onSliderChange(nbPortion) {
         this.choosenWeight = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.format(__WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.multiplyByScalar(this.fuzzyChoosenFoodPortionWeight, nbPortion));
      },
      onWeightChange: function onWeightChange(weight) {
         console.log('onWeightChange');
         try {
            var fuzzyWeight = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.parse(weight);
            var fuzzyCount = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.divide(fuzzyWeight, this.fuzzyChoosenFoodPortionWeight);
            this.choosenFoodPortionCount = __WEBPACK_IMPORTED_MODULE_4__utilities_fuzzy_js___default.a.middleValue(fuzzyCount);
         } catch (error) {
            this.choosenFoodPortionCount = 1;
         }
      },
      onWeightChangeDebounced: function onWeightChangeDebounced(weight) {
         console.log('onWeightChangeDebounced');
         var self = this;
         __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
            self.onWeightChange(weight);
         }, 1000)();
      },

      debouncedCreateOrUpdate: function debouncedCreateOrUpdate() {
         var _this5 = this;

         var self = this;
         __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
            self.editDialog = false;
            self.createOrUpdateMealElement(_this5.mealElementToEdit);
         }, 300, { 'leading': true, 'trailing': false })();
      },
      createOrUpdateMealElement: function createOrUpdateMealElement(mealElement) {
         var _this6 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var mealId_, meal, action, favorites;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
               while (1) {
                  switch (_context5.prev = _context5.next) {
                     case 0:
                        mealId_ = _this6.mealId;

                        if (!(mealId_ === null)) {
                           _context5.next = 6;
                           break;
                        }

                        _context5.next = 4;
                        return _this6.$store.dispatch('meals/POST_USER_MEAL', {
                           user: _this6.userId,
                           date: _this6.date,
                           index: _this6.index
                        });

                     case 4:
                        meal = _context5.sent;

                        mealId_ = meal.id;

                     case 6:
                        mealElement.meal = mealId_;
                        mealElement.food = _this6.choosenFood.id;
                        if (_this6.choosenFoodPortion) {
                           mealElement.portion = _this6.choosenFoodPortion.id;
                           // 2 decimal places to make sure it does not get error 400 against Django model MealElement.nbportion
                           mealElement.nbportion = parseFloat(Math.round(_this6.choosenFoodPortionCount * 100) / 100).toFixed(2);
                        }
                        mealElement.weight = _this6.choosenWeight;
                        _context5.prev = 10;
                        action = _this6.create ? 'meals/POST_MEAL_ELEMENT' : 'meals/PUT_MEAL_ELEMENT';
                        _context5.next = 14;
                        return _this6.$store.dispatch(action, mealElement);

                     case 14:
                        _context5.next = 19;
                        break;

                     case 16:
                        _context5.prev = 16;
                        _context5.t0 = _context5['catch'](10);

                        console.log(_context5.t0);

                     case 19:
                        if (!mealElement.portion) {
                           _context5.next = 24;
                           break;
                        }

                        _context5.next = 22;
                        return _this6.$store.dispatch('meals/GET_FAVORITE', { userId: _this6.meal.user, index: _this6.meal.index, portion: mealElement.portion, nbportion: mealElement.nbportion });

                     case 22:
                        favorites = _context5.sent;

                        if (favorites.length === 0) {
                           // create new favorite
                           _this6.$store.dispatch('meals/POST_FAVORITE', { user: _this6.meal.user, index: _this6.meal.index, portion: mealElement.portion, nbportion: mealElement.nbportion });
                        }

                     case 24:
                     case 'end':
                        return _context5.stop();
                  }
               }
            }, _callee5, _this6, [[10, 16]]);
         }))();
      }
   }

});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_fuzzy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_fuzzy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utilities_fuzzy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_meals_FractionningDialog_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_meals_FractionningDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_meals_FractionningDialog_vue__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      baseRoute: String
   },

   components: {
      FractionningDialog: __WEBPACK_IMPORTED_MODULE_10__components_meals_FractionningDialog_vue___default.a
   },

   mounted: function mounted() {
      this.fetchSurveyData();
   },
   data: function data() {
      return {
         selectedMealId: null,
         fractionningDialog: false,
         editedFractionning: {},
         disableFractionningDate: true
      };
   },


   computed: {
      fractionnings: function fractionnings() {
         var _this = this;

         if (this.$store.state.meals.user2surveyFractionningList[this.userId]) {
            return this.$store.state.meals.user2surveyFractionningList[this.userId].map(function (id) {
               return _this.$store.state.meals.fractionnings[id];
            });
         } else {
            return [];
         }
      },
      surveyMeals: function surveyMeals() {
         var _this2 = this;

         var date2meals = {};
         this.fractionnings.forEach(function (fractionning) {
            if (_this2.$store.state.meals.user2date2index2meal[_this2.userId] && _this2.$store.state.meals.user2date2index2meal[_this2.userId][fractionning.date]) {
               var index2meal = _this2.$store.state.meals.user2date2index2meal[_this2.userId][fractionning.date];
               var dateMeals = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(index2meal).map(function (id) {
                  return _this2.$store.state.meals.meals[id];
               });
               date2meals[fractionning.date] = dateMeals;
            }
         });
         return date2meals;
      },
      defaultMealIndexes: function defaultMealIndexes() {
         return __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].MEAL_TYPE_LIST.filter(function (index) {
            return __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].MEAL_TYPES[index]['default'];
         });
      },
      selectedMeal: function selectedMeal() {
         return this.$store.state.meals.meals[this.selectedMealId];
      }
   },

   methods: {
      fetchSurveyData: function fetchSurveyData() {
         var _this3 = this;

         return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var fractionnings;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        _context2.next = 2;
                        return _this3.$store.dispatch('meals/GET_SURVEY_FRACTIONNINGS', _this3.userId);

                     case 2:
                        fractionnings = _context2.sent;

                        // then fetch associated meals
                        fractionnings.forEach(function () {
                           var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(fractionning) {
                              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                 while (1) {
                                    switch (_context.prev = _context.next) {
                                       case 0:
                                          _this3.$store.dispatch('meals/GET_USER_DAY_MEALS', { userId: _this3.userId, date: fractionning.date });

                                       case 1:
                                       case 'end':
                                          return _context.stop();
                                    }
                                 }
                              }, _callee, _this3);
                           }));

                           return function (_x) {
                              return _ref.apply(this, arguments);
                           };
                        }());

                     case 4:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, _this3);
         }))();
      },
      addFractionningDialog: function addFractionningDialog() {
         var today = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');
         this.editedFractionning = {
            user: this.userId,
            date: today,
            mealPresenceArray: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.clone(this.defaultMealIndexes),
            surveyIndex: 0
         };
         this.disableFractionningDate = false;
         this.fractionningDialog = true;
      },
      editFractionningDialog: function editFractionningDialog(date) {
         var fractionningId = this.$store.state.meals.user2date2fractionning[this.userId][date];
         var fractionning = this.$store.state.meals.fractionnings[fractionningId];
         this.editedFractionning = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(fractionning);
         this.disableFractionningDate = true;
         this.fractionningDialog = true;
      },
      setFractionning: function setFractionning() {
         var _this4 = this;

         if (this.editedFractionning.id) {
            var previousFractionning = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(this.$store.state.meals.fractionnings[this.editedFractionning.id]);
            // update existing fractionning
            this.$store.dispatch('meals/PUT_FRACTIONNING', this.editedFractionning);
            // compare `editedFractionning` and `previousFractionning` and add/delete meals accordingly
            this.editedFractionning.mealPresenceArray.forEach(function (index) {
               if (previousFractionning.mealPresenceArray.indexOf(index) === -1) {
                  // add new meal
                  _this4.$store.dispatch('meals/POST_USER_MEAL', { user: _this4.userId, date: _this4.editedFractionning.date, index: index, extra: {} });
               }
            });
            previousFractionning.mealPresenceArray.forEach(function (index) {
               if (_this4.editedFractionning.mealPresenceArray.indexOf(index) === -1) {
                  // delete existing meal
                  var mealId = _this4.$store.state.meals.user2date2index2meal[_this4.userId][_this4.editedFractionning.date][index];
                  _this4.$store.dispatch('meals/DELETE_USER_MEAL', _this4.$store.state.meals.meals[mealId]);
               }
            });
         } else {
            // add new fractionning
            // check whether a fractionning for this date already exist
            if (this.$store.state.meals.user2date2fractionning[this.userId] && this.$store.state.meals.user2date2fractionning[this.userId][this.editedFractionning.date]) {
               // a fractionning for this date already exist
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Des repas existent déjà pour cette journée", color: 'red' });
            } else {
               // create new fractionning
               this.$store.dispatch('meals/POST_FRACTIONNING', this.editedFractionning);
               // create associated empty meals
               this.editedFractionning.mealPresenceArray.forEach(function (index) {
                  _this4.$store.dispatch('meals/POST_USER_MEAL', { user: _this4.userId, date: _this4.editedFractionning.date, index: index, extra: {} });
               });
            }
         }
      },
      fractionningDescription: function fractionningDescription(fractionning) {
         var surveyDescription = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].MEAL_SURVEYS[fractionning.surveyIndex];
         if (surveyDescription) {
            var dateDescription = __WEBPACK_IMPORTED_MODULE_5_moment___default()(fractionning.date).format("DD/MM/YYYY, dddd");
            return surveyDescription.name + ' - ' + dateDescription;
         } else {
            return '';
         }
      },
      mealIndexName: function mealIndexName(meal) {
         return __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].MEAL_TYPES[meal.index] ? __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].MEAL_TYPES[meal.index].name : '';
      },
      selectMeal: function selectMeal(mealId) {
         var _this5 = this;

         return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var meal;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        _this5.selectedMealId = mealId;
                        _context3.next = 3;
                        return _this5.$store.dispatch('meals/GET_MEAL', mealId);

                     case 3:
                        meal = _context3.sent;

                        // fetch meal elements
                        _this5.$store.dispatch('meals/GET_MEAL_ELEMENTS', mealId);
                        // fetch favorites
                        _this5.$store.dispatch('meals/GET_FAVORITES', { userId: _this5.userId, index: meal.index });
                        // change route : UserMealElements will have all necessary information (mealElements)
                        _this5.$router.push('' + _this5.baseRoute + meal.date + '/' + meal.index);

                     case 7:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, _this5);
         }))();
      },
      emitMealsUpdatedEvent: function emitMealsUpdatedEvent() {
         // send event to Coaching component
         this.$emit('userMealsUpdated', this.userId);
      },
      addFavorite: function addFavorite(favorite) {
         var _this6 = this;

         return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var portionWeight, weight, mealElement, favoriteCopy, foodPortion;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
               while (1) {
                  switch (_context4.prev = _context4.next) {
                     case 0:
                        // create and add meal element from favorite
                        portionWeight = __WEBPACK_IMPORTED_MODULE_7__utilities_fuzzy_js___default.a.parse(favorite.portion_weight);
                        weight = __WEBPACK_IMPORTED_MODULE_7__utilities_fuzzy_js___default.a.multiplyByScalar(portionWeight, parseFloat(favorite.nbportion));
                        mealElement = { meal: _this6.selectedMealId, food: favorite.food, weight: __WEBPACK_IMPORTED_MODULE_7__utilities_fuzzy_js___default.a.format(weight), portion: favorite.portion, nbportion: favorite.nbportion };

                        _this6.$store.dispatch('meals/POST_MEAL_ELEMENT', mealElement);
                        // increment favorite count
                        favoriteCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, favorite);

                        favoriteCopy.count += 1;
                        _this6.$store.dispatch('meals/PUT_FAVORITE', favoriteCopy);
                        // fetch favorite's associated foodPortion
                        _context4.next = 9;
                        return _this6.$store.dispatch('meals/GET_FOODPORTION', favorite.portion);

                     case 9:
                        foodPortion = _context4.sent;

                        // then fetch associated food and food's nutdata
                        _this6.$store.dispatch('meals/GET_FOOD', foodPortion.food);
                        _this6.$store.dispatch('meals/GET_FOOD_NUTDATA', foodPortion.food);

                     case 12:
                     case 'end':
                        return _context4.stop();
                  }
               }
            }, _callee4, _this6);
         }))();
      }
   }

});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_formatDate_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number
   },

   mounted: function mounted() {
      var self = this;
      // fetch user and her coaches
      this.$store.dispatch('GET_USER', this.userId).then(function (user) {
         user.coaches.forEach(function (coachId) {
            self.$store.dispatch('GET_USER', coachId);
         });
      });
      // fetch user messages
      this.$store.dispatch('GET_USER_MESSAGES', this.userId);
   },

   data: function data() {
      return {
         selectedMessageId: null,
         newMessageDialog: false,
         messageToSend: {
            user: null,
            text: null,
            author: null,
            visible_by: [],
            read_by: []
         },
         valid: false
      };
   },


   computed: {
      user: function user() {
         return this.$store.state.users[this.userId];
      },
      coaches: function coaches() {
         var _this = this;

         return this.user.coaches.map(function (userId) {
            return _this.$store.state.users[userId];
         });
      },
      possible_targets: function possible_targets() {
         var targets = [];
         if (this.$store.state.loggedUserId !== this.userId) {
            targets.push(this.user);
         }
         var self = this;
         this.user.coaches.forEach(function (coachId) {
            if (coachId !== self.$store.state.loggedUserId) {
               var coach = self.$store.state.users[coachId];
               targets.push(coach);
            }
         });
         return targets;
      },
      messages: function messages() {
         if (this.$store.state.user2messageList.hasOwnProperty(this.userId)) {
            var result = [];
            var self = this;
            this.$store.state.user2messageList[this.userId].forEach(function () {
               var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(messageId) {
                  var message, messageCopy;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                     while (1) {
                        switch (_context.prev = _context.next) {
                           case 0:
                              message = self.$store.state.messages[messageId];
                              // logged user must be the author of the message, or in its 'visible_by' list

                              if (!(message.author === self.$store.state.loggedUserId || message.visible_by.indexOf(self.$store.state.loggedUserId) !== -1)) {
                                 _context.next = 9;
                                 break;
                              }

                              result.push(message);
                              // mark it as read

                              if (!(message.read_by.indexOf(self.$store.state.loggedUserId) === -1)) {
                                 _context.next = 9;
                                 break;
                              }

                              messageCopy = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(message);

                              messageCopy.read_by.push(self.$store.state.loggedUserId);
                              _context.next = 8;
                              return self.$store.dispatch('PUT_USER_MESSAGE', messageCopy);

                           case 8:
                              self.$store.dispatch('COUNT_UNREAD_MESSAGES', self.userId);

                           case 9:
                           case 'end':
                              return _context.stop();
                        }
                     }
                  }, _callee, this);
               }));

               return function (_x) {
                  return _ref.apply(this, arguments);
               };
            }());
            return result;
         } else {
            return [];
         }
      },
      formValid: function formValid() {
         if (this.$v.messageToSend.text.$error) return false;
         if (this.$v.messageToSend.visible_by.$error) return false;
         return true;
      },
      formDirty: function formDirty() {
         return this.$v.messageToSend.$dirty;
      },
      formValidAndDirty: function formValidAndDirty() {
         return this.formValid && this.formDirty;
      },
      targetsErrors: function targetsErrors() {
         var errors = [];
         if (!this.$v.messageToSend.visible_by.$dirty) return errors;
         !this.$v.messageToSend.visible_by.required && errors.push("Un destinataire au moins est requis");
         return errors;
      },
      textErrors: function textErrors() {
         var errors = [];
         if (!this.$v.messageToSend.text.$dirty) return errors;
         !this.$v.messageToSend.text.required && errors.push("Le texte est obligatoire");
         return errors;
      }
   },

   methods: {
      authorName: function authorName(message) {
         var author = this.$store.state.users[message.author];
         return author.fullname;
      },
      sendMessage: function sendMessage(message) {
         try {
            this.$store.dispatch('POST_USER_MESSAGE', message);
         } catch (e) {
            console.log(e.response);
         }
      },
      newMessage: function newMessage() {
         this.messageToSend = {
            user: this.userId,
            author: this.$store.state.loggedUserId,
            visible_by: this.possible_targets.map(function (user) {
               return user.id;
            }),
            read_by: [this.$store.state.loggedUserId],
            text: null
         }, this.newMessageDialog = true;
      },
      onChanged: function onChanged() {
         this.dirty = true;
      },
      formatDate: function formatDate(date) {
         return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utilities_formatDate_js__["a" /* default */])(date);
      }
   },

   // vuelidate validators
   validations: {
      messageToSend: {
         visible_by: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
         },
         text: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
         }
      }
   }

});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
   data: function data() {
      return {};
   },


   computed: {
      // 'nutrieduc', 'shdl'
      platform: function platform() {
         return this.$store.getters.platform;
      }
   },

   mounted: function mounted() {
      if (this.platform) {
         this.$router.push('/news/' + this.platform);
      }
   },

   watch: {
      // necessary at first launch
      'platform': function platform(newVal, oldVal) {
         console.log('platform changed from/to', oldVal, newVal);
         if (newVal) {
            this.$router.push('/news/' + newVal);
         }
      }
   }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
   data: function data() {
      return {
         title: 'Diabétologie, Nutrition et Hygiène de vie',
         shrink: false,
         interval: null
      };
   },
   mounted: function mounted() {
      // start shrinking background image
      this.shrink = true;
   },

   methods: {
      salutanceInfo: function salutanceInfo() {
         console.log('ee');
      }
   }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASESIZE = 24.;

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      size: {
         type: [Number, String],
         default: 120.
      },
      mark: {
         type: String,
         default: "10"
      },
      backColor: {
         type: String,
         default: "#a3937a"
      },
      frontColor: {
         type: String,
         default: "white"
      }
   },

   computed: {
      basesize: function basesize() {
         return BASESIZE;
      },
      scale: function scale() {
         return this.size / BASESIZE;
      },
      svgSize: function svgSize() {
         return 10 + BASESIZE * this.scale + 'px';
      },
      transform: function transform() {
         return "translate(5, 5) scale(" + this.scale + ")";
      },
      starPath: function starPath() {
         return "M10.151 1.013c.931-1.221 2.769-1.219 3.697 0 .617.809 1.688 1.123 2.643.776 1.442-.524 2.987.471 3.111 1.999.081 1.014.812 1.856 1.803 2.081 1.496.339 2.259 2.011 1.536 3.364-.479.896-.32 2.001.393 2.726 1.075 1.095.812 2.913-.526 3.66-.889.495-1.352 1.509-1.145 2.505.313 1.498-.888 2.891-2.421 2.794-1.015-.063-1.953.54-2.317 1.489-.546 1.429-2.31 1.952-3.548 1.042-.819-.602-1.935-.602-2.754 0-1.232.907-2.998.393-3.548-1.042-.363-.949-1.302-1.552-2.316-1.489-1.53.096-2.733-1.292-2.422-2.794.207-.996-.256-2.01-1.144-2.505-1.346-.751-1.598-2.572-.526-3.66.712-.725.871-1.83.392-2.726-.724-1.354.041-3.024 1.536-3.364.991-.225 1.722-1.067 1.804-2.081.122-1.528 1.67-2.522 3.11-1.999.956.347 2.026.033 2.642-.776z";
      },
      circlePath: function circlePath() {
         return "M 6.308363,19.379611 A 9.2306128,9.1798944 0 0 1 4.7182868,6.5108235 9.2306128,9.1798944 0 0 1 17.65403,4.8963053 9.2306128,9.1798944 0 0 1 19.310819,17.756766 9.2306128,9.1798944 0 0 1 6.3836209,19.437609";
      },
      linePath: function linePath() {
         return "M 7.6223714,13.932717 16.754836,12.134988";
      }
   }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      index: Number
   },

   computed: {
      favorites: function favorites() {
         var _this = this;

         if (this.$store.state.meals.user2index2favorites[this.userId] && this.$store.state.meals.user2index2favorites[this.userId][this.index]) {
            var favoriteIds = this.$store.state.meals.user2index2favorites[this.userId][this.index];
            var favorites = favoriteIds.map(function (favoriteId) {
               return _this.$store.state.meals.favorites[favoriteId];
            });
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(favorites, ['count'], ['desc']);
         } else {
            return [];
         }
      }
   },

   methods: {
      pictPath: function pictPath(pict) {
         return '/static/media/' + pict;
      },
      favoritePortionDescription: function favoritePortionDescription(favorite) {
         if (favorite.nbportion === '1.00') {
            return favorite.portion_name;
         } else if (favorite.nbportion === '0.25') {
            return '\xBC x ' + favorite.portion_name;
         } else if (favorite.nbportion === '0.50') {
            return '\xBD x ' + favorite.portion_name;
         } else if (favorite.nbportion === '0.75') {
            return '\xBE x ' + favorite.portion_name;
         } else {
            var nbPortionStr = parseFloat(favorite.nbportion).toLocaleString('fr-FR', { maximumFractionDigits: 2 });
            return nbPortionStr + ' x ' + favorite.portion_name;
         }
      },
      addFavorite: function addFavorite(favorite) {
         this.$emit('addFavorite', favorite);
      }
   }

});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function valueToAngle(liminf, limsup, val) {
   if (val < -1000000) {
      return 150.0;
   }
   if (val > 1000000) {
      return 30.0;
   }
   var ang = 30.0 + 120.0 * (val - liminf) / (limsup - liminf);
   ang = Math.max(ang, 30.0);
   ang = Math.min(ang, 150.0);
   return ang * Math.PI / 180.0;
}

var BASESIZE = 300.; // adapted to a font size of 46

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      name: {
         type: String,
         default: "UNNAMED"
      },
      size: {
         type: [Number, String],
         default: 120.
      },
      domain: {
         type: Object,
         default: { inf: 0., sup: 100. }
      },
      norm: {
         type: Object,
         default: { d1: 40., d2: 60., dt1: 5., dt2: 5., h: 0. }
      },
      value: {
         type: Object,
         default: { d1: 50., d2: 50., dt1: 2., dt2: 2., h: 0. }
      }
   },

   computed: {
      basesize: function basesize() {
         return BASESIZE;
      },
      scale: function scale() {
         return this.size / BASESIZE;
      },
      svgSize: function svgSize() {
         return 10 + BASESIZE * this.scale + 'px';
      },
      transform: function transform() {
         return 'translate(5, 5) scale(' + this.scale + ')';
      },
      redPath: function redPath() {
         return 'M ' + BASESIZE * 0.5 + ',' + BASESIZE * 0.75 + '  l ' + this.xSupRed + ',' + this.ySupRed + '  a  ' + BASESIZE * 0.7 + ',' + BASESIZE * 0.7 + '  0  0,0  ' + (this.xInfRed - this.xSupRed) + ',' + (this.yInfRed - this.ySupRed) + '  z';
      },
      orangePath: function orangePath() {
         return 'M ' + BASESIZE * 0.5 + ',' + BASESIZE * 0.75 + '  l ' + this.xSupOrange + ',' + this.ySupOrange + '  a  ' + BASESIZE * 0.7 + ',' + BASESIZE * 0.7 + '  0  0,0  ' + (this.xInfOrange - this.xSupOrange) + ',' + (this.yInfOrange - this.ySupOrange) + '  z';
      },
      greenPath: function greenPath() {
         return 'M ' + BASESIZE * 0.5 + ',' + BASESIZE * 0.75 + '  l ' + this.xSupGreen + ',' + this.ySupGreen + '  a  ' + BASESIZE * 0.7 + ',' + BASESIZE * 0.7 + '  0  0,0  ' + (this.xInfGreen - this.xSupGreen) + ',' + (this.yInfGreen - this.ySupGreen) + '  z';
      },
      whitePath: function whitePath() {
         return 'M ' + BASESIZE * 0.5 + ',' + BASESIZE * 0.75 + '  l ' + this.xWhite + ',' + this.yWhite + '  a  ' + BASESIZE * 0.5 + ',' + BASESIZE * 0.5 + '  0  0,0  ' + -2. * this.xWhite + ',0  z';
      },
      grayPath: function grayPath() {
         return 'M ' + BASESIZE * 0.5 + ',' + BASESIZE * 0.75 + '  l ' + this.xSupGray + ',' + this.ySupGray + '  a  ' + BASESIZE * 0.65 + ',' + BASESIZE * 0.65 + '  0  0,0  ' + (this.xInfGray - this.xSupGray) + ',' + (this.yInfGray - this.ySupGray) + '  z';
      },
      blackPath: function blackPath() {
         return 'M ' + BASESIZE * 0.5 + ',' + BASESIZE * 0.75 + '  l ' + this.xSupBlack + ',' + this.ySupBlack + '  a  ' + BASESIZE * 0.65 + ',' + BASESIZE * 0.65 + '  0  0,0  ' + (this.xInfBlack - this.xSupBlack) + ',' + (this.yInfBlack - this.ySupBlack) + '  z';
      },
      xWhite: function xWhite() {
         return -BASESIZE * 0.5 * Math.cos(150.0 * Math.PI / 180.0);
      },
      yWhite: function yWhite() {
         return -BASESIZE * 0.5 * Math.sin(150.0 * Math.PI / 180.0);
      },
      xInfRed: function xInfRed() {
         var angInfRed = 30.0 * Math.PI / 180.0;
         return -BASESIZE * 0.7 * Math.cos(angInfRed);
      },
      yInfRed: function yInfRed() {
         var angInfRed = 30.0 * Math.PI / 180.0;
         return -BASESIZE * 0.7 * Math.sin(angInfRed);
      },
      xSupRed: function xSupRed() {
         var angSupRed = 150.0 * Math.PI / 180.0;
         return -BASESIZE * 0.7 * Math.cos(angSupRed);
      },
      ySupRed: function ySupRed() {
         var angSupRed = 150.0 * Math.PI / 180.0;
         return -BASESIZE * 0.7 * Math.sin(angSupRed);
      },
      angInfOrange: function angInfOrange() {
         return valueToAngle(this.domain.inf, this.domain.sup, this.norm.d1 - this.norm.dt1);
      },
      xInfOrange: function xInfOrange() {
         return -BASESIZE * 0.7 * Math.cos(this.angInfOrange);
      },
      yInfOrange: function yInfOrange() {
         return -BASESIZE * 0.7 * Math.sin(this.angInfOrange);
      },
      angSupOrange: function angSupOrange() {
         return valueToAngle(this.domain.inf, this.domain.sup, this.norm.d2 + this.norm.dt2);
      },
      xSupOrange: function xSupOrange() {
         return -BASESIZE * 0.7 * Math.cos(this.angSupOrange);
      },
      ySupOrange: function ySupOrange() {
         return -BASESIZE * 0.7 * Math.sin(this.angSupOrange);
      },
      angInfGreen: function angInfGreen() {
         return valueToAngle(this.domain.inf, this.domain.sup, this.norm.d1);
      },
      xInfGreen: function xInfGreen() {
         return -BASESIZE * 0.7 * Math.cos(this.angInfGreen);
      },
      yInfGreen: function yInfGreen() {
         return -BASESIZE * 0.7 * Math.sin(this.angInfGreen);
      },
      angSupGreen: function angSupGreen() {
         return valueToAngle(this.domain.inf, this.domain.sup, this.norm.d2);
      },
      xSupGreen: function xSupGreen() {
         return -BASESIZE * 0.7 * Math.cos(this.angSupGreen);
      },
      ySupGreen: function ySupGreen() {
         return -BASESIZE * 0.7 * Math.sin(this.angSupGreen);
      },
      angInfGray: function angInfGray() {
         return valueToAngle(this.domain.inf, this.domain.sup, this.value.d1 - this.value.dt1);
      },
      xInfGray: function xInfGray() {
         return -BASESIZE * 0.65 * Math.cos(this.angInfGray);
      },
      yInfGray: function yInfGray() {
         return -BASESIZE * 0.65 * Math.sin(this.angInfGray);
      },
      angSupGray: function angSupGray() {
         return valueToAngle(this.domain.inf, this.domain.sup, this.value.d2 + this.value.dt2);
      },
      xSupGray: function xSupGray() {
         return -BASESIZE * 0.65 * Math.cos(this.angSupGray);
      },
      ySupGray: function ySupGray() {
         return -BASESIZE * 0.65 * Math.sin(this.angSupGray);
      },
      xInfBlack: function xInfBlack() {
         var angInfBlack = valueToAngle(this.domain.inf, this.domain.sup, this.value.d1);
         return -BASESIZE * 0.65 * Math.cos(angInfBlack);
      },
      yInfBlack: function yInfBlack() {
         var angInfBlack = valueToAngle(this.domain.inf, this.domain.sup, this.value.d1);
         return -BASESIZE * 0.65 * Math.sin(angInfBlack);
      },
      xSupBlack: function xSupBlack() {
         var angSupBlack = valueToAngle(this.domain.inf, this.domain.sup, this.value.d2);
         return -BASESIZE * 0.65 * Math.cos(angSupBlack);
      },
      ySupBlack: function ySupBlack() {
         var angSupBlack = valueToAngle(this.domain.inf, this.domain.sup, this.value.d2);
         return -BASESIZE * 0.65 * Math.sin(angSupBlack);
      },
      style: function style() {
         if (this.value.d1 - this.value.dt1 > this.norm.d2 + this.norm.dt2 || this.value.d2 + this.value.dt2 < this.norm.d1 - this.norm.dt1) {
            return 'fill:#da2d2a;'; // red
         } else if (this.value.d1 - this.value.dt1 >= this.norm.d1 && this.value.d2 + this.value.dt2 <= this.norm.d2) {
            return 'fill:#5bca72;'; // green
         } else {
               return 'fill:#f1b463;'; // orange
            }
      }
   }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_nutrieduc_Galva_vue__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_nutrieduc_Galva_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_nutrieduc_Galva_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_nutrieduc_Badge_vue__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_nutrieduc_Badge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_nutrieduc_Badge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_fuzzy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_fuzzy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utilities_fuzzy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

   components: {
      Galva: __WEBPACK_IMPORTED_MODULE_0__components_nutrieduc_Galva_vue___default.a,
      Badge: __WEBPACK_IMPORTED_MODULE_1__components_nutrieduc_Badge_vue___default.a
   },

   props: {
      userId: Number,
      date: String,
      index: Number
   },

   data: function data() {
      return {
         nutrnoArray: ['208', '204', '205', '203']
      };
   },


   computed: {
      mealId: function mealId() {
         if (this.$store.state.meals.user2date2index2meal[this.userId] && this.$store.state.meals.user2date2index2meal[this.userId][this.date] && this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index]) {
            return this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index];
         } else {
            return null;
         }
      },
      meal: function meal() {
         if (this.mealId) {
            return this.$store.state.meals.meals[this.mealId];
         } else {
            return null;
         }
      },
      mealElements: function mealElements() {
         var _this = this;

         if (this.$store.state.meals.meal2mealElementList.hasOwnProperty(this.mealId)) {
            return this.$store.state.meals.meal2mealElementList[this.mealId].map(function (mealElementId) {
               return _this.$store.state.meals.mealElements[mealElementId];
            });
         } else {
            return [];
         }
      },
      mealElementWeights: function mealElementWeights() {
         return this.mealElements.map(function (mealElement) {
            return __WEBPACK_IMPORTED_MODULE_2__utilities_fuzzy_js___default.a.parse(mealElement.weight);
         });
      },
      user: function user() {
         return this.$store.state.users[this.userId];
      },
      nutrients: function nutrients() {
         var _this2 = this;

         return this.nutrnoArray.map(function (nutr_no) {
            return _this2.$store.state.meals.nutrients[nutr_no];
         });
      },
      rda: function rda() {
         return this.user.extra.gender === "M" ? 8.8 * this.user.extra.height + 932. : 17.5 * this.extra.height - 700.;
      },
      fractionning: function fractionning() {
         if (this.userId && this.date && this.$store.state.meals.user2date2fractionning[this.userId] && this.$store.state.meals.user2date2fractionning[this.userId][this.date]) {
            var fractionningId = this.$store.state.meals.user2date2fractionning[this.userId][this.date];
            return this.$store.state.meals.fractionnings[fractionningId];
         } else {
            return null;
         }
      },
      fractionningCategory: function fractionningCategory() {
         return __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default.a.evaluateFractionning(this.fractionning);
      },
      mealPercentage: function mealPercentage() {
         var isDiabetic = false;
         var lowCalories = !isDiabetic && this.rda < 1600;
         return __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default.a.getMealPercentage(this.fractionningCategory, lowCalories, this.index);
      },
      mealEnergy: function mealEnergy() {
         return this.rda * this.mealPercentage * 0.01;
      },
      nutrientRangeDict: function nutrientRangeDict() {
         var _this3 = this;

         var dict = {};
         var mealEnergy = this.rda * this.mealPercentage * 0.01;
         this.nutrnoArray.forEach(function (nutr_no) {
            var nutrient = _this3.$store.state.meals.nutrients[nutr_no];
            dict[nutr_no] = nutrient ? __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default.a.getNutrientAbsoluteRange(_this3.user, nutrient, mealEnergy) : { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 };
         });
         return dict;
      },
      nutrientLimSupDict: function nutrientLimSupDict() {
         var _this4 = this;

         var dict = {};
         var mealEnergy = this.rda * this.mealPercentage * 0.01;
         this.nutrnoArray.forEach(function (nutr_no) {
            var nutrient = _this4.$store.state.meals.nutrients[nutr_no];
            dict[nutr_no] = nutrient ? __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default.a.getNutrientLimSup(nutrient, mealEnergy) : 0.;
         });
         return dict;
      },
      nutrientArray: function nutrientArray() {
         var _this5 = this;

         return this.nutrnoArray.map(function (nutr_no) {
            return __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default.a.computeNutrientValue(nutr_no, _this5.mealElements, _this5.$store.state.meals.foods, _this5.$store.state.meals.foodPortions, _this5.$store.state.meals.nutdatas, _this5.$store.state.meals.food2nutrient2nutdata);
         });
      },
      nutrientDict: function nutrientDict() {
         var _this6 = this;

         var dict = {};
         this.nutrnoArray.forEach(function (nutrno, index) {
            dict[nutrno] = _this6.nutrientArray[index];
         });
         return dict;
      },
      mealScore: function mealScore() {
         return __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default.a.getMealScore(this.user, this.nutrients, this.mealElements, this.mealEnergy, this.$store.state.meals.foods, this.$store.state.meals.foodPortions, this.$store.state.meals.nutdatas, this.$store.state.meals.food2nutrient2nutdata);
      },
      mealMark: function mealMark() {
         var score10 = this.mealScore * 10.;
         return score10.toLocaleString('fr-FR', { maximumSignificantDigits: 2 });
      }
   },

   methods: {
      isMealPresent: function isMealPresent(index) {
         return __WEBPACK_IMPORTED_MODULE_3__utilities_nutrition_nutrition_js___default.a.isMealPresent(this.fractionning, index);
      }
   }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_fuzzy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_fuzzy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utilities_fuzzy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_meals_FractionningDialog_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_meals_FractionningDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_meals_FractionningDialog_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var path = __webpack_require__(1089);




/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      baseRoute: String
   },

   components: {
      FractionningDialog: __WEBPACK_IMPORTED_MODULE_8__components_meals_FractionningDialog_vue___default.a
   },

   mounted: function mounted() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
         var today;
         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     today = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');

                     _this.changeDate(today);

                  case 2:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, _this);
      }))();
   },
   data: function data() {
      return {
         currentDate: null,
         currentIndex: null,

         pickerDateModal: null,
         pickerDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
         fractionningDialog: false,
         editedFractionning: {}
      };
   },


   computed: {
      displayDate: function displayDate() {
         return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentDate).format("dddd, Do MMMM YYYY");
      },
      fractionning: function fractionning() {
         if (this.userId && this.currentDate && this.$store.state.meals.user2date2fractionning[this.userId] && this.$store.state.meals.user2date2fractionning[this.userId][this.currentDate]) {
            var fractionningId = this.$store.state.meals.user2date2fractionning[this.userId][this.currentDate];
            return this.$store.state.meals.fractionnings[fractionningId];
         } else {
            return null;
         }
      },
      mealTypes: function mealTypes() {
         return __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].MEAL_TYPES;
      },
      mealNames: function mealNames() {
         return __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].MEAL_TYPE_LIST.map(function (index) {
            return __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].MEAL_TYPES[index]['name'];
         });
      },
      defaultMealIndexes: function defaultMealIndexes() {
         return __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].MEAL_TYPE_LIST.filter(function (index) {
            return __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].MEAL_TYPES[index]['default'];
         });
      }
   },

   methods: {
      isMealPresent: function isMealPresent(index) {
         return this.fractionning && this.fractionning.mealPresenceArray.indexOf(parseInt(index)) !== -1;
      },
      openFractionningDialog: function openFractionningDialog() {
         this.fractionningDialog = true;
         this.editedFractionning = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.fractionning);
      },
      setFractionning: function setFractionning() {
         var _this2 = this;

         // store edited fractionning
         this.$store.dispatch('meals/PUT_FRACTIONNING', this.editedFractionning);
         // compare `editedFractionning` && `fractionning` && add/delete meals accordingly
         this.editedFractionning.mealPresenceArray.forEach(function (index) {
            if (_this2.fractionning.mealPresenceArray.indexOf(index) === -1) {
               // add new meal
               _this2.$store.dispatch('meals/POST_USER_MEAL', { user: _this2.userId, date: _this2.currentDate, index: index, extra: {} });
            }
         });
         this.fractionning.mealPresenceArray.forEach(function (index) {
            if (_this2.editedFractionning.mealPresenceArray.indexOf(index) === -1) {
               // delete existing meal
               var mealId = _this2.$store.state.meals.user2date2index2meal[_this2.userId][_this2.currentDate][index];
               _this2.$store.dispatch('meals/DELETE_USER_MEAL', _this2.$store.state.meals.meals[mealId]);
            }
         });
         // fetch reactive data && change route
         // ??? necessary ???
         this.fetchCurrentMealAndFavoritesAndChangeRoute();
      },
      cancelFractionning: function cancelFractionning() {
         // fetch reactive data && change route
         this.fetchCurrentMealAndFavoritesAndChangeRoute();
      },
      changeDate: function changeDate(date) {
         var _this3 = this;

         return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var fractionning;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        _this3.currentDate = date;
                        _context2.next = 3;
                        return _this3.$store.dispatch('meals/GET_FRACTIONNING', { userId: _this3.userId, date: _this3.currentDate });

                     case 3:
                        fractionning = _context2.sent;

                        if (!(fractionning === null)) {
                           _context2.next = 11;
                           break;
                        }

                        _context2.next = 7;
                        return _this3.$store.dispatch('meals/POST_FRACTIONNING', {
                           user: _this3.userId,
                           date: _this3.currentDate,
                           mealPresenceArray: _this3.defaultMealIndexes
                        });

                     case 7:
                        // then create all meals of default fractionning
                        _this3.defaultMealIndexes.forEach(function (index) {
                           _this3.$store.dispatch('meals/POST_USER_MEAL', { user: _this3.userId, date: _this3.currentDate, index: index, extra: {} });
                        });
                        // then open fractionning dialog
                        _this3.openFractionningDialog();
                        _context2.next = 14;
                        break;

                     case 11:
                        // update currentIndex in the case where it does not exist for the new fractionning
                        if (_this3.currentIndex === null) _this3.currentIndex = 2; // default initial value
                        if (fractionning.mealPresenceArray.indexOf(_this3.currentIndex) === -1) {
                           // set it to the first existing index of new fractionning
                           _this3.currentIndex = fractionning.mealPresenceArray[0];
                        }
                        // fetch reactive data && change route
                        _this3.fetchCurrentMealAndFavoritesAndChangeRoute();

                     case 14:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, _this3);
         }))();
      },
      changeIndex: function changeIndex(index) {
         // update currentIndex
         this.currentIndex = index;
         // fetch reactive data && change route
         this.fetchCurrentMealAndFavoritesAndChangeRoute();
      },
      addFavorite: function addFavorite(favorite) {
         var _this4 = this;

         return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var portionWeight, weight, mealId, mealElement, favoriteCopy, foodPortion;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        // create && add meal element from favorite
                        portionWeight = __WEBPACK_IMPORTED_MODULE_6__utilities_fuzzy_js___default.a.parse(favorite.portion_weight);
                        weight = __WEBPACK_IMPORTED_MODULE_6__utilities_fuzzy_js___default.a.multiplyByScalar(portionWeight, parseFloat(favorite.nbportion));
                        mealId = _this4.$store.state.meals.user2date2index2meal[_this4.userId][_this4.currentDate][_this4.currentIndex];
                        mealElement = { meal: mealId, food: favorite.food, weight: __WEBPACK_IMPORTED_MODULE_6__utilities_fuzzy_js___default.a.format(weight), portion: favorite.portion, nbportion: favorite.nbportion };

                        _this4.$store.dispatch('meals/POST_MEAL_ELEMENT', mealElement);
                        // increment favorite count
                        favoriteCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, favorite);

                        favoriteCopy.count += 1;
                        _this4.$store.dispatch('meals/PUT_FAVORITE', favoriteCopy);
                        // fetch favorite's associated foodPortion
                        _context3.next = 10;
                        return _this4.$store.dispatch('meals/GET_FOODPORTION', favorite.portion);

                     case 10:
                        foodPortion = _context3.sent;

                        // then fetch associated food and food's nutdata
                        _this4.$store.dispatch('meals/GET_FOOD', foodPortion.food);
                        _this4.$store.dispatch('meals/GET_FOOD_NUTDATA', foodPortion.food);

                     case 13:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, _this4);
         }))();
      },
      fetchCurrentMealAndFavoritesAndChangeRoute: function fetchCurrentMealAndFavoritesAndChangeRoute() {
         // fetch meal
         var self = this;
         this.$store.dispatch('meals/GET_USER_MEAL', { userId: this.userId, date: this.currentDate, index: this.currentIndex }).then(function (meal) {
            // then fetch meal elements
            return self.$store.dispatch('meals/GET_MEAL_ELEMENTS', meal.id);
         }).then(function (mealElements) {
            // then fetch associated Food, FoodPortion, NutData for each MealElement
            mealElements.forEach(function (mealElement) {
               var foodId = mealElement.food;
               if (mealElement.foodPortion) {
                  self.$store.dispatch('meals/GET_FOOD_PORTION', mealElement.foodPortion).then(function (foodPortion) {
                     if (!foodId) foodId = foodPortion.food;
                  });
               }
               self.$store.dispatch('meals/GET_FOOD', foodId);
               self.$store.dispatch('meals/GET_FOOD_NUTDATA', foodId);
            });
         });
         // fetch favorites
         this.$store.dispatch('meals/GET_FAVORITES', { userId: this.userId, index: this.currentIndex });
         // fetch nutrients
         this.$store.dispatch('meals/GET_NUTRIENTS');
         // change route
         var newRoute = path.join(this.baseRoute, __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentDate).format("YYYY-MM-DD"), '' + this.currentIndex);
         this.$router.push(newRoute);
      }
   }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
   mounted: function mounted() {
      // fetch questions; reactivity will update question list
      this.$store.dispatch('nutrikiosk/GET_QCU_QUESTIONS');
   },


   data: function data() {
      return {};
   },

   methods: {},

   computed: {
      questions: function questions() {
         return this.$store.getters['nutrikiosk/qcuQuestions'];
      }
   }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_nutrikiosk_QCUList__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_nutrikiosk_QCUList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_nutrikiosk_QCUList__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      baseRoute: String
   },

   components: {
      qculist: __WEBPACK_IMPORTED_MODULE_2__components_nutrikiosk_QCUList___default.a
   },

   mounted: function mounted() {
      // fetch questions; reactivity will update question list
      this.$store.dispatch('nutrikiosk/GET_QCU_QUESTIONS');
   },
   data: function data() {
      return {
         selectedQuestionId: null
      };
   },


   computed: {
      questions: function questions() {
         return this.$store.getters['nutrikiosk/qcuQuestions'];
      }
   },

   methods: {
      questionSelected: function questionSelected(questionId) {
         var _this = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        // select question in list
                        _this.selectedQuestionId = questionId;
                        // get associated images & items
                        _context.next = 3;
                        return _this.$store.dispatch('nutrikiosk/GET_QCU_IMAGES', questionId);

                     case 3:
                        _context.next = 5;
                        return _this.$store.dispatch('nutrikiosk/GET_QCU_ITEMS', questionId);

                     case 5:
                        // change route
                        _this.$router.push(_this.baseRoute + 'question/' + questionId);

                     case 6:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, _this);
         }))();
      },
      addQuestion: function addQuestion() {
         this.$router.push('/qcu-editor/create');
      },
      createQuestion: function createQuestion(question) {
         this.$store.dispatch('nutrikiosk/POST_QCU_QUESTION', question);
      },
      updateQuestion: function updateQuestion(question) {
         this.$store.dispatch('nutrikiosk/PUT_QCU_QUESTION', question);
      },
      deleteQuestion: function deleteQuestion(question) {
         this.$store.dispatch('nutrikiosk/DELETE_QCU_QUESTION', question);
      },

      updatedList: function updatedList() {
         // list has been updated: unselect all & remove detail view
         this.selectedQuestionId = null;
         this.$router.push('/qcu-editor/');
      }

   }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__ = __webpack_require__(216);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      questions: Array,
      selectedQuestionId: Number
   },

   data: function data() {
      return {
         deleteDialog: false,
         questionToDelete: {},
         playDialog: false,
         questionToPlay: {},
         answerDialog: false,
         answeredItem: {},
         filterDialog: false,
         valid: false,
         dirty: false,
         editedFilter: {
            selectedTypes: ['truefalse', 'intruder', 'findadish'],
            filterTypes: false,
            selectedLevels: ['easy', 'medium', 'expert'],
            includedDiabetes: ['nodiabetes', 'type1', 'type2'],
            excludedDiabetes: [],
            includedCholesterols: ['no', 'yes'],
            excludedCholesterols: [],
            includedSSsels: ['noss', 'ss2g', 'ss4g', 'ss6g'],
            excludedSSsels: []
         },
         currentFilter: {
            selectedTypes: ['truefalse', 'intruder', 'findadish'],
            filterTypes: false,
            selectedLevels: ['easy', 'medium', 'expert'],
            includedDiabetes: ['nodiabetes', 'type1', 'type2'],
            excludedDiabetes: [],
            includedCholesterols: ['no', 'yes'],
            excludedCholesterols: [],
            includedSSsels: ['noss', 'ss2g', 'ss4g', 'ss6g'],
            excludedSSsels: []
         },
         search: null
      };
   },


   computed: {
      types: function types() {
         return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].typeList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].types[uid];
         });
      },
      levels: function levels() {
         return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].levelList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].levels[uid];
         });
      },
      diabetes: function diabetes() {
         return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].diabetesList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].diabetes[uid];
         });
      },
      cholesterols: function cholesterols() {
         return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].cholesterolList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].cholesterols[uid];
         });
      },
      sssels: function sssels() {
         return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].ssselList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].sssels[uid];
         });
      },
      filteredQuestions: function filteredQuestions() {
         var filtered = this.questions;

         // type filtering
         var selectedTypes = this.currentFilter.selectedTypes;
         filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filtered, function (question) {
            return selectedTypes.indexOf(question.type) !== -1;
         });
         // level filtering
         var selectedLevels = this.currentFilter.selectedLevels;
         filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filtered, function (question) {
            return selectedLevels.indexOf(question.level) !== -1;
         });

         // diabetes questions filtering
         var includedDiabetes = this.currentFilter.includedDiabetes;
         var excludedDiabetes = this.currentFilter.excludedDiabetes;
         filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filtered, function (question) {
            if (question.diabete.indexOf('0') !== -1 && (includedDiabetes.indexOf('nodiabetes') === -1 || excludedDiabetes.indexOf('nodiabetes') !== -1)) return false;
            if (question.diabete.indexOf('1') !== -1 && (includedDiabetes.indexOf('type1') === -1 || excludedDiabetes.indexOf('type1') !== -1)) return false;
            if (question.diabete.indexOf('2') !== -1 && (includedDiabetes.indexOf('type2') === -1 || excludedDiabetes.indexOf('type2') !== -1)) return false;
            return true;
         });
         // cholesterol questions filtering
         var includedCholesterols = this.currentFilter.includedCholesterols;
         var excludedCholesterols = this.currentFilter.excludedCholesterols;
         filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filtered, function (question) {
            if (question.chol.indexOf('0') !== -1 && (includedCholesterols.indexOf('no') === -1 || excludedCholesterols.indexOf('nodiabetes') !== -1)) return false;
            if (question.chol.indexOf('1') !== -1 && (includedCholesterols.indexOf('yes') === -1 || excludedCholesterols.indexOf('type1') !== -1)) return false;
            return true;
         });
         // sssel questions filtering
         var includedSSsels = this.currentFilter.includedSSsels;
         var excludedSSsels = this.currentFilter.excludedSSsels;
         filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filtered, function (question) {
            if (question.sssel.indexOf('0') !== -1 && (includedSSsels.indexOf('noss') === -1 || excludedSSsels.indexOf('noss') !== -1)) return false;
            if (question.sssel.indexOf('2') !== -1 && (includedSSsels.indexOf('ss2g') === -1 || excludedSSsels.indexOf('ss2g') !== -1)) return false;
            if (question.sssel.indexOf('4') !== -1 && (includedSSsels.indexOf('ss4g') === -1 || excludedSSsels.indexOf('ss4g') !== -1)) return false;
            if (question.sssel.indexOf('6') !== -1 && (includedSSsels.indexOf('ss6g') === -1 || excludedSSsels.indexOf('ss6g') !== -1)) return false;
            return true;
         });

         if (this.search !== null) {
            var searchText = this.search.toLowerCase();
            filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filtered, function (question) {
               return question.question.toLowerCase().indexOf(searchText) !== -1;
            });
         }
         return filtered;
      },
      playTitle: function playTitle() {
         return this.questionToPlay.type ? __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].types[this.questionToPlay.type].name : '';
      },
      playPoints: function playPoints() {
         return this.questionToPlay.level ? __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].levels[this.questionToPlay.level].points : '';
      },
      questionToPlayImages: function questionToPlayImages() {
         var _this = this;

         return this.questionToPlay.id ? this.$store.state.nutrikiosk.qcuQuestion2qcuImageList[this.questionToPlay.id].map(function (qcuImageId) {
            return _this.$store.state.nutrikiosk.qcuImages[qcuImageId];
         }) : [];
      },
      questionToPlayItems: function questionToPlayItems() {
         var _this2 = this;

         return this.questionToPlay.id ? this.$store.state.nutrikiosk.qcuQuestion2qcuItemList[this.questionToPlay.id].map(function (qcuItemId) {
            return _this2.$store.state.nutrikiosk.qcuItems[qcuItemId];
         }) : [];
      }
   },

   methods: {
      clone: function clone(question) {
         return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(question);
      },
      selectQuestion: function selectQuestion(questionId) {
         this.$emit('questionSelected', questionId);
      },
      addQuestion: function addQuestion() {
         this.$emit('addQuestion');
      },
      deleteQuestion: function deleteQuestion(question) {
         this.$emit('deleteQuestion', question);
      },
      typeIcon: function typeIcon(question) {
         //return 'extension'
         return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].types[question.type].icon;
      },
      level: function level(question) {
         return __WEBPACK_IMPORTED_MODULE_4__utilities_qcuConstants_js__["a" /* default */].levels[question.level].name;
      },

      openFilterDialog: function openFilterDialog() {
         //this.editedFilter = _.clone(this.currentFilter)
         this.filterDialog = true;
      },
      setFilter: function setFilter() {
         this.currentFilter = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(this.editedFilter);
         this.$emit('updatedList');
      },
      playQuestion: function playQuestion(question) {
         var _this3 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        _context.next = 2;
                        return _this3.$store.dispatch('nutrikiosk/GET_QCU_IMAGES', question.id);

                     case 2:
                        _context.next = 4;
                        return _this3.$store.dispatch('nutrikiosk/GET_QCU_ITEMS', question.id);

                     case 4:
                        _this3.questionToPlay = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(question);
                        _this3.playDialog = true;

                     case 6:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, _this3);
         }))();
      },

      questionAnswered: function questionAnswered(item) {
         this.answeredItem = item;
         this.answerDialog = true;
      },
      onChanged: function onChanged() {
         this.dirty = true;
      }
   }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__ = __webpack_require__(216);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
   props: {
      questionId: Number
   },

   data: function data() {
      return {
         valid: false,
         dirty: false,
         requiredRules: [function (v) {
            return !!v || 'Ce champ est obligatoire';
         }]
      };
   },


   computed: {
      question: function question() {
         // question changed : form is not dirty
         this.dirty = false;
         if (this.questionId > 0) {
            // Vuex question
            var question = this.$store.getters['nutrikiosk/qcuQuestions'][this.questionId];
            // form operates on a clone of Vuex question (otherwise, direct store change)
            return _.clone(question);
         } else {
            return {
               type: null,
               level: null,
               question: ''
            };
         }
      },
      images: function images() {
         var _this = this;

         return this.$store.state.nutrikiosk.qcuQuestion2qcuImageList[this.questionId].map(function (qcuImageId) {
            return _this.$store.state.nutrikiosk.qcuImages[qcuImageId];
         });
      },
      items: function items() {
         var _this2 = this;

         return this.$store.state.nutrikiosk.qcuQuestion2qcuItemList[this.questionId].map(function (qcuItemId) {
            return _this2.$store.state.nutrikiosk.qcuItems[qcuItemId];
         });
      },
      types: function types() {
         return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].typeList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].types[uid];
         });
      },
      levels: function levels() {
         return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].levelList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].levels[uid];
         });
      },
      diabetes: function diabetes() {
         return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].diabetesList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].diabetes[uid];
         });
      },
      cholesterols: function cholesterols() {
         return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].cholesterolList.map(function (uid) {
            return __WEBPACK_IMPORTED_MODULE_0__utilities_qcuConstants_js__["a" /* default */].cholesterols[uid];
         });
      }
   },

   methods: {
      onChanged: function onChanged() {
         this.dirty = true;
      },
      create: function create() {
         this.$emit('createQuestion', this.question);
      },
      update: function update() {
         this.$emit('updateQuestion', this.question);
      },
      diabetesStringToList: function diabetesStringToList(str) {
         var list = [];
         if (str.indexOf('0') !== -1) list.push('nodiabetes');
         if (str.indexOf('1') !== -1) list.push('type1');
         if (str.indexOf('2') !== -1) list.push('type2');
         return list;
      },
      diabetesListToString: function diabetesListToString(list) {
         var str = '';
         if (list.indexOf('nodiabetes') !== -1) str += '0';
         if (list.indexOf('type1') !== -1) str += '1';
         if (list.indexOf('type2') !== -1) str += '2';
         return str;
      },
      onDiabetesChanged: function onDiabetesChanged(question, list) {
         this.dirty = true;
         question.diabete = this.diabetesListToString(list);
      },
      cholesterolStringToList: function cholesterolStringToList(str) {
         var list = [];
         if (str.indexOf('0') !== -1) list.push('no');
         if (str.indexOf('1') !== -1) list.push('yes');
         return list;
      },
      cholesterolListToString: function cholesterolListToString(list) {
         var str = '';
         if (list.indexOf('no') !== -1) str += '0';
         if (list.indexOf('yes') !== -1) str += '1';
         return str;
      },
      onCholesterolChanged: function onCholesterolChanged(question, list) {
         this.dirty = true;
         question.chol = this.cholesterolListToString(list);
      }
   }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//

// adapted from https://www.npmjs.com/package/vue-codemirror-lite

var CodeMirror = __webpack_require__(102);
__webpack_require__(1007);
__webpack_require__(939);
__webpack_require__(938);

/* harmony default export */ __webpack_exports__["default"] = ({
   props: {
      value: String,
      readOnly: { type: Boolean, default: false },
      selectedline: Number,
      styleactiveline: Boolean,
      options: {
         type: Object,
         default: function _default() {
            return {
               readOnly: false,
               styleActiveLine: true,
               lineNumbers: true,
               lineWrapping: true,
               tabSize: 3,
               //styleSelectedText: true,
               firstLineNumber: 1
            };
         }
      }
   },
   created: function created() {
      // adapted from https://github.com/codemirror/CodeMirror/blob/master/demo/simplemode.html
      CodeMirror.defineSimpleMode("simplemode", {
         // The start state contains the rules that are intially used
         start: [
         // The regex matches the token, the token property contains the type
         //{regex: /"(?:[^\\]|\\.)*?(?:"|$)/, token: "string"},
         // You can match multiple tokens at once. Note that the captured
         // groups must span the whole string in this case
         //{regex: /(function)(\s+)([a-z$][\w$]*)/, token: ["keyword", null, "variable-2"]},
         // Rules are matched in the order in which they appear, so there is
         // no ambiguity between this one and the one above
         //{regex: /(?:function|var|return|if|for|while|else|do|this)\b/, token: "keyword"},

         { regex: /(?:module|end|fsm)\b/, token: "keyword" },

         //{regex: /true|false|null|undefined/, token: "atom"},
         { regex: /go|compare|push|pop|call|return|stop/, token: "atom" }, { regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i, token: "number" }, { regex: /\/\/.*/, token: "comment" },
         //{regex: /\/(?:[^\\]|\\.)*?\//, token: "variable-3"},
         // A next property will cause the mode to move to a different state
         { regex: /\/\*/, token: "comment", next: "comment" }, { regex: /[-+/*=<>!]+/, token: "operator" }],
         // The multi-line comment state.
         comment: [{ regex: /.*?\*\//, token: "comment", next: "start" }, { regex: /.*/, token: "comment" }],
         // The meta property contains global information about the mode. It
         // can contain properties like lineComment, which are supported by
         // all modes, and also directives like dontIndentStates, which are
         // specific to simple modes.
         meta: {
            dontIndentStates: ["comment"],
            lineComment: "//"
         }
      });
   },
   mounted: function mounted() {
      var _this = this;
      this.editor = CodeMirror.fromTextArea(this.$el, this.options);
      this.editor.setValue(this.value);
      this.editor.setOption('styleActiveLine', this.styleactiveline);
      this.editor.setOption('readOnly', this.readOnly);
      this.editor.on('change', function (cm) {
         if (_this.$emit) {
            _this.$emit('change', cm.getValue());
            _this.$emit('input', cm.getValue());
         }
      });

      this.editor.setOption('mode', 'simplemode');
   },
   watch: {
      'value': function value(newVal, oldVal) {
         var editorValue = this.editor.getValue();
         if (newVal !== editorValue) {
            this.editor.removeLineClass(oldVal, "background", "styled-background");
            var scrollInfo = this.editor.getScrollInfo();
            this.editor.setValue(newVal);
            this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
         }
      },
      'selectedline': function selectedline(newVal, oldVal) {
         //this.editor.setCursor(newVal)
         this.editor.removeLineClass(oldVal, "background", "styled-background");
         this.editor.addLineClass(newVal, "background", "styled-background");
      },
      'styleactiveline': function styleactiveline(newVal, oldVal) {
         this.editor.setOption('styleActiveLine', newVal);
      },
      'readOnly': function readOnly(newVal, oldVal) {
         this.editor.setOption('readOnly', newVal);
      },
      'options': function options(newOptions, oldVal) {
         if ((typeof newOptions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(newOptions)) === 'object') {
            for (var optionName in newOptions) {
               if (newOptions.hasOwnProperty(optionName)) {
                  this.editor.setOption(optionName, newOptions[optionName]);
               }
            }
         }
      }
   },
   beforeDestroy: function beforeDestroy() {
      if (this.editor) {
         this.editor.toTextArea();
      }
   }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shdl_doc_txt__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shdl_doc_txt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shdl_doc_txt__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
   computed: {
      compiledMarkdown: function compiledMarkdown() {
         return __WEBPACK_IMPORTED_MODULE_0_marked___default()(__WEBPACK_IMPORTED_MODULE_1__shdl_doc_txt___default.a, { sanitize: true });
      }
   }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shdl_ShdlCodeMirror__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shdl_ShdlCodeMirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shdl_ShdlCodeMirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_shdl_shdlAnalyser_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_shdl_shdlAnalyser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utilities_shdl_shdlAnalyser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlUtilities_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlUtilities_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlUtilities_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* Voir Pegjs.org pour un Codemirror ajusté à la taille de l'écran :
function doLayout() {
    $("#left-column").height("0px");    // needed for IE
    $("#right-column").height("0px");   // needed for IE
    $(".CodeMirror").height("0px");
    $("#input").height("0px");

    $("#left-column").height(($("#left-column").parent().innerHeight() - 2) + "px");     // needed for IE
    $("#right-column").height(($("#right-column").parent().innerHeight() - 2) + "px");   // needed for IE
    $(".CodeMirror").height(($(".CodeMirror").parent().parent().innerHeight() - 14) + "px");
    $("#input").height(($("#input").parent().parent().innerHeight() - 14) + "px");
  }
*/







/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      module: Object
   },

   components: {
      ShdlCodeMirror: __WEBPACK_IMPORTED_MODULE_0__components_shdl_ShdlCodeMirror___default.a
   },

   data: function data() {
      return {
         editedText: "",
         selectedline: 0,
         styleactiveline: null,
         err: null,
         equipotentialCount: null,
         unusedEquipotentialCount: null
      };
   },


   mounted: function mounted() {
      var mountedModule = this.$store.state.shdl.modules[this.module.id];
      this.editedText = mountedModule.text;
      this.parseModule();
      // set editor height dynamically
      var element = this.$refs.editor.$el.parentElement;
      element.style.height = this.$store.state.appHeight - 233 + 'px';
   },

   beforeDestroy: function beforeDestroy() {
      console.log('beforeDestroy...');
      this.saveIfModified(this.module.id);
   },

   watch: {
      'module.id': function moduleId(newVal, oldVal) {
         console.log('module.id changed from/to', oldVal, newVal);
         if (newVal) {
            this.saveIfModified(oldVal);
            var newModule = this.$store.state.shdl.modules[newVal];
            this.editedText = newModule.text;
         }
      }
   },

   computed: {
      readOnly: function readOnly() {
         return !!this.module.locked_date;
      },
      userOrTeamModuleIds: function userOrTeamModuleIds() {
         return this.module.user ? this.$store.state.shdl.user2moduleList[this.module.user] : this.$store.state.shdl.team2moduleList[this.module.team];
      },
      toolbarMessage: function toolbarMessage() {
         if (this.err) {
            var message = this.err.message;
            var moduleName = this.err.module + ': ' || '';
            var locationDescription = this.err.location ? 'line ' + this.err.location.start.line + ', column ' + this.err.location.start.column + ': ' : '';
            return '*** ' + moduleName + locationDescription + message;
         } else if (this.equipotentialCount) {
            if (this.unusedEquipotentialCount) {
               return 'Module OK, ' + this.equipotentialCount + ' equipotentials (' + this.unusedEquipotentialCount + ' unused)';
            } else {
               return 'Module OK, ' + this.equipotentialCount + ' equipotentials';
            }
         }
      }
   },

   methods: {
      test: function test() {
         var element = this.$refs.editor.$el.parentElement;
         console.log(element.style);
         element.style.height = '550px';
      },
      save: function save(moduleId) {
         var vuexModule = this.$store.state.shdl.modules[moduleId];
         vuexModule.text = this.editedText;
         vuexModule.update_author = this.$store.state.loggedUserId;
         try {
            return this.$store.dispatch('shdl/PUT_SHDL_MODULE', vuexModule);
         } catch (e) {
            this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'enregistrement", color: 'red' });
         }
      },
      saveIfModified: function saveIfModified(moduleId) {
         var vuexModule = this.$store.state.shdl.modules[moduleId];
         if (vuexModule && vuexModule.text != this.editedText) {
            this.save(moduleId);
         }
      },


      // triggered when user edits text, or when this.module.id is changed
      codeChanged: function codeChanged(text) {
         console.log("code changed");
         this.editedText = text;
         this.parseModuleDebounced();
      },


      parseModule: function parseModule() {
         var _this = this;

         console.log("parsing");
         // build a map (name -> module) for modules of same user/team
         var name2module = {};
         var self = this;
         this.userOrTeamModuleIds.forEach(function (moduleId) {
            var module = self.$store.state.shdl.modules[moduleId];
            name2module[module.name] = module;
         });

         // check module

         var _checkModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_shdl_shdlAnalyser_js__["checkModule"])(this.module.name, name2module),
             err = _checkModule.err,
             moduleList = _checkModule.moduleList;

         this.err = err;
         var module = name2module[this.module.name];
         if (err) {
            this.equipotentialCount = null;
            this.unusedEquipotentialCount = null;
         } else {
            this.equipotentialCount = __WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlUtilities_js___default.a.equipotentialCount(module);
            this.unusedEquipotentialCount = __WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlUtilities_js___default.a.unusedEquipotentialCount(module);
            // set module name according to text if changed
            if (module.structure.name !== module.name) {
               console.log("changing name...");
               module.name = module.structure.name;
               this.$store.dispatch('shdl/PUT_SHDL_MODULE', module);
            }
         }
         // commit checking info of all analysed modules in Vuex
         moduleList.forEach(function (module) {
            var _checkModule2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_shdl_shdlAnalyser_js__["checkModule"])(module.name, name2module),
                err = _checkModule2.err,
                moduleList = _checkModule2.moduleList;

            _this.$store.commit('shdl/UPDATE_MODULE_PARSE_INFO', {
               moduleId: module.id,
               structure: module.structure,
               equipotentials: module.equipotentials,
               isOk: !err
            });
         });

         this.$forceUpdate();
      },

      parseModuleDebounced: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
         this.save(this.module.id);
         this.parseModule();
      }, 1000)

   }

});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      moduleId: Number,
      baseRoute: String
   },

   data: function data() {
      return {
         currentTab: null
      };
   },


   computed: {
      module: function module() {
         return this.$store.state.shdl.modules[this.moduleId];
      },
      parseInfo: function parseInfo() {
         return this.$store.state.shdl.module2parseInfo[this.moduleId];
      },
      appParams: function appParams() {
         return this.$store.getters.appParams;
      }
   },

   mounted: function mounted() {
      this.$emit('userModuleUpdated', this.moduleId);
   },

   updated: function updated() {
      this.$emit('userModuleUpdated', this.moduleId);
   },

   methods: {}
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      user: Object,
      teams: Array,
      selectedModuleId: Number
   },

   data: function data() {
      return {
         addDialog: false,
         deleteDialog: false,
         moduleToDelete: {},
         lockDialog: false,
         moduleToLock: {},
         moduleToAddName: null,
         moduleToAddType: 'personal',
         moduleToAddTeam: null,
         moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a
      };
   },


   computed: {
      userModules: function userModules() {
         var _this = this;

         return this.$store.state.shdl.user2moduleList.hasOwnProperty(this.user.id) ? this.$store.state.shdl.user2moduleList[this.user.id].map(function (moduleId) {
            return _this.$store.state.shdl.modules[moduleId];
         }) : [];
      },
      teamModulesDict: function teamModulesDict() {
         var dict = {};
         var self = this;
         this.teams.forEach(function (team) {
            if (self.$store.state.shdl.team2moduleList.hasOwnProperty(team.id)) {
               dict[team.id] = self.$store.state.shdl.team2moduleList[team.id].map(function (moduleId) {
                  return self.$store.state.shdl.modules[moduleId];
               });
            }
         });
         return dict;
      },
      formValid: function formValid() {
         if (this.$v.moduleToAddName.$error) return false;
         if (this.moduleToAddType === 'team' && this.moduleToAddTeam === null) return false;
         return true;
      },
      nameErrors: function nameErrors() {
         var errors = [];
         if (!this.$v.moduleToAddName.$dirty) return errors;
         !this.$v.moduleToAddName.required && errors.push("Le nom est obligatoire");
         return errors;
      }
   },

   methods: {
      clone: function clone(module) {
         return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(module);
      },
      sorted: function sorted(moduleList) {
         return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(moduleList, [function (o) {
            return o.name;
         }]);
      },
      selectModule: function selectModule(moduleId) {
         this.$emit('moduleSelected', moduleId);
      },
      addModule: function addModule() {
         this.$emit('addModule', this.moduleToAddName, this.moduleToAddType === 'personal' ? null : this.moduleToAddTeam);
      },
      deleteModule: function deleteModule(module) {
         this.$emit('deleteModule', module);
      },
      lockModule: function lockModule(module) {
         this.$emit('lockModule', module);
      },
      parseInfo: function parseInfo(module) {
         return this.$store.state.shdl.module2parseInfo[module.id];
      },
      isModuleOk: function isModuleOk(module) {
         if (this.$store.state.shdl.module2parseInfo.hasOwnProperty(module.id)) {
            var parseInfo = this.$store.state.shdl.module2parseInfo[module.id];
            return parseInfo.isOk;
         } else {
            return null;
         }
      },
      teamDescription: function teamDescription(teamId) {
         var team = this.$store.state.teams.teams[teamId];
         var self = this;
         var memberNames = team.members.map(function (userId) {
            var user = self.$store.state.users[userId];
            return user ? user.last_name : '--';
         });
         return team.name + ' (' + memberNames.join(', ') + ')';
      },
      iconName: function iconName(module) {
         var isOk = this.isModuleOk(module);
         if (isOk === null) {
            return 'more_horiz';
         } else if (isOk) {
            return 'check_circle';
         } else {
            return 'error_outline';
         }
      },
      iconColor: function iconColor(module) {
         var isOk = this.isModuleOk(module);
         if (isOk === null) {
            return 'gray';
         } else if (isOk) {
            return 'green';
         } else {
            return 'pink';
         }
      }
   },

   validations: {
      moduleToAddName: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] }
   }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_shdl_shdlUtilities_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_shdl_shdlUtilities_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utilities_shdl_shdlUtilities_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_binutils_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_binutils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utilities_binutils_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var lineTestParser = __webpack_require__(666);

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      module: Object
   },

   data: function data() {
      return {
         previousValues: null,
         currentValues: null,
         showOthers: false,
         barStatus: 0, // 0: closed, 1: open but not started, 2: started & ok, 3: started & KO
         barStatusText: null
      };
   },


   created: function created() {
      this.previousValues = this.equipotentials.map(function (equipotential) {
         return null;
      });
      this.currentValues = this.equipotentials.map(function (equipotential) {
         return null;
      });
   },

   mounted: function mounted() {
      var error = this.updateState();
      if (error) {
         this.barStatus = 3;
         this.barStatusText = error;
      }
   },

   computed: {
      moduleParseInfo: function moduleParseInfo() {
         return this.$store.state.shdl.module2parseInfo[this.module.id];
      },
      structure: function structure() {
         return this.moduleParseInfo.structure;
      },
      equipotentials: function equipotentials() {
         return this.moduleParseInfo.equipotentials;
      },
      parameterGroups: function parameterGroups() {
         // build homogeneous groups in terms of input/output
         var groups = [];
         for (var i = 0; i < this.structure.params.length; i++) {
            var parameter = this.structure.params[i];
            if (parameter.type === 'scalar') {
               // each scalar has its own group
               var equipotentialIndex = this.equipotentials["__" + parameter.name];
               var equipotential = this.equipotentials[equipotentialIndex];
               groups.push({
                  name: parameter.name,
                  isInput: equipotential.isInput,
                  isOutput: equipotential.isOutput,
                  equipotentialIndexes: [equipotentialIndex]
               });
            } else {
               // a vector parameter may result in several groups
               var firstIndex = void 0;
               var firstSignalName = void 0;
               var firstEquipotential = void 0;
               var equipotentialIndexes = void 0;
               var reset = true;
               var parameterArity = __WEBPACK_IMPORTED_MODULE_2__utilities_shdl_shdlUtilities_js___default.a.parameterArity(parameter);
               var j = void 0;
               for (j = 0; j < parameterArity; j++) {
                  var signalName = __WEBPACK_IMPORTED_MODULE_2__utilities_shdl_shdlUtilities_js___default.a.parameterNameAtIndex(parameter, j);
                  var _equipotentialIndex = this.equipotentials["__" + signalName];
                  var _equipotential = this.equipotentials[_equipotentialIndex];
                  if (reset) {
                     firstIndex = parameter.start - j;
                     firstSignalName = __WEBPACK_IMPORTED_MODULE_2__utilities_shdl_shdlUtilities_js___default.a.parameterNameAtIndex(parameter, j);
                     firstEquipotential = this.equipotentials[this.equipotentials["__" + firstSignalName]];
                     equipotentialIndexes = [];
                     reset = false;
                  }
                  if (_equipotential.isInput && firstEquipotential.isInput || _equipotential.isOutput && firstEquipotential.isOutput) {
                     equipotentialIndexes.push(_equipotentialIndex);
                  } else {
                     groups.push({
                        name: parameter.name + '[' + firstIndex + '..' + (parameter.start - j + 1) + ']',
                        isInput: firstEquipotential.isInput,
                        isOutput: firstEquipotential.isOutput,
                        equipotentialIndexes: equipotentialIndexes
                     });
                     reset = true;
                  }
               }
               if (equipotentialIndexes.length > 0) {
                  groups.push({
                     name: parameter.name + '[' + firstIndex + ':' + (parameter.start - j + 1) + ']',
                     isInput: firstEquipotential.isInput,
                     isOutput: firstEquipotential.isOutput,
                     equipotentialIndexes: equipotentialIndexes
                  });
               }
            }
         }
         return groups;
      },
      otherGroups: function otherGroups() {
         // collect all remaining equipotentials
         var otherEquipotentials = this.equipotentials.filter(function (equipotential) {
            if (equipotential === undefined) return false; // alias empty slot
            if (equipotential.name === null) return false;
            if (equipotential.isInput) return false;
            if (equipotential.isOutput) return false;
            return true;
         });
         // sort them by name in descending order, then by decreasing indexes for vectors
         otherEquipotentials.sort(function (a, b) {
            if (a.name < b.name) return 1;
            if (a.name > b.name) return -1;
            return 0;
         });
         otherEquipotentials.sort(function (a, b) {
            var ai = a.name.indexOf('[');
            var bi = a.name.indexOf('[');
            var aPrefix = ai === -1 ? a.name : a.name.substring(0, ai);
            var bPrefix = bi === -1 ? b.name : b.name.substring(0, bi);
            if (aPrefix < bPrefix) return 1;
            if (aPrefix > bPrefix) return -1;
            // same prefix
            if (ai === -1) return 0;
            // extract last index for a, first index for b
            var aj = a.name.indexOf('..');
            var ak = a.name.indexOf(']');
            var aLastIndex = parseInt(a.name.substring(aj === -1 ? ai + 1 : aj + 2, ak));
            var bj = b.name.indexOf('..');
            var bk = b.name.indexOf(']');
            var bFirstIndex = parseInt(b.name.substring(bi + 1, bj === -1 ? bk : bj));
            if (aLastIndex < bFirstIndex) return 1;
            if (aLastIndex > bFirstIndex) return -1;
            return 0;
         });

         // make groups by name prefix and consecutive indexes
         var currentPrefix = null;
         var startIndex = null;
         var stopIndex = null;
         var equipotentialIndexes = null;
         var groups = [];
         for (var i = 0; i < otherEquipotentials.length; i++) {
            var equipotential = otherEquipotentials[i];
            var x = equipotential.name.indexOf('[');
            if (x === -1) {
               // scalar
               if (currentPrefix !== null) {
                  // flush current group
                  var range = startIndex === stopIndex ? '' + startIndex : startIndex + ':' + stopIndex;
                  groups.push({
                     name: currentPrefix + '[' + range + ']',
                     equipotentialIndexes: equipotentialIndexes
                  });
               }
               // a scalar has its own group
               groups.push({
                  name: equipotential.name,
                  equipotentialIndexes: [equipotential.index]
               });
               currentPrefix = null;
            } else {
               // vector
               var prefix = equipotential.name.substring(0, x);
               var index = parseInt(equipotential.name.substring(x + 1, equipotential.name.length - 1));
               if (currentPrefix === null) {
                  // start new group
                  currentPrefix = prefix;
                  startIndex = index;
                  stopIndex = index;
                  equipotentialIndexes = [equipotential.index];
               } else if (prefix == currentPrefix) {
                  if (index === stopIndex - 1) {
                     // next consecutive index: continues current group
                     stopIndex = index;
                     equipotentialIndexes.push(equipotential.index);
                  } else {
                     // same name prefix, but break in indexes: flush current group
                     var _range = startIndex === stopIndex ? '' + startIndex : startIndex + ':' + stopIndex;
                     groups.push({
                        name: currentPrefix + '[' + _range + ']',
                        equipotentialIndexes: equipotentialIndexes
                     });
                     // start new group
                     currentPrefix = prefix;
                     startIndex = index;
                     stopIndex = index;
                     equipotentialIndexes = [equipotential.index];
                  }
               } else {
                  // change of name prefix: flush current group
                  groups.push({
                     name: currentPrefix + '[' + startIndex + ':' + stopIndex + ']',
                     equipotentialIndexes: equipotentialIndexes
                  });
                  // start new group
                  currentPrefix = prefix;
                  startIndex = index;
                  stopIndex = index;
                  equipotentialIndexes = [equipotential.index];
               }
               if (i === otherEquipotentials.length - 1 && currentPrefix !== null) {
                  // flush current group
                  var _range2 = startIndex === stopIndex ? '' + startIndex : startIndex + ':' + stopIndex;
                  groups.push({
                     name: currentPrefix + '[' + _range2 + ']',
                     equipotentialIndexes: equipotentialIndexes
                  });
               }
            }
         }
         return groups;
      }
   },

   methods: {
      inputOutputIcon: function inputOutputIcon(signalGroup) {
         if (signalGroup.isInput) {
            return 'fa-long-arrow-alt-right';
         } else if (signalGroup.isOutput) {
            return 'fa-long-arrow-alt-left';
         } else {
            return null;
         }
      },
      inputOutputIconColor: function inputOutputIconColor(signalGroup) {
         if (signalGroup.isInput) {
            return 'pink';
         } else if (signalGroup.isOutput) {
            return 'green';
         } else {
            return null;
         }
      },

      checkIcon: function checkIcon(index, isInput) {
         if (this.currentValues[index] === null) {
            return isInput ? 'indeterminate_check_box' : 'remove_circle';
         } else if (this.currentValues[index]) {
            return isInput ? 'check_box' : 'radio_button_checked';
         } else {
            return isInput ? 'check_box_outline_blank' : 'radio_button_unchecked';
         }
      },
      onIconClick: function onIconClick(index) {
         if (this.currentValues[index] === null) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.currentValues, index, false);
         } else {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.currentValues, index, !this.currentValues[index]);
         }
         var error = this.updateState();
         if (error) {
            this.barStatus = 3;
            this.barStatusText = error;
         }
      },

      clear: function clear(signalGroup) {
         if (!signalGroup.isInput) return;
         var self = this;
         var first = this.currentValues[signalGroup.equipotentialIndexes[0]];
         var toggled = first === null ? false : first ? null : true;
         signalGroup.equipotentialIndexes.forEach(function (index) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(self.currentValues, index, toggled);
         });
         // propagate changes
         var error = this.updateState();
         if (error) {
            this.barStatus = 3;
            this.barStatusText = error;
         }
      },

      updateState: function updateState() {
         var _this = this;

         // TO IMPROVE : ALL EQUIPOTENTIALS ARE REEVALUATED AT EACH CYCLE
         // USE 'uses' ATTRIBUTE TO ONLY UPDATE WHEN NECESSARY
         var change = true;
         var cycles = 0;
         var error = '';
         while (change && cycles < 100) {
            // evaluation cycle
            change = false;
            var nextValues = [];
            // plain loop is used because we need to break
            for (var index = 0; index < this.equipotentials.length; index++) {
               var equipotential = this.equipotentials[index];
               if (equipotential === undefined) continue; // alias empty slot
               if (equipotential.isInput) continue;

               var previousValue = this.currentValues[index];
               var value = this.equipotentialValue(index, this.currentValues, this.previousValues);
               change = change | value != previousValue;
               nextValues[index] = value;
            }
            // update dataArray all at once (not one by one) for the next evaluation cycle
            for (var _index = 0; _index < this.equipotentials.length; _index++) {
               this.previousValues[_index] = this.currentValues[_index];
               var _equipotential2 = this.equipotentials[_index];
               if (_equipotential2 === undefined) continue; // alias empty slot
               if (_equipotential2.isInput) continue;
               __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.currentValues, _index, nextValues[_index]);
            }
            cycles += 1;
         }
         // now that propagation has stabilized, check for tri-state short-circuits
         // plain loop is used because we need to break

         var _loop = function _loop(_index2) {
            var equipotential = _this.equipotentials[_index2];
            if (equipotential === undefined) return 'continue'; // alias empty slot
            if (equipotential.type !== 'tri-state') return 'continue';

            var outputEnableValues = equipotential.sources.map(function (source) {
               return _this.currentValues[source.oeEquipotential];
            });
            var indexes = outputEnableValues.reduce(function (accu, value, index) {
               return value === true ? [index].concat(accu) : accu;
            }, []);
            if (indexes.length > 1) {
               var conflicting_sources = indexes.map(function (index) {
                  return equipotential.sources[index];
               });
               var conflictNames = conflicting_sources.map(function (src) {
                  var srcText = _this.equipotentials[src.srcEquipotential].name || "<anonymous equipotential>";
                  var oeText = _this.equipotentials[src.oeEquipotential].name || "<anonymous equipotential>";
                  return srcText + ':' + oeText;
               });
               error = '*** short-circuit on ' + equipotential.name + ' between: ' + conflictNames.join(' and ');
               return 'break';
            }
         };

         _loop2: for (var _index2 = 0; _index2 < this.equipotentials.length; _index2++) {
            var _ret = _loop(_index2);

            switch (_ret) {
               case 'continue':
                  continue;

               case 'break':
                  break _loop2;}
         }

         return error;
      },

      // return false (0), true (1) or null (indeterminate or short-circuit)
      equipotentialValue: function equipotentialValue(equipotentialIndex, dataArray, previousValueArray) {
         if (dataArray === null) return null;
         var equipotential = this.equipotentials[equipotentialIndex];
         if (equipotential === undefined) {
            equipotential = equipotential;
         }
         if (equipotential.isInput) {
            return dataArray[equipotentialIndex];
         } else if (equipotential.type === 'constant') {
            // return equipotential.name === '>1' ? true : false
            return equipotential.cvalue === 1 ? true : equipotential.cvalue === 0 ? false : null;
         } else if (equipotential.type === 'combinatorial') {
            return this.evaluateFormula(equipotential.formula, dataArray);
         } else if (equipotential.type === 'tri-state') {
            var outputEnableValues = equipotential.sources.map(function (source) {
               return dataArray[source.oeEquipotential];
            });
            var _indexes = outputEnableValues.reduce(function (accu, value, index) {
               return value === true ? [index].concat(accu) : accu;
            }, []);
            if (_indexes.length === 0) {
               // no output enable is true -> indeterminate
               return null;
            }
            if (_indexes.length === 1) {
               return dataArray[equipotential.sources[_indexes[0]].srcEquipotential];
            }
            // short-circuit: return null
            // Short-circuits do not break simulation during propagation instabilities
            // They are checked again when progation has stabilized (see updateState())
            return null;
         } else if (equipotential.type === 'sequential') {
            if (equipotential.rst !== undefined) {
               //let resetValue = this.equipotentialValue(equipotential.rst, dataArray, previousValueArray)
               var resetValue = dataArray[equipotential.rst];
               if (resetValue === true) {
                  // reset exists and is on
                  return false;
               }
            }
            if (equipotential.set !== undefined) {
               //let setValue = this.equipotentialValue(equipotential.set, dataArray, previousValueArray)
               var setValue = dataArray[equipotential.set];
               if (setValue === true) {
                  // set exists and is on
                  return true;
               }
            }
            if (equipotential.en !== undefined) {
               //let enValue = this.equipotentialValue(equipotential.en, dataArray, previousValueArray)
               var enValue = dataArray[equipotential.en];
               if (enValue === false) {
                  // enable exists and is false -> return current value (no change)
                  return dataArray[equipotentialIndex];
               }
            }
            // no reset & no enable or enable true -> check clock tick
            var previousClkValue = previousValueArray[equipotential.clk];
            var currentClkValue = dataArray[equipotential.clk];
            if (previousClkValue === false && currentClkValue === true) {
               // rising edge on clock -> return computed value
               return this.evaluateFormula(equipotential.formula, dataArray);
            } else {
               // no clock tick: keep current value
               return dataArray[equipotentialIndex];
            }
         } else if (equipotential.type === 'rom' || equipotential.type === 'ram_aread_swrite') {
            var addressKey = equipotential.addrs.map(function (equipotentialIndex) {
               return dataArray[equipotentialIndex];
            }).join();
            if (equipotential.type === 'ram_aread_swrite') {
               // check clock tick & wr
               var _previousClkValue = previousValueArray[equipotential.clk];
               var _currentClkValue = dataArray[equipotential.clk];
               var currentWrValue = dataArray[equipotential.wr];
               if (_previousClkValue === false && _currentClkValue === true && currentWrValue === true) {
                  // rising edge on clock + write -> store din value in dict
                  equipotential.dict[addressKey] = dataArray[equipotential.din];
               }
            }
            // in all cases return current dict value
            var value = equipotential.dict[addressKey];
            return value === undefined ? null : value;
         }
         return null;
      },

      evaluateFormula: function evaluateFormula(formula, dataArray) {
         var self = this;
         if (formula.op === 'or') {
            var one = formula.args.some(function (f) {
               return self.evaluateFormula(f, dataArray) === true;
            });
            if (one) {
               return true;
            }
            var zero = formula.args.every(function (f) {
               return self.evaluateFormula(f, dataArray) === false;
            });
            if (zero) {
               return false;
            }
            // indeterminate
            return null;
         } else if (formula.op === 'and') {
            var _zero = formula.args.some(function (f) {
               return self.evaluateFormula(f, dataArray) === false;
            });
            if (_zero) {
               return false;
            }
            var _one = formula.args.every(function (f) {
               return self.evaluateFormula(f, dataArray) === true;
            });
            if (_one) {
               return true;
            }
            // indeterminate
            return null;
         } else if (formula.op === 'maxterm') {
            var value = dataArray[formula.equipotentialIndex];
            if (value === null) {
               return null;
            } else {
               if (formula.inverted) value = !value;
               return value;
            }
         } else if (formula.op === 'expr') {
            // return this.equipotentialValue(formula.equipotentialIndex, dataArray, null)
            return dataArray[formula.equipotentialIndex];
         } else {
            // constant
            if (formula === '0') {
               return false;
            } else if (formula === '1') {
               return true;
            } else {
               return null;
            }
         }
      },

      onBarButtonClick: function onBarButtonClick() {
         if (this.barStatus === 0) {
            this.barStatus = 1;
         } else {
            this.barStatus = 0;
         }
      },
      onTestFileChange: function onTestFileChange(e) {
         var files = e.target.files || e.dataTransfer.files;
         if (!files.length) return;

         var reader = new FileReader();
         var vm = this;
         reader.onload = function (e) {
            var testContent = e.target.result;
            vm.executeTest(testContent);
         };
         reader.readAsText(files[0]);
      },


      executeTest: function executeTest(testContent) {
         this.barStatus = 2;
         // split text in lines
         var lines = testContent.split(/\r?\n/);
         for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            if (line.trim().length == 0) continue;
            this.barStatusText = 'line ' + (i + 1) + ' / ' + lines.length;
            // execute line
            var status = this.executeLine(line);
            if (status.length > 0) {
               this.barStatus = 3;
               this.barStatusText = ' line ' + (i + 1) + ' / ' + lines.length + ' ' + status;
               break;
            }
            // update vue
            var error = this.updateState();
            if (error) {
               this.barStatus = 3;
               this.barStatusText = ' line ' + (i + 1) + ' / ' + lines.length + ' ' + error;
               break;
            }
         }
         if (this.barStatus === 2) {
            this.barStatusText = "SUCCESS";
         }
      },

      executeLine: function executeLine(line) {
         try {
            // parse line
            var command = lineTestParser.parse(line);
            if (command.cmd === 'comment') return '';
            if (command.signal.type === 'scalar') {
               if (command.value.length !== 1) {
                  return "*** value arity error ***";
               }
               var signalName = command.signal.name;
               var equipotentialIndex = this.equipotentials["__" + signalName];
               if (equipotentialIndex === undefined) {
                  return '*** unknown signal name: ' + signalName + ' ***';
               }
               var value = command.value === '0' ? false : command.value === '1' ? true : null;
               if (command.cmd === 'set') {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.currentValues, equipotentialIndex, value);
               } else if (command.cmd === 'check') {
                  var currentValue = this.currentValues[equipotentialIndex];
                  if (currentValue !== value) {
                     return '*** expected ' + signalName + ' = ' + command.value + ' ***';
                  }
               }
            }if (command.signal.type === 'vector') {
               var vectorSize = command.signal.start - command.signal.stop + 1;
               if (vectorSize !== command.value.length) {
                  return "*** value arity error ***";
               }
               for (var index = command.signal.start; index >= command.signal.stop; index--) {
                  var _signalName = command.signal.name + '[' + index + ']';
                  var _equipotentialIndex2 = this.equipotentials["__" + _signalName];
                  if (_equipotentialIndex2 === undefined) {
                     return '*** unknown signal name: ' + _signalName + ' ***';
                  }
                  var i = command.signal.start - index;
                  var _value = command.value[i] === '0' ? false : command.value[i] === '1' ? true : null;
                  if (command.cmd === 'set') {
                     __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.currentValues, _equipotentialIndex2, _value);
                  } else if (command.cmd === 'check') {
                     var _currentValue = this.currentValues[_equipotentialIndex2];
                     if (_currentValue !== _value) {
                        return '*** expected ' + _signalName + ' = ' + command.value[i] + ' ***';
                     }
                  }
               }
            }
            return '';
         } catch (err) {
            return "*** syntax error ***";
         }
      },

      onMemFileChange: function onMemFileChange(e) {
         var files = e.target.files || e.dataTransfer.files;
         if (!files.length) return;

         var reader = new FileReader();
         var vm = this;
         reader.onload = function (e) {
            var memContent = e.target.result;
            vm.loadMemContents(memContent);
            vm.updateState();
         };
         reader.readAsText(files[0]);
      },


      getMemoryInstanceArray: function getMemoryInstanceArray() {
         var memoryEquipotentials = this.equipotentials.filter(function (equipotential) {
            if (equipotential.type === 'rom') return true;
            if (equipotential.type === 'ram_aread_swrite') return true;
         });
         var memoryInstanceArray = [];
         memoryEquipotentials.forEach(function (equipotential) {
            if (memoryInstanceArray[equipotential.memUUID] === undefined) memoryInstanceArray[equipotential.memUUID] = [];
            memoryInstanceArray[equipotential.memUUID][equipotential.memOutIndex] = equipotential;
         });
         return memoryInstanceArray;
      },

      loadMemContents: function loadMemContents(memoryFileContent) {
         var _this2 = this;

         this.barStatus = 2;
         var memoryContentArray = void 0;
         try {
            memoryContentArray = JSON.parse(memoryFileContent);
         } catch (err) {
            this.barStatus = 3;
            this.barStatusText = "JSON syntax error";
            return;
         }
         var memoryInstanceArray = this.getMemoryInstanceArray();
         if (memoryInstanceArray.length != memoryContentArray.length) {
            this.barStatus = 3;
            this.barStatusText = "Wrong number of memory initialization blocks";
            return;
         }

         memoryContentArray.forEach(function (memoryContent, memoryIndex) {
            // look for memory equipotentials
            var memEquipotentials = memoryInstanceArray[memoryIndex];
            // check arities
            for (var addr in memoryContent) {
               var addrLength = memEquipotentials[0].addrs.length;
               var dataLength = memEquipotentials.length;
               var addrArray = __WEBPACK_IMPORTED_MODULE_3__utilities_binutils_js___default.a.strToBin(addr, addrLength);
               var dataArray = __WEBPACK_IMPORTED_MODULE_3__utilities_binutils_js___default.a.strToBin(memoryContent[addr], dataLength);
               if (dataArray.length !== dataLength || addr.length !== addrLength) {
                  _this2.barStatus = 3;
                  _this2.barStatusText = 'arity issue for ' + addr + ' : ' + memoryContent[addr];
                  break;
               }
               // fill memory
               var status = _this2.loadMemLine(addr, dataArray, memEquipotentials);
               if (status.length > 0) {
                  _this2.barStatus = 3;
                  _this2.barStatusText = status;
                  break;
               }
            }
         });
         if (this.barStatus === 2) {
            this.barStatusText = "MEMORY LOADED";
         }
      },

      loadMemLine: function loadMemLine(addr, dataArray, memEquipotentials) {
         for (var i = 0; i < addr.length; i++) {
            if (addr[i] !== '0' && addr[i] !== '1') {
               return 'ADDRESS ISSUE';
            }
         }
         var arity = memEquipotentials.length;
         for (var _i = 0; _i < arity; _i++) {
            var equipotential = memEquipotentials[_i];
            var value = dataArray[arity - equipotential.memOutIndex - 1];
            if (value !== '0' && value !== '1') {
               return 'VALUE ISSUE';
            }
            var boolValue = value === '0' ? false : true;
            var saddr = Array.prototype.map.call(addr, function (digit) {
               if (digit === '0') return false;
               if (digit === '1') return true;
            }).join(',');
            equipotential.dict[saddr] = boolValue;
         }
         return '';
      }

   }

});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shdl_ShdlModuleList__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shdl_ShdlModuleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shdl_ShdlModuleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlAnalyser_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlAnalyser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlAnalyser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      baseRoute: String
   },

   components: {
      ShdlModuleList: __WEBPACK_IMPORTED_MODULE_2__components_shdl_ShdlModuleList___default.a
   },

   mounted: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
         var teams, self;
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     // fetch user SHDL modules in central store: reactivity will update the list view
                     this.$store.dispatch('shdl/GET_SHDL_MODULES', { userId: this.userId, teamId: 0 });
                     // fetch teams for which userId is a member
                     _context.next = 3;
                     return this.$store.dispatch('teams/GET_USER_TEAMS', this.userId);

                  case 3:
                     teams = _context.sent;

                     // for each team, fetch members & SHDL modules: reactivity will update the list view
                     self = this;

                     teams.forEach(function (team) {
                        self.$store.dispatch('shdl/GET_SHDL_MODULES', { userId: 0, teamId: team.id });
                        team.members.forEach(function (userId) {
                           self.$store.dispatch('GET_USER', userId);
                        });
                     });

                  case 6:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function mounted() {
         return _ref.apply(this, arguments);
      }

      return mounted;
   }(),

   data: function data() {
      return {
         selectedModuleId: null
      };
   },


   computed: {
      user: function user() {
         return this.$store.state.users[this.userId];
      },
      teams: function teams() {
         var _this = this;

         if (this.$store.state.teams.user2teamList.hasOwnProperty(this.userId)) {
            return this.$store.state.teams.user2teamList[this.userId].map(function (teamId) {
               return _this.$store.state.teams.teams[teamId];
            });
         } else {
            return [];
         }
      },
      selectedModule: function selectedModule() {
         return this.$store.state.shdl.modules[this.selectedModuleId];
      }
   },

   methods: {
      selectModule: function selectModule(moduleId) {
         // make the module selected in ShdlModuleList
         this.selectedModuleId = moduleId;
         // change route
         this.$router.push(this.baseRoute + 'module/' + moduleId + '/editor');
         // post event that module has been accessed
         var module = this.$store.state.shdl.modules[moduleId];
         this.$store.dispatch('POST_HISTORY_EVENT', {
            author: this.$store.state.loggedUserId,
            user: this.user.id, // team = null
            message: { "text": "Accès au module " + module.name }
         });
      },
      unselectAll: function unselectAll() {
         this.selectedModuleId = null;
         // change route
         this.$router.push(this.baseRoute);
      },
      userModuleUpdated: function userModuleUpdated(moduleId) {
         this.$emit('userModuleUpdated', moduleId);
         this.selectedModuleId = moduleId;
      },
      addModule: function addModule(name, teamId) {
         var _this2 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var moduleList, addedModule;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        moduleList = teamId ? _this2.$store.state.shdl.team2moduleList[teamId] : _this2.$store.state.shdl.user2moduleList[_this2.user.id];

                        if (!(moduleList.map(function (moduleId) {
                           return _this2.$store.state.shdl.modules[moduleId].name;
                        }).indexOf(name) !== -1)) {
                           _context2.next = 5;
                           break;
                        }

                        _this2.$store.commit('SNACKBAR', { timeout: 3500, text: "Un module de ce nom existe déjà", color: 'red' });
                        _context2.next = 15;
                        break;

                     case 5:
                        _context2.prev = 5;
                        _context2.next = 8;
                        return _this2.$store.dispatch('shdl/POST_SHDL_MODULE', {
                           name: name,
                           user: teamId ? null : _this2.user.id,
                           team: teamId ? teamId : null,
                           update_author: _this2.$store.state.loggedUserId,
                           text: 'module ' + name + '()\nend module'
                        });

                     case 8:
                        addedModule = _context2.sent;

                        _this2.selectModule(addedModule.id);
                        _context2.next = 15;
                        break;

                     case 12:
                        _context2.prev = 12;
                        _context2.t0 = _context2['catch'](5);

                        _this2.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la création", color: 'red' });

                     case 15:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, _this2, [[5, 12]]);
         }))();
      },
      deleteModule: function deleteModule(module) {
         var _this3 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return _this3.$store.dispatch('shdl/DELETE_SHDL_MODULE', module);

                     case 3:
                        _context3.next = 5;
                        return _this3.$store.dispatch('POST_HISTORY_EVENT', {
                           author: _this3.$store.state.loggedUserId,
                           user: _this3.user.id, // team = null
                           message: { "text": "Suppression du module " + module.name }
                        });

                     case 5:
                        _this3.unselectAll();
                        _context3.next = 11;
                        break;

                     case 8:
                        _context3.prev = 8;
                        _context3.t0 = _context3['catch'](0);

                        _this3.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la suppression", color: 'red' });

                     case 11:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, _this3, [[0, 8]]);
         }))();
      },
      isModuleOk: function isModuleOk(module) {
         if (this.$store.state.shdl.module2parseInfo.hasOwnProperty(module.id)) {
            var parseInfo = this.$store.state.shdl.module2parseInfo[module.id];
            return parseInfo.isOk;
         } else {
            return null;
         }
      },
      lockModule: function lockModule(module) {
         var _this4 = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var name2module, userOrTeamModuleIds, _checkModule, err, moduleList;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
               while (1) {
                  switch (_context5.prev = _context5.next) {
                     case 0:
                        console.log("lock module", module);

                        // check module and its submodules
                        name2module = {};
                        userOrTeamModuleIds = module.user ? _this4.$store.state.shdl.user2moduleList[module.user] : _this4.$store.state.shdl.team2moduleList[module.team];

                        userOrTeamModuleIds.forEach(function (moduleId) {
                           var module = _this4.$store.state.shdl.modules[moduleId];
                           name2module[module.name] = module;
                        });
                        _checkModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_shdl_shdlAnalyser_js__["checkModule"])(module.name, name2module), err = _checkModule.err, moduleList = _checkModule.moduleList;

                        console.log('moduleList', moduleList);

                        // lock module and all its submodules
                        try {
                           moduleList.forEach(function () {
                              var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(module) {
                                 var vuexModule;
                                 return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                    while (1) {
                                       switch (_context4.prev = _context4.next) {
                                          case 0:
                                             vuexModule = _this4.$store.state.shdl.modules[module.id];

                                             vuexModule.locked_date = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format();
                                             _context4.next = 4;
                                             return _this4.$store.dispatch('shdl/PUT_SHDL_MODULE', vuexModule);

                                          case 4:
                                          case 'end':
                                             return _context4.stop();
                                       }
                                    }
                                 }, _callee4, _this4);
                              }));

                              return function (_x) {
                                 return _ref2.apply(this, arguments);
                              };
                           }());
                        } catch (e) {
                           _this4.$store.commit('SNACKBAR', { timeout: 3500, text: "Error while saving", color: 'red' });
                        }

                     case 7:
                     case 'end':
                        return _context5.stop();
                  }
               }
            }, _callee5, _this4);
         }))();
      }
   }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userSurveyId: Number,
      baseRoute: String,
      mode: String // 'patient', 'caregiver'
   },

   data: function data() {
      return {
         editedAnswers: []
      };
   },


   computed: {
      // warning: 'answers' attribute is not reactively updated
      userSurvey: function userSurvey() {
         return this.$store.state.surveys.userSurveys[this.userSurveyId];
      },

      // reactively updated
      userSurveyAnswers: function userSurveyAnswers() {
         return this.$store.state.surveys.userSurveys[this.userSurveyId]['answers'];
      },
      userSurveyAnswerStrings: function userSurveyAnswerStrings() {
         return this.$store.state.surveys.userSurveyAnswers[this.userSurveyId];
      },
      survey: function survey() {
         return this.$store.state.surveys.surveys[this.userSurvey.survey];
      },
      questions: function questions() {
         return this.survey.params.questions;
      },
      scoreDescription: function scoreDescription() {
         var self = this;
         return this.survey.params.dimensions.map(function (dimension) {
            var score = self.survey.params.questions.reduce(function (cumul, question, index) {
               var answer = self.userSurveyAnswers[index];
               if (dimension.computation === 'sum' || dimension.computation === 'sum_with_offset') {
                  return cumul + question.choices[answer].value[dimension.uid];
               }
            }, 0);
            if (dimension.computation === 'sum_with_offset') {
               score += dimension.offset;
            }
            score = Math.round(score * 100) / 100;
            return '<div>' + dimension.name + ' : ' + score + '</div>';
         }).join('');
      },
      questionCount: function questionCount() {
         return this.survey.params.questions.length;
      },
      answerCount: function answerCount() {
         return this.userSurveyAnswers.reduce(function (accu, answer) {
            if (answer === null) {
               return accu;
            } else {
               return accu + 1;
            }
         }, 0);
      },
      isComplete: function isComplete() {
         return this.questionCount === this.answerCount;
      }
   },

   methods: {
      saveAnswer: function saveAnswer(questionIndex, answer) {
         console.log('questionIndex', questionIndex, 'answer', answer);
         var userSurveyCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.userSurvey);
         var answers = this.userSurveyAnswers;
         answers[questionIndex] = answer;
         userSurveyCopy.answers = answers;
         //this.$store.commit('surveys/SET_USER_SURVEY', userSurveyCopy)
         //return

         try {
            this.$store.dispatch('surveys/PUT_USER_SURVEY', userSurveyCopy);
         } catch (e) {
            this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'enregistrement", color: 'red' });
         }
      }
   }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      title: String,
      userId: Number,
      selectedUserSurveyId: Number,
      mode: String // 'patient', 'caregiver'
   },

   data: function data() {
      return {
         addDialog: false,
         deleteDialog: false,
         userSurveyToDelete: {},
         choice: null
      };
   },


   computed: {
      surveys: function surveys() {
         var _this = this;

         return this.$store.state.surveys.surveyList.map(function (surveyId) {
            return _this.$store.state.surveys.surveys[surveyId];
         });
      },
      userSurveys: function userSurveys() {
         return this.$store.getters['surveys/userSurveys'](this.userId);
      }
   },

   methods: {
      clone: function clone(userSurvey) {
         return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(userSurvey);
      },
      selectUserSurvey: function selectUserSurvey(userSurveyId) {
         this.$emit('userSurveySelected', userSurveyId);
      },

      openAddDialog: function openAddDialog() {
         this.choice = null;
         this.addDialog = true;
      },
      assignSurveys: function assignSurveys() {
         this.$emit('addUserSurvey', this.choice.id);
      },
      deleteUserSurvey: function deleteUserSurvey(userSurvey) {
         this.$emit('deleteUserSurvey', userSurvey);
      },

      surveyName: function surveyName(userSurvey) {
         var survey = this.$store.state.surveys.surveys[userSurvey.survey];
         return survey.name;
      },
      answerCount: function answerCount(userSurvey) {
         var answerCount = userSurvey.answers.reduce(function (accu, answer) {
            if (answer === null) {
               return accu;
            } else {
               return accu + 1;
            }
         }, 0);
         return answerCount;
      },
      questionCount: function questionCount(userSurvey) {
         var survey = this.$store.state.surveys.surveys[userSurvey.survey];
         return survey.params.questions.length;
      },
      isComplete: function isComplete(userSurvey) {
         var survey = this.$store.state.surveys.surveys[userSurvey.survey];
         return survey.params.questions.length === this.answerCount(userSurvey);
      }
   }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_surveys_UserSurveyList__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_surveys_UserSurveyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_surveys_UserSurveyList__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number,
      baseRoute: String,
      mode: String // 'patient', 'caregiver'
   },

   components: {
      UserSurveyList: __WEBPACK_IMPORTED_MODULE_2__components_surveys_UserSurveyList___default.a
   },

   mounted: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     _context.next = 2;
                     return this.$store.dispatch('surveys/GET_SURVEYS');

                  case 2:
                     // fetch user' surveys in central store: reactivity will update the list view
                     this.$store.dispatch('surveys/GET_USER_SURVEYS', this.userId);

                  case 3:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function mounted() {
         return _ref.apply(this, arguments);
      }

      return mounted;
   }(),

   data: function data() {
      return {
         selectedUserSurveyId: null
      };
   },


   computed: {
      title: function title() {
         return this.user ? "Questionnaires de " + this.user.first_name + ' ' + this.user.last_name : '';
      },
      user: function user() {
         return this.$store.state.users[this.userId];
      },
      listCss: function listCss() {
         //return { xs12: true, sm3: this.selectedMealId, sm4: !this.selectedMealId }
         return { xs12: true, sm4: true };
      },
      detailCss: function detailCss() {
         //return { xs12: true, sm9: this.selectedMealId, sm8: !this.selectedMealId }
         return { xs12: true, sm8: true };
      }
   },

   methods: {
      userSurveySelected: function userSurveySelected(userSurveyId) {
         // make the module selected in UserSurveyList
         this.selectedUserSurveyId = userSurveyId;
         // change route
         this.$router.push('' + this.baseRoute + userSurveyId);
      },

      addUserSurvey: function () {
         var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(surveyId) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        _context2.next = 2;
                        return this.$store.dispatch('surveys/POST_USER_SURVEY', { userId: this.userId, surveyId: surveyId });

                     case 2:
                        this.$store.dispatch('surveys/GET_USER_SURVEYS', this.userId);

                     case 3:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, this);
         }));

         function addUserSurvey(_x) {
            return _ref2.apply(this, arguments);
         }

         return addUserSurvey;
      }(),
      deleteUserSurvey: function () {
         var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(userSurvey) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        _context3.next = 2;
                        return this.$store.dispatch('surveys/DELETE_USER_SURVEY', userSurvey);

                     case 2:
                        this.$store.dispatch('surveys/GET_USER_SURVEYS', this.userId);

                     case 3:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, this);
         }));

         function deleteUserSurvey(_x2) {
            return _ref3.apply(this, arguments);
         }

         return deleteUserSurvey;
      }(),
      assignSurveys: function assignSurveys(assignments) {
         console.log("assign", assignments);
      }
   }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   mounted: function mounted() {
      // refs are not reactive, this is the way to get template component instances
      this.heightInputComp = this.$refs.height;
      this.weightInputComp = this.$refs.weight;
   },

   data: function data() {
      return {
         valid: false,
         height: '',
         heightRules: [function (v) {
            return !!v || 'Champ obligatoire';
         }, function (v) {
            return v && !isNaN(parseInt(v)) || 'La taille doit être un nombre entier (cm)';
         }, function (v) {
            return v && parseInt(v) >= 70 && parseInt(v) <= 250 || 'La taille doit être comprise entre 70 et 250';
         }],
         heightInputComp: null,
         weight: '',
         weightRules: [function (v) {
            return !!v || 'Champ obligatoire';
         }, function (v) {
            return v && !isNaN(parseInt(v)) || 'Le poids doit être un nombre entier (kg)';
         }, function (v) {
            return v && parseInt(v) >= 30 && parseInt(v) <= 250 || 'Le poids doit être compris entre 30 et 250';
         }],
         weightInputComp: null
      };
   },

   methods: {
      heightValid: function heightValid() {
         return this.heightInputComp.errorBucket.length === 0;
      },
      weightValid: function weightValid() {
         return this.weightInputComp.errorBucket.length === 0;
      }
   },

   computed: {
      bmi: function bmi() {
         if (this.heightValid() && this.weightValid()) {
            var h = this.height / 100.0;
            var result = this.weight / (h * h);
            return Math.round(result * 10) / 10;
         } else {
            return -1;
         }
      }
   }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   mounted: function mounted() {
      // refs are not reactive, this is the way to get template component instances
      this.heightInputComp = this.$refs.height;
      this.weightInputComp = this.$refs.weight;
      this.weightBeforeInputComp = this.$refs.weightBefore;
   },

   data: function data() {
      return {
         valid: false,
         height: '',
         heightRules: [function (v) {
            return !!v || 'Champ obligatoire';
         }, function (v) {
            return v && !isNaN(parseInt(v)) || 'La taille doit être un nombre entier (cm)';
         }, function (v) {
            return v && parseInt(v) >= 70 && parseInt(v) <= 250 || 'La taille doit être comprise entre 70 et 250';
         }],
         heightInputComp: null,
         weight: '',
         weightBefore: '',
         weightRules: [function (v) {
            return !!v || 'Champ obligatoire';
         }, function (v) {
            return v && !isNaN(parseInt(v)) || 'Le poids doit être un nombre entier (kg)';
         }, function (v) {
            return v && parseInt(v) >= 30 && parseInt(v) <= 250 || 'Le poids doit être compris entre 30 et 250';
         }],
         weightInputComp: null,
         weightBeforeInputComp: null
      };
   },

   methods: {
      heightValid: function heightValid() {
         return this.heightInputComp.errorBucket.length === 0;
      },
      weightValid: function weightValid() {
         return this.weightInputComp.errorBucket.length === 0;
      },
      weightBeforeValid: function weightBeforeValid() {
         return this.weightBeforeInputComp.errorBucket.length === 0;
      }
   },

   computed: {
      bmi: function bmi() {
         if (this.heightValid() && this.weightValid()) {
            var h = this.height / 100.0;
            var result = this.weight / (h * h);
            return Math.round(result * 10) / 10;
         } else {
            return -1;
         }
      },
      excessWeightloss: function excessWeightloss() {
         if (this.heightValid() && this.weightValid()) {
            var h = this.height / 100.0;
            var result = 100 * (this.weightBefore - this.weight) / (this.weightBefore - 25 * h * h);
            return Math.round(result);
         } else {
            return -1;
         }
      }
   }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(19);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var axios = __webpack_require__(24);

/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number
   },

   mounted: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
         return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     // fetch user list
                     this.$store.dispatch('GET_USERS');
                     this.updateUserView();

                  case 2:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function mounted() {
         return _ref.apply(this, arguments);
      }

      return mounted;
   }(),

   beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
      this.confirmLeaving(to, from, next);
   },
   beforeRouteLeave: function beforeRouteLeave(to, from, next) {
      this.confirmLeaving(to, from, next);
   },
   data: function data() {
      return {
         user: {
            password: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].INITIAL_PASSWORD, // must be non-empty
            date_joined: "1970-01-01T00:00", // must be non-null
            roles: [], // must be non-null
            extra: {}
         },
         genders: [{ code: 'M', name: "Masculin" }, { code: 'F', name: "Féminin" }],
         smokers: [{ code: 'Y', name: "Fumeur" }, { code: 'N', name: "Non-fumeur" }],
         birthdate_menu: false,
         birthdate_temp: null,
         superuser: false,
         loading: false,
         search: null,
         select: [],
         moment: __WEBPACK_IMPORTED_MODULE_6_moment___default.a,
         fitbitAuthorizationURL: null
      };
   },


   // vuelidate validators (as a function)
   validations: function validations() {
      var validators = {
         user: {
            username: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
               minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["minLength"])(4),
               maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["maxLength"])(150),
               validChars: function validChars(value) {
                  var pattern = /^[a-zA-Z\u00C0-\u024F0-9_@+.-]+$/i;
                  return pattern.test(value);
               },
               isUnique: function isUnique(value) {
                  if (!this.creation) return true;
                  return this.$store.dispatch('IS_USERNAME_AVAILABLE', value);
               }
            },
            email: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
               email: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["email"]
            },
            roles: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            }
         }
      };
      if (this.userExtras.heightweightbmi) {
         if (validators.user.extra === undefined) validators.user.extra = {};
         __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(validators.user.extra, {
            height: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
               decimal: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["decimal"],
               between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["between"])(100, 250)
            }
         });
         __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(validators.user.extra, {
            weight: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
               decimal: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["decimal"],
               between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["between"])(30, 300)
            }
         });
      }
      if (this.userExtras.nutrieduc) {
         if (validators.user.extra === undefined) validators.user.extra = {};
         __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(validators.user.extra, {
            gender: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            }
         });
         __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(validators.user.extra, {
            birthdate: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            }
         });
         __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(validators.user.extra, {
            smoker: {
               required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
            }
         });
      }
      return validators;
   },


   computed: {
      users: function users() {
         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.$store.state.users).map(function (_ref2) {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];

            return value;
         });
      },
      usernameErrors: function usernameErrors() {
         var errors = [];
         if (!this.$v.user.username.$dirty) return errors;
         !this.$v.user.username.required && errors.push("L'identifiant est obligatoire");
         !this.$v.user.username.minLength && errors.push("L'identifiant doit faire au moins 4 caractères");
         !this.$v.user.username.minLength && errors.push("L'identifiant doit faire moins de 150 caractères");
         !this.$v.user.username.isUnique && errors.push("L'identifiant est déjà utilisé");
         !this.$v.user.username.validChars && errors.push("L'identifiant ne doit contenir que des lettres, chiffres ou _, @, +, ., -");
         return errors;
      },
      emailErrors: function emailErrors() {
         var errors = [];
         if (!this.$v.user.email.$dirty) return errors;
         !this.$v.user.email.required && errors.push("L'e-mail est obligatoire");
         !this.$v.user.email.email && errors.push("L'e-mail est incorrect");
         return errors;
      },
      rolesErrors: function rolesErrors() {
         var errors = [];
         if (!this.$v.user.roles.$dirty) return errors;
         !this.$v.user.roles.required && errors.push("Un rôle au moins est obligatoire");
         return errors;
      },
      heightErrors: function heightErrors() {
         var errors = [];
         if (!this.$v.user.extra.height.$dirty) return errors;
         !this.$v.user.extra.height.required && errors.push("La taille est obligatoire");
         !this.$v.user.extra.height.decimal && errors.push("La taille doit être un nombre en cm (ex: 175)");
         !this.$v.user.extra.height.between && errors.push("La taille (en cm) doit être un nombre compris entre 100 et 250");
         return errors;
      },
      weightErrors: function weightErrors() {
         var errors = [];
         if (!this.$v.user.extra.weight.$dirty) return errors;
         !this.$v.user.extra.weight.required && errors.push("Le poids est obligatoire");
         !this.$v.user.extra.weight.decimal && errors.push("Le poids doit être un nombre en kg (ex: 82.5)");
         !this.$v.user.extra.weight.between && errors.push("Le poids (en kg) doit être compris entre 30 et 300");
         return errors;
      },
      genderErrors: function genderErrors() {
         var errors = [];
         if (!this.$v.user.extra.gender.$dirty) return errors;
         !this.$v.user.extra.gender.required && errors.push("Le genre est obligatoire");
         return errors;
      },
      birthdateErrors: function birthdateErrors() {
         var errors = [];
         if (!this.$v.user.extra.birthdate.$dirty) return errors;
         !this.$v.user.extra.birthdate.required && errors.push("La date de naissance est obligatoire");
         return errors;
      },
      smokerErrors: function smokerErrors() {
         var errors = [];
         if (!this.$v.user.extra.smoker.$dirty) return errors;
         !this.$v.user.extra.smoker.required && errors.push("Le statut de fumeur est obligatoire");
         return errors;
      },
      creation: function creation() {
         return this.userId === 0;
      },
      loggedInUserRoles: function loggedInUserRoles() {
         return this.$store.getters.loggedInUserRoles;
      },
      roles: function roles() {
         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.$store.state.roles).map(function (_ref4) {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                key = _ref5[0],
                value = _ref5[1];

            return value;
         });
      },
      roleUIDs: function roleUIDs() {
         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.$store.state.roles).map(function (_ref6) {
            var _ref7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
                key = _ref7[0],
                value = _ref7[1];

            return value.uid;
         });
      },
      userExtras: function userExtras() {
         var tagDict = {};
         var self = this;
         this.user.roles.forEach(function (roleId) {
            var role = self.$store.state.roles[roleId];
            if (role && role.params && role.params.user_extras) {
               __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(tagDict, role.params.user_extras);
            }
         });
         return tagDict;
      },
      title: function title() {
         return this.userId ? this.user.fullname : "Nouvel utilisateur";
      },
      formValid: function formValid() {
         if (this.$v.user.username.$error) return false;
         if (this.$v.user.email.$error) return false;
         if (this.$v.user.roles.$error) return false;
         if (this.userExtras.nutrieduc && this.$v.user.extra.gender.$error) return false;
         if (this.userExtras.nutrieduc && this.$v.user.extra.birthdate.$error) return false;
         if (this.userExtras.nutrieduc && this.$v.user.extra.smoker.$error) return false;
         if (this.userExtras.heightweightbmi && this.$v.user.extra.height.$error) return false;
         if (this.userExtras.heightweightbmi && this.$v.user.extra.weight.$error) return false;
         return true;
      },
      formDirty: function formDirty() {
         return this.$v.user.$dirty;
      },
      formValidAndDirty: function formValidAndDirty() {
         return this.formValid && this.formDirty;
      },
      saveMessage: function saveMessage() {
         return this.userId === 0 ? "Enregistrer et envoyer mail d'initialisation" : "Enregistrer";
      },
      imc: function imc() {
         var bmi = this.user.extra.weight / (this.user.extra.height * this.user.extra.height / 10000.);
         if (isNaN(bmi)) {
            return '';
         } else {
            return bmi.toLocaleString('fr-FR', { maximumFractionDigits: 1 });
         }
      }
   },

   watch: {
      search: function search(val) {
         val && this.querySelections(val);
      },
      userId: function userId(val) {
         this.updateUserView();
      }
   },

   methods: {
      setUser: function setUser(userId) {
         this.$v.$reset();
         if (this.userId > 0) {
            // Vuex user
            var user = this.$store.state.users[this.userId];
            // form operates on a clone of Vuex user (otherwise, direct store change)
            this.user = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.clone(user);
         } else {
            this.user = {
               username: null,
               password: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].INITIAL_PASSWORD, // must be non-empty
               date_joined: "1970-01-01T00:00", // must be non-null
               roles: [], // must be non-null
               extra: {}
            };
         }
         // used for selecting user in cousin user list
         this.$emit('userIdChanged', this.userId);
      },

      updateUserView: function () {
         var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        this.setUser(this.userId);

                        if (!(this.userId > 0 && this.userExtras.fitbit)) {
                           _context2.next = 5;
                           break;
                        }

                        _context2.next = 4;
                        return this.getFitbitAuthorizationURL();

                     case 4:
                        this.fitbitAuthorizationURL = _context2.sent;

                     case 5:
                     case 'end':
                        return _context2.stop();
                  }
               }
            }, _callee2, this);
         }));

         function updateUserView() {
            return _ref8.apply(this, arguments);
         }

         return updateUserView;
      }(),
      isUserExtra: function isUserExtra(tag) {
         return this.userExtras.hasOwnProperty(tag);
      },
      saveOrUpdate: function saveOrUpdate() {
         this.$v.$reset();
         if (this.creation) {
            this.createUser(this.user);
         } else {
            this.updateUser(this.user);
         }
      },
      createUser: function createUser(userData) {
         var _this = this;

         return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var user;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        _context3.prev = 0;

                        _this.$store.commit('WAITING', true);
                        // create user
                        _context3.next = 4;
                        return _this.$store.dispatch('POST_USER', userData);

                     case 4:
                        user = _context3.sent;

                        _this.$store.commit('SNACKBAR', { timeout: 1500, text: "Utilisateur créé: " + user.username, color: 'green' });
                        // replace create view by read/update view
                        _this.$router.push('/user-manager/user/' + user.id);
                        // send account activation mail
                        _context3.next = 9;
                        return _this.$store.dispatch('SEND_ACTIVATE_ACCOUNT_MAIL', user.id);

                     case 9:
                        _this.$store.commit('SNACKBAR', { timeout: 1500, text: "Mail d'activation de compte envoyé", color: 'green' });
                        _context3.next = 15;
                        break;

                     case 12:
                        _context3.prev = 12;
                        _context3.t0 = _context3['catch'](0);

                        if (_context3.t0.message === '400') {
                           _this.$store.commit('SNACKBAR', { timeout: 4000, text: 'Erreur lors de la cr\xE9ation, l\'identifiant \'' + userData.username + '\' est probablement d\xE9j\xE0 utilis\xE9', color: 'red' });
                        } else {
                           _this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur inconnue lors de la création", color: 'red' });
                        }

                     case 15:
                        _context3.prev = 15;

                        _this.$store.commit('WAITING', false);
                        return _context3.finish(15);

                     case 18:
                     case 'end':
                        return _context3.stop();
                  }
               }
            }, _callee3, _this, [[0, 12, 15, 18]]);
         }))();
      },
      updateUser: function updateUser(userData) {
         var _this2 = this;

         return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
               while (1) {
                  switch (_context4.prev = _context4.next) {
                     case 0:
                        _context4.prev = 0;

                        _this2.$store.commit('WAITING', true);
                        _context4.next = 4;
                        return _this2.$store.dispatch('PUT_USER', userData);

                     case 4:
                        _this2.$store.commit('SNACKBAR', { timeout: 1500, text: "Modifications enregistrées", color: 'green' });
                        _context4.next = 10;
                        break;

                     case 7:
                        _context4.prev = 7;
                        _context4.t0 = _context4['catch'](0);

                        _this2.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'enregistrement", color: 'red' });

                     case 10:
                        _context4.prev = 10;

                        _this2.selectedUserDirty = false;
                        _this2.$store.commit('WAITING', false);
                        return _context4.finish(10);

                     case 14:
                     case 'end':
                        return _context4.stop();
                  }
               }
            }, _callee4, _this2, [[0, 7, 10, 14]]);
         }))();
      },
      sendResetPasswordMail: function sendResetPasswordMail() {
         this.$store.commit('WAITING', true);
         var authData = this.$store.state.authenticationData;
         try {
            var promise = axios({
               method: 'post',
               url: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].RESET_PASSWORD_MAIL_URL,
               headers: { "Authorization": 'JWT ' + authData.token },
               data: { "user_id": this.userId }
            });
            this.$store.commit('SNACKBAR', { timeout: 1500, text: "Mail de réinitialisation de compte envoyé", color: 'green' });
            var self = this;
            promise.catch(function (error) {
               self.$store.commit('SNACKBAR', { timeout: 3500, text: 'Erreur lors de l\'envoi du mail de r\xE9initialisation de compte de : \'' + self.user.fullname + '\'', color: 'red' });
            });
         } catch (err) {
            this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'envoi du mail de réinitialisation de compte", color: 'red' });
         } finally {
            this.$store.commit('WAITING', false);
         }
      },
      querySelections: function querySelections(text) {
         var _this3 = this;

         return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
               while (1) {
                  switch (_context5.prev = _context5.next) {
                     case 0:
                     case 'end':
                        return _context5.stop();
                  }
               }
            }, _callee5, _this3);
         }))();
      },
      confirmLeaving: function confirmLeaving(to, from, next) {
         var _this4 = this;

         return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
            var _ref9, save, proceed;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
               while (1) {
                  switch (_context6.prev = _context6.next) {
                     case 0:
                        if (!_this4.formDirty) {
                           _context6.next = 10;
                           break;
                        }

                        _context6.next = 3;
                        return _this4.$store.dispatch('confirmer/ask', {
                           title: 'Quitter le formulaire sans sauvegarder ?',
                           body: 'Vous avez effectué des modifications dans le formulaire et vous vous apprêtez à en sortir sans sauvegarder',
                           choices: [{ text: "Sauvegarder et quitter", value: { save: true, proceed: true } }, { text: "Quitter sans sauvegarder", value: { save: false, proceed: true } }, { text: "Annuler", value: { save: false, proceed: false } }]
                        });

                     case 3:
                        _ref9 = _context6.sent;
                        save = _ref9.save;
                        proceed = _ref9.proceed;

                        if (save) {
                           // save when choice is 'Sauvegarder et quitter'
                           _this4.saveOrUpdate();
                        }
                        // proceed (or not) with route change
                        next(proceed);
                        _context6.next = 11;
                        break;

                     case 10:
                        // form is not dirty: proceed with route change
                        next();

                     case 11:
                     case 'end':
                        return _context6.stop();
                  }
               }
            }, _callee6, _this4);
         }))();
      },
      getFitbitAuthorizationURL: function getFitbitAuthorizationURL() {
         var _this5 = this;

         return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
            var authorizationURL, response, fitbitClientId, redirectUri;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
               while (1) {
                  switch (_context7.prev = _context7.next) {
                     case 0:
                        authorizationURL = null;
                        _context7.prev = 1;
                        _context7.next = 4;
                        return axios.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].FITBIT_CLIENT_ID_URL);

                     case 4:
                        response = _context7.sent;
                        fitbitClientId = response.data;
                        redirectUri = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].APIBASE.indexOf('nutrieduc') !== -1 ? "https://nutrieduc.fr:443/api/fitbit-authorize" : "https://shdl.fr:443/api/fitbit-authorize";

                        authorizationURL = "https://www.fitbit.com/oauth2/authorize" + "?response_type=code" +
                        // force login with Fitbit user's credentials and ask for consent
                        "&prompt=login consent" +
                        // 'state' is the way to pass additionnal information - in this case the user id to whom refresh token is created
                        "&state=" + _this5.userId + "&client_id=" + fitbitClientId + "&redirect_uri=" + encodeURIComponent(redirectUri) + "&scope=activity%20heartrate%20location%20nutrition%20profile%20settings%20sleep%20social%20weight" + "&expires_in=604800";
                        //console.log('authorizationURL', authorizationURL)
                        _context7.next = 13;
                        break;

                     case 10:
                        _context7.prev = 10;
                        _context7.t0 = _context7['catch'](1);

                        console.error(_context7.t0);

                     case 13:
                        return _context7.abrupt('return', authorizationURL);

                     case 14:
                     case 'end':
                        return _context7.stop();
                  }
               }
            }, _callee7, _this5, [[1, 10]]);
         }))();
      }
   }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_users_LineChart_js__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_users_BarChart_js__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var periodDescription = { '7d': { count: 7, step: 1 }, '30d': { count: 10, step: 3 }, '3m': { count: 10, step: 10 } };

/* harmony default export */ __webpack_exports__["default"] = ({

   components: {
      LineChart: __WEBPACK_IMPORTED_MODULE_3__components_users_LineChart_js__["a" /* default */],
      BarChart: __WEBPACK_IMPORTED_MODULE_4__components_users_BarChart_js__["a" /* default */]
   },

   props: {
      userId: Number,
      attribute: Object
   },

   data: function data() {
      return {
         userAttributesDatedValues: null,
         options: {
            scales: {
               xAxes: [{
                  type: 'time',
                  display: true,
                  distribution: 'linear',
                  bounds: 'data',
                  ticks: {
                     source: 'auto'
                  },
                  time: {
                     unit: 'day'
                  }
               }]
            },
            onClick: this.onMeasureClick
         },
         version: 0,
         graphData: null,
         period: '30d',

         addDialog: false,
         defaultDate: null,
         measureDate: new Date(),
         measureValue: null,
         menu: false,
         moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a,

         datedValues: null,
         clickedDatedValue: null
      };
   },


   computed: {
      isAcquisitionManual: function isAcquisitionManual() {
         return this.attribute.params.acquisition === 'manual';
      },
      isAcquisitionFitbit: function isAcquisitionFitbit() {
         return this.attribute.params.acquisition === 'fitbit';
      },
      formValid: function formValid() {
         if (this.$v.measureValue.$error) return false;
         return true;
      },
      valueErrors: function valueErrors() {
         var errors = [];
         if (!this.$v.measureValue.$dirty) return errors;
         !this.$v.measureValue.required && errors.push("La valeur est obligatoire");
         !this.$v.measureValue.decimal && errors.push("Il faut saisir un nombre, par exemple : 69.5");
         return errors;
      }
   },

   mounted: function mounted() {
      this.getDataAndUpdateGraph();
   },


   methods: {
      getDataAndUpdateGraph: function () {
         var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var self, periodDescr, authorizationJWT;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        self = this;

                        if (!this.isAcquisitionManual) {
                           _context.next = 6;
                           break;
                        }

                        periodDescr = periodDescription[this.period];

                        this.$store.dispatch('GET_USER_ATTRIBUTE_DATED_VALUES', {
                           userId: this.userId,
                           attributeId: this.attribute.id,
                           start: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-periodDescr.step * periodDescr.count, 'days').format("YYYY-MM-DDTHH:MM"),
                           end: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY-MM-DDTHH:MM")
                        }).then(function (datedValues_) {
                           self.datedValues = datedValues_;
                           var datetimeValues = datedValues_.map(function (datedValue) {
                              return { dateTime: datedValue.date, value: datedValue.value };
                           });
                           self.graphData = self.buildGraphData([datetimeValues]);
                           // update graph view
                           self.updateGraph();
                        });

                        _context.next = 9;
                        break;

                     case 6:
                        if (!this.isAcquisitionFitbit) {
                           _context.next = 9;
                           break;
                        }

                        authorizationJWT = this.$store.state.authenticationData.token;
                        return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_6_axios___default()({
                           method: 'get',
                           url: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].FITBIT_IS_AUTHORIZED_URL + "?user=" + this.userId,
                           headers: { "Authorization": "JWT " + authorizationJWT }
                        }).then(function (response) {
                           var isAuthorized = response.data;
                           if (isAuthorized) {
                              __WEBPACK_IMPORTED_MODULE_6_axios___default()({
                                 method: 'get',
                                 url: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].FITBIT_ACCESS_TOKEN_URL + "?user=" + self.userId,
                                 headers: { "Authorization": "JWT " + authorizationJWT }
                              }).then(function (response) {
                                 var accessToken = response.data;
                                 //console.log('accessToken', accessToken)
                                 var promises = self.attribute.params.dimensions.map(function (dimension) {
                                    return __WEBPACK_IMPORTED_MODULE_6_axios___default()({
                                       method: 'get',
                                       url: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].FITBIT_USER_TIME_SERIES_URL + "?access_token=" + accessToken + "&resource=" + dimension.fitbit_resource + "&period=" + self.period,
                                       headers: { "Authorization": "JWT " + authorizationJWT }
                                    });
                                 });
                                 return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);
                              }).then(function (response) {
                                 var valuesArray = response.map(function (e) {
                                    return e.data;
                                 });
                                 self.graphData = self.buildGraphData(valuesArray);
                              }).then(function (response) {
                                 self.updateGraph();
                              });
                           }
                        }).catch(function (error) {
                           console.log('error', error);
                        }));

                     case 9:
                     case "end":
                        return _context.stop();
                  }
               }
            }, _callee, this);
         }));

         function getDataAndUpdateGraph() {
            return _ref.apply(this, arguments);
         }

         return getDataAndUpdateGraph;
      }(),

      buildGraphData: function buildGraphData(datedValuesArray) {
         var self = this;
         var datasets = this.attribute.params.dimensions.map(function (dimension, index) {
            return {
               label: dimension.name,
               backgroundColor: dimension.color,
               pointRadius: 5,
               data: datedValuesArray[index].map(function (datedValue) {
                  return { x: __WEBPACK_IMPORTED_MODULE_5_moment___default()(datedValue.dateTime), y: parseFloat(datedValue.value) };
               })
            };
         });
         return {
            datasets: datasets,
            labels: []
         };
      },

      updateGraph: function updateGraph() {
         this.version += 1;
      },
      onMeasureClick: function onMeasureClick(event, chartElementArray) {
         console.log('onClick', chartElementArray);
         if (chartElementArray.length === 1) {
            if (chartElementArray.length !== 1) return;
            var dataIndex = chartElementArray[0]._index;
            this.clickedDatedValue = this.datedValues[dataIndex];
         } else {
            this.clickedDatedValue = null;
         }
      },
      removeMeasure: function removeMeasure() {
         var _this = this;

         return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
               while (1) {
                  switch (_context2.prev = _context2.next) {
                     case 0:
                        _context2.next = 2;
                        return _this.$store.dispatch('DELETE_USER_ATTRIBUTE_DATED_VALUE', _this.clickedDatedValue);

                     case 2:
                        _context2.next = 4;
                        return _this.getDataAndUpdateGraph();

                     case 4:
                        _this.clickedDatedValue = null;

                     case 5:
                     case "end":
                        return _context2.stop();
                  }
               }
            }, _callee2, _this);
         }))();
      },


      addMeasure: function () {
         var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var datedValue;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
               while (1) {
                  switch (_context3.prev = _context3.next) {
                     case 0:
                        datedValue = {
                           user: this.userId,
                           author: this.$store.state.loggedUserId,
                           attribute: this.attribute.id,
                           date: __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.measureDate).format("YYYY-MM-DDTHH:MM"),
                           value: this.measureValue
                        };
                        _context3.next = 3;
                        return this.$store.dispatch('POST_USER_ATTRIBUTE_DATED_VALUE', datedValue);

                     case 3:
                        _context3.next = 5;
                        return this.getDataAndUpdateGraph();

                     case 5:
                        this.clickedDatedValue = null;

                     case 6:
                     case "end":
                        return _context3.stop();
                  }
               }
            }, _callee3, this);
         }));

         function addMeasure() {
            return _ref2.apply(this, arguments);
         }

         return addMeasure;
      }()
   },

   validations: {
      measureValue: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], decimal: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["decimal"] }
   },

   watch: {
      period: function period(newVal, oldVal) {
         // get data for the new period
         this.getDataAndUpdateGraph();
      }
   }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_UserAttributeChart__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_UserAttributeChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_users_UserAttributeChart__);


//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number
   },

   components: {
      UserAttributeChart: __WEBPACK_IMPORTED_MODULE_2__components_users_UserAttributeChart___default.a
   },

   mounted: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     _context.next = 2;
                     return this.$store.dispatch('GET_USER_ATTRIBUTES', this.userId);

                  case 2:
                     this.userAttributes = _context.sent;

                  case 3:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function mounted() {
         return _ref.apply(this, arguments);
      }

      return mounted;
   }(),

   data: function data() {
      return {
         userAttributes: null
      };
   },


   computed: {
      user: function user() {
         return this.$store.state.users[this.userId];
      }
   },

   methods: {
      isVisible: function isVisible(attribute) {
         if (attribute.params.acquisition === 'fitbit' && !this.user.extra.fitbit_user_id) return false;
         return true;
      }
   }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_formatDate_js__ = __webpack_require__(215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      userId: Number
   },

   mounted: function mounted() {
      // fetch user history in central store: reactivity will update the list view
      this.$store.dispatch('GET_USER_HISTORY_EVENTS', this.userId);
   },

   data: function data() {
      return {};
   },


   computed: {
      user: function user() {
         return this.$store.state.users[this.userId];
      },
      events: function events() {
         var _this = this;

         if (this.$store.state.user2eventList.hasOwnProperty(this.userId)) {
            return this.$store.state.user2eventList[this.userId].map(function (eventId) {
               return _this.$store.state.events[eventId];
            });
         } else {
            return [];
         }
      }
   },

   methods: {
      formatDate: function formatDate(date) {
         return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_formatDate_js__["a" /* default */])(date);
      },
      eventAuthorName: function eventAuthorName(event) {
         if (this.$store.state.users.hasOwnProperty(event.author)) {
            var author = this.$store.state.users[event.author];
            return author.first_name + ' ' + author.last_name;
         } else {
            return '';
         }
      }
   }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

   props: {
      title: {
         type: String,
         default: "Utilisateurs"
      },
      users: Array,
      selectedUserId: Number,
      canAdd: {
         type: Boolean,
         default: true
      }
   },

   data: function data() {
      return {
         deleteDialog: false,
         userToDelete: {},
         filter: ''
      };
   },


   computed: {
      displayedUsers: function displayedUsers() {
         var self = this;
         var filteredUsers = this.users.filter(function (user) {
            return self.displayName(user).toLowerCase().indexOf(self.filter.toLowerCase()) !== -1 || user.username.toLowerCase().indexOf(self.filter.toLowerCase()) !== -1 || user.extra.tag && user.extra.tag.toLowerCase().indexOf(self.filter.toLowerCase()) !== -1;
         });
         var sortedUsers = filteredUsers.sort(function (a, b) {
            if (self.displayName(a).toLowerCase() < self.displayName(b).toLowerCase()) {
               return -1;
            } else if (self.displayName(a).toLowerCase() > self.displayName(b).toLowerCase()) {
               return 1;
            } else {
               return 0;
            }
         });
         return sortedUsers;
      }
   },

   methods: {
      clone: function clone(user) {
         return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(user);
      },
      selectUser: function selectUser(userId) {
         //this.filter = ''
         this.$emit('userSelected', userId);
      },
      birthDescription: function birthDescription(user) {
         return user.birthdate ? "Né le " + __WEBPACK_IMPORTED_MODULE_0_moment___default()(user.birthdate).format("DD/MM/YYYY") : '';
      },
      displayName: function displayName(user) {
         if (user) {
            if (user.first_name && user.last_name) {
               return user.last_name + ' ' + user.first_name;
            } else if (user.fullname) {
               return user.fullname;
            } else {
               return user.username;
            }
         } else {
            return '';
         }
      },
      add: function add() {
         this.$emit('addUser');
      },
      deleteUser: function deleteUser(user) {
         this.$emit('deleteUser', user.id);
      },
      unreadMessageCount: function unreadMessageCount(userId) {
         return this.$store.state.user2unreadMessageCount[userId];
      },
      noPasswordUser: function noPasswordUser(user) {
         return user.password === __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].INITIAL_PASSWORD;
      }
   }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_users_UserList__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_users_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_users_UserList__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var axios = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["default"] = ({

   components: {
      UserList: __WEBPACK_IMPORTED_MODULE_5__components_users_UserList___default.a
   },

   mounted: function mounted() {
      // fetch user list
      this.$store.dispatch('GET_USERS');
   },

   data: function data() {
      return {
         selectedUserId: null,
         selectedUserDirty: false
      };
   },


   computed: {
      users: function users() {
         return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.$store.state.users).map(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            return value;
         });
      }
   },

   methods: {
      userSelected: function userSelected(userId) {
         if (this.selectedUserDirty) {
            this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la création", color: 'red' });
         }
         // fetch user data for User component
         this.$store.dispatch('GET_USER', userId);
         this.selectedUserId = userId;
         this.$router.push('/user-manager/user/' + userId);
      },
      addUser: function addUser(user) {
         this.$router.push('/user-manager/create');
      },
      deleteUser: function deleteUser(userId) {
         var _this = this;

         return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
               while (1) {
                  switch (_context.prev = _context.next) {
                     case 0:
                        _this.$router.push('/user-manager');
                        _this.selectedUserId = null;
                        _context.prev = 2;

                        _this.$store.commit('WAITING', true);
                        _context.next = 6;
                        return _this.$store.dispatch('DELETE_USER', userId);

                     case 6:
                        _this.$store.commit('SNACKBAR', { timeout: 1500, text: "Suppression effectuée", color: 'green' });
                        _context.next = 12;
                        break;

                     case 9:
                        _context.prev = 9;
                        _context.t0 = _context['catch'](2);

                        _this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la suppression", color: 'red' });

                     case 12:
                        _context.prev = 12;

                        _this.$store.commit('WAITING', false);
                        return _context.finish(12);

                     case 15:
                     case 'end':
                        return _context.stop();
                  }
               }
            }, _callee, _this, [[2, 9, 12, 15]]);
         }))();
      },
      userIdChanged: function userIdChanged(userId) {
         this.selectedUserId = userId;
      }
   }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(568);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['data', 'options', 'version'],

  mounted: function mounted() {
    this.renderChart(this.data, this.options);
  },


  watch: {
    version: function version(val) {
      //console.log('version', val, 'data', this.data)
      this.renderChart(this.data, this.options);
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(568);



/* harmony default export */ __webpack_exports__["a"] = ({

   extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],

   props: {
      data: Object,
      options: Object,
      version: Number // change it to update view
   },

   mounted: function mounted() {
      this.renderChart(this.data, this.options);
   },


   watch: {
      version: function version(val) {
         //console.log('version', val, 'data', this.data)
         this.renderChart(this.data, this.options);
      }
   }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);



var initialState = {
   active: false,
   title: '',
   body: '',
   choices: [],
   resolve: null,
   reject: null
};

var state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, initialState);

var mutations = {
   'ACTIVATE': function ACTIVATE(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, payload);
   },
   'DEACTIVATE': function DEACTIVATE(state) {
      state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, initialState);
   }
};

var actions = {
   ask: function ask(_ref, _ref2) {
      var commit = _ref.commit;
      var title = _ref2.title,
          body = _ref2.body,
          choices = _ref2.choices;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
         commit('ACTIVATE', {
            active: true,
            title: title,
            body: body,
            choices: choices,
            resolve: resolve,
            reject: reject
         });
      });
   }
};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   state: state,
   mutations: mutations,
   actions: actions
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);




var axios = __webpack_require__(24);


function resetState(state) {
   __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, {
      // persisted in model ShdlModule
      modules: {},
      user2moduleList: {},
      team2moduleList: {},

      // not persisted in database
      module2parseInfo: {}
   });
}

var state = {};
resetState(state);

var mutations = {
   RESET_STATE: function RESET_STATE(state) {
      //console.log('craps/RESET_STATE')
      resetState(state);
   },


   // between userId and teamId, one is null and the other is not
   SET_CRAPS_MODULES: function SET_CRAPS_MODULES(state, _ref) {
      var userId = _ref.userId,
          teamId = _ref.teamId,
          modules = _ref.modules;

      modules.forEach(function (module) {
         state.modules[module.id] = module;
      });
      if (userId) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2moduleList, userId, modules.map(function (module) {
            return module.id;
         }));
      }
      if (teamId) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.team2moduleList, teamId, modules.map(function (module) {
            return module.id;
         }));
      }
   },
   ADD_CRAPS_MODULE: function ADD_CRAPS_MODULE(state, module) {
      // add module to state.modules
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.modules, module.id, module);
      if (module.user) {
         // add module to state.user2moduleList
         if (!state.user2moduleList.hasOwnProperty(module.user)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2moduleList, module.user, []);
         // simply push it: sorting is done in UI
         state.user2moduleList[module.user].push(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2moduleList, module.user, state.user2moduleList[module.user]);
      }
      if (module.team) {
         // add module to state.team2moduleList
         if (!state.team2moduleList.hasOwnProperty(module.team)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.team2moduleList, module.team, []);
         // simply push it: sorting is done in UI
         state.team2moduleList[module.team].push(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.team2moduleList, module.team, state.team2moduleList[module.team]);
      }
   },
   UPDATE_CRAPS_MODULE: function UPDATE_CRAPS_MODULE(state, module) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.modules, module.id, module);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2moduleList, module.user, state.user2moduleList[module.user]);
   },
   REMOVE_CRAPS_MODULE: function REMOVE_CRAPS_MODULE(state, module) {
      if (module.user) {
         var index = state.user2moduleList[module.user].indexOf(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.user2moduleList[module.user], index);
      }
      if (module.team) {
         var _index = state.team2moduleList[module.team].indexOf(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.team2moduleList[module.team], _index);
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.modules, module.id);
   },


   // this mutation allows to store additionnal info on modules (parsing, checking etc.), which are not saved in database
   UPDATE_MODULE_PARSE_INFO: function UPDATE_MODULE_PARSE_INFO(state, _ref2) {
      var moduleId = _ref2.moduleId,
          memory = _ref2.memory,
          symbols = _ref2.symbols,
          isOk = _ref2.isOk;

      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.module2parseInfo, moduleId, {
         memory: memory,
         symbols: symbols,
         isOk: isOk
      });
   }
};

var actions = {

   // between userId and teamId, one is null and the other is not
   GET_CRAPS_MODULES: function GET_CRAPS_MODULES(_ref3, _ref4) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;
      var userId = _ref4.userId,
          teamId = _ref4.teamId;

      var queryParams = void 0;
      if (userId) {
         queryParams = 'user=' + userId;
      }
      if (teamId) {
         queryParams = 'team=' + teamId;
      }
      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].CRAPS_MODULES_URL + '?' + queryParams,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var shdlModulesDict = { userId: userId, teamId: teamId, modules: response.data };
         commit('SET_CRAPS_MODULES', shdlModulesDict);
         return response.data;
      });
   },
   POST_CRAPS_MODULE: function POST_CRAPS_MODULE(_ref5, module) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].CRAPS_MODULES_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: module
      }).then(function (response) {
         commit('ADD_CRAPS_MODULE', response.data);
         return response.data;
      });
   },
   PUT_CRAPS_MODULE: function PUT_CRAPS_MODULE(_ref6, module) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].CRAPS_MODULES_URL + module.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: module
      }).then(function (response) {
         commit('UPDATE_CRAPS_MODULE', response.data);
         return response.data;
      });
   },
   DELETE_CRAPS_MODULE: function DELETE_CRAPS_MODULE(_ref7, module) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].CRAPS_MODULES_URL + module.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_CRAPS_MODULE', module);
         return module;
      });
   }
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   state: state,
   mutations: mutations,
   actions: actions,
   getters: getters
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);




var axios = __webpack_require__(24);


function resetState(state) {
   __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, {
      meals: {},
      mealElements: {},
      meal2mealElementList: {}, // mealId -> list of mealelements
      user2mealList: {}, // userId -> list of meals
      user2date2index2meal: {},
      foods: {},
      foodPortions: {},
      food2foodPortionList: {},
      fractionnings: {},
      user2date2fractionning: {},
      user2surveyFractionningList: {},
      favorites: {},
      user2index2favorites: {},
      nutrients: {},
      nutrientList: [],
      nutdatas: {},
      food2nutrient2nutdata: {}
   });
}

var state = {};
resetState(state);

function sortUserMeals(state, meals) {
   meals.sort(function (id1, id2) {
      var meal1 = state.meals[id1];
      var meal2 = state.meals[id2];
      if (meal1.date < meal2.date) {
         return -1;
      } else if (meal1.date > meal2.date) {
         return 1;
      } else {
         return meal1.index - meal2.index;
      }
   });
}

var mutations = {
   RESET_STATE: function RESET_STATE(state) {
      //console.log('meals/RESET_STATE')
      resetState(state);
   },
   SET_FOOD: function SET_FOOD(state, food) {
      state.foods[food.id] = food;
   },
   SET_FOODS: function SET_FOODS(state, foods) {
      foods.forEach(function (food) {
         state.foods[food.id] = food;
      });
   },
   SET_MEAL: function SET_MEAL(state, meal) {
      // update state.meals
      state.meals[meal.id] = meal;
   },
   SET_USER_MEALS: function SET_USER_MEALS(state, _ref) {
      var userId = _ref.userId,
          meals = _ref.meals;

      meals.forEach(function (meal) {
         // update state.meals
         state.meals[meal.id] = meal;
         // update state.user2date2index2meal
         if (!state.user2date2index2meal.hasOwnProperty(meal.user)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal, meal.user, {});
         if (!state.user2date2index2meal[meal.user].hasOwnProperty(meal.date)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal[meal.user], meal.date, {});
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal[meal.user][meal.date], meal.index, meal.id);
      });
      var mealList = meals.map(function (meal) {
         return meal.id;
      });
      // sort it by date, index
      sortUserMeals(state, mealList);
      // update state.user2mealList
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2mealList, userId, mealList);
   },
   SET_USER_MEAL: function SET_USER_MEAL(state, _ref2) {
      var userId = _ref2.userId,
          date = _ref2.date,
          index = _ref2.index,
          meal = _ref2.meal;

      if (meal !== null) {
         state.meals[meal.id] = meal;
      }
      if (!state.user2date2index2meal.hasOwnProperty(userId)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal, userId, {});
      if (!state.user2date2index2meal[userId].hasOwnProperty(date)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal[userId], date, {});
      if (meal === null) {
         state.user2date2index2meal[userId][date][index] = -1;
      } else {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal[userId][date], index, meal.id);
         if (!state.user2mealList.hasOwnProperty(userId)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2mealList, userId, []);
         var mealList = state.user2mealList[userId];
         if (mealList.indexOf(meal.id) === -1) {
            mealList.push(meal.id);
         }
         // sort it by date, index
         sortUserMeals(state, mealList);
         // update state.user2mealList
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2mealList, userId, mealList);
      }
   },
   CREATE_USER_MEAL: function CREATE_USER_MEAL(state, meal) {
      // add meal to state.meals
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.meals, meal.id, meal);
      // add meal to state.user.date2index2meal
      if (!state.user2date2index2meal.hasOwnProperty(meal.user)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal, meal.user, {});
      if (!state.user2date2index2meal[meal.user].hasOwnProperty(meal.date)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal[meal.user], meal.date, {});
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2index2meal[meal.user][meal.date], meal.index, meal.id);
      // add meal to state.user2mealList
      if (!state.user2mealList.hasOwnProperty(meal.user)) state.user2mealList[meal.user] = [];
      var mealList = state.user2mealList[meal.user];
      mealList.push(meal.id);
      // sort it by date, index
      sortUserMeals(state, mealList);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2mealList, meal.user, mealList);
   },
   UPDATE_USER_MEAL: function UPDATE_USER_MEAL(state, meal) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.meals, meal.id, meal);
      // then sort state.user2mealList[meal.user] by date, index
      sortUserMeals(state, state.user2mealList[meal.user]);
   },
   REMOVE_USER_MEAL: function REMOVE_USER_MEAL(state, meal) {
      // remove it from state.user2mealList
      var index = state.user2mealList[meal.user].indexOf(meal.id);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.user2mealList[meal.user], index);
      // remove it from state.user2date2index2meal
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.user2date2index2meal[meal.user][meal.date], meal.index);
      // remove it from state.meals
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.meals, meal.id);
   },
   SET_FOODPORTION: function SET_FOODPORTION(state, foodPortion) {
      state.foodPortions[foodPortion.id] = foodPortion;
   },
   SET_FOOD_FOODPORTIONS: function SET_FOOD_FOODPORTIONS(state, _ref3) {
      var foodId = _ref3.foodId,
          foodPortions = _ref3.foodPortions;

      foodPortions.forEach(function (foodPortion) {
         state.foodPortions[foodPortion.id] = foodPortion;
      });
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.food2foodPortionList, foodId, foodPortions.map(function (foodPortion) {
         return foodPortion.id;
      }));
   },
   SET_MEAL_ELEMENTS: function SET_MEAL_ELEMENTS(state, _ref4) {
      var mealId = _ref4.mealId,
          elements = _ref4.elements;

      elements.forEach(function (element) {
         state.mealElements[element.id] = element;
      });
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.meal2mealElementList, mealId, elements.map(function (element) {
         return element.id;
      }));
   },
   ADD_MEAL_ELEMENT: function ADD_MEAL_ELEMENT(state, mealElement) {
      // add mealElement to state.mealElements
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.mealElements, mealElement.id, mealElement);
      // add mealElement to state.meal2mealElementList
      if (!state.meal2mealElementList.hasOwnProperty(mealElement.meal)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.meal2mealElementList, mealElement.meal, []);
      state.meal2mealElementList[mealElement.meal].push(mealElement.id);
   },
   UPDATE_MEAL_ELEMENT: function UPDATE_MEAL_ELEMENT(state, mealElement) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.mealElements, mealElement.id, mealElement);
      // force reactivity of state.meal2mealElementList by removing / adding back mealElement into it
      var index = state.meal2mealElementList[mealElement.meal].indexOf(mealElement.id);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.meal2mealElementList[mealElement.meal], index);
      //state.meal2mealElementList[mealElement.meal].push(mealElement.id)
      state.meal2mealElementList[mealElement.meal].splice(index, 0, mealElement.id);
   },
   REMOVE_MEAL_ELEMENT: function REMOVE_MEAL_ELEMENT(state, mealElement) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.mealElements, mealElement.id);
      var index = state.meal2mealElementList[mealElement.meal].indexOf(mealElement.id);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.meal2mealElementList[mealElement.meal], index);
   },
   SET_FRACTIONNING: function SET_FRACTIONNING(state, fractionning) {
      // add fractionning to state.fractionnings
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.fractionnings, fractionning.id, fractionning);
      // add fractionning to state.user2date2fractionning
      if (!state.user2date2fractionning.hasOwnProperty(fractionning.user)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2fractionning, fractionning.user, {});
      if (!state.user2date2fractionning[fractionning.user].hasOwnProperty(fractionning.date)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2fractionning[fractionning.user], fractionning.date, fractionning.id);
      // update state.user2surveyFractionningList
      if (fractionning.surveyIndex !== null) {
         if (!state.user2surveyFractionningList[fractionning.user]) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2surveyFractionningList, fractionning.user, []);
         var surveyFractionningList = state.user2surveyFractionningList[fractionning.user];
         var surveyFractionningDateList = surveyFractionningList.map(function (id) {
            return state.fractionnings[id].date;
         });
         if (surveyFractionningDateList.indexOf(fractionning.date) === -1) {
            surveyFractionningList.push(fractionning.id);
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2surveyFractionningList, fractionning.user, surveyFractionningList);
         }
      }
   },
   UPDATE_FRACTIONNING: function UPDATE_FRACTIONNING(state, fractionning) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.fractionnings, fractionning.id, fractionning);
   },
   SET_SURVEY_FRACTIONNINGS: function SET_SURVEY_FRACTIONNINGS(state, _ref5) {
      var userId = _ref5.userId,
          fractionnings = _ref5.fractionnings;

      fractionnings.forEach(function (fractionning) {
         // add fractionning to state.fractionnings
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.fractionnings, fractionning.id, fractionning);
         // add fractionning to state.user2date2fractionning
         if (!state.user2date2fractionning.hasOwnProperty(fractionning.user)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2fractionning, fractionning.user, {});
         if (!state.user2date2fractionning[fractionning.user].hasOwnProperty(fractionning.date)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2date2fractionning[fractionning.user], fractionning.date, fractionning.id);
      });
      // update state.user2surveyFractionningList
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2surveyFractionningList, userId, fractionnings.map(function (fractionning) {
         return fractionning.id;
      }));
   },
   SET_FAVORITES: function SET_FAVORITES(state, _ref6) {
      var userId = _ref6.userId,
          index = _ref6.index,
          favorites = _ref6.favorites;

      // update state.favorites
      favorites.forEach(function (favorite) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.favorites, favorite.id, favorite);
      });
      // update state.user2index2favorites 
      if (!state.user2index2favorites.hasOwnProperty(userId)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2index2favorites, userId, {});
      if (!state.user2index2favorites[userId].hasOwnProperty(index)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2index2favorites[userId], index, []);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2index2favorites[userId], index, favorites.map(function (favorite) {
         return favorite.id;
      }));
   },
   ADD_FAVORITE: function ADD_FAVORITE(state, favorite) {
      var userId = favorite.user;
      var index = favorite.index;
      // update state.favorites
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.favorites, favorite.id, favorite);
      // update state.user2index2favorites 
      if (!state.user2index2favorites.hasOwnProperty(userId)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2index2favorites, userId, {});
      if (!state.user2index2favorites[userId].hasOwnProperty(index)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2index2favorites[userId], index, []);
      var list = state.user2index2favorites[userId][index];
      list.push(favorite.id);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2index2favorites[userId], index, list);
   },
   UPDATE_FAVORITE: function UPDATE_FAVORITE(state, favorite) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.favorites, favorite.id, favorite);
   },
   SET_NUTRIENTS: function SET_NUTRIENTS(state, nutrients) {
      // update state.nutrients
      nutrients.forEach(function (nutrient) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.nutrients, nutrient.nutr_no, nutrient);
      });
      // update state.nutrientList 
      state.nutrientList = nutrients.map(function (nutrient) {
         return nutrient.nutr_no;
      });
   },
   SET_FOOD_NUTDATA: function SET_FOOD_NUTDATA(state, nutdatas) {
      // update state.nutdatas & state.food2nutrient2nutdata
      nutdatas.forEach(function (nutdata) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.nutdatas, nutdata.id, nutdata);
         if (!state.food2nutrient2nutdata.hasOwnProperty(nutdata.food)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.food2nutrient2nutdata, nutdata.food, {});
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.food2nutrient2nutdata[nutdata.food], nutdata.nutrient, nutdata.id);
      });
   }
};

var actions = {
   GET_FOOD: function GET_FOOD(_ref7, foodId) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FOODS_URL + foodId + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('SET_FOOD', response.data);
         return response.data;
      });
   },
   GET_FOOD_SEARCH: function GET_FOOD_SEARCH(_ref8, text) {
      var commit = _ref8.commit,
          rootState = _ref8.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FOODS_URL + '?search=' + text,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('SET_FOODS', response.data);
         return response.data;
      });
   },
   GET_MEAL: function GET_MEAL(_ref9, mealId) {
      var commit = _ref9.commit,
          rootState = _ref9.rootState;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEALS_URL + mealId + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var meal = response.data;
         commit('SET_MEAL', meal);
         return meal;
      });
   },
   GET_USER_DAY_MEALS: function GET_USER_DAY_MEALS(_ref10, _ref11) {
      var commit = _ref10.commit,
          rootState = _ref10.rootState;
      var userId = _ref11.userId,
          date = _ref11.date;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEALS_URL + '?user=' + userId + '&date=' + date,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var userMealsDict = { userId: userId, meals: response.data };
         commit('SET_USER_MEALS', userMealsDict);
         return response.data;
      });
   },


   // return null when meal (userId, date, index) does not exist
   GET_USER_MEAL: function GET_USER_MEAL(_ref12, _ref13) {
      var commit = _ref12.commit,
          rootState = _ref12.rootState;
      var userId = _ref13.userId,
          date = _ref13.date,
          index = _ref13.index;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEALS_URL + '?user=' + userId + '&date=' + date + '&index=' + index,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var meals = response.data; // 0 or 1 meal
         var meal = meals.length === 0 ? null : meals[0];
         commit('SET_USER_MEAL', { userId: userId, date: date, index: index, meal: meal });
         return meal;
      });
   },
   DELETE_USER_MEAL: function DELETE_USER_MEAL(_ref14, meal) {
      var commit = _ref14.commit,
          rootState = _ref14.rootState;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEALS_URL + meal.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_USER_MEAL', meal);
         return meal;
      });
   },
   POST_USER_MEAL: function POST_USER_MEAL(_ref15, mealToCreate) {
      var commit = _ref15.commit,
          rootState = _ref15.rootState;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEALS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: mealToCreate
      }).then(function (response) {
         commit('CREATE_USER_MEAL', response.data);
         return response.data;
      });
   },
   PUT_USER_MEAL: function PUT_USER_MEAL(_ref16, meal) {
      var commit = _ref16.commit,
          rootState = _ref16.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEALS_URL + meal.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: meal
      }).then(function (response) {
         commit('UPDATE_USER_MEAL', response.data);
         return response.data;
      });
   },


   // fetch portions of a food
   GET_FOODPORTION: function GET_FOODPORTION(_ref17, foodPortionId) {
      var commit = _ref17.commit,
          rootState = _ref17.rootState;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FOOD_PORTIONS_URL + foodPortionId + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var foodPortion = response.data;
         commit('SET_FOODPORTION', foodPortion);
         return response.data;
      });
   },


   // fetch portions of a food
   GET_FOOD_FOODPORTIONS: function GET_FOOD_FOODPORTIONS(_ref18, foodId) {
      var commit = _ref18.commit,
          rootState = _ref18.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FOOD_PORTIONS_URL + '?food=' + foodId,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var foodPortionsDict = { foodId: foodId, foodPortions: response.data };
         commit('SET_FOOD_FOODPORTIONS', foodPortionsDict);
         return response.data;
      });
   },


   // fetch meal elements
   GET_MEAL_ELEMENTS: function GET_MEAL_ELEMENTS(_ref19, mealId) {
      var commit = _ref19.commit,
          rootState = _ref19.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEAL_ELEMENTS_URL + '?meal=' + mealId,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var mealElementsDict = { mealId: mealId, elements: response.data };
         commit('SET_MEAL_ELEMENTS', mealElementsDict);
         return response.data;
      });
   },
   POST_MEAL_ELEMENT: function POST_MEAL_ELEMENT(_ref20, mealElement) {
      var commit = _ref20.commit,
          rootState = _ref20.rootState;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEAL_ELEMENTS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: mealElement
      }).then(function (response) {
         commit('ADD_MEAL_ELEMENT', response.data);
         return response.data;
      });
   },
   PUT_MEAL_ELEMENT: function PUT_MEAL_ELEMENT(_ref21, mealElement) {
      var commit = _ref21.commit,
          rootState = _ref21.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEAL_ELEMENTS_URL + mealElement.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: mealElement
      }).then(function (response) {
         commit('UPDATE_MEAL_ELEMENT', response.data);
         return response.data;
      });
   },
   DELETE_MEAL_ELEMENT: function DELETE_MEAL_ELEMENT(_ref22, mealElement) {
      var commit = _ref22.commit,
          rootState = _ref22.rootState;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].MEAL_ELEMENTS_URL + mealElement.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_MEAL_ELEMENT', mealElement);
         return mealElement;
      });
   },


   // fetch fractionning
   GET_FRACTIONNING: function GET_FRACTIONNING(_ref23, _ref24) {
      var commit = _ref23.commit,
          rootState = _ref23.rootState;
      var userId = _ref24.userId,
          date = _ref24.date;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FRACTIONNINGS_URL + '?user=' + userId + '&date=' + date,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         if (response.data.length === 1) {
            commit('SET_FRACTIONNING', response.data[0]);
            return response.data[0];
         } else {
            return null;
         }
      });
   },


   // fetch all fractionnings of days of survey
   GET_SURVEY_FRACTIONNINGS: function GET_SURVEY_FRACTIONNINGS(_ref25, userId) {
      var commit = _ref25.commit,
          rootState = _ref25.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FRACTIONNINGS_URL + '?user=' + userId + '&onlySurveys=true',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('SET_SURVEY_FRACTIONNINGS', { userId: userId, fractionnings: response.data });
         return response.data;
      });
   },
   POST_FRACTIONNING: function POST_FRACTIONNING(_ref26, fractionning) {
      var commit = _ref26.commit,
          rootState = _ref26.rootState;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FRACTIONNINGS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: fractionning
      }).then(function (response) {
         commit('SET_FRACTIONNING', response.data);
         return response.data;
      });
   },
   PUT_FRACTIONNING: function PUT_FRACTIONNING(_ref27, fractionning) {
      var commit = _ref27.commit,
          rootState = _ref27.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FRACTIONNINGS_URL + fractionning.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: fractionning
      }).then(function (response) {
         commit('UPDATE_FRACTIONNING', response.data);
         return response.data;
      });
   },
   GET_FAVORITES: function GET_FAVORITES(_ref28, _ref29) {
      var commit = _ref28.commit,
          rootState = _ref28.rootState;
      var userId = _ref29.userId,
          index = _ref29.index;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FAVORITES_URL + '?user=' + userId + '&index=' + index,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var favoritesDict = { userId: userId, index: index, favorites: response.data };
         commit('SET_FAVORITES', favoritesDict);
         return response.data;
      });
   },
   GET_FAVORITE: function GET_FAVORITE(_ref30, _ref31) {
      var commit = _ref30.commit,
          rootState = _ref30.rootState;
      var userId = _ref31.userId,
          index = _ref31.index,
          portion = _ref31.portion,
          nbportion = _ref31.nbportion;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FAVORITES_URL + '?user=' + userId + '&index=' + index + '&portion=' + portion + '&nbportion=' + nbportion,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         return response.data;
      });
   },
   POST_FAVORITE: function POST_FAVORITE(_ref32, favorite) {
      var commit = _ref32.commit,
          rootState = _ref32.rootState;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FAVORITES_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: favorite
      }).then(function (response) {
         commit('ADD_FAVORITE', response.data);
         return response.data;
      });
   },
   PUT_FAVORITE: function PUT_FAVORITE(_ref33, favorite) {
      var commit = _ref33.commit,
          rootState = _ref33.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FAVORITES_URL + favorite.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: favorite
      }).then(function (response) {
         commit('UPDATE_FAVORITE', response.data);
         return response.data;
      });
   },
   GET_NUTRIENTS: function GET_NUTRIENTS(_ref34) {
      var commit = _ref34.commit,
          rootState = _ref34.rootState;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].NUTRIENTS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('SET_NUTRIENTS', response.data);
         return response.data;
      });
   },
   GET_FOOD_NUTDATA: function GET_FOOD_NUTDATA(_ref35, foodId) {
      var commit = _ref35.commit,
          rootState = _ref35.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].NUTDATA_URL + '?food=' + foodId,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('SET_FOOD_NUTDATA', response.data);
         return response.data;
      });
   }
};

var getters = {

   // returns a function giving the meals of a user
   userMeals: function userMeals(state) {
      return function (userId) {
         return state.user2mealList.hasOwnProperty(userId) ? state.user2mealList[userId].map(function (mealId) {
            return state.meals[mealId];
         }) : [];
      };
   },

   // returns a function giving the mealElements of a meal
   mealElements: function mealElements(state) {
      return function (mealId) {
         return state.meal2mealElementList.hasOwnProperty(mealId) ? state.meal2mealElementList[mealId].map(function (mealElementId) {
            return state.mealElements[mealElementId];
         }) : [];
      };
   }
};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   state: state,
   mutations: mutations,
   actions: actions,
   getters: getters
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);




var axios = __webpack_require__(24);


function resetState(state) {
   __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, {
      qcuQuestions: {},
      qcuQuestionList: [],
      qcuImages: {},
      qcuQuestion2qcuImageList: {},
      qcuItems: {},
      qcuQuestion2qcuItemList: {}
   });
}

var state = {};
resetState(state);

var mutations = {
   RESET_STATE: function RESET_STATE(state) {
      //console.log('nutrikiosk/RESET_STATE')
      resetState(state);
   },
   SET_QCU_QUESTIONS: function SET_QCU_QUESTIONS(state, questions) {
      questions.forEach(function (question) {
         state.qcuQuestions[question.id] = question;
      });
      state.qcuQuestionList = questions.map(function (question) {
         return question.id;
      });
   },
   ADD_QCU_QUESTION: function ADD_QCU_QUESTION(state, question) {
      state.qcuQuestionList.push(question.id);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.qcuQuestions, question.id, question);
   },
   UPDATE_QCU_QUESTION: function UPDATE_QCU_QUESTION(state, question) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.qcuQuestions, question.id, question);
   },
   REMOVE_QCU_QUESTION: function REMOVE_QCU_QUESTION(state, questionId) {
      // remove it from state.qcuQuestionList
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.qcuQuestionList, state.qcuQuestionList.indexOf(questionId));
      // remove it from state.qcuQuestions
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.qcuQuestions, questionId);
   },
   SET_QCU_IMAGES: function SET_QCU_IMAGES(state, _ref) {
      var questionId = _ref.questionId,
          images = _ref.images;

      images.forEach(function (image) {
         state.qcuImages[image.id] = image;
      });
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.qcuQuestion2qcuImageList, questionId, images.map(function (image) {
         return image.id;
      }));
   },
   SET_QCU_ITEMS: function SET_QCU_ITEMS(state, _ref2) {
      var questionId = _ref2.questionId,
          items = _ref2.items;

      items.forEach(function (item) {
         state.qcuItems[item.id] = item;
      });
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.qcuQuestion2qcuItemList, questionId, items.map(function (item) {
         return item.id;
      }));
   }
};

var actions = {
   GET_QCU_QUESTIONS: function GET_QCU_QUESTIONS(_ref3) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;

      return axios({
         method: 'get',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].QCU_QUESTIONS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('SET_QCU_QUESTIONS', response.data);
         return response.data;
      });
   },
   POST_QCUQUESTION: function POST_QCUQUESTION(_ref4, question) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].QCU_QUESTIONS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: question
      }).then(function (response) {
         commit('ADD_QCU_QUESTION', response.data);
         return response.data;
      });
   },
   PUT_QCU_QUESTION: function PUT_QCU_QUESTION(_ref5, question) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].QCU_QUESTIONS_URL + question.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: question
      }).then(function (response) {
         commit('UPDATE_QCU_QUESTION', response.data);
         console.log('PUT_QCU_QUESTION response', response.data);
         return response.data;
      });
   },
   DELETE_QCU_QUESTION: function DELETE_QCU_QUESTION(_ref6, question) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].QCU_QUESTIONS_URL + question.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_QCU_QUESTION', question);
         return question;
      });
   },


   // fetch qcu images
   GET_QCU_IMAGES: function GET_QCU_IMAGES(_ref7, questionId) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].QCU_IMAGES_URL + '?question=' + questionId,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var qcuImagesDict = { questionId: questionId, images: response.data };
         commit('SET_QCU_IMAGES', qcuImagesDict);
         return qcuImagesDict;
      });
   },


   // fetch qcu items
   GET_QCU_ITEMS: function GET_QCU_ITEMS(_ref8, questionId) {
      var commit = _ref8.commit,
          rootState = _ref8.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].QCU_ITEMS_URL + '?question=' + questionId,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var qcuItemsDict = { questionId: questionId, items: response.data };
         commit('SET_QCU_ITEMS', qcuItemsDict);
         return qcuItemsDict;
      });
   }
};

var getters = {
   qcuQuestions: function qcuQuestions(state) {
      return state.qcuQuestionList.map(function (questionId) {
         return state.qcuQuestions[questionId];
      });
   }
};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   state: state,
   mutations: mutations,
   actions: actions,
   getters: getters
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);




var axios = __webpack_require__(24);


function resetState(state) {
   __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, {
      // persisted in model ShdlModule
      modules: {},
      user2moduleList: {},
      team2moduleList: {},

      // not persisted in database
      module2parseInfo: {}
   });
}

var state = {};
resetState(state);

var mutations = {
   RESET_STATE: function RESET_STATE(state) {
      //console.log('shdl/RESET_STATE')
      resetState(state);
   },


   // between userId and teamId, one is null and the other is not
   SET_SHDL_MODULES: function SET_SHDL_MODULES(state, _ref) {
      var userId = _ref.userId,
          teamId = _ref.teamId,
          modules = _ref.modules;

      modules.forEach(function (module) {
         state.modules[module.id] = module;
      });
      if (userId) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2moduleList, userId, modules.map(function (module) {
            return module.id;
         }));
      }
      if (teamId) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.team2moduleList, teamId, modules.map(function (module) {
            return module.id;
         }));
      }
   },
   ADD_SHDL_MODULE: function ADD_SHDL_MODULE(state, module) {
      // add module to state.modules
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.modules, module.id, module);
      if (module.user) {
         // add module to state.user2moduleList
         if (!state.user2moduleList.hasOwnProperty(module.user)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2moduleList, module.user, []);
         // simply push it: sorting is done in UI
         state.user2moduleList[module.user].push(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2moduleList, module.user, state.user2moduleList[module.user]);
      }
      if (module.team) {
         // add module to state.team2moduleList
         if (!state.team2moduleList.hasOwnProperty(module.team)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.team2moduleList, module.team, []);
         // simply push it: sorting is done in UI
         state.team2moduleList[module.team].push(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.team2moduleList, module.team, state.team2moduleList[module.team]);
      }
   },
   UPDATE_SHDL_MODULE: function UPDATE_SHDL_MODULE(state, module) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.modules, module.id, module);
   },
   REMOVE_SHDL_MODULE: function REMOVE_SHDL_MODULE(state, module) {
      if (module.user) {
         var index = state.user2moduleList[module.user].indexOf(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.user2moduleList[module.user], index);
      }
      if (module.team) {
         var _index = state.team2moduleList[module.team].indexOf(module.id);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.team2moduleList[module.team], _index);
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.modules, module.id);
   },


   // this mutation allows to store additionnal info on modules (parsing, checking etc.), which are not saved in database
   UPDATE_MODULE_PARSE_INFO: function UPDATE_MODULE_PARSE_INFO(state, _ref2) {
      var moduleId = _ref2.moduleId,
          structure = _ref2.structure,
          equipotentials = _ref2.equipotentials,
          isOk = _ref2.isOk;

      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.module2parseInfo, moduleId, {
         structure: structure,
         equipotentials: equipotentials,
         isOk: isOk
      });
   }
};

var actions = {

   // between userId and teamId, one is null and the other is not
   GET_SHDL_MODULES: function GET_SHDL_MODULES(_ref3, _ref4) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;
      var userId = _ref4.userId,
          teamId = _ref4.teamId;

      var queryParams = void 0;
      if (userId) {
         queryParams = 'user=' + userId;
      }
      if (teamId) {
         queryParams = 'team=' + teamId;
      }
      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].SHDL_MODULES_URL + '?' + queryParams,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var shdlModulesDict = { userId: userId, teamId: teamId, modules: response.data };
         commit('SET_SHDL_MODULES', shdlModulesDict);
         return response.data;
      });
   },
   POST_SHDL_MODULE: function POST_SHDL_MODULE(_ref5, module) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].SHDL_MODULES_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: module
      }).then(function (response) {
         commit('ADD_SHDL_MODULE', response.data);
         return response.data;
      });
   },
   PUT_SHDL_MODULE: function PUT_SHDL_MODULE(_ref6, module) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].SHDL_MODULES_URL + module.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: module
      }).then(function (response) {
         commit('UPDATE_SHDL_MODULE', response.data);
         return response.data;
      });
   },
   DELETE_SHDL_MODULE: function DELETE_SHDL_MODULE(_ref7, module) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].SHDL_MODULES_URL + module.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_SHDL_MODULE', module);
         return module;
      });
   }
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   state: state,
   mutations: mutations,
   actions: actions,
   getters: getters
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);




var axios = __webpack_require__(24);


function resetState(state) {
   __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, {
      surveys: {},
      surveyList: [],
      userSurveys: {},
      userSurveyAnswers: {},
      user2userSurveyList: {}
   });
}

var state = {};
resetState(state);

var mutations = {
   RESET_STATE: function RESET_STATE(state) {
      //console.log('surveys/RESET_STATE')
      resetState(state);
   },
   SET_SURVEYS: function SET_SURVEYS(state, surveys) {
      surveys.forEach(function (survey) {
         state.surveys[survey.id] = survey;
      });
      state.surveyList = surveys.map(function (survey) {
         return survey.id;
      });
   },
   SET_USER_SURVEYS: function SET_USER_SURVEYS(state, _ref) {
      var userId = _ref.userId,
          userSurveys = _ref.userSurveys;

      userSurveys.forEach(function (userSurvey) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.userSurveys, userSurvey.id, userSurvey);
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.userSurveyAnswers, userSurvey.id, userSurvey.answers.join(','));
      });
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2userSurveyList, userId, userSurveys.map(function (userSurvey) {
         return userSurvey.id;
      }));
   },
   ADD_USER_SURVEY: function ADD_USER_SURVEY(state, userSurvey) {
      // add userSurvey to state.userSurveys
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.userSurveys, userSurvey.id, userSurvey);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.userSurveyAnswers, userSurvey.id, userSurvey.answers.join(','));
      // add userSurvey to state.user2userSurveyList
      if (!state.user2userSurveyList.hasOwnProperty(userSurvey.user)) state.user2userSurveyList[userSurvey.user] = [];
      state.user2userSurveyList[userSurvey.user].push(userSurvey.id);
   },
   REMOVE_USER_SURVEY: function REMOVE_USER_SURVEY(state, userSurvey) {
      var index = state.user2userSurveyList[userSurvey.user].indexOf(userSurvey.id);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.user2userSurveyList[userSurvey.user], index);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.userSurveys, userSurvey.id);
   },
   SET_USER_SURVEY: function SET_USER_SURVEY(state, userSurvey) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.userSurveys, userSurvey.id, userSurvey);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.userSurveyAnswers, userSurvey.id, userSurvey.answers.join(','));
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.userSurveys[userSurvey.id], 'answers', userSurvey.answers);
   }
};

var actions = {
   GET_SURVEYS: function GET_SURVEYS(_ref2) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].SURVEYS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('SET_SURVEYS', response.data);
         return response.data;
      });
   },
   GET_USER_SURVEYS: function GET_USER_SURVEYS(_ref3, userId) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].USER_SURVEYS_URL + '?user=' + userId,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var userSurveysDict = { userId: userId, userSurveys: response.data };
         commit('SET_USER_SURVEYS', userSurveysDict);
         return response.data;
      });
   },
   POST_USER_SURVEY: function POST_USER_SURVEY(_ref4, _ref5) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState;
      var userId = _ref5.userId,
          surveyId = _ref5.surveyId;

      return axios({
         method: 'post',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].USER_SURVEYS_URL,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: { user: userId, survey: surveyId }
      }).then(function (response) {
         commit('ADD_USER_SURVEY', response.data);
         return response.data;
      });
   },
   DELETE_USER_SURVEY: function DELETE_USER_SURVEY(_ref6, userSurvey) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState;

      return axios({
         method: 'delete',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].USER_SURVEYS_URL + userSurvey.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         commit('REMOVE_USER_SURVEY', userSurvey);
         return userSurvey;
      });
   },
   PUT_USER_SURVEY: function PUT_USER_SURVEY(_ref7, userSurvey) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState;

      return axios({
         method: 'put',
         url: '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].USER_SURVEYS_URL + userSurvey.id + '/',
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token },
         data: userSurvey
      }).then(function (response) {
         commit('SET_USER_SURVEY', userSurvey);
         return userSurvey;
      });
   }
};

var getters = {

   // returns a function giving the surveys of a user
   userSurveys: function userSurveys(state) {
      return function (userId) {
         return state.user2userSurveyList.hasOwnProperty(userId) ? state.user2userSurveyList[userId].map(function (userSurveyId) {
            return state.userSurveys[userSurveyId];
         }) : [];
      };
   }
};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   state: state,
   mutations: mutations,
   actions: actions,
   getters: getters
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);




var axios = __webpack_require__(24);


function resetState(state) {
   __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, {
      teams: {},
      user2teamList: {}
   });
}

var state = {};
resetState(state);

var mutations = {
   RESET_STATE: function RESET_STATE(state) {
      //console.log('teams/RESET_STATE')
      resetState(state);
   },
   SET_USER_TEAMS: function SET_USER_TEAMS(state, _ref) {
      var userId = _ref.userId,
          teams = _ref.teams;

      if (!state.user2teamList.hasOwnProperty(userId)) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2teamList, userId, []);
      // add each team of teams to state.teams
      teams.forEach(function (team) {
         __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.teams, team.id, team);
      });
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.user2teamList, userId, teams.map(function (team) {
         return team.id;
      }));
   }
};

var actions = {
   GET_USER_TEAMS: function GET_USER_TEAMS(_ref2, userId) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState;

      return axios({
         method: 'get',
         url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].TEAMS_URL + '?user=' + userId,
         headers: { "Authorization": 'JWT ' + rootState.authenticationData.token }
      }).then(function (response) {
         var userTeamsDict = { userId: userId, teams: response.data };
         commit('SET_USER_TEAMS', userTeamsDict);
         return response.data;
      });
   }
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   state: state,
   mutations: mutations,
   actions: actions,
   getters: getters
});

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {


var parser = __webpack_require__(661);
var _ = __webpack_require__(13);
var binutils = __webpack_require__(93);

var op2bin = {
   add: '000000',
   addcc: '010000',
   sub: '000100',
   subcc: '010100',
   umulcc: '011010',
   and: '000001',
   andcc: '010001',
   or: '000010',
   orcc: '010010',
   xor: '000011',
   xorcc: '010011',
   slr: '001101',
   sll: '001110'
};

var cond2bin = {
   a: '1000',
   e: '0001',
   eq: '0001',
   z: '0001',
   ne: '1001',
   nz: '1001',
   neg: '0110',
   n: '0110',
   pos: '1110',
   nn: '1110',
   cs: '0101',
   cc: '1101',
   vs: '0111',
   vc: '1111',
   g: '1010',
   gt: '1010',
   ge: '1011',
   l: '0011',
   lt: '0011',
   le: '0010',
   gu: '1100',
   geu: '1101',
   lu: '0101',
   leu: '0100'
};

module.exports = function () {

   return {
      checkModule: checkModule
   };

   function checkModule(module, name2module) {

      // syntactic analysis by PegJS
      var lines = void 0;
      try {
         lines = parser.parse(module.text);
         console.log('lines', lines);
      } catch (err) {
         if (err.location) {
            errorMsg = 'Line ' + err.location.start.line + ', column ' + err.location.start.column + ': ';
         }
         errorMsg += err.message;
         return { errorMsg: errorMsg };
      }

      // first pass to get all labels and constants, check statements and compute addresses
      console.log('PASS1');
      var currentAddress = 0;
      var symbols = {};
      try {
         lines.forEach(function (line) {
            // console.log('line', line)
            // line starts with a label
            if (line.label) {
               var labelName = line.label;
               var labelEntry = symbols[labelName];
               // check if it is already defined and has a value
               if (labelEntry && labelEntry.value !== null) {
                  var message = '*** error line ' + line.lineno + ': symbol \'' + labelName + '\' already defined';
                  throw new Error(message);
               } else {
                  labelEntry = { type: 'label', value: currentAddress };
                  symbols[labelName] = labelEntry;
               }
            }
            // check each statement
            if (line.directive) {
               checkDirective(line.directive, line.lineno);
            } else if (line.instruction) {
               checkInstruction(line.instruction, line.lineno);
            } else if (line.synthetic) {
               checkSynthetic(line.synthetic, line.lineno);
            }
         });
         // now all symbols should have a value
         for (var labelName in symbols) {
            var labelEntry = symbols[labelName];
            if (labelEntry.value === null) {
               var message = '*** error: symbol \'' + labelName + '\' is referenced but not defined';
               throw new Error(message);
            }
         }
      } catch (err) {
         return { errorMsg: err.message };
      }

      // second pass to compute all memory values
      console.log('PASS2');
      var memory = {};
      currentAddress = 0;
      try {
         lines.forEach(function (line) {
            // console.log('linex', line)
            // handle each type of lines
            if (line.directive) {
               assembleDirective(line);
            } else if (line.instruction) {
               assembleInstruction(line);
            } else if (line.synthetic) {
               assembleSynthetic(line);
            }
         });
      } catch (err) {
         return { errorMsg: err.message };
      }

      return { errorMsg: null, lines: lines, symbols: symbols, memory: memory };

      function checkDirective(directive, lineno) {
         if (directive.code === 'org') {
            // change current address
            currentAddress = numExprValue(directive.address, symbols);
         } else if (directive.code === 'word') {
            currentAddress += directive.values.length;
         } else if (directive.code === 'equ') {
            // add a new entry into symbols table
            var constantEntry = symbols[directive.label];
            if (constantEntry && constantEntry.value !== null) {
               var _message = '*** error line ' + lineno + ': symbol \'' + directive.label + '\' already defined';
               throw new Error(_message);
            }
            constantEntry = { type: 'constant', value: directive.value };
            symbols[directive.label] = constantEntry;
         }
      }

      function assembleDirective(line) {
         var directive = line.directive;
         var lineno = line.lineno;
         if (directive.code === 'org') {
            // change current address
            currentAddress = numExprValue(directive.address, symbols);
         } else if (directive.code === 'word') {
            // add values in memory
            directive.values.forEach(function (numexpr, index) {
               if (memory[currentAddress]) {
                  var _message2 = '*** error line ' + lineno + ': memory is multiply assigned at address ' + currentAddress;
                  throw new Error(_message2);
               }
               var binaryString = void 0;
               var value = numExprValue(numexpr, symbols);
               if (value < 0) {
                  binaryString = (value >>> 0).toString(2);
               } else {
                  binaryString = _.padStart(parseInt(value, 10).toString(2), 32, '0');
               }
               var label = index === 0 ? line.label : '';
               var memoryEntry = { text: line.text, label: label, value: binaryString };
               memory[currentAddress] = memoryEntry;
               currentAddress += 1;
            });
         } else if (directive.code === 'equ') {
            // already done at pass1
         }
      }

      function checkInstruction(instruction, lineno) {
         // check limits
         if (instruction.rs1) {
            if (instruction.rs1 < 0 || instruction.rs1 > 31) {
               var _message3 = '*** error line ' + lineno + ': register index of \'%r' + instruction.rs1 + '\' must be in [0..31]';
               throw new Error(_message3);
            }
         }
         if (instruction.rs2) {
            if (instruction.rs2 < 0 || instruction.rs2 > 31) {
               var _message4 = '*** error line ' + lineno + ': register index of \'%r' + instruction.rs2 + '\' must be in [0..31]';
               throw new Error(_message4);
            }
         }
         if (instruction.rd) {
            if (instruction.rd < 0 || instruction.rd > 31) {
               var _message5 = '*** error line ' + lineno + ': register index of \'%r' + instruction.rd + '\' must be in [0..31]';
               throw new Error(_message5);
            }
         }
         if (instruction.type === 'instructionBcc') {
            var targetEntry = symbols[instruction.label];
            if (!targetEntry) {
               symbols[instruction.label] = { type: 'label', value: null };
            }
         }
         // increment current address
         currentAddress += 1;
      }

      function assembleInstruction(line) {
         var instruction = line.instruction;
         if (instruction.simm13) {
            // replace instruction.simm13 by its evaluation, so that the simulator won't have to compute it
            try {
               instruction.simm13 = numExprValue(instruction.simm13, symbols);
            } catch (error) {
               var _message6 = '*** error line ' + lineno + ': ' + error.message;
               throw new Error(_message6);
            }
            if (instruction.simm13 < -4096 || instruction.simm13 > 4095) {
               var _message7 = '*** error line ' + lineno + ': 13-bit immediate value \'' + instruction.simm13 + '\' must be in [-4096..4095]';
               throw new Error(_message7);
            }
         }
         if (instruction.imm24) {
            try {
               // replace instruction.imm24 by its evaluation, so that the simulator won't have to compute it
               instruction.imm24 = numExprValue(instruction.imm24, symbols);
            } catch (error) {
               var _message8 = '*** error line ' + lineno + ': ' + error.message;
               throw new Error(_message8);
            }
            if (instruction.imm24 < 0 || instruction.imm24 > 16777216) {
               var _message9 = '*** error line ' + lineno + ': 24-bit value \'' + instruction.imm24 + '\' must be in [0..16777216]';
               throw new Error(_message9);
            }
         }

         var memoryEntry = void 0;
         var label = line.label ? line.label : '';
         if (instruction.type === 'instructionArithLog1a') {
            var rs1 = _.padStart(parseInt(instruction.rs1, 10).toString(2), 5, '0');
            var rs2 = _.padStart(parseInt(instruction.rs2, 10).toString(2), 5, '0');
            var rd = _.padStart(parseInt(instruction.rd, 10).toString(2), 5, '0');
            var op = op2bin[instruction.codeop];
            var code = '10' + rd + op + rs1 + '000000000' + rs2;
            memoryEntry = { label: label, value: code, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionArithLog1b') {
            var _rs = _.padStart(parseInt(instruction.rs1, 10).toString(2), 5, '0');
            var simm13 = void 0;
            if (instruction.simm13 < 0) {
               simm13 = (instruction.simm13 >>> 0).toString(2).substring(19);
            } else {
               simm13 = _.padStart(parseInt(instruction.simm13, 10).toString(2), 13, '0');
            }
            var _rd = _.padStart(parseInt(instruction.rd, 10).toString(2), 5, '0');
            var _op = op2bin[instruction.codeop];
            var _code = '10' + _rd + _op + _rs + '1' + simm13;
            memoryEntry = { label: label, value: _code, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionLoad1a') {
            var _rs2 = _.padStart(parseInt(instruction.rs1, 10).toString(2), 5, '0');
            var _rs3 = _.padStart(parseInt(instruction.rs2, 10).toString(2), 5, '0');
            var _rd2 = _.padStart(parseInt(instruction.rd, 10).toString(2), 5, '0');
            var _code2 = '11' + _rd2 + '000000' + _rs2 + '000000000' + _rs3;
            memoryEntry = { label: label, value: _code2, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionLoad1b') {
            var _rs4 = _.padStart(parseInt(instruction.rs1, 10).toString(2), 5, '0');
            var _simm = void 0;
            if (instruction.plusMinus === '-') {
               _simm = (-instruction.simm13 >>> 0).toString(2).substring(19);
            } else {
               _simm = _.padStart(parseInt(instruction.simm13, 10).toString(2), 13, '0');
            }
            var _rd3 = _.padStart(parseInt(instruction.rd, 10).toString(2), 5, '0');
            var _op2 = op2bin[instruction.codeop];
            var _code3 = '11' + _rd3 + '000000' + _rs4 + '1' + _simm;
            memoryEntry = { label: label, value: _code3, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionStore1a') {
            var _rs5 = _.padStart(parseInt(instruction.rs1, 10).toString(2), 5, '0');
            var _rs6 = _.padStart(parseInt(instruction.rs2, 10).toString(2), 5, '0');
            var _rd4 = _.padStart(parseInt(instruction.rd, 10).toString(2), 5, '0');
            var _code4 = '11' + _rd4 + '000100' + _rs5 + '000000000' + _rs6;
            memoryEntry = { label: label, value: _code4, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionStore1b') {
            var _rs7 = _.padStart(parseInt(instruction.rs1, 10).toString(2), 5, '0');
            var _simm2 = void 0;
            if (instruction.plusMinus === '-') {
               _simm2 = (-instruction.simm13 >>> 0).toString(2).substring(19);
            } else {
               _simm2 = _.padStart(parseInt(instruction.simm13, 10).toString(2), 13, '0');
            }
            var _rd5 = _.padStart(parseInt(instruction.rd, 10).toString(2), 5, '0');
            var _op3 = op2bin[instruction.codeop];
            var _code5 = '11' + _rd5 + '000100' + _rs7 + '1' + _simm2;
            memoryEntry = { label: label, value: _code5, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionBcc') {
            var target = symbols[instruction.label];
            var disp = target.value - currentAddress;
            instruction.disp = disp;
            var disp25 = void 0;
            if (disp < 0) {
               disp25 = (disp >>> 0).toString(2).substring(7);
            } else {
               disp25 = _.padStart(parseInt(disp, 10).toString(2), 25, '0');
            }
            var cond = cond2bin[instruction.cond];
            var _code6 = '001' + cond + disp25;
            memoryEntry = { label: label, value: _code6, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionSethi') {
            var _rd6 = _.padStart(parseInt(instruction.rd, 10).toString(2), 5, '0');
            var imm24Value = _.padStart(parseInt(instruction.imm24, 10).toString(2), 24, '0');
            var _code7 = '000' + _rd6 + imm24Value;
            memoryEntry = { label: label, value: _code7, instruction: instruction, synthetic: null };
         } else if (instruction.type === 'instructionReti') {
            var _code8 = '01000000000000000000000000000000';
            memoryEntry = { label: label, value: _code8, instruction: instruction, synthetic: null };
         }
         // copy instruction code in memory
         memory[currentAddress] = memoryEntry;
         // increment current address
         currentAddress += 1;
      }

      function checkSynthetic(synthetic, lineno) {
         if (synthetic.rs < 0 || synthetic.rs > 31) {
            var _message10 = '*** error line ' + lineno + ': register index of \'%r' + synthetic.rs + '\' must be in [0..31]';
            throw new Error(_message10);
         }
         if (synthetic.rd < 0 || synthetic.rd > 31) {
            var _message11 = '*** error line ' + lineno + ': register index of \'%r' + synthetic.rd + '\' must be in [0..31]';
            throw new Error(_message11);
         }
         if (synthetic.type === 'clr') {
            currentAddress += 1;
         } else if (synthetic.type === 'mov') {
            currentAddress += 1;
         } else if (synthetic.type === 'inc' || synthetic.type === 'inccc' || synthetic.type === 'dec' || synthetic.type === 'deccc') {
            currentAddress += 1;
         } else if (synthetic.type === 'setq') {
            currentAddress += 1;
         } else if (synthetic.type === 'set') {
            currentAddress += 2;
         } else if (synthetic.type === 'cmp') {
            currentAddress += 1;
         } else if (synthetic.type === 'tst') {
            currentAddress += 1;
         } else if (synthetic.type === 'negcc') {
            currentAddress += 1;
         } else if (synthetic.type === 'nop') {
            currentAddress += 1;
         } else if (synthetic.type === 'call') {
            var targetEntry = symbols[synthetic.label];
            if (!targetEntry) {
               symbols[synthetic.label] = { type: 'label', value: null };
            }
            currentAddress += 2;
         } else if (synthetic.type === 'rcall') {
            var _targetEntry = symbols[synthetic.label];
            if (!_targetEntry) {
               symbols[synthetic.label] = { type: 'label', value: null };
            }
            currentAddress += 6;
         } else if (synthetic.type === 'ret') {
            currentAddress += 1;
         } else if (synthetic.type === 'push') {
            currentAddress += 2;
         } else if (synthetic.type === 'pop') {
            currentAddress += 2;
         }
      }

      function assembleSynthetic(line) {
         var synthetic = line.synthetic;
         if (synthetic.simm13) {
            // replace synthetic.simm13 by its evaluation, so that the simulator won't have to compute it
            try {
               synthetic.simm13 = numExprValue(synthetic.simm13, symbols);
            } catch (error) {
               var _message12 = '*** error line ' + line.lineno + ': ' + error.message;
               throw new Error(_message12);
            }
            if (synthetic.simm13 < -4096 || synthetic.simm13 > 4095) {
               var _message13 = '*** error line ' + line.lineno + ': 13-bit immediate value \'' + synthetic.simm13 + '\' must be in [-4096..4095]';
               throw new Error(_message13);
            }
         }
         if (synthetic.simm32) {
            // replace synthetic.simm32 by its evaluation, so that the simulator won't have to compute it
            try {
               synthetic.simm32 = numExprValue(synthetic.simm32, symbols);
            } catch (error) {
               var _message14 = '*** error line ' + line.lineno + ': ' + error.message;
               throw new Error(_message14);
            }
            if (synthetic.simm32 < -2147483648 || synthetic.simm32 > 4294967295) {
               var _message15 = '*** error line ' + line.lineno + ': immediate value ' + synthetic.simm32 + ' must be in [-2147483648..4294967295]';
               throw new Error(_message15);
            }
         }

         var memoryEntry = void 0;
         var label = line.label ? line.label : '';
         if (synthetic.type === 'clr') {
            var rd = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var code = '10' + rd + '0100100000000000000000000';
            memoryEntry = { label: null, value: code, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'mov') {
            var rs = _.padStart(parseInt(synthetic.rs, 10).toString(2), 5, '0');
            var _rd7 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var _code9 = '10' + _rd7 + '010010' + rs + '00000000000000';
            memoryEntry = { label: label, value: _code9, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'inc') {
            var _rd8 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var _code10 = '10' + _rd8 + '0000000000010000000000001';
            memoryEntry = { label: label, value: _code10, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'inccc') {
            var _rd9 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var _code11 = '10' + _rd9 + '0100000000010000000000001';
            memoryEntry = { label: label, value: _code11, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'dec') {
            var _rd10 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var _code12 = '10' + _rd10 + '0001000000010000000000001';
            memoryEntry = { label: label, value: _code12, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'deccc') {
            var _rd11 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var _code13 = '10' + _rd11 + '0101000000010000000000001';
            memoryEntry = { label: label, value: _code13, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'setq') {
            var _rd12 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var simm13Value = binutils.signedToBin13(synthetic.simm13);
            var _code14 = '10' + _rd12 + '010010' + _rd12 + '1' + simm13Value;
            memoryEntry = { label: label, value: _code14, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'set') {
            var _rd13 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var imm32Value = binutils.unsignedToBin32(synthetic.simm32);
            var code1 = '000' + _rd13 + imm32Value.substring(0, 24);
            memoryEntry = { label: label, value: code1, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
            var code2 = '10' + _rd13 + '010010' + _rd13 + '100000' + imm32Value.substring(24);
            memoryEntry = { label: null, value: code2, instruction: null, synthetic: null };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'cmp') {
            var _rs8 = _.padStart(parseInt(synthetic.rs, 10).toString(2), 5, '0');
            var _code15 = void 0;
            if (synthetic.rd) {
               var _rd14 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
               _code15 = '1000000010100' + _rs8 + '000000000' + _rd14;
            } else {
               var _simm13Value = binutils.signedToBin13(synthetic.simm13);
               _code15 = '1000000010100' + _rs8 + '1' + _simm13Value;
            }
            memoryEntry = { label: label, value: _code15, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'tst') {
            var _rs9 = _.padStart(parseInt(synthetic.rs, 10).toString(2), 5, '0');
            var _code16 = '1000000010100' + _rs9 + '00000000000000';
            memoryEntry = { label: label, value: _code16, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'negcc') {
            var _rd15 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var _code17 = '10' + _rd15 + '01010000000000000000' + _rd15;
            memoryEntry = { label: label, value: _code17, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'nop') {
            var _code18 = '00000000000000000000000000000000';
            memoryEntry = { label: label, value: _code18, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'call') {
            var target = symbols[synthetic.label];
            var disp = target.value - currentAddress - 1;
            synthetic.disp = disp;
            var disp25 = void 0;
            if (disp < 0) {
               disp25 = (disp >>> 0).toString(2).substring(7);
            } else {
               disp25 = _.padStart(parseInt(disp, 10).toString(2), 25, '0');
            }
            var _code19 = '10111000000100000000000000011110';
            memoryEntry = { label: label, value: _code19, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
            var _code20 = '0101000' + disp25;
            memoryEntry = { label: null, value: _code20, instruction: null, synthetic: null };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'rcall') {
            var _target = symbols[synthetic.label];
            var _disp = _target.value - currentAddress - 1;
            synthetic.disp = _disp;
            var _disp2 = void 0;
            if (_disp < 0) {
               _disp2 = (_disp >>> 0).toString(2).substring(7);
            } else {
               _disp2 = _.padStart(parseInt(_disp, 10).toString(2), 25, '0');
            }
            var _code21 = '10111010001001110110000000000001';
            memoryEntry = { label: label, value: _code21, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
            var _code22 = '11111000001001110100000000000000';
            memoryEntry = { label: null, value: _code22, instruction: null, synthetic: null };
            memory[currentAddress++] = memoryEntry;
            var code3 = '10111000000100000000000000011110';
            memoryEntry = { label: null, value: code3, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
            var code4 = '0101000' + _disp2;
            memoryEntry = { label: null, value: code4, instruction: null, synthetic: null };
            memory[currentAddress++] = memoryEntry;
            var code5 = '11111000000001110100000000000000';
            memoryEntry = { label: null, value: code5, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
            var code6 = '10111010000001110110000000000001';
            memoryEntry = { label: null, value: code6, instruction: null, synthetic: null };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'ret') {
            var _code23 = '10111100000001110010000000000001';
            memoryEntry = { label: label, value: _code23, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'push') {
            var _rs10 = _.padStart(parseInt(synthetic.rs, 10).toString(2), 5, '0');
            var _code24 = '10111010001001110110000000000001';
            memoryEntry = { label: label, value: _code24, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
            var _code25 = '11' + _rs10 + '0001001110100000000000000';
            memoryEntry = { label: null, value: _code25, instruction: null, synthetic: null };
            memory[currentAddress++] = memoryEntry;
         } else if (synthetic.type === 'pop') {
            var _rd16 = _.padStart(parseInt(synthetic.rd, 10).toString(2), 5, '0');
            var _code26 = '11' + _rd16 + '0000001110100000000000000';
            memoryEntry = { label: label, value: _code26, instruction: null, synthetic: synthetic };
            memory[currentAddress++] = memoryEntry;
            var _code27 = '10111010000001110110000000000001';
            memoryEntry = { label: null, value: _code27, instruction: null, synthetic: null };
            memory[currentAddress++] = memoryEntry;
         }
      }

      function numExprSymbols(numexpr) {
         if (typeof numexpr === 'number') {
            return [];
         } else if (typeof numexpr === 'string') {
            return [numexpr];
         } else {
            return numExprSymbols(numexpr.arg1).concat(numExprSymbols(numexpr.arg2));
         }
      }

      function numExprValue(numexpr, symbols) {
         if (typeof numexpr === 'number') {
            return numexpr;
         } else if (typeof numexpr === 'string') {
            var symbolEntry = symbols[numexpr];
            if (symbolEntry) {
               return symbolEntry.value;
            } else {
               throw new Error('symbol ' + numexpr + ' is undefined');
            }
         } else if (numexpr.op === '+') {
            return numExprValue(numexpr.arg1, symbols) + numExprValue(numexpr.arg2, symbols);
         } else if (numexpr.op === '-') {
            return numExprValue(numexpr.arg1, symbols) - numExprValue(numexpr.arg2, symbols);
         } else if (numexpr.op === '*') {
            return numExprValue(numexpr.arg1, symbols) * numExprValue(numexpr.arg2, symbols);
         } else if (numexpr.op === '/') {
            return numExprValue(numexpr.arg1, symbols) / numExprValue(numexpr.arg2, symbols);
         }
      }
   }
}();

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = /*
                 * Generated by PEG.js 0.10.0.
                 *
                 * http://pegjs.org/
                 */
function () {
  "use strict";

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
      literal: function literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },

      "class": function _class(expectation) {
        var escapedParts = "",
            i;

        for (i = 0; i < expectation.parts.length; i++) {
          escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
        }

        return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
      },

      any: function any(expectation) {
        return "any character";
      },

      end: function end(expectation) {
        return "end of input";
      },

      other: function other(expectation) {
        return expectation.description;
      }
    };

    function hex(ch) {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function classEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      var descriptions = new Array(expected.length),
          i,
          j;

      for (i = 0; i < expected.length; i++) {
        descriptions[i] = describeExpectation(expected[i]);
      }

      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  };

  function peg$parse(input, options) {
    options = options !== void 0 ? options : {};

    var peg$FAILED = {},
        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction = peg$parsestart,
        peg$c0 = function peg$c0(line, tail) {
      return [line].concat(tail);
    },
        peg$c1 = function peg$c1(line) {
      return [line];
    },
        peg$c2 = function peg$c2() {
      return [];
    },
        peg$c3 = function peg$c3(directive) {
      return { lineno: location().start.line, label: null, directive: directive, instruction: null, synthetic: null };
    },
        peg$c4 = ":",
        peg$c5 = peg$literalExpectation(":", false),
        peg$c6 = function peg$c6(label, directive) {
      return { lineno: location().start.line, label: label, directive: directive, instruction: null, synthetic: null };
    },
        peg$c7 = function peg$c7(label, instruction) {
      return { lineno: location().start.line, label: label, directive: null, instruction: instruction, synthetic: null };
    },
        peg$c8 = function peg$c8(instruction) {
      return { lineno: location().start.line, label: null, directive: null, instruction: instruction, synthetic: null };
    },
        peg$c9 = function peg$c9(label, synthetic) {
      return { lineno: location().start.line, label: label, directive: null, instruction: null, synthetic: synthetic };
    },
        peg$c10 = function peg$c10(synthetic) {
      return { lineno: location().start.line, label: null, directive: null, instruction: null, synthetic: synthetic };
    },
        peg$c11 = function peg$c11(label) {
      return { lineno: location().start.line, label: label, directive: null, instruction: null, synthetic: null };
    },
        peg$c12 = ".org",
        peg$c13 = peg$literalExpectation(".org", false),
        peg$c14 = function peg$c14(address) {
      return { type: 'directive', code: 'org', address: address };
    },
        peg$c15 = ".word",
        peg$c16 = peg$literalExpectation(".word", false),
        peg$c17 = ",",
        peg$c18 = peg$literalExpectation(",", false),
        peg$c19 = function peg$c19(head, tail) {
      return { type: 'directive', code: 'word',
        values: [head].concat(tail.map(function (elt) {
          return elt[3];
        })) };
    },
        peg$c20 = "=",
        peg$c21 = peg$literalExpectation("=", false),
        peg$c22 = function peg$c22(label, value) {
      return { type: 'directive', code: 'equ', label: label, value: value };
    },
        peg$c23 = function peg$c23(instructionArithLog1a) {
      return instructionArithLog1a;
    },
        peg$c24 = function peg$c24(instructionArithLog1b) {
      return instructionArithLog1b;
    },
        peg$c25 = function peg$c25(instructionLoad1a) {
      return instructionLoad1a;
    },
        peg$c26 = function peg$c26(instructionLoad1b) {
      return instructionLoad1b;
    },
        peg$c27 = function peg$c27(instructionStore1a) {
      return instructionStore1a;
    },
        peg$c28 = function peg$c28(instructionStore1b) {
      return instructionStore1b;
    },
        peg$c29 = function peg$c29(instructionSethi) {
      return instructionSethi;
    },
        peg$c30 = function peg$c30(instructionBcc) {
      return instructionBcc;
    },
        peg$c31 = "reti",
        peg$c32 = peg$literalExpectation("reti", false),
        peg$c33 = function peg$c33() {
      return { type: 'instructionReti', text: text() };
    },
        peg$c34 = function peg$c34(codeop, rs1, rs2, rd) {
      return { type: 'instructionArithLog1a', codeop: codeop, rs1: rs1, rs2: rs2, rd: rd, text: text() };
    },
        peg$c35 = function peg$c35(codeop, rs1, simm13, rd) {
      return { type: 'instructionArithLog1b', codeop: codeop, rs1: rs1, simm13: simm13, rd: rd, text: text() };
    },
        peg$c36 = "addcc",
        peg$c37 = peg$literalExpectation("addcc", false),
        peg$c38 = "add",
        peg$c39 = peg$literalExpectation("add", false),
        peg$c40 = "subcc",
        peg$c41 = peg$literalExpectation("subcc", false),
        peg$c42 = "sub",
        peg$c43 = peg$literalExpectation("sub", false),
        peg$c44 = "andcc",
        peg$c45 = peg$literalExpectation("andcc", false),
        peg$c46 = "and",
        peg$c47 = peg$literalExpectation("and", false),
        peg$c48 = "orcc",
        peg$c49 = peg$literalExpectation("orcc", false),
        peg$c50 = "or",
        peg$c51 = peg$literalExpectation("or", false),
        peg$c52 = "xorcc",
        peg$c53 = peg$literalExpectation("xorcc", false),
        peg$c54 = "xor",
        peg$c55 = peg$literalExpectation("xor", false),
        peg$c56 = "umulcc",
        peg$c57 = peg$literalExpectation("umulcc", false),
        peg$c58 = "slr",
        peg$c59 = peg$literalExpectation("slr", false),
        peg$c60 = "sll",
        peg$c61 = peg$literalExpectation("sll", false),
        peg$c62 = function peg$c62(codeop) {
      return codeop;
    },
        peg$c63 = "ld",
        peg$c64 = peg$literalExpectation("ld", false),
        peg$c65 = "[",
        peg$c66 = peg$literalExpectation("[", false),
        peg$c67 = "+",
        peg$c68 = peg$literalExpectation("+", false),
        peg$c69 = "]",
        peg$c70 = peg$literalExpectation("]", false),
        peg$c71 = function peg$c71(rs1, rs2, rd) {
      return { type: 'instructionLoad1a', rs1: rs1, rs2: rs2, rd: rd, text: text() };
    },
        peg$c72 = function peg$c72(rs1, rd) {
      return { type: 'instructionLoad1a', rs1: rs1, rs2: 0, rd: rd, text: text() };
    },
        peg$c73 = "-",
        peg$c74 = peg$literalExpectation("-", false),
        peg$c75 = function peg$c75(rs1, plusMinus, simm13, rd) {
      return { type: 'instructionLoad1b', rs1: rs1, plusMinus: plusMinus, simm13: simm13, rd: rd, text: text() };
    },
        peg$c76 = "st",
        peg$c77 = peg$literalExpectation("st", false),
        peg$c78 = function peg$c78(rd, rs1, rs2) {
      return { type: 'instructionStore1a', rs1: rs1, rs2: rs2, rd: rd, text: text() };
    },
        peg$c79 = function peg$c79(rd, rs1) {
      return { type: 'instructionStore1a', rs1: rs1, rs2: 0, rd: rd, text: text() };
    },
        peg$c80 = function peg$c80(rd, rs1, plusMinus, simm13) {
      return { type: 'instructionStore1b', rs1: rs1, plusMinus: plusMinus, simm13: simm13, rd: rd, text: text() };
    },
        peg$c81 = "sethi",
        peg$c82 = peg$literalExpectation("sethi", false),
        peg$c83 = function peg$c83(imm24, rd) {
      return { type: 'instructionSethi', imm24: imm24, rd: rd, text: text() };
    },
        peg$c84 = "b",
        peg$c85 = peg$literalExpectation("b", false),
        peg$c86 = function peg$c86(cond, label) {
      return { type: 'instructionBcc', cond: cond, label: label, text: text() };
    },
        peg$c87 = "leu",
        peg$c88 = peg$literalExpectation("leu", false),
        peg$c89 = "le",
        peg$c90 = peg$literalExpectation("le", false),
        peg$c91 = "lu",
        peg$c92 = peg$literalExpectation("lu", false),
        peg$c93 = "lt",
        peg$c94 = peg$literalExpectation("lt", false),
        peg$c95 = "l",
        peg$c96 = peg$literalExpectation("l", false),
        peg$c97 = "neg",
        peg$c98 = peg$literalExpectation("neg", false),
        peg$c99 = "ne",
        peg$c100 = peg$literalExpectation("ne", false),
        peg$c101 = "nz",
        peg$c102 = peg$literalExpectation("nz", false),
        peg$c103 = "nn",
        peg$c104 = peg$literalExpectation("nn", false),
        peg$c105 = "n",
        peg$c106 = peg$literalExpectation("n", false),
        peg$c107 = "geu",
        peg$c108 = peg$literalExpectation("geu", false),
        peg$c109 = "ge",
        peg$c110 = peg$literalExpectation("ge", false),
        peg$c111 = "gt",
        peg$c112 = peg$literalExpectation("gt", false),
        peg$c113 = "gu",
        peg$c114 = peg$literalExpectation("gu", false),
        peg$c115 = "g",
        peg$c116 = peg$literalExpectation("g", false),
        peg$c117 = "a",
        peg$c118 = peg$literalExpectation("a", false),
        peg$c119 = "z",
        peg$c120 = peg$literalExpectation("z", false),
        peg$c121 = "pos",
        peg$c122 = peg$literalExpectation("pos", false),
        peg$c123 = "cs",
        peg$c124 = peg$literalExpectation("cs", false),
        peg$c125 = "cc",
        peg$c126 = peg$literalExpectation("cc", false),
        peg$c127 = "vs",
        peg$c128 = peg$literalExpectation("vs", false),
        peg$c129 = "vc",
        peg$c130 = peg$literalExpectation("vc", false),
        peg$c131 = "eq",
        peg$c132 = peg$literalExpectation("eq", false),
        peg$c133 = "e",
        peg$c134 = peg$literalExpectation("e", false),
        peg$c135 = function peg$c135(cond) {
      return cond;
    },
        peg$c136 = "clr",
        peg$c137 = peg$literalExpectation("clr", false),
        peg$c138 = function peg$c138(rd) {
      return { type: 'clr', rd: rd, text: text() };
    },
        peg$c139 = "mov",
        peg$c140 = peg$literalExpectation("mov", false),
        peg$c141 = function peg$c141(rs, rd) {
      return { type: 'mov', rs: rs, rd: rd, text: text() };
    },
        peg$c142 = "inccc",
        peg$c143 = peg$literalExpectation("inccc", false),
        peg$c144 = function peg$c144(rd) {
      return { type: 'inccc', rd: rd, text: text() };
    },
        peg$c145 = "inc",
        peg$c146 = peg$literalExpectation("inc", false),
        peg$c147 = function peg$c147(rd) {
      return { type: 'inc', rd: rd, text: text() };
    },
        peg$c148 = "deccc",
        peg$c149 = peg$literalExpectation("deccc", false),
        peg$c150 = function peg$c150(rd) {
      return { type: 'deccc', rd: rd, text: text() };
    },
        peg$c151 = "dec",
        peg$c152 = peg$literalExpectation("dec", false),
        peg$c153 = function peg$c153(rd) {
      return { type: 'dec', rd: rd, text: text() };
    },
        peg$c154 = "setq",
        peg$c155 = peg$literalExpectation("setq", false),
        peg$c156 = function peg$c156(simm13, rd) {
      return { type: 'setq', simm13: simm13, rd: rd, text: text() };
    },
        peg$c157 = "set",
        peg$c158 = peg$literalExpectation("set", false),
        peg$c159 = function peg$c159(simm32, rd) {
      return { type: 'set', simm32: simm32, rd: rd, text: text() };
    },
        peg$c160 = "cmp",
        peg$c161 = peg$literalExpectation("cmp", false),
        peg$c162 = function peg$c162(rs, rd) {
      return { type: 'cmp', rs: rs, rd: rd, text: text() };
    },
        peg$c163 = function peg$c163(rs, simm13) {
      return { type: 'cmp', rs: rs, simm13: simm13, text: text() };
    },
        peg$c164 = "tst",
        peg$c165 = peg$literalExpectation("tst", false),
        peg$c166 = function peg$c166(rs) {
      return { type: 'tst', rs: rs, text: text() };
    },
        peg$c167 = "negcc",
        peg$c168 = peg$literalExpectation("negcc", false),
        peg$c169 = function peg$c169(rd) {
      return { type: 'negcc', rd: rd, text: text() };
    },
        peg$c170 = "nop",
        peg$c171 = peg$literalExpectation("nop", false),
        peg$c172 = function peg$c172() {
      return { type: 'nop', text: text() };
    },
        peg$c173 = "call",
        peg$c174 = peg$literalExpectation("call", false),
        peg$c175 = function peg$c175(label) {
      return { type: 'call', label: label, text: text() };
    },
        peg$c176 = "ret",
        peg$c177 = peg$literalExpectation("ret", false),
        peg$c178 = function peg$c178() {
      return { type: 'ret', text: text() };
    },
        peg$c179 = "push",
        peg$c180 = peg$literalExpectation("push", false),
        peg$c181 = function peg$c181(rs) {
      return { type: 'push', rs: rs, text: text() };
    },
        peg$c182 = "pop",
        peg$c183 = peg$literalExpectation("pop", false),
        peg$c184 = function peg$c184(rd) {
      return { type: 'pop', rd: rd, text: text() };
    },
        peg$c185 = "%r",
        peg$c186 = peg$literalExpectation("%r", false),
        peg$c187 = function peg$c187(regnum) {
      return regnum;
    },
        peg$c188 = "%fp",
        peg$c189 = peg$literalExpectation("%fp", false),
        peg$c190 = function peg$c190() {
      return 27;
    },
        peg$c191 = "%sp",
        peg$c192 = peg$literalExpectation("%sp", false),
        peg$c193 = function peg$c193() {
      return 29;
    },
        peg$c194 = "%pc",
        peg$c195 = peg$literalExpectation("%pc", false),
        peg$c196 = function peg$c196() {
      return 30;
    },
        peg$c197 = "%ir",
        peg$c198 = peg$literalExpectation("%ir", false),
        peg$c199 = function peg$c199() {
      return 31;
    },
        peg$c200 = function peg$c200(head, tail) {
      return tail.reduce(function (result, element) {
        return { 'op': element[1], arg1: result, arg2: element[3] };
      }, head);
    },
        peg$c201 = "*",
        peg$c202 = peg$literalExpectation("*", false),
        peg$c203 = "/",
        peg$c204 = peg$literalExpectation("/", false),
        peg$c205 = "(",
        peg$c206 = peg$literalExpectation("(", false),
        peg$c207 = ")",
        peg$c208 = peg$literalExpectation(")", false),
        peg$c209 = function peg$c209(expr) {
      return expr;
    },
        peg$c210 = function peg$c210(val) {
      return val;
    },
        peg$c211 = function peg$c211(val) {
      return -val;
    },
        peg$c212 = "0b",
        peg$c213 = peg$literalExpectation("0b", false),
        peg$c214 = /^[0-1]/,
        peg$c215 = peg$classExpectation([["0", "1"]], false, false),
        peg$c216 = function peg$c216() {
      return parseInt(text().substring(2), 2);
    },
        peg$c217 = "0x",
        peg$c218 = peg$literalExpectation("0x", false),
        peg$c219 = /^[0-9a-fA-F]/,
        peg$c220 = peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"]], false, false),
        peg$c221 = function peg$c221() {
      return parseInt(text().substring(2), 16);
    },
        peg$c222 = /^[0-9]/,
        peg$c223 = peg$classExpectation([["0", "9"]], false, false),
        peg$c224 = function peg$c224() {
      return parseInt(text(), 10);
    },
        peg$c225 = /^[a-zA-Z0-9_]/,
        peg$c226 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false),
        peg$c227 = function peg$c227(chars) {
      return chars.join("");
    },
        peg$c228 = function peg$c228() {
      return [];
    },
        peg$c229 = peg$otherExpectation("whitespace"),
        peg$c230 = /^[\t\x0B\f \xA0\uFEFF]/,
        peg$c231 = peg$classExpectation(["\t", "\x0B", "\f", " ", "\xA0", "\uFEFF"], false, false),
        peg$c232 = /^[\n\r]/,
        peg$c233 = peg$classExpectation(["\n", "\r"], false, false),
        peg$c234 = "/*",
        peg$c235 = peg$literalExpectation("/*", false),
        peg$c236 = "*/",
        peg$c237 = peg$literalExpectation("*/", false),
        peg$c238 = "//",
        peg$c239 = peg$literalExpectation("//", false),
        peg$c240 = peg$anyExpectation(),
        peg$currPos = 0,
        peg$savedPos = 0,
        peg$posDetailsCache = [{ line: 1, column: 1 }],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
    }

    function error(message, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildSimpleError(message, location);
    }

    function peg$literalExpectation(text, ignoreCase) {
      return { type: "literal", text: text, ignoreCase: ignoreCase };
    }

    function peg$classExpectation(parts, inverted, ignoreCase) {
      return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }

    function peg$anyExpectation() {
      return { type: "any" };
    }

    function peg$endExpectation() {
      return { type: "end" };
    }

    function peg$otherExpectation(description) {
      return { type: "other", description: description };
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column
        };

        while (p < pos) {
          if (input.charCodeAt(p) === 10) {
            details.line++;
            details.column = 1;
          } else {
            details.column++;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildSimpleError(message, location) {
      return new peg$SyntaxError(message, null, null, location);
    }

    function peg$buildStructuredError(expected, found, location) {
      return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parseLines();

      return s0;
    }

    function peg$parseLines() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseLine();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parseLines();
            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c0(s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseLine();
          if (s2 !== peg$FAILED) {
            s3 = peg$parse_();
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c1(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parse_();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c2();
          }
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseLine() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = peg$parseDirective();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseLabel();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 58) {
              s3 = peg$c4;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c5);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseDirective();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c6(s1, s5);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseLabel();
          if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 58) {
                s3 = peg$c4;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c5);
                }
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                  s5 = peg$parseInstruction();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c7(s1, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseInstruction();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c8(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseLabel();
              if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 58) {
                    s3 = peg$c4;
                    peg$currPos++;
                  } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c5);
                    }
                  }
                  if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                      s5 = peg$parseSynthetic();
                      if (s5 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c9(s1, s5);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseSynthetic();
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c10(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$parseLabel();
                  if (s1 !== peg$FAILED) {
                    s2 = peg$parse_();
                    if (s2 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 58) {
                        s3 = peg$c4;
                        peg$currPos++;
                      } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c5);
                        }
                      }
                      if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c11(s1);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseDirective() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 4) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 4;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c13);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseNumExpr();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c14(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c15) {
          s1 = peg$c15;
          peg$currPos += 5;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c16);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            s3 = peg$parseNumExpr();
            if (s3 !== peg$FAILED) {
              s4 = [];
              s5 = peg$currPos;
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 44) {
                  s7 = peg$c17;
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c18);
                  }
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parseNumExpr();
                    if (s9 !== peg$FAILED) {
                      s6 = [s6, s7, s8, s9];
                      s5 = s6;
                    } else {
                      peg$currPos = s5;
                      s5 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                s5 = peg$currPos;
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 44) {
                    s7 = peg$c17;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c18);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseNumExpr();
                      if (s9 !== peg$FAILED) {
                        s6 = [s6, s7, s8, s9];
                        s5 = s6;
                      } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s5;
                      s5 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              }
              if (s4 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c19(s3, s4);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseLabel();
          if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 61) {
                s3 = peg$c20;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c21);
                }
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                  s5 = peg$parseNumExpr();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c22(s1, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }

      return s0;
    }

    function peg$parseInstruction() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parseInstructionArithLog1a();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c23(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseInstructionArithLog1b();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c24(s1);
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseInstructionLoad1a();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c25(s1);
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseInstructionLoad1b();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c26(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseInstructionStore1a();
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s1);
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseInstructionStore1b();
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c28(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$parseInstructionSethi();
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c29(s1);
                  }
                  s0 = s1;
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parseInstructionBcc();
                    if (s1 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s1);
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      if (input.substr(peg$currPos, 4) === peg$c31) {
                        s1 = peg$c31;
                        peg$currPos += 4;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c32);
                        }
                      }
                      if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c33();
                      }
                      s0 = s1;
                    }
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseInstructionArithLog1a() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

      s0 = peg$currPos;
      s1 = peg$parseCodeOp();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseRegister();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c17;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c18);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parseRegister();
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 44) {
                        s9 = peg$c17;
                        peg$currPos++;
                      } else {
                        s9 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c18);
                        }
                      }
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          s11 = peg$parseRegister();
                          if (s11 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c34(s1, s3, s7, s11);
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseInstructionArithLog1b() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

      s0 = peg$currPos;
      s1 = peg$parseCodeOp();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseRegister();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c17;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c18);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parseNumExpr();
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 44) {
                        s9 = peg$c17;
                        peg$currPos++;
                      } else {
                        s9 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c18);
                        }
                      }
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          s11 = peg$parseRegister();
                          if (s11 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c35(s1, s3, s7, s11);
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseCodeOp() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 5) === peg$c36) {
        s1 = peg$c36;
        peg$currPos += 5;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c37);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 3) === peg$c38) {
          s1 = peg$c38;
          peg$currPos += 3;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c39);
          }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 5) === peg$c40) {
            s1 = peg$c40;
            peg$currPos += 5;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c41);
            }
          }
          if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c42) {
              s1 = peg$c42;
              peg$currPos += 3;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c43);
              }
            }
            if (s1 === peg$FAILED) {
              if (input.substr(peg$currPos, 5) === peg$c44) {
                s1 = peg$c44;
                peg$currPos += 5;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c45);
                }
              }
              if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c46) {
                  s1 = peg$c46;
                  peg$currPos += 3;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c47);
                  }
                }
                if (s1 === peg$FAILED) {
                  if (input.substr(peg$currPos, 4) === peg$c48) {
                    s1 = peg$c48;
                    peg$currPos += 4;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c49);
                    }
                  }
                  if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c50) {
                      s1 = peg$c50;
                      peg$currPos += 2;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c51);
                      }
                    }
                    if (s1 === peg$FAILED) {
                      if (input.substr(peg$currPos, 5) === peg$c52) {
                        s1 = peg$c52;
                        peg$currPos += 5;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c53);
                        }
                      }
                      if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c54) {
                          s1 = peg$c54;
                          peg$currPos += 3;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c55);
                          }
                        }
                        if (s1 === peg$FAILED) {
                          if (input.substr(peg$currPos, 6) === peg$c56) {
                            s1 = peg$c56;
                            peg$currPos += 6;
                          } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c57);
                            }
                          }
                          if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 3) === peg$c58) {
                              s1 = peg$c58;
                              peg$currPos += 3;
                            } else {
                              s1 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c59);
                              }
                            }
                            if (s1 === peg$FAILED) {
                              if (input.substr(peg$currPos, 3) === peg$c60) {
                                s1 = peg$c60;
                                peg$currPos += 3;
                              } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c61);
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c62(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseInstructionLoad1a() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c63) {
        s1 = peg$c63;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c64);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 91) {
            s3 = peg$c65;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c66);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseRegister();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 43) {
                    s7 = peg$c67;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c68);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseRegister();
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 93) {
                            s11 = peg$c69;
                            peg$currPos++;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c70);
                            }
                          }
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();
                            if (s12 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 44) {
                                s13 = peg$c17;
                                peg$currPos++;
                              } else {
                                s13 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c18);
                                }
                              }
                              if (s13 !== peg$FAILED) {
                                s14 = peg$parse_();
                                if (s14 !== peg$FAILED) {
                                  s15 = peg$parseRegister();
                                  if (s15 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c71(s5, s9, s15);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c63) {
          s1 = peg$c63;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c64);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 91) {
              s3 = peg$c65;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c66);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseRegister();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_();
                  if (s6 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 93) {
                      s7 = peg$c69;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c70);
                      }
                    }
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parse_();
                      if (s8 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                          s9 = peg$c17;
                          peg$currPos++;
                        } else {
                          s9 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c18);
                          }
                        }
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parse_();
                          if (s10 !== peg$FAILED) {
                            s11 = peg$parseRegister();
                            if (s11 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c72(s5, s11);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseInstructionLoad1b() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c63) {
        s1 = peg$c63;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c64);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 91) {
            s3 = peg$c65;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c66);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseRegister();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 43) {
                    s7 = peg$c67;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c68);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 45) {
                      s7 = peg$c73;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c74);
                      }
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseNumExpr();
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 93) {
                            s11 = peg$c69;
                            peg$currPos++;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c70);
                            }
                          }
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();
                            if (s12 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 44) {
                                s13 = peg$c17;
                                peg$currPos++;
                              } else {
                                s13 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c18);
                                }
                              }
                              if (s13 !== peg$FAILED) {
                                s14 = peg$parse_();
                                if (s14 !== peg$FAILED) {
                                  s15 = peg$parseRegister();
                                  if (s15 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c75(s5, s7, s9, s15);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseInstructionStore1a() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c76) {
        s1 = peg$c76;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c77);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseRegister();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c17;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c18);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 91) {
                    s7 = peg$c65;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c66);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseRegister();
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 43) {
                            s11 = peg$c67;
                            peg$currPos++;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c68);
                            }
                          }
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();
                            if (s12 !== peg$FAILED) {
                              s13 = peg$parseRegister();
                              if (s13 !== peg$FAILED) {
                                s14 = peg$parse_();
                                if (s14 !== peg$FAILED) {
                                  if (input.charCodeAt(peg$currPos) === 93) {
                                    s15 = peg$c69;
                                    peg$currPos++;
                                  } else {
                                    s15 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$c70);
                                    }
                                  }
                                  if (s15 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c78(s3, s9, s13);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c76) {
          s1 = peg$c76;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c77);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            s3 = peg$parseRegister();
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 44) {
                  s5 = peg$c17;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c18);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_();
                  if (s6 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 91) {
                      s7 = peg$c65;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c66);
                      }
                    }
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parse_();
                      if (s8 !== peg$FAILED) {
                        s9 = peg$parseRegister();
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parse_();
                          if (s10 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 93) {
                              s11 = peg$c69;
                              peg$currPos++;
                            } else {
                              s11 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c70);
                              }
                            }
                            if (s11 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c79(s3, s9);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseInstructionStore1b() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c76) {
        s1 = peg$c76;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c77);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseRegister();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c17;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c18);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 91) {
                    s7 = peg$c65;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c66);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseRegister();
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 43) {
                            s11 = peg$c67;
                            peg$currPos++;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c68);
                            }
                          }
                          if (s11 === peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 45) {
                              s11 = peg$c73;
                              peg$currPos++;
                            } else {
                              s11 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c74);
                              }
                            }
                          }
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();
                            if (s12 !== peg$FAILED) {
                              s13 = peg$parseNumExpr();
                              if (s13 !== peg$FAILED) {
                                s14 = peg$parse_();
                                if (s14 !== peg$FAILED) {
                                  if (input.charCodeAt(peg$currPos) === 93) {
                                    s15 = peg$c69;
                                    peg$currPos++;
                                  } else {
                                    s15 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$c70);
                                    }
                                  }
                                  if (s15 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c80(s3, s9, s11, s13);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseInstructionSethi() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 5) === peg$c81) {
        s1 = peg$c81;
        peg$currPos += 5;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c82);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseInteger();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c17;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c18);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parseRegister();
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c83(s3, s7);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseInstructionBcc() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 98) {
        s1 = peg$c84;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c85);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parseCond();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parseLabel();
            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c86(s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseCond() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 3) === peg$c87) {
        s1 = peg$c87;
        peg$currPos += 3;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c88);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c89) {
          s1 = peg$c89;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c90);
          }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c91) {
            s1 = peg$c91;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c92);
            }
          }
          if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c93) {
              s1 = peg$c93;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c94);
              }
            }
            if (s1 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 108) {
                s1 = peg$c95;
                peg$currPos++;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c96);
                }
              }
              if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c97) {
                  s1 = peg$c97;
                  peg$currPos += 3;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c98);
                  }
                }
                if (s1 === peg$FAILED) {
                  if (input.substr(peg$currPos, 2) === peg$c99) {
                    s1 = peg$c99;
                    peg$currPos += 2;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c100);
                    }
                  }
                  if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c101) {
                      s1 = peg$c101;
                      peg$currPos += 2;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c102);
                      }
                    }
                    if (s1 === peg$FAILED) {
                      if (input.substr(peg$currPos, 2) === peg$c103) {
                        s1 = peg$c103;
                        peg$currPos += 2;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c104);
                        }
                      }
                      if (s1 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 110) {
                          s1 = peg$c105;
                          peg$currPos++;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c106);
                          }
                        }
                        if (s1 === peg$FAILED) {
                          if (input.substr(peg$currPos, 3) === peg$c107) {
                            s1 = peg$c107;
                            peg$currPos += 3;
                          } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c108);
                            }
                          }
                          if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 2) === peg$c109) {
                              s1 = peg$c109;
                              peg$currPos += 2;
                            } else {
                              s1 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c110);
                              }
                            }
                            if (s1 === peg$FAILED) {
                              if (input.substr(peg$currPos, 2) === peg$c111) {
                                s1 = peg$c111;
                                peg$currPos += 2;
                              } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c112);
                                }
                              }
                              if (s1 === peg$FAILED) {
                                if (input.substr(peg$currPos, 2) === peg$c113) {
                                  s1 = peg$c113;
                                  peg$currPos += 2;
                                } else {
                                  s1 = peg$FAILED;
                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c114);
                                  }
                                }
                                if (s1 === peg$FAILED) {
                                  if (input.charCodeAt(peg$currPos) === 103) {
                                    s1 = peg$c115;
                                    peg$currPos++;
                                  } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$c116);
                                    }
                                  }
                                  if (s1 === peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 97) {
                                      s1 = peg$c117;
                                      peg$currPos++;
                                    } else {
                                      s1 = peg$FAILED;
                                      if (peg$silentFails === 0) {
                                        peg$fail(peg$c118);
                                      }
                                    }
                                    if (s1 === peg$FAILED) {
                                      if (input.charCodeAt(peg$currPos) === 122) {
                                        s1 = peg$c119;
                                        peg$currPos++;
                                      } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                          peg$fail(peg$c120);
                                        }
                                      }
                                      if (s1 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 3) === peg$c121) {
                                          s1 = peg$c121;
                                          peg$currPos += 3;
                                        } else {
                                          s1 = peg$FAILED;
                                          if (peg$silentFails === 0) {
                                            peg$fail(peg$c122);
                                          }
                                        }
                                        if (s1 === peg$FAILED) {
                                          if (input.substr(peg$currPos, 2) === peg$c123) {
                                            s1 = peg$c123;
                                            peg$currPos += 2;
                                          } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                              peg$fail(peg$c124);
                                            }
                                          }
                                          if (s1 === peg$FAILED) {
                                            if (input.substr(peg$currPos, 2) === peg$c125) {
                                              s1 = peg$c125;
                                              peg$currPos += 2;
                                            } else {
                                              s1 = peg$FAILED;
                                              if (peg$silentFails === 0) {
                                                peg$fail(peg$c126);
                                              }
                                            }
                                            if (s1 === peg$FAILED) {
                                              if (input.substr(peg$currPos, 2) === peg$c127) {
                                                s1 = peg$c127;
                                                peg$currPos += 2;
                                              } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                  peg$fail(peg$c128);
                                                }
                                              }
                                              if (s1 === peg$FAILED) {
                                                if (input.substr(peg$currPos, 2) === peg$c129) {
                                                  s1 = peg$c129;
                                                  peg$currPos += 2;
                                                } else {
                                                  s1 = peg$FAILED;
                                                  if (peg$silentFails === 0) {
                                                    peg$fail(peg$c130);
                                                  }
                                                }
                                                if (s1 === peg$FAILED) {
                                                  if (input.substr(peg$currPos, 2) === peg$c131) {
                                                    s1 = peg$c131;
                                                    peg$currPos += 2;
                                                  } else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                      peg$fail(peg$c132);
                                                    }
                                                  }
                                                  if (s1 === peg$FAILED) {
                                                    if (input.charCodeAt(peg$currPos) === 101) {
                                                      s1 = peg$c133;
                                                      peg$currPos++;
                                                    } else {
                                                      s1 = peg$FAILED;
                                                      if (peg$silentFails === 0) {
                                                        peg$fail(peg$c134);
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c135(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseSynthetic() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 3) === peg$c136) {
        s1 = peg$c136;
        peg$currPos += 3;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c137);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseRegister();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c138(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 3) === peg$c139) {
          s1 = peg$c139;
          peg$currPos += 3;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c140);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            s3 = peg$parseRegister();
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 44) {
                  s5 = peg$c17;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c18);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_();
                  if (s6 !== peg$FAILED) {
                    s7 = peg$parseRegister();
                    if (s7 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c141(s3, s7);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 5) === peg$c142) {
            s1 = peg$c142;
            peg$currPos += 5;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c143);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
              s3 = peg$parseRegister();
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c144(s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3) === peg$c145) {
              s1 = peg$c145;
              peg$currPos += 3;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c146);
              }
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parse_();
              if (s2 !== peg$FAILED) {
                s3 = peg$parseRegister();
                if (s3 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c147(s3);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 5) === peg$c148) {
                s1 = peg$c148;
                peg$currPos += 5;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c149);
                }
              }
              if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                  s3 = peg$parseRegister();
                  if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c150(s3);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 3) === peg$c151) {
                  s1 = peg$c151;
                  peg$currPos += 3;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c152);
                  }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$parse_();
                  if (s2 !== peg$FAILED) {
                    s3 = peg$parseRegister();
                    if (s3 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c153(s3);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  if (input.substr(peg$currPos, 4) === peg$c154) {
                    s1 = peg$c154;
                    peg$currPos += 4;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c155);
                    }
                  }
                  if (s1 !== peg$FAILED) {
                    s2 = peg$parse_();
                    if (s2 !== peg$FAILED) {
                      s3 = peg$parseNumExpr();
                      if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c17;
                            peg$currPos++;
                          } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c18);
                            }
                          }
                          if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                              s7 = peg$parseRegister();
                              if (s7 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c156(s3, s7);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 3) === peg$c157) {
                      s1 = peg$c157;
                      peg$currPos += 3;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c158);
                      }
                    }
                    if (s1 !== peg$FAILED) {
                      s2 = peg$parse_();
                      if (s2 !== peg$FAILED) {
                        s3 = peg$parseNumExpr();
                        if (s3 !== peg$FAILED) {
                          s4 = peg$parse_();
                          if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 44) {
                              s5 = peg$c17;
                              peg$currPos++;
                            } else {
                              s5 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c18);
                              }
                            }
                            if (s5 !== peg$FAILED) {
                              s6 = peg$parse_();
                              if (s6 !== peg$FAILED) {
                                s7 = peg$parseRegister();
                                if (s7 !== peg$FAILED) {
                                  peg$savedPos = s0;
                                  s1 = peg$c159(s3, s7);
                                  s0 = s1;
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      if (input.substr(peg$currPos, 3) === peg$c160) {
                        s1 = peg$c160;
                        peg$currPos += 3;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c161);
                        }
                      }
                      if (s1 !== peg$FAILED) {
                        s2 = peg$parse_();
                        if (s2 !== peg$FAILED) {
                          s3 = peg$parseRegister();
                          if (s3 !== peg$FAILED) {
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 44) {
                                s5 = peg$c17;
                                peg$currPos++;
                              } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c18);
                                }
                              }
                              if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                  s7 = peg$parseRegister();
                                  if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c162(s3, s7);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                      if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 3) === peg$c160) {
                          s1 = peg$c160;
                          peg$currPos += 3;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c161);
                          }
                        }
                        if (s1 !== peg$FAILED) {
                          s2 = peg$parse_();
                          if (s2 !== peg$FAILED) {
                            s3 = peg$parseRegister();
                            if (s3 !== peg$FAILED) {
                              s4 = peg$parse_();
                              if (s4 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 44) {
                                  s5 = peg$c17;
                                  peg$currPos++;
                                } else {
                                  s5 = peg$FAILED;
                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c18);
                                  }
                                }
                                if (s5 !== peg$FAILED) {
                                  s6 = peg$parse_();
                                  if (s6 !== peg$FAILED) {
                                    s7 = peg$parseNumExpr();
                                    if (s7 !== peg$FAILED) {
                                      peg$savedPos = s0;
                                      s1 = peg$c163(s3, s7);
                                      s0 = s1;
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                          s0 = peg$currPos;
                          if (input.substr(peg$currPos, 3) === peg$c164) {
                            s1 = peg$c164;
                            peg$currPos += 3;
                          } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c165);
                            }
                          }
                          if (s1 !== peg$FAILED) {
                            s2 = peg$parse_();
                            if (s2 !== peg$FAILED) {
                              s3 = peg$parseRegister();
                              if (s3 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c166(s3);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                          if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 5) === peg$c167) {
                              s1 = peg$c167;
                              peg$currPos += 5;
                            } else {
                              s1 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c168);
                              }
                            }
                            if (s1 !== peg$FAILED) {
                              s2 = peg$parse_();
                              if (s2 !== peg$FAILED) {
                                s3 = peg$parseRegister();
                                if (s3 !== peg$FAILED) {
                                  peg$savedPos = s0;
                                  s1 = peg$c169(s3);
                                  s0 = s1;
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                            if (s0 === peg$FAILED) {
                              s0 = peg$currPos;
                              if (input.substr(peg$currPos, 3) === peg$c170) {
                                s1 = peg$c170;
                                peg$currPos += 3;
                              } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c171);
                                }
                              }
                              if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c172();
                              }
                              s0 = s1;
                              if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 4) === peg$c173) {
                                  s1 = peg$c173;
                                  peg$currPos += 4;
                                } else {
                                  s1 = peg$FAILED;
                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c174);
                                  }
                                }
                                if (s1 !== peg$FAILED) {
                                  s2 = peg$parse_();
                                  if (s2 !== peg$FAILED) {
                                    s3 = peg$parseLabel();
                                    if (s3 !== peg$FAILED) {
                                      peg$savedPos = s0;
                                      s1 = peg$c175(s3);
                                      s0 = s1;
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                                if (s0 === peg$FAILED) {
                                  s0 = peg$currPos;
                                  if (input.substr(peg$currPos, 3) === peg$c176) {
                                    s1 = peg$c176;
                                    peg$currPos += 3;
                                  } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$c177);
                                    }
                                  }
                                  if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c178();
                                  }
                                  s0 = s1;
                                  if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.substr(peg$currPos, 4) === peg$c179) {
                                      s1 = peg$c179;
                                      peg$currPos += 4;
                                    } else {
                                      s1 = peg$FAILED;
                                      if (peg$silentFails === 0) {
                                        peg$fail(peg$c180);
                                      }
                                    }
                                    if (s1 !== peg$FAILED) {
                                      s2 = peg$parse_();
                                      if (s2 !== peg$FAILED) {
                                        s3 = peg$parseRegister();
                                        if (s3 !== peg$FAILED) {
                                          peg$savedPos = s0;
                                          s1 = peg$c181(s3);
                                          s0 = s1;
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                    if (s0 === peg$FAILED) {
                                      s0 = peg$currPos;
                                      if (input.substr(peg$currPos, 3) === peg$c182) {
                                        s1 = peg$c182;
                                        peg$currPos += 3;
                                      } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                          peg$fail(peg$c183);
                                        }
                                      }
                                      if (s1 !== peg$FAILED) {
                                        s2 = peg$parse_();
                                        if (s2 !== peg$FAILED) {
                                          s3 = peg$parseRegister();
                                          if (s3 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c184(s3);
                                            s0 = s1;
                                          } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                          }
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseRegister() {
      var s0, s1, s2;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c185) {
        s1 = peg$c185;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c186);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parseInteger();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c187(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 3) === peg$c188) {
          s1 = peg$c188;
          peg$currPos += 3;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c189);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c190();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 3) === peg$c191) {
            s1 = peg$c191;
            peg$currPos += 3;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c192);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c193();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3) === peg$c194) {
              s1 = peg$c194;
              peg$currPos += 3;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c195);
              }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c196();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 3) === peg$c197) {
                s1 = peg$c197;
                peg$currPos += 3;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c198);
                }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c199();
              }
              s0 = s1;
            }
          }
        }
      }

      return s0;
    }

    function peg$parseNumExpr() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parseTerm();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 43) {
            s5 = peg$c67;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c68);
            }
          }
          if (s5 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 45) {
              s5 = peg$c73;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c74);
              }
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseTerm();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 43) {
              s5 = peg$c67;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c68);
              }
            }
            if (s5 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 45) {
                s5 = peg$c73;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c74);
                }
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseTerm();
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c200(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseTerm() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parseFactor();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 42) {
            s5 = peg$c201;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c202);
            }
          }
          if (s5 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 47) {
              s5 = peg$c203;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c204);
              }
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseFactor();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 42) {
              s5 = peg$c201;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c202);
              }
            }
            if (s5 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 47) {
                s5 = peg$c203;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c204);
                }
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseFactor();
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c200(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseFactor() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s1 = peg$c205;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c206);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseNumExpr();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s5 = peg$c207;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c208);
                }
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c209(s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parseInteger();
        if (s0 === peg$FAILED) {
          s0 = peg$parseLabel();
        }
      }

      return s0;
    }

    function peg$parseInteger() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = peg$parseNaturalInteger();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c210(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 45) {
          s1 = peg$c73;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c74);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parseNaturalInteger();
          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c211(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseNaturalInteger() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c212) {
        s1 = peg$c212;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c213);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c214.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c215);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            if (peg$c214.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c215);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c216();
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c217) {
          s1 = peg$c217;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c218);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = [];
          if (peg$c219.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c220);
            }
          }
          if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c219.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c220);
                }
              }
            }
          } else {
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c221();
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = [];
          if (peg$c222.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c223);
            }
          }
          if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              if (peg$c222.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c223);
                }
              }
            }
          } else {
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c224();
          }
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseLabel() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      if (peg$c225.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c226);
        }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c225.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c226);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c227(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsesepar() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 44) {
        s1 = peg$c17;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c18);
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c228();
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 58) {
          s1 = peg$c4;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c5);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c228();
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsewhiteSpace();
      if (s2 === peg$FAILED) {
        s2 = peg$parseenclosedComment();
        if (s2 === peg$FAILED) {
          s2 = peg$parselineComment();
          if (s2 === peg$FAILED) {
            s2 = peg$parselineTerminator();
          }
        }
      }
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsewhiteSpace();
        if (s2 === peg$FAILED) {
          s2 = peg$parseenclosedComment();
          if (s2 === peg$FAILED) {
            s2 = peg$parselineComment();
            if (s2 === peg$FAILED) {
              s2 = peg$parselineTerminator();
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c228();
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c229);
        }
      }

      return s0;
    }

    function peg$parsewhiteSpace() {
      var s0;

      if (peg$c230.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c231);
        }
      }

      return s0;
    }

    function peg$parselineTerminator() {
      var s0;

      if (peg$c232.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c233);
        }
      }

      return s0;
    }

    function peg$parseenclosedComment() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c234) {
        s1 = peg$c234;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c235);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$currPos;
        peg$silentFails++;
        if (input.substr(peg$currPos, 2) === peg$c236) {
          s5 = peg$c236;
          peg$currPos += 2;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c237);
          }
        }
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = void 0;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseanyCharacter();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$currPos;
          peg$silentFails++;
          if (input.substr(peg$currPos, 2) === peg$c236) {
            s5 = peg$c236;
            peg$currPos += 2;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c237);
            }
          }
          peg$silentFails--;
          if (s5 === peg$FAILED) {
            s4 = void 0;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseanyCharacter();
            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c236) {
            s3 = peg$c236;
            peg$currPos += 2;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c237);
            }
          }
          if (s3 !== peg$FAILED) {
            s1 = [s1, s2, s3];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parselineComment() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c238) {
        s1 = peg$c238;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c239);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$currPos;
        peg$silentFails++;
        s5 = peg$parselineTerminator();
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = void 0;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseanyCharacter();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$currPos;
          peg$silentFails++;
          s5 = peg$parselineTerminator();
          peg$silentFails--;
          if (s5 === peg$FAILED) {
            s4 = void 0;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseanyCharacter();
            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseanyCharacter() {
      var s0;

      if (input.length > peg$currPos) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c240);
        }
      }

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail(peg$endExpectation());
      }

      throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
}();

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fuzzy = __webpack_require__(94);

module.exports = function () {

   return {
      isMealPresent: isMealPresent,
      evaluateFractionning: evaluateFractionning,
      getMealPercentage: getMealPercentage,
      computeNutrientValue: computeNutrientValue,
      getNutrientAbsoluteRange: getNutrientAbsoluteRange,
      getNutrientLimSup: getNutrientLimSup,
      getMealScore: getMealScore
   };

   function isMealPresent(fractionning, index) {
      return fractionning && fractionning.mealPresenceArray.indexOf(index) !== -1;
   }

   // categorize the way meals are split
   function evaluateFractionning(fractionning) {
      var nbMeals = fractionning.mealPresenceArray.length;
      var evalFract = void 0;
      if (nbMeals === 2 && (isMealPresent(fractionning, 0) || isMealPresent(fractionning, 2)) && isMealPresent(fractionning, 4)) {
         evalFract = 1;
      } else if (nbMeals === 3 && (isMealPresent(fractionning, 0) || isMealPresent(fractionning, 1)) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 4)) {
         evalFract = 2;
      } else if (nbMeals === 3 && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 4)) {
         evalFract = 10;
      } else if (nbMeals === 4 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 4)) {
         evalFract = 3;
      } else if (nbMeals === 4 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 1) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 4)) {
         evalFract = 4;
      } else if (nbMeals === 4 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 5)) {
         evalFract = 5;
      } else if ((isMealPresent(fractionning, 0) || isMealPresent(fractionning, 1)) && nbMeals === 4 && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 4)) {
         evalFract = 8;
      } else if (nbMeals === 5 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 4)) {
         evalFract = 6;
      } else if (nbMeals === 6) {
         evalFract = 7;
      } else {
         evalFract = 0;
      }
      return evalFract;
   }

   function getMealPercentage(fractionningCategory, lowCalories, mealIndex) {
      if (fractionningCategory === 0) {
         // hors categorie
         return 40;
      } else if (fractionningCategory === 1) {
         if (mealIndex === 0) {
            return 50;
         } else if (mealIndex === 2) {
            return 50;
         } else if (mealIndex === 4) {
            return 50;
         }
      } else if (fractionningCategory === 2) {
         if (mealIndex === 0) {
            return 20;
         } else if (mealIndex === 1) {
            return 20;
         } else if (mealIndex === 2) {
            return 40;
         } else if (mealIndex === 4) {
            return 40;
         }
      } else if (fractionningCategory === 3) {
         if (mealIndex === 0) {
            return 20;
         } else if (mealIndex === 1) {
            return lowCalories ? 5 : 10;
         } else if (mealIndex === 2) {
            return lowCalories ? 37 : 35;
         } else if (mealIndex === 3) {
            return lowCalories ? 5 : 10;
         } else if (mealIndex === 4) {
            return lowCalories ? 38 : 35;
         } else if (mealIndex === 5) {
            return lowCalories ? 5 : 10;
         }
      } else if (fractionningCategory === 4) {
         if (mealIndex === 0) {
            return 20;
         } else if (mealIndex === 1) {
            return 20;
         } else if (mealIndex === 3) {
            return 20;
         } else if (mealIndex === 4) {
            return 40;
         }
      } else if (fractionningCategory === 5) {
         if (mealIndex === 0) {
            return 20;
         } else if (mealIndex === 2) {
            return 40;
         } else if (mealIndex === 3) {
            return 20;
         } else if (mealIndex === 5) {
            return 20;
         }
      } else if (fractionningCategory === 6) {
         if (mealIndex === 0) {
            return 20;
         } else if (mealIndex === 1) {
            return lowCalories ? 5 : 10;
         } else if (mealIndex === 2) {
            return lowCalories ? 35 : 30;
         } else if (mealIndex === 3) {
            return lowCalories ? 5 : 10;
         } else if (mealIndex === 4) {
            return lowCalories ? 35 : 30;
         } else if (mealIndex === 5) {
            return lowCalories ? 5 : 10;
         }
      } else if (fractionningCategory === 7) {
         if (mealIndex === 0) {
            return 20;
         } else if (mealIndex === 1) {
            return lowCalories ? 5 : 8;
         } else if (mealIndex === 2) {
            return lowCalories ? 32 : 30;
         } else if (mealIndex === 3) {
            return lowCalories ? 5 : 7;
         } else if (mealIndex === 4) {
            return lowCalories ? 33 : 30;
         } else if (mealIndex === 5) {
            return 5;
         }
      } else if (fractionningCategory === 8) {
         if (mealIndex === 0) {
            return 20;
         } else if (mealIndex === 1) {
            return 20;
         } else if (mealIndex === 2) {
            return 35;
         } else if (mealIndex === 3) {
            return 15;
         } else if (mealIndex === 4) {
            return 30;
         }
      } else if (fractionningCategory === 10) {
         if (mealIndex === 2) {
            return 40;
         } else if (mealIndex === 3) {
            return 20;
         } else if (mealIndex === 4) {
            return 40;
         }
      } else {
         return 0.;
      }
   }

   function getNutrientLimSup(nutrient, mealEnergy) {
      if (nutrient.nutr_no === "208") {
         // special case of energy: limsup = 200%
         return mealEnergy * 2.;
      } else if (nutrient.nutr_no === "301") {
         // special case of calcium
         return 1000.;
      } else if (nutrient.nutr_no === "291") {
         // special case of fibers
         return 25.;
      } else {
         // all others: range relative to mealEnergy
         return mealEnergy / nutrient.energy_ratio;
      }
   }

   function getNutrientAbsoluteRange(user, nutrient, mealEnergy) {
      if (nutrient.nutr_no === "208") {
         // special case of energy
         var percentRange = { d1: 90., d2: 110., dt1: 15., dt2: 15., h: 0. };
         return fuzzy.multiplyByScalar(percentRange, mealEnergy * 0.01);
      } else if (nutrient.nutr_no === "301") {
         // special case of calcium
         return 1000.;
      } else if (nutrient.nutr_no === "291") {
         // special case of fibers
         return 25.;
      } else if (nutrient.nutr_no === "205") {
         // special case of carbohydrates
         var _percentRange = void 0;
         if (false) {
            _percentRange = { d1: 40., d2: 55., dt1: 5., dt2: 5., h: 0. };
         } else {
            _percentRange = { d1: 45., d2: 60., dt1: 5., dt2: 5., h: 0. };
         }
         return fuzzy.multiplyByScalar(_percentRange, mealEnergy * 0.01 / nutrient.energy_ratio);
      } else {
         // all others: range is relative to mealEnergy / nutrient.energy_ratio
         var _percentRange2 = void 0;
         if (nutrient.nutr_no === "203") {
            // proteins
            _percentRange2 = { d1: 10., d2: 18., dt1: 8., dt2: 8., h: 0. };
         } else if (nutrient.nutr_no === "204") {
            // fat
            _percentRange2 = { d1: 30., d2: 35., dt1: 8., dt2: 8., h: 0. };
         }
         return fuzzy.multiplyByScalar(_percentRange2, mealEnergy * 0.01 / nutrient.energy_ratio);
      }
   }

   function computeNutrientValue(nutr_no, mealElements, foods, foodPortions, nutdatas, food2nutrient2nutdata) {
      // map
      var mealElementNutrientArray = mealElements.map(function (mealElement) {
         var food = void 0,
             fuzzyWeight = void 0;
         if (mealElement.food) {
            food = foods[mealElement.food];
            if (!food) {
               console.log('missing', mealElement);return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 };
            }
            fuzzyWeight = fuzzy.parse(mealElement.weight);
         } else {
            var foodPortion = foodPortions[mealElement.food_portion];
            if (!foodPortion) {
               console.log('missing', mealElement);return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 };
            }
            food = foods[foodPortion.food];
            if (!food) {
               console.log('missing', mealElement);return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 };
            }
            var portionWeight = fuzzy.parse(foodPortion.portion_weight);
            fuzzyWeight = fuzzy.multiplyByScalar(portionWeight, parseFloat(foodPortion.nbportion));
         }
         if (!food2nutrient2nutdata[food.id]) {
            console.log('missing', mealElement);return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 };
         }
         var foodNutdataId = food2nutrient2nutdata[food.id][nutr_no];
         var foodNutData = nutdatas[foodNutdataId];
         if (!foodNutData) {
            console.log('missing', mealElement);return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 };
         }
         var fuzzyNutData = fuzzy.parse(foodNutData.val);
         var fuzzyValue = fuzzy.multiply(fuzzyWeight, fuzzyNutData);
         return fuzzy.multiplyByScalar(fuzzyValue, 0.01);
      });
      // reduce
      var zero = { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 };
      return mealElementNutrientArray.reduce(function (accu, mealElementNutrient) {
         return fuzzy.add(accu, mealElementNutrient);
      }, zero);
   }

   function getNutrientWeight(user, nutr_no) {
      if (nutr_no === "208") {
         // energy
         return 10.;
      } else if (nutr_no === "205") {
         // carbohydrates
         return 4.;
      } else if (nutr_no === "209") {
         // complex carbs
         return  false ? 10. : 3.;
      } else if (nutr_no === "210") {
         // saccharose
         if (false) {
            return 20.;
         } else {
            return  false ? 10. : 3.;
         }
      } else if (nutr_no === "203") {
         // proteins
         return 6.;
      } else if (nutr_no === "204") {
         // fat
         return 4.;
      } else if (nutr_no === "606") {
         // saturated fat
         return  false ? 10. : 3.;
      } else if (nutr_no === "648") {
         // lipides polyinsaturés
         return 1.;
      } else if (nutr_no === "601") {
         // cholesterol
         return  false ? 20. : 2.;
      } else if (nutr_no === "301") {
         // calcium
         return 5.;
      } else if (nutr_no === "291") {
         // fibres
         return 5.;
      } else if (nutr_no === "221") {
         // alcool
         return  false ? 20. : 1.;
      } else if (nutr_no === "307") {
         // sodium
         if (false) {
            return 25.;
         } else {
            // no salt-free diet -> < 8g/j
            return 1.;
         }
      }
   }

   function getMealScore(user, nutrients, mealElements, mealEnergy, foods, foodPortions, nutdatas, food2nutrient2nutdata) {
      var totalw = 0.;
      var total = 0.;
      nutrients.forEach(function (nutrient) {
         var s = getMealNutrientScore(user, nutrient, mealElements, mealEnergy, foods, foodPortions, nutdatas, food2nutrient2nutdata);
         var weight = getNutrientWeight(user, nutrient.nutr_no);
         totalw += weight;
         total += weight * s;
      });
      return total / totalw;
   }

   function getMealNutrientScore(user, nutrient, mealElements, mealEnergy, foods, foodPortions, nutdatas, food2nutrient2nutdata) {
      var nutrientValue = computeNutrientValue(nutrient.nutr_no, mealElements, foods, foodPortions, nutdatas, food2nutrient2nutdata);
      var nutrientRange = getNutrientAbsoluteRange(user, nutrient, mealEnergy);
      var inclusionDegree = fuzzy.necessity(nutrientRange, nutrientValue);
      var score = 0.;
      if (inclusionDegree >= 0.99) {
         score = 1.;
      } else {
         var overlapDegree = fuzzy.possibility(nutrientRange, nutrientValue);
         score = inclusionDegree * 0.8 + overlapDegree * 0.2;
      }
      return score;
   }
}();

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = /*
                 * Generated by PEG.js 0.10.0.
                 *
                 * http://pegjs.org/
                 */
function () {
  "use strict";

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
      literal: function literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },

      "class": function _class(expectation) {
        var escapedParts = "",
            i;

        for (i = 0; i < expectation.parts.length; i++) {
          escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
        }

        return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
      },

      any: function any(expectation) {
        return "any character";
      },

      end: function end(expectation) {
        return "end of input";
      },

      other: function other(expectation) {
        return expectation.description;
      }
    };

    function hex(ch) {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function classEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      var descriptions = new Array(expected.length),
          i,
          j;

      for (i = 0; i < expected.length; i++) {
        descriptions[i] = describeExpectation(expected[i]);
      }

      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  };

  function peg$parse(input, options) {
    options = options !== void 0 ? options : {};

    var peg$FAILED = {},
        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction = peg$parsestart,
        peg$c0 = "module",
        peg$c1 = peg$literalExpectation("module", false),
        peg$c2 = "(",
        peg$c3 = peg$literalExpectation("(", false),
        peg$c4 = ")",
        peg$c5 = peg$literalExpectation(")", false),
        peg$c6 = "end",
        peg$c7 = peg$literalExpectation("end", false),
        peg$c8 = function peg$c8(name, params, instances) {
      return { "name": name, "params": params, "instances": instances };
    },
        peg$c9 = "[",
        peg$c10 = peg$literalExpectation("[", false),
        peg$c11 = "]",
        peg$c12 = peg$literalExpectation("]", false),
        peg$c13 = function peg$c13(name, i) {
      return { "type": "vector", "name": name, "start": i, "stop": i, "location": location() };
    },
        peg$c14 = function peg$c14(name, i, j) {
      return { "type": "vector", "name": name, "start": i, "stop": j, "location": location() };
    },
        peg$c15 = function peg$c15(name) {
      return { "type": "scalar", "name": name, "location": location() };
    },
        peg$c16 = "&",
        peg$c17 = peg$literalExpectation("&", false),
        peg$c18 = function peg$c18(head, tail) {
      return { 'type': 'signalcompound', 'signals': [head].concat(tail.map(function (block) {
          return block[3];
        })), "location": location() };
    },
        peg$c19 = function peg$c19(head, tail) {
      return { 'type': 'signalorliteralcompound', 'signalorliterals': [head].concat(tail.map(function (block) {
          return block[3];
        })), "location": location() };
    },
        peg$c20 = "..",
        peg$c21 = peg$literalExpectation("..", false),
        peg$c22 = ":",
        peg$c23 = peg$literalExpectation(":", false),
        peg$c24 = peg$otherExpectation("module name"),
        peg$c25 = /^[a-zA-Z0-9_]/,
        peg$c26 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false),
        peg$c27 = function peg$c27(chars) {
      return chars.join("");
    },
        peg$c28 = peg$otherExpectation("signal name"),
        peg$c29 = /^[a-zA-Z_]/,
        peg$c30 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false),
        peg$c31 = function peg$c31(char0, chars) {
      return char0 + chars.join("");
    },
        peg$c32 = peg$otherExpectation("state name"),
        peg$c33 = function peg$c33(chars) {
      return { 'name': chars.join(""), 'location': location() };
    },
        peg$c34 = function peg$c34(head, tail) {
      return [head].concat(tail);
    },
        peg$c35 = function peg$c35(param) {
      return [param];
    },
        peg$c36 = function peg$c36(arg) {
      return [arg];
    },
        peg$c37 = function peg$c37(inst) {
      return [inst];
    },
        peg$c38 = function peg$c38(head, tail) {
      return { 'type': 'sumoftermscompound', 'sumofterms': [head].concat(tail.map(function (block) {
          return block[3];
        })), "location": location() };
    },
        peg$c39 = "+",
        peg$c40 = peg$literalExpectation("+", false),
        peg$c41 = function peg$c41(head, tail) {
      return { 'type': 'sumofterms', 'terms': [head].concat(tail.map(function (block) {
          return block[3];
        })), "location": location() };
    },
        peg$c42 = "*",
        peg$c43 = peg$literalExpectation("*", false),
        peg$c44 = function peg$c44(head, tail) {
      return { 'type': 'term', 'factors': [head].concat(tail.map(function (block) {
          return block[3];
        })), "location": location() };
    },
        peg$c45 = function peg$c45(sumofterms) {
      return { 'type': 'sumofterms', 'sumofterms': sumofterms, "location": location() };
    },
        peg$c46 = "0",
        peg$c47 = peg$literalExpectation("0", false),
        peg$c48 = function peg$c48() {
      return { 'type': 'bitfield', 'value': "0", "location": location() };
    },
        peg$c49 = "1",
        peg$c50 = peg$literalExpectation("1", false),
        peg$c51 = function peg$c51() {
      return { 'type': 'bitfield', 'value': "1", "location": location() };
    },
        peg$c52 = function peg$c52(bitField) {
      return { 'type': 'bitfield', 'value': bitField.value, "location": location() };
    },
        peg$c53 = function peg$c53(signal) {
      return { 'type': 'maxterm', 'signal': signal, 'inverted': false, "location": location() };
    },
        peg$c54 = "/",
        peg$c55 = peg$literalExpectation("/", false),
        peg$c56 = function peg$c56(signal) {
      return { 'type': 'maxterm', 'signal': signal, 'inverted': true, "location": location() };
    },
        peg$c57 = "=",
        peg$c58 = peg$literalExpectation("=", false),
        peg$c59 = function peg$c59(leftCompound, rightCompound) {
      return { 'type': 'assignment', 'leftCompound': leftCompound, 'rightCompound': rightCompound };
    },
        peg$c60 = "output",
        peg$c61 = peg$literalExpectation("output", false),
        peg$c62 = "enabled",
        peg$c63 = peg$literalExpectation("enabled", false),
        peg$c64 = "when",
        peg$c65 = peg$literalExpectation("when", false),
        peg$c66 = function peg$c66(leftCompound, rightCompound, oe) {
      return { 'type': 'tri_state', 'leftCompound': leftCompound, 'rightCompound': rightCompound, oe: oe };
    },
        peg$c67 = ":=",
        peg$c68 = peg$literalExpectation(":=", false),
        peg$c69 = "on",
        peg$c70 = peg$literalExpectation("on", false),
        peg$c71 = ",",
        peg$c72 = peg$literalExpectation(",", false),
        peg$c73 = "reset",
        peg$c74 = peg$literalExpectation("reset", false),
        peg$c75 = "set",
        peg$c76 = peg$literalExpectation("set", false),
        peg$c77 = function peg$c77(q, d, clk, setReset, rst, en) {
      return { 'type': 'memory_point', 'q': q, 'd': d, clk: clk, setReset: setReset, rst: rst, en: en };
    },
        peg$c78 = function peg$c78(q, d, clk, setReset, rst) {
      return { 'type': 'memory_point', 'q': q, 'd': d, clk: clk, setReset: setReset, rst: rst, en: null };
    },
        peg$c79 = function peg$c79(name, args) {
      return { 'type': 'module_instance', 'name': name, 'arguments': args, location: location() };
    },
        peg$c80 = "$",
        peg$c81 = peg$literalExpectation("$", false),
        peg$c82 = function peg$c82(name, args) {
      return { 'type': 'predefined_module_instance', 'name': name, 'arguments': args, location: location() };
    },
        peg$c83 = "map",
        peg$c84 = peg$literalExpectation("map", false),
        peg$c85 = "->",
        peg$c86 = peg$literalExpectation("->", false),
        peg$c87 = function peg$c87(input, output, values) {
      return { 'type': 'array', 'input': input, 'output': output, 'values': values };
    },
        peg$c88 = function peg$c88(input, output) {
      return { 'input': input, 'output': output };
    },
        peg$c89 = function peg$c89(header, rules) {
      return { 'type': 'fsm', 'header': header, 'rules': rules };
    },
        peg$c90 = "fsm",
        peg$c91 = peg$literalExpectation("fsm", false),
        peg$c92 = "statemachine",
        peg$c93 = peg$literalExpectation("statemachine", false),
        peg$c94 = "asynchronous",
        peg$c95 = peg$literalExpectation("asynchronous", false),
        peg$c96 = function peg$c96() {
      return { 'type': 'asynchronous' };
    },
        peg$c97 = "synchronous",
        peg$c98 = peg$literalExpectation("synchronous", false),
        peg$c99 = function peg$c99(init, rst, clk) {
      return { 'type': 'synchronous', 'rst': rst, 'clk': clk, 'init': init };
    },
        peg$c100 = function peg$c100(clk, init, rst) {
      return { 'type': 'synchronous', 'rst': rst, 'clk': clk, 'init': init };
    },
        peg$c101 = ";",
        peg$c102 = peg$literalExpectation(";", false),
        peg$c103 = function peg$c103(leftStates, rightState, condition) {
      return { 'type': 'fsm_rule', 'left_states': leftStates, 'right_state': rightState, 'condition': condition };
    },
        peg$c104 = function peg$c104(leftStates, rightState) {
      return { 'type': 'fsm_rule', 'left_states': leftStates, 'right_state': rightState };
    },
        peg$c105 = function peg$c105(rule) {
      return [rule];
    },
        peg$c106 = function peg$c106(state) {
      return [state];
    },
        peg$c107 = "\"",
        peg$c108 = peg$literalExpectation("\"", false),
        peg$c109 = /^[0-1]/,
        peg$c110 = peg$classExpectation([["0", "1"]], false, false),
        peg$c111 = function peg$c111(value) {
      return { type: 'bitfield', value: value.join('') };
    },
        peg$c112 = function peg$c112(bitfield) {
      return { type: 'literal', value: bitfield.value };
    },
        peg$c113 = function peg$c113() {
      return { type: 'literal', value: "0" };
    },
        peg$c114 = function peg$c114() {
      return { type: 'literal', value: "1" };
    },
        peg$c115 = /^[0-9]/,
        peg$c116 = peg$classExpectation([["0", "9"]], false, false),
        peg$c117 = function peg$c117() {
      return parseInt(text(), 10);
    },
        peg$c118 = function peg$c118() {
      return [];
    },
        peg$c119 = peg$otherExpectation("whitespace"),
        peg$c120 = function peg$c120() {
      return [];
    },
        peg$c121 = /^[\t\x0B\f \xA0\uFEFF]/,
        peg$c122 = peg$classExpectation(["\t", "\x0B", "\f", " ", "\xA0", "\uFEFF"], false, false),
        peg$c123 = /^[\n\r]/,
        peg$c124 = peg$classExpectation(["\n", "\r"], false, false),
        peg$c125 = "//",
        peg$c126 = peg$literalExpectation("//", false),
        peg$c127 = "#",
        peg$c128 = peg$literalExpectation("#", false),
        peg$c129 = peg$anyExpectation(),
        peg$currPos = 0,
        peg$savedPos = 0,
        peg$posDetailsCache = [{ line: 1, column: 1 }],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
    }

    function error(message, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildSimpleError(message, location);
    }

    function peg$literalExpectation(text, ignoreCase) {
      return { type: "literal", text: text, ignoreCase: ignoreCase };
    }

    function peg$classExpectation(parts, inverted, ignoreCase) {
      return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }

    function peg$anyExpectation() {
      return { type: "any" };
    }

    function peg$endExpectation() {
      return { type: "end" };
    }

    function peg$otherExpectation(description) {
      return { type: "other", description: description };
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column
        };

        while (p < pos) {
          if (input.charCodeAt(p) === 10) {
            details.line++;
            details.column = 1;
          } else {
            details.column++;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildSimpleError(message, location) {
      return new peg$SyntaxError(message, null, null, location);
    }

    function peg$buildStructuredError(expected, found, location) {
      return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parseModule();

      return s0;
    }

    function peg$parseModule() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        if (input.substr(peg$currPos, 6) === peg$c0) {
          s2 = peg$c0;
          peg$currPos += 6;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c1);
          }
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parseModuleName();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 40) {
                  s6 = peg$c2;
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c3);
                  }
                }
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parseParamList();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parse_();
                      if (s9 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 41) {
                          s10 = peg$c4;
                          peg$currPos++;
                        } else {
                          s10 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c5);
                          }
                        }
                        if (s10 !== peg$FAILED) {
                          s11 = peg$parse_();
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parseInstanceList();
                            if (s12 !== peg$FAILED) {
                              s13 = peg$parse_();
                              if (s13 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 3) === peg$c6) {
                                  s14 = peg$c6;
                                  peg$currPos += 3;
                                } else {
                                  s14 = peg$FAILED;
                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c7);
                                  }
                                }
                                if (s14 !== peg$FAILED) {
                                  s15 = peg$parse_();
                                  if (s15 !== peg$FAILED) {
                                    if (input.substr(peg$currPos, 6) === peg$c0) {
                                      s16 = peg$c0;
                                      peg$currPos += 6;
                                    } else {
                                      s16 = peg$FAILED;
                                      if (peg$silentFails === 0) {
                                        peg$fail(peg$c1);
                                      }
                                    }
                                    if (s16 !== peg$FAILED) {
                                      s17 = peg$parse_();
                                      if (s17 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c8(s4, s8, s12);
                                        s0 = s1;
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseSignal() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

      s0 = peg$currPos;
      s1 = peg$parseSignalName();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 91) {
            s3 = peg$c9;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c10);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseNaturalInteger();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 93) {
                    s7 = peg$c11;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c12);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c13(s1, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseSignalName();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 91) {
              s3 = peg$c9;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c10);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseNaturalInteger();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_();
                  if (s6 !== peg$FAILED) {
                    s7 = peg$parseDotDot();
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parse_();
                      if (s8 !== peg$FAILED) {
                        s9 = peg$parseNaturalInteger();
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parse_();
                          if (s10 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 93) {
                              s11 = peg$c11;
                              peg$currPos++;
                            } else {
                              s11 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c12);
                              }
                            }
                            if (s11 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c14(s1, s5, s9);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseSignalName();
          if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 91) {
                s3 = peg$c9;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c10);
                }
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                  s5 = peg$parseNaturalInteger();
                  if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                      s7 = peg$parseDotDot();
                      if (s7 !== peg$FAILED) {
                        s8 = peg$parse_();
                        if (s8 !== peg$FAILED) {
                          s9 = peg$parseNaturalInteger();
                          if (s9 !== peg$FAILED) {
                            s10 = peg$parse_();
                            if (s10 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 93) {
                                s11 = peg$c11;
                                peg$currPos++;
                              } else {
                                s11 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c12);
                                }
                              }
                              if (s11 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c14(s1, s5, s9);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseSignalName();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c15(s1);
            }
            s0 = s1;
          }
        }
      }

      return s0;
    }

    function peg$parseSignalCompound() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parseSignal();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 38) {
            s5 = peg$c16;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c17);
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseSignal();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 38) {
              s5 = peg$c16;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c17);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseSignal();
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c18(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseSignalOrLiteralCompound() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parseSignal();
      if (s1 === peg$FAILED) {
        s1 = peg$parseLiteralValue();
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 38) {
            s5 = peg$c16;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c17);
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseSignal();
              if (s7 === peg$FAILED) {
                s7 = peg$parseLiteralValue();
              }
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 38) {
              s5 = peg$c16;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c17);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseSignal();
                if (s7 === peg$FAILED) {
                  s7 = peg$parseLiteralValue();
                }
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c19(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseDotDot() {
      var s0;

      if (input.substr(peg$currPos, 2) === peg$c20) {
        s0 = peg$c20;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c21);
        }
      }
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 58) {
          s0 = peg$c22;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c23);
          }
        }
      }

      return s0;
    }

    function peg$parseModuleName() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      if (peg$c25.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c26);
        }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c25.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c26);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c27(s1);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c24);
        }
      }

      return s0;
    }

    function peg$parseSignalName() {
      var s0, s1, s2, s3;

      peg$silentFails++;
      s0 = peg$currPos;
      if (peg$c29.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c30);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c25.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c26);
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          if (peg$c25.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c26);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c31(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c28);
        }
      }

      return s0;
    }

    function peg$parseStateName() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      if (peg$c25.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c26);
        }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c25.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c26);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c33(s1);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c32);
        }
      }

      return s0;
    }

    function peg$parseParamList() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = peg$parseSignal();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsesepar();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseParamList();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c34(s1, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseSignal();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c35(s1);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseArgList() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = peg$parseSignalOrLiteralCompound();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsesepar();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseArgList();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c34(s1, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseSignalOrLiteralCompound();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c36(s1);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseInstanceList() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$parseInstance();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseInstanceList();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseInstance();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c37(s1);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseInstance() {
      var s0;

      s0 = peg$parseModuleInstance();
      if (s0 === peg$FAILED) {
        s0 = peg$parseTriState();
        if (s0 === peg$FAILED) {
          s0 = peg$parseAssignment();
          if (s0 === peg$FAILED) {
            s0 = peg$parseMemoryPoint();
            if (s0 === peg$FAILED) {
              s0 = peg$parseFsm();
              if (s0 === peg$FAILED) {
                s0 = peg$parseMap();
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseSumOfTermsCompound() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parseSumOfTerms();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 38) {
            s5 = peg$c16;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c17);
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseSumOfTerms();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 38) {
              s5 = peg$c16;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c17);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseSumOfTerms();
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c38(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseSumOfTerms() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parseTerm();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 43) {
            s5 = peg$c39;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c40);
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseTerm();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 43) {
              s5 = peg$c39;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c40);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseTerm();
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c41(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseTerm() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parseFactor();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 42) {
            s5 = peg$c42;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c43);
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parseFactor();
              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 42) {
              s5 = peg$c42;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c43);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseFactor();
                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c44(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseFactor() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s1 = peg$c2;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c3);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseSumOfTerms();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s5 = peg$c4;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c5);
                }
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c45(s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 48) {
          s1 = peg$c46;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c47);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c48();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 49) {
            s1 = peg$c49;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c50);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c51();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseBitField();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c52(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseSignal();
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c53(s1);
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 47) {
                  s1 = peg$c54;
                  peg$currPos++;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c55);
                  }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$parse_();
                  if (s2 !== peg$FAILED) {
                    s3 = peg$parseSignal();
                    if (s3 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c56(s3);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseAssignment() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = peg$parseSignalCompound();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 61) {
            s3 = peg$c57;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c58);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseSumOfTermsCompound();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c59(s1, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseTriState() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;

      s0 = peg$currPos;
      s1 = peg$parseSignalCompound();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 61) {
            s3 = peg$c57;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c58);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseSumOfTermsCompound();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.substr(peg$currPos, 6) === peg$c60) {
                    s7 = peg$c60;
                    peg$currPos += 6;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c61);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      if (input.substr(peg$currPos, 7) === peg$c62) {
                        s9 = peg$c62;
                        peg$currPos += 7;
                      } else {
                        s9 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c63);
                        }
                      }
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.substr(peg$currPos, 4) === peg$c64) {
                            s11 = peg$c64;
                            peg$currPos += 4;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c65);
                            }
                          }
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();
                            if (s12 !== peg$FAILED) {
                              s13 = peg$parseSumOfTerms();
                              if (s13 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c66(s1, s5, s13);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseMemoryPoint() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19, s20, s21, s22, s23, s24, s25;

      s0 = peg$currPos;
      s1 = peg$parseSignalCompound();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c67) {
            s3 = peg$c67;
            peg$currPos += 2;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c68);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseSumOfTermsCompound();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.substr(peg$currPos, 2) === peg$c69) {
                    s7 = peg$c69;
                    peg$currPos += 2;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c70);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseSumOfTerms();
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 44) {
                            s11 = peg$c71;
                            peg$currPos++;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c72);
                            }
                          }
                          if (s11 === peg$FAILED) {
                            s11 = null;
                          }
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();
                            if (s12 !== peg$FAILED) {
                              if (input.substr(peg$currPos, 5) === peg$c73) {
                                s13 = peg$c73;
                                peg$currPos += 5;
                              } else {
                                s13 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c74);
                                }
                              }
                              if (s13 === peg$FAILED) {
                                if (input.substr(peg$currPos, 3) === peg$c75) {
                                  s13 = peg$c75;
                                  peg$currPos += 3;
                                } else {
                                  s13 = peg$FAILED;
                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c76);
                                  }
                                }
                              }
                              if (s13 !== peg$FAILED) {
                                s14 = peg$parse_();
                                if (s14 !== peg$FAILED) {
                                  if (input.substr(peg$currPos, 4) === peg$c64) {
                                    s15 = peg$c64;
                                    peg$currPos += 4;
                                  } else {
                                    s15 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$c65);
                                    }
                                  }
                                  if (s15 !== peg$FAILED) {
                                    s16 = peg$parse_();
                                    if (s16 !== peg$FAILED) {
                                      s17 = peg$parseSumOfTerms();
                                      if (s17 !== peg$FAILED) {
                                        s18 = peg$parse_();
                                        if (s18 !== peg$FAILED) {
                                          if (input.charCodeAt(peg$currPos) === 44) {
                                            s19 = peg$c71;
                                            peg$currPos++;
                                          } else {
                                            s19 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                              peg$fail(peg$c72);
                                            }
                                          }
                                          if (s19 === peg$FAILED) {
                                            s19 = null;
                                          }
                                          if (s19 !== peg$FAILED) {
                                            s20 = peg$parse_();
                                            if (s20 !== peg$FAILED) {
                                              if (input.substr(peg$currPos, 7) === peg$c62) {
                                                s21 = peg$c62;
                                                peg$currPos += 7;
                                              } else {
                                                s21 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                  peg$fail(peg$c63);
                                                }
                                              }
                                              if (s21 !== peg$FAILED) {
                                                s22 = peg$parse_();
                                                if (s22 !== peg$FAILED) {
                                                  if (input.substr(peg$currPos, 4) === peg$c64) {
                                                    s23 = peg$c64;
                                                    peg$currPos += 4;
                                                  } else {
                                                    s23 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                      peg$fail(peg$c65);
                                                    }
                                                  }
                                                  if (s23 !== peg$FAILED) {
                                                    s24 = peg$parse_();
                                                    if (s24 !== peg$FAILED) {
                                                      s25 = peg$parseSumOfTerms();
                                                      if (s25 !== peg$FAILED) {
                                                        peg$savedPos = s0;
                                                        s1 = peg$c77(s1, s5, s9, s13, s17, s25);
                                                        s0 = s1;
                                                      } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                      }
                                                    } else {
                                                      peg$currPos = s0;
                                                      s0 = peg$FAILED;
                                                    }
                                                  } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                  }
                                                } else {
                                                  peg$currPos = s0;
                                                  s0 = peg$FAILED;
                                                }
                                              } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                              }
                                            } else {
                                              peg$currPos = s0;
                                              s0 = peg$FAILED;
                                            }
                                          } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                          }
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseSignalCompound();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c67) {
              s3 = peg$c67;
              peg$currPos += 2;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c68);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseSumOfTermsCompound();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_();
                  if (s6 !== peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c69) {
                      s7 = peg$c69;
                      peg$currPos += 2;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c70);
                      }
                    }
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parse_();
                      if (s8 !== peg$FAILED) {
                        s9 = peg$parseSumOfTerms();
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parse_();
                          if (s10 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 44) {
                              s11 = peg$c71;
                              peg$currPos++;
                            } else {
                              s11 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c72);
                              }
                            }
                            if (s11 === peg$FAILED) {
                              s11 = null;
                            }
                            if (s11 !== peg$FAILED) {
                              s12 = peg$parse_();
                              if (s12 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 5) === peg$c73) {
                                  s13 = peg$c73;
                                  peg$currPos += 5;
                                } else {
                                  s13 = peg$FAILED;
                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c74);
                                  }
                                }
                                if (s13 === peg$FAILED) {
                                  if (input.substr(peg$currPos, 3) === peg$c75) {
                                    s13 = peg$c75;
                                    peg$currPos += 3;
                                  } else {
                                    s13 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$c76);
                                    }
                                  }
                                }
                                if (s13 !== peg$FAILED) {
                                  s14 = peg$parse_();
                                  if (s14 !== peg$FAILED) {
                                    if (input.substr(peg$currPos, 4) === peg$c64) {
                                      s15 = peg$c64;
                                      peg$currPos += 4;
                                    } else {
                                      s15 = peg$FAILED;
                                      if (peg$silentFails === 0) {
                                        peg$fail(peg$c65);
                                      }
                                    }
                                    if (s15 !== peg$FAILED) {
                                      s16 = peg$parse_();
                                      if (s16 !== peg$FAILED) {
                                        s17 = peg$parseSumOfTerms();
                                        if (s17 !== peg$FAILED) {
                                          peg$savedPos = s0;
                                          s1 = peg$c78(s1, s5, s9, s13, s17);
                                          s0 = s1;
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseModuleInstance() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parseModuleName();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 40) {
            s3 = peg$c2;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c3);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseArgList();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 41) {
                    s7 = peg$c4;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c5);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c79(s1, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 36) {
          s1 = peg$c80;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c81);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parseModuleName();
          if (s2 !== peg$FAILED) {
            s3 = peg$parse_();
            if (s3 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 40) {
                s4 = peg$c2;
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c3);
                }
              }
              if (s4 !== peg$FAILED) {
                s5 = peg$parse_();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parseArgList();
                  if (s6 !== peg$FAILED) {
                    s7 = peg$parse_();
                    if (s7 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c4;
                        peg$currPos++;
                      } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c5);
                        }
                      }
                      if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c82(s2, s6);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseMap() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 3) === peg$c83) {
        s1 = peg$c83;
        peg$currPos += 3;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c84);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseSignalCompound();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c85) {
                s5 = peg$c85;
                peg$currPos += 2;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c86);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parseSignalCompound();
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = [];
                      s10 = peg$parseMapValue();
                      while (s10 !== peg$FAILED) {
                        s9.push(s10);
                        s10 = peg$parseMapValue();
                      }
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.substr(peg$currPos, 3) === peg$c6) {
                            s11 = peg$c6;
                            peg$currPos += 3;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c7);
                            }
                          }
                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();
                            if (s12 !== peg$FAILED) {
                              if (input.substr(peg$currPos, 3) === peg$c83) {
                                s13 = peg$c83;
                                peg$currPos += 3;
                              } else {
                                s13 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c84);
                                }
                              }
                              if (s13 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c87(s3, s7, s9);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseMapValue() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      s1 = peg$parseBitField();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c85) {
            s3 = peg$c85;
            peg$currPos += 2;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c86);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseBitField();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c88(s1, s5);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseFsm() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

      s0 = peg$currPos;
      s1 = peg$parseFsmKeyword();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseFsmHeader();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseFsmRules();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.substr(peg$currPos, 3) === peg$c6) {
                    s7 = peg$c6;
                    peg$currPos += 3;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c7);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseFsmKeyword();
                      if (s9 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c89(s3, s5);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseFsmKeyword() {
      var s0;

      if (input.substr(peg$currPos, 3) === peg$c90) {
        s0 = peg$c90;
        peg$currPos += 3;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c91);
        }
      }
      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 12) === peg$c92) {
          s0 = peg$c92;
          peg$currPos += 12;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c93);
          }
        }
      }

      return s0;
    }

    function peg$parseFsmHeader() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 12) === peg$c94) {
        s1 = peg$c94;
        peg$currPos += 12;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c95);
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c96();
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseStateName();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c64) {
              s3 = peg$c64;
              peg$currPos += 4;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c65);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseSumOfTerms();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_();
                  if (s6 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s7 = peg$c71;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c72);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = null;
                    }
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parse_();
                      if (s8 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 11) === peg$c97) {
                          s9 = peg$c97;
                          peg$currPos += 11;
                        } else {
                          s9 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c98);
                          }
                        }
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parse_();
                          if (s10 !== peg$FAILED) {
                            if (input.substr(peg$currPos, 2) === peg$c69) {
                              s11 = peg$c69;
                              peg$currPos += 2;
                            } else {
                              s11 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c70);
                              }
                            }
                            if (s11 !== peg$FAILED) {
                              s12 = peg$parse_();
                              if (s12 !== peg$FAILED) {
                                s13 = peg$parseSumOfTerms();
                                if (s13 !== peg$FAILED) {
                                  peg$savedPos = s0;
                                  s1 = peg$c99(s1, s5, s13);
                                  s0 = s1;
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 11) === peg$c97) {
            s1 = peg$c97;
            peg$currPos += 11;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c98);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c69) {
                s3 = peg$c69;
                peg$currPos += 2;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c70);
                }
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                  s5 = peg$parseSumOfTerms();
                  if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (s6 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 44) {
                        s7 = peg$c71;
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c72);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = null;
                      }
                      if (s7 !== peg$FAILED) {
                        s8 = peg$parse_();
                        if (s8 !== peg$FAILED) {
                          s9 = peg$parseStateName();
                          if (s9 !== peg$FAILED) {
                            s10 = peg$parse_();
                            if (s10 !== peg$FAILED) {
                              if (input.substr(peg$currPos, 4) === peg$c64) {
                                s11 = peg$c64;
                                peg$currPos += 4;
                              } else {
                                s11 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c65);
                                }
                              }
                              if (s11 !== peg$FAILED) {
                                s12 = peg$parse_();
                                if (s12 !== peg$FAILED) {
                                  s13 = peg$parseSumOfTerms();
                                  if (s13 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c100(s5, s9, s13);
                                    s0 = s1;
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }

      return s0;
    }

    function peg$parseFsmRule() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

      s0 = peg$currPos;
      s1 = peg$parseFsmRuleLeft();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c85) {
            s3 = peg$c85;
            peg$currPos += 2;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c86);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseStateName();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.substr(peg$currPos, 4) === peg$c64) {
                    s7 = peg$c64;
                    peg$currPos += 4;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c65);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseSumOfTerms();
                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();
                        if (s10 !== peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 59) {
                            s11 = peg$c101;
                            peg$currPos++;
                          } else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$c102);
                            }
                          }
                          if (s11 === peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 44) {
                              s11 = peg$c71;
                              peg$currPos++;
                            } else {
                              s11 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c72);
                              }
                            }
                          }
                          if (s11 === peg$FAILED) {
                            s11 = null;
                          }
                          if (s11 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c103(s1, s5, s9);
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseFsmRuleLeft();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c85) {
              s3 = peg$c85;
              peg$currPos += 2;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c86);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseStateName();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c104(s1, s5);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseFsmRuleLeft() {
      var s0;

      s0 = peg$parseStateNameList();
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 42) {
          s0 = peg$c42;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c43);
          }
        }
      }

      return s0;
    }

    function peg$parseFsmRules() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$parseFsmRule();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseFsmRules();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseFsmRule();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c105(s1);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseStateNameList() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = peg$parseStateName();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c71;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c72);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseStateNameList();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c34(s1, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseStateName();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c106(s1);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseBitField() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 34) {
        s1 = peg$c107;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c108);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c109.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c110);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            if (peg$c109.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c110);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 34) {
            s3 = peg$c107;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c108);
            }
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c111(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseLiteralValue() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parseBitField();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c112(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 48) {
          s1 = peg$c46;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c47);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c113();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 49) {
            s1 = peg$c49;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c50);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c114();
          }
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseNaturalInteger() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      if (peg$c115.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c116);
        }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c115.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c116);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c117();
      }
      s0 = s1;

      return s0;
    }

    function peg$parsesepar() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 44) {
        s1 = peg$c71;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c72);
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c118();
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 58) {
          s1 = peg$c22;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c23);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c118();
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsewhiteSpace();
      if (s2 === peg$FAILED) {
        s2 = peg$parselineTerminator();
        if (s2 === peg$FAILED) {
          s2 = peg$parselineComment();
        }
      }
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsewhiteSpace();
        if (s2 === peg$FAILED) {
          s2 = peg$parselineTerminator();
          if (s2 === peg$FAILED) {
            s2 = peg$parselineComment();
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c120();
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c119);
        }
      }

      return s0;
    }

    function peg$parsewhiteSpace() {
      var s0;

      if (peg$c121.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c122);
        }
      }

      return s0;
    }

    function peg$parselineTerminator() {
      var s0;

      if (peg$c123.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c124);
        }
      }

      return s0;
    }

    function peg$parselineComment() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c125) {
        s1 = peg$c125;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c126);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$currPos;
        peg$silentFails++;
        s5 = peg$parselineTerminator();
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = void 0;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseanyCharacter();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$currPos;
          peg$silentFails++;
          s5 = peg$parselineTerminator();
          peg$silentFails--;
          if (s5 === peg$FAILED) {
            s4 = void 0;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseanyCharacter();
            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 35) {
          s1 = peg$c127;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c128);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$currPos;
          s4 = peg$currPos;
          peg$silentFails++;
          s5 = peg$parselineTerminator();
          peg$silentFails--;
          if (s5 === peg$FAILED) {
            s4 = void 0;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseanyCharacter();
            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            s4 = peg$currPos;
            peg$silentFails++;
            s5 = peg$parselineTerminator();
            peg$silentFails--;
            if (s5 === peg$FAILED) {
              s4 = void 0;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parseanyCharacter();
              if (s5 !== peg$FAILED) {
                s4 = [s4, s5];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          }
          if (s2 !== peg$FAILED) {
            s1 = [s1, s2];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseanyCharacter() {
      var s0;

      if (input.length > peg$currPos) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c129);
        }
      }

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail(peg$endExpectation());
      }

      throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
}();

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {


var utilities = __webpack_require__(95);
var _ = __webpack_require__(13);
var uuidv1 = __webpack_require__(1113);

var uuid = 0;

module.exports = function () {

   return {
      collectEquipotentials: collectEquipotentials,
      checkIOStatus: checkIOStatus

      // Collect the equipotentials of `module` and set its .equipotentials attribute
      // .equipotentials is both an array (with possible empty slots, but still iterable) and a map (name -> equipotential index)
      // It is supposed that all submodules have already been analysed and their equipotentials completed and simplified
   };function collectEquipotentials(moduleName, name2module) {
      var module = name2module[moduleName];
      module.equipotentials = [];
      uuid = 0;

      // collect equipotentials, possibly creating aliases
      for (var i = 0; i < module.structure.instances.length; i++) {
         var instance = module.structure.instances[i];
         var err = void 0;
         if (instance.type === 'assignment') {
            err = collectAssignmentEquipotentials(instance, module.equipotentials);
            if (err) return err;
         } else if (instance.type === 'memory_point') {
            err = collectMemoryPointEquipotentials(instance, module.equipotentials);
            if (err) return err;
         } else if (instance.type === 'tri_state') {
            err = collectTriStateEquipotentials(instance, module.equipotentials);
            if (err) return err;
         } else if (instance.type === 'module_instance') {
            err = collectModuleInstanceEquipotentials(instance, module, name2module);
            if (err) return err;
         } else if (instance.type === 'predefined_module_instance') {
            err = collectPredefinedModuleInstanceEquipotentials(instance, module.equipotentials);
            if (err) return err;
         }
      }

      // update alias indexes in cases of multiple indirections
      module.equipotentials.forEach(function (equipotential) {
         if (equipotential.type === 'alias') {
            // look for real associated equipotential, following indirections
            var realEquipotential = module.equipotentials[equipotential.aliasIndex];
            while (realEquipotential.type === 'alias') {
               realEquipotential = module.equipotentials[realEquipotential.aliasIndex];
            }
            // update .aliasIndex
            equipotential.aliasIndex = realEquipotential.index;
            // update name->equipotential mapping
            module.equipotentials['__' + equipotential.name] = realEquipotential.index;
         }
      });

      // in all instances, replace alias references by their target
      module.equipotentials.forEach(function (equipotential) {
         if (equipotential.type === 'combinatorial') {
            utilities.replaceAliases(equipotential.formula, module.equipotentials);
         } else if (equipotential.type === 'sequential') {
            utilities.replaceAliases(equipotential.formula, module.equipotentials);
            equipotential.clk = utilities.getOriginalEquipotentialIndex(equipotential.clk, module.equipotentials);
            if (equipotential.rst) equipotential.rst = utilities.getOriginalEquipotentialIndex(equipotential.rst, module.equipotentials);
            if (equipotential.set) equipotential.set = utilities.getOriginalEquipotentialIndex(equipotential.set, module.equipotentials);
            if (equipotential.en) equipotential.en = utilities.getOriginalEquipotentialIndex(equipotential.en, module.equipotentials);
         } else if (equipotential.type === 'tri-state') {
            equipotential.sources.forEach(function (source) {
               source.srcEquipotential = utilities.getOriginalEquipotentialIndex(source.srcEquipotential, module.equipotentials);
               source.oeEquipotential = utilities.getOriginalEquipotentialIndex(source.oeEquipotential, module.equipotentials);
            });
         } else if (equipotential.type === 'rom' || equipotential.type === 'ram_aread_swrite') {
            equipotential.addrs = equipotential.addrs.map(function (addr) {
               return utilities.getOriginalEquipotentialIndex(addr, module.equipotentials);
            });
            if (equipotential.type === 'ram_aread_swrite') {
               equipotential.clk = utilities.getOriginalEquipotentialIndex(equipotential.clk, module.equipotentials);
               equipotential.wr = utilities.getOriginalEquipotentialIndex(equipotential.wr, module.equipotentials);
               equipotential.din = utilities.getOriginalEquipotentialIndex(equipotential.din, module.equipotentials);
            }
         }
      });

      // remove aliases
      module.equipotentials.forEach(function (equipotential) {
         if (equipotential.type === 'alias') {
            delete module.equipotentials[equipotential.index];
         }
      });
   }

   function collectAssignmentEquipotentials(assignment, equipotentials) {
      // for each signal of assignment
      var arity = utilities.signalCompoundArity(assignment.leftCompound);
      for (var i = 0; i < arity; i++) {
         // get its associated sum of terms and the local index in it
         var leftSignalName = utilities.signalCompoundAtIndex(assignment.leftCompound, i);

         var _utilities$sumofterms = utilities.sumoftermsCompoundAtIndex(assignment.rightCompound, i),
             sumofterms = _utilities$sumofterms.sumofterms,
             localindex = _utilities$sumofterms.localindex;
         // create or complete assigned equipotential


         var equipotentialIndex = equipotentials["__" + leftSignalName];
         var equipotential = void 0;
         if (equipotentialIndex === undefined) {
            // does not exist yet: create it
            equipotential = utilities.createEquipotential(leftSignalName, equipotentials);
         } else {
            // already exists: complete it
            equipotential = equipotentials[equipotentialIndex];
            if (equipotential.type !== null && !equipotential.isInput) {
               return {
                  message: 'signal \'' + leftSignalName + '\' is assigned several times',
                  location: assignment.leftCompound.location
               };
            }
         }
         // build its associated formula, creating new uncomplete equipotentials when needed
         var formula = sumOfTermsFormula(sumofterms, localindex, equipotentials);
         formula = utilities.simplifyFormula(formula);
         if (formula === "0" || formula === "1") {
            equipotential.type = 'constant';
            equipotential.cvalue = formula === "0" ? 0 : 1;
         } else {
            equipotential.type = 'combinatorial';
            if (formula.op === 'maxterm' && !formula.inverted) {
               // alias
               equipotential.type = 'alias';
               equipotential.aliasIndex = formula.equipotentialIndex;
               equipotentials["__" + leftSignalName] = formula.equipotentialIndex;
            } else {
               equipotential.formula = formula;
            }
         }
      }
   }

   function collectTriStateEquipotentials(assignment, equipotentials) {
      // output enable equipotential
      var oeEquipotential = void 0;
      var oeFormula = utilities.simplifyFormula(sumOfTermsFormula(assignment.oe, 0, equipotentials));
      if (oeFormula.op === 'maxterm' && !oeFormula.inverted) {
         oeEquipotential = equipotentials[oeFormula.equipotentialIndex];
      } else {
         oeEquipotential = utilities.createEquipotential(null, equipotentials);
         oeEquipotential.type = 'combinatorial';
         oeEquipotential.formula = oeFormula;
      }
      // for each signal of assignment
      var arity = utilities.signalCompoundArity(assignment.leftCompound);
      for (var i = 0; i < arity; i++) {
         // get its associated sum of terms and the local index in it
         var leftSignalName = utilities.signalCompoundAtIndex(assignment.leftCompound, i);
         if (leftSignalName === 'areg[4]') {
            leftSignalName = leftSignalName;
         }

         var _utilities$sumofterms2 = utilities.sumoftermsCompoundAtIndex(assignment.rightCompound, i),
             sumofterms = _utilities$sumofterms2.sumofterms,
             localindex = _utilities$sumofterms2.localindex;
         // create or complete tri-state assigned equipotential


         var triStateEquipotentialIndex = equipotentials["__" + leftSignalName];
         var triStateEquipotential = void 0;
         if (triStateEquipotentialIndex === undefined) {
            // does not exist yet: create it
            triStateEquipotential = utilities.createEquipotential(leftSignalName, equipotentials);
            triStateEquipotential.type = 'tri-state';
            triStateEquipotential.sources = [];
         } else {
            // already exists: complete it
            triStateEquipotential = equipotentials[triStateEquipotentialIndex];
            if (triStateEquipotential.type === 'combinatorial') {
               return {
                  message: '\'' + leftSignalName + '\' is assigned both as a combinatorial signal and as a tri-state signal',
                  location: assignment.leftCompound.location
               };
            }
            if (triStateEquipotential.type === null) {
               triStateEquipotential.type = 'tri-state';
               triStateEquipotential.sources = [];
            }
         }
         // source equipotential
         var srcEquipotential = void 0;
         var srcFormula = utilities.simplifyFormula(sumOfTermsFormula(sumofterms, localindex, equipotentials));
         if (srcFormula.op === 'maxterm' && !srcFormula.inverted) {
            srcEquipotential = equipotentials[srcFormula.equipotentialIndex];
         } else {
            srcEquipotential = utilities.createEquipotential(null, equipotentials);
            srcEquipotential.type = 'combinatorial';
            srcEquipotential.formula = srcFormula;
         }
         // add their 2-uple to sources list
         if (triStateEquipotential.sources === undefined) {
            triStateEquipotential = triStateEquipotential;
         }
         triStateEquipotential.sources.push({ srcEquipotential: srcEquipotential.index, oeEquipotential: oeEquipotential.index });
      }
   }

   function collectMemoryPointEquipotentials(memoryPoint, equipotentials) {
      // clk equipotential
      var clkEquipotential = void 0;
      var clkFormula = utilities.simplifyFormula(sumOfTermsFormula(memoryPoint.clk, 0, equipotentials));
      if (clkFormula.op === 'maxterm' && !clkFormula.inverted) {
         clkEquipotential = equipotentials[clkFormula.equipotentialIndex];
      } else {
         clkEquipotential = utilities.createEquipotential(null, equipotentials);
         clkEquipotential.type = 'combinatorial';
         clkEquipotential.formula = clkFormula;
      }
      // rst equipotential
      var rstEquipotential = void 0;
      var rstFormula = utilities.simplifyFormula(sumOfTermsFormula(memoryPoint.rst, 0, equipotentials));
      if (rstFormula.op === 'maxterm' && !rstFormula.inverted) {
         rstEquipotential = equipotentials[rstFormula.equipotentialIndex];
      } else {
         rstEquipotential = utilities.createEquipotential(null, equipotentials);
         rstEquipotential.type = 'combinatorial';
         rstEquipotential.formula = rstFormula;
      }
      var enEquipotential = void 0;
      if (memoryPoint.en) {
         // en equipotential
         var enFormula = utilities.simplifyFormula(sumOfTermsFormula(memoryPoint.en, 0, equipotentials));
         if (enFormula.op === 'maxterm' && !enFormula.inverted) {
            enEquipotential = equipotentials[enFormula.equipotentialIndex];
         } else {
            enEquipotential = utilities.createEquipotential(null, equipotentials);
            enEquipotential.type = 'combinatorial';
            enEquipotential.formula = enFormula;
         }
      }

      // for each signal of left side of ':='
      var arity = utilities.signalCompoundArity(memoryPoint.q);
      for (var i = 0; i < arity; i++) {
         // get its associated sum of terms and the local index in it
         var leftSignalName = utilities.signalCompoundAtIndex(memoryPoint.q, i);

         var _utilities$sumofterms3 = utilities.sumoftermsCompoundAtIndex(memoryPoint.d, i),
             sumofterms = _utilities$sumofterms3.sumofterms,
             localindex = _utilities$sumofterms3.localindex;
         // create or complete assigned equipotential


         var equipotential = void 0;
         var equipotentialIndex = equipotentials["__" + leftSignalName];
         if (equipotentialIndex === undefined) {
            // does not exist yet: create it
            equipotential = utilities.createEquipotential(leftSignalName, equipotentials);
         } else {
            // already exists: complete it
            equipotential = equipotentials[equipotentialIndex];
            if (equipotential.type !== null && !equipotential.isInput) {
               return {
                  message: 'signal \'' + leftSignalName + '\' is assigned several times',
                  location: memoryPoint.q.location
               };
            }
         }
         equipotential.type = 'sequential';
         // build its associated formula, creating new uncomplete equipotentials when needed
         var formula = utilities.simplifyFormula(sumOfTermsFormula(sumofterms, localindex, equipotentials));
         equipotential.formula = formula;
         equipotential.clk = clkEquipotential.index;
         if (memoryPoint.setReset === 'reset') {
            equipotential.rst = rstEquipotential.index;
         } else if (memoryPoint.setReset === 'set') {
            equipotential.set = rstEquipotential.index;
         }
         if (enEquipotential) {
            equipotential.en = enEquipotential.index;
         }
      }
   }

   function collectModuleInstanceEquipotentials(instance, module, name2module) {
      var submodule = name2module[instance.name];
      var submoduleArity = utilities.argumentsArity(instance.arguments);
      var mapping = {};
      var toApply = [];
      // connect input equipotentials, and add outputs equipotentials
      for (var i = 0; i < submoduleArity; i++) {
         var argName = utilities.argumentAtIndex(instance.arguments, i); // argName may be a constant '>0' or '>1'
         var paramName = utilities.parametersNameAtIndex(submodule.structure.params, i);
         var paramIndex = submodule.equipotentials["__" + paramName];
         // check if it has been treated already (alias parameter)
         if (mapping[paramIndex] !== undefined) {
            module.equipotentials["__" + argName] = mapping[paramIndex];
            continue;
         }
         var paramEquipotential = submodule.equipotentials[paramIndex];
         if (paramEquipotential.isInput) {
            // input
            // get or create it in module.equipotentials
            var equipotential = void 0;
            var equipotentialIndex = module.equipotentials["__" + argName];
            if (equipotentialIndex === undefined) {
               equipotential = utilities.createEquipotential(argName, module.equipotentials);
               if (argName === '>0' || argName === '>1') {
                  equipotential.type = 'constant';
                  equipotential.cvalue = argName === '>0' ? 0 : 1;
               } else {
                  equipotential.type = null;
               }
            } else {
               equipotential = module.equipotentials[equipotentialIndex];
            }
            // add entry to mapping
            mapping[paramIndex] = equipotential.index;
         } else {
            // output or null
            // check first that an equipotential of this name does not already exist
            if (module.equipotentials["__" + argName] === undefined) {
               // copy paramEquipotential
               var equipotentialCopy = {
                  name: argName
               };
               copySubmoduleEquipotential(paramEquipotential, equipotentialCopy);
               utilities.addEquipotential(equipotentialCopy, module.equipotentials);
               // add entry to mapping
               mapping[paramIndex] = equipotentialCopy.index;
               toApply.push(equipotentialCopy);
            } else {
               var eqIndex = module.equipotentials["__" + argName];
               var eq = module.equipotentials[eqIndex];
               if (eq.type !== null) {
                  return {
                     message: 'signal \'' + argName + '\' is assigned several times',
                     location: instance.location
                  };
               }
               copySubmoduleEquipotential(paramEquipotential, eq);
               mapping[paramIndex] = eq.index;
               toApply.push(eq);
            }
         }
      }
      // then add remaining, not unused internal submodule equipotentials
      submodule.equipotentials.forEach(function (submoduleEquipotential) {
         if (!submoduleEquipotential.isUnused && mapping[submoduleEquipotential.index] === undefined) {
            // copy internal equipotential
            var _equipotentialCopy = {
               name: null
            };
            copySubmoduleEquipotential(submoduleEquipotential, _equipotentialCopy);
            utilities.addEquipotential(_equipotentialCopy, module.equipotentials);
            // add entry to mapping
            mapping[submoduleEquipotential.index] = _equipotentialCopy.index;
            toApply.push(_equipotentialCopy);
         }
      });
      // console.log('toApply', toApply, 'mapping', mapping)
      // apply `mapping` to all equipotentials of `toApply`
      toApply.forEach(function (equipotential) {
         if (equipotential.type === 'combinatorial') {
            utilities.updateFormulaIndexes(equipotential.formula, mapping);
         } else if (equipotential.type === 'sequential') {
            utilities.updateFormulaIndexes(equipotential.formula, mapping);
            equipotential.clk = mapping[equipotential.clk];
            if (equipotential.rst !== undefined) {
               equipotential.rst = mapping[equipotential.rst];
            }
            if (equipotential.set !== undefined) {
               equipotential.set = mapping[equipotential.set];
            }
            if (equipotential.en !== undefined) {
               equipotential.en = mapping[equipotential.en];
            }
         } else if (equipotential.type === 'tri-state') {
            equipotential.sources.forEach(function (source) {
               source.srcEquipotential = mapping[source.srcEquipotential];
               source.oeEquipotential = mapping[source.oeEquipotential];
            });
         } else if (equipotential.type === 'rom') {
            equipotential.addrs = equipotential.addrs.map(function (index) {
               return mapping[index];
            });
         } else if (equipotential.type === 'ram_aread_swrite') {
            equipotential.clk = mapping[equipotential.clk];
            equipotential.wr = mapping[equipotential.wr];
            equipotential.addrs = equipotential.addrs.map(function (index) {
               return mapping[index];
            });
            equipotential.din = mapping[equipotential.din];
         }
      });
   }

   function copySubmoduleEquipotential(equipotentialSrc, equipotentialDest) {
      equipotentialDest.type = equipotentialSrc.type;

      if (equipotentialSrc.type === 'combinatorial') {
         // copy assignment formule
         equipotentialDest.formula = _.cloneDeep(equipotentialSrc.formula);
      } else if (equipotentialSrc.type === 'sequential') {
         // copy evolution formula
         equipotentialDest.formula = _.cloneDeep(equipotentialSrc.formula);
         // link clk equipotential
         equipotentialDest.clk = equipotentialSrc.clk;
         // link rst/set/en equipotential, if exists
         if (equipotentialSrc.rst !== undefined) {
            equipotentialDest.rst = equipotentialSrc.rst;
         }
         if (equipotentialSrc.set !== undefined) {
            equipotentialDest.set = equipotentialSrc.set;
         }
         if (equipotentialSrc.en !== undefined) {
            equipotentialDest.en = equipotentialSrc.en;
         }
      } else if (equipotentialSrc.type === 'tri-state') {
         equipotentialDest.sources = equipotentialSrc.sources.map(function (source) {
            return { srcEquipotential: source.srcEquipotential, oeEquipotential: source.oeEquipotential };
         });
      } else if (equipotentialSrc.type === 'constant') {
         equipotentialDest.cvalue = equipotentialSrc.cvalue;
      } else if (equipotentialSrc.type === 'rom' || equipotentialSrc.type === 'ram_aread_swrite') {
         equipotentialDest.memUUID = equipotentialSrc.memUUID;
         equipotentialDest.memOutIndex = equipotentialSrc.memOutIndex;
         // link addr equipotentials
         equipotentialDest.addrs = equipotentialSrc.addrs.map(function (addr) {
            return addr;
         });
         // create dict (holds memory values)
         equipotentialDest.dict = {};
         if (equipotentialSrc.type === 'ram_aread_swrite') {
            // link clk, wr & din equipotentials
            equipotentialDest.clk = equipotentialSrc.clk;
            equipotentialDest.wr = equipotentialSrc.wr;
            equipotentialDest.din = equipotentialSrc.din;
         }
      }
      return equipotentialDest;
   }

   function collectPredefinedModuleInstanceEquipotentials(predefinedModule, equipotentials) {
      if (predefinedModule.name === 'rom') {
         var memUUID = uuid++;
         predefinedModule.memUUID = memUUID;
         // addr equipotentials
         var addrs = [];
         var addrArity = utilities.argumentArity(predefinedModule.arguments[0]);
         for (var i = 0; i < addrArity; i++) {
            var addrName = utilities.argumentAt(predefinedModule.arguments[0], i);
            var addrEquipotentialIndex = equipotentials["__" + addrName];
            if (addrEquipotentialIndex === undefined) {
               var addrEquipotential = utilities.createEquipotential(addrName, equipotentials);
               addrEquipotentialIndex = addrEquipotential.index;
               if (addrName === '>0' || addrName === '>1') {
                  addrEquipotential.type = 'constant';
                  addrEquipotential.cvalue = addrName === '>0' ? 0 : 1;
               } else {
                  addrEquipotential.type = null;
               }
            }
            addrs.push(addrEquipotentialIndex);
         }
         // data-out equipotentials
         var doutArguments = predefinedModule.arguments[1];
         var doutArity = utilities.argumentArity(doutArguments);
         for (var _i = 0; _i < doutArity; _i++) {
            var doutName = utilities.argumentAt(doutArguments, _i);
            if (doutName === '>0' || doutName === '>1') {
               return {
                  message: 'data-out argument of instance of $rom cannot contain constants',
                  location: predefinedModule.location
               };
            }
            var doutEquipotential = void 0;
            var doutEquipotentialIndex = equipotentials["__" + doutName];
            if (doutEquipotentialIndex === undefined) {
               doutEquipotential = utilities.createEquipotential(doutName, equipotentials);
            } else {
               doutEquipotential = equipotentials[doutEquipotentialIndex];
            }
            doutEquipotential.type = 'rom';
            doutEquipotential.addrs = addrs;
            doutEquipotential.dict = {};
            doutEquipotential.memUUID = memUUID;
            doutEquipotential.memOutIndex = doutArity - _i - 1;
         }
      } else if (predefinedModule.name === 'ram_aread_swrite') {
         var _memUUID = uuid++;
         predefinedModule.memUUID = _memUUID;
         // clk equipotential
         var clkName = utilities.argumentAt(predefinedModule.arguments[0], 0);
         var clkEquipotentialIndex = equipotentials["__" + clkName];
         if (clkEquipotentialIndex === undefined) {
            var clkEquipotential = utilities.createEquipotential(clkName, equipotentials);
            clkEquipotentialIndex = clkEquipotential.index;
            if (clkName === '>0' || clkName === '>1') {
               clkEquipotential.type = 'constant';
               clkEquipotential.cvalue = clkName === '>0' ? 0 : 1;
            } else {
               clkEquipotential.type = null;
            }
         }
         // wr equipotential
         var wrName = utilities.argumentAt(predefinedModule.arguments[1], 0);
         var wrEquipotentialIndex = equipotentials["__" + wrName];
         if (wrEquipotentialIndex === undefined) {
            var wrEquipotential = utilities.createEquipotential(wrName, equipotentials);
            wrEquipotentialIndex = wrEquipotential.index;
            if (wrName === '>0' || wrName === '>1') {
               wrEquipotential.type = 'constant';
               wrEquipotential.cvalue = wrName === '>0' ? 0 : 1;
            } else {
               wrEquipotential.type = null;
            }
         }
         // addr equipotentials
         var _addrs = [];
         var _addrArity = utilities.argumentArity(predefinedModule.arguments[2]);
         for (var _i2 = 0; _i2 < _addrArity; _i2++) {
            var _addrName = utilities.argumentAt(predefinedModule.arguments[2], _i2);
            var _addrEquipotentialIndex = equipotentials["__" + _addrName];
            if (_addrEquipotentialIndex === undefined) {
               var _addrEquipotential = utilities.createEquipotential(_addrName, equipotentials);
               _addrEquipotentialIndex = _addrEquipotential.index;
               if (_addrName === '>0' || _addrName === '>1') {
                  _addrEquipotential.type = 'constant';
                  _addrEquipotential.cvalue = _addrName === '>0' ? 0 : 1;
               } else {
                  _addrEquipotential.type = null;
               }
            }
            _addrs.push(_addrEquipotentialIndex);
         }
         // data-in / data-out equipotentials
         var dinArity = utilities.argumentArity(predefinedModule.arguments[3]);
         for (var _i3 = 0; _i3 < dinArity; _i3++) {
            var dinName = utilities.argumentAt(predefinedModule.arguments[3], _i3);
            var dinEquipotentialIndex = equipotentials["__" + dinName];
            if (dinEquipotentialIndex === undefined) {
               var dinEquipotential = utilities.createEquipotential(dinName, equipotentials);
               dinEquipotentialIndex = dinEquipotential.index;
               if (dinName === '>0' || dinName === '>1') {
                  dinEquipotential.type = 'constant';
                  dinEquipotential.cvalue = dinName === '>0' ? 0 : 1;
               } else {
                  dinEquipotential.type = null;
               }
            }

            var _doutName = utilities.argumentAt(predefinedModule.arguments[4], _i3);
            if (_doutName === '>0' || _doutName === '>1') {
               return {
                  message: 'data-out argument of instance of $ram cannot contain constants',
                  location: predefinedModule.location
               };
            }
            var _doutEquipotential = void 0;
            var _doutEquipotentialIndex = equipotentials["__" + _doutName];
            if (_doutEquipotentialIndex === undefined) {
               _doutEquipotential = utilities.createEquipotential(_doutName, equipotentials);
            } else {
               _doutEquipotential = equipotentials[_doutEquipotentialIndex];
            }
            _doutEquipotential.type = 'ram_aread_swrite';
            _doutEquipotential.clk = clkEquipotentialIndex;
            _doutEquipotential.wr = wrEquipotentialIndex;
            _doutEquipotential.addrs = _addrs;
            _doutEquipotential.din = dinEquipotentialIndex;
            _doutEquipotential.dict = {};
            _doutEquipotential.memUUID = _memUUID;
            _doutEquipotential.memOutIndex = dinArity - _i3 - 1;
         }
      }
   }

   // Create a formula from syntactic description `sumOfTerms`. `i` is a local index in the sum of terms
   // This is where anonymous equipotentials are created
   function sumOfTermsFormula(sumOfTerms, i, equipotentials) {
      var formula = { op: 'or', args: [] };
      sumOfTerms.terms.forEach(function (term) {
         var termFormula = { op: 'and', args: [] };
         term.factors.forEach(function (factor) {
            var factorFormula = void 0;
            // add computation information
            if (factor.type === 'bitfield') {
               factorFormula = factor.value[i];
            } else if (factor.type === 'maxterm') {
               // get equipotential name
               var equipotentialName = void 0;
               if (factor.signal.type === 'scalar') {
                  equipotentialName = factor.signal.name;
               } else if (factor.signal.type === 'vector') {
                  if (factor.signal.start === factor.signal.stop) {
                     // scalar product
                     equipotentialName = factor.signal.name + '[' + factor.signal.start + ']';
                  } else {
                     equipotentialName = factor.signal.name + '[' + (factor.signal.start - i) + ']';
                  }
               }
               var equipotentialIndex = equipotentials["__" + equipotentialName];
               if (equipotentialIndex === undefined) {
                  // create an uncomplete equipotential for this name
                  equipotentialIndex = equipotentials.length;
                  var equipotential = {
                     type: null,
                     name: equipotentialName,
                     index: equipotentialIndex
                     // `equipotentials` is an array
                  };equipotentials.push(equipotential);
                  // and a map
                  equipotentials["__" + equipotentialName] = equipotentialIndex;
               }
               factorFormula = {
                  op: 'maxterm',
                  inverted: factor.inverted,
                  equipotentialIndex: equipotentialIndex
               };
            } else if (factor.type === 'sumofterms') {
               var sotFormula = utilities.simplifyFormula(sumOfTermsFormula(factor.sumofterms, i, equipotentials));
               // create a new, unnamed equipotential
               var _equipotentialIndex = equipotentials.length;
               var unnamedEquipotential = {
                  type: 'combinatorial',
                  name: null,
                  index: _equipotentialIndex,
                  formula: sotFormula
               };
               equipotentials.push(unnamedEquipotential);
               factorFormula = {
                  op: 'maxterm',
                  inverted: false,
                  equipotentialIndex: _equipotentialIndex
               };
            }
            termFormula.args.push(factorFormula);
         });
         formula.args.push(termFormula);
      });
      return formula;
   }

   // Check that all equipotentials have a type (among 'constant', 'combinatorial', 'sequential', 'tri-state', 'ram_aread_swrite')
   // or have type = null and are present in parameters as inputs
   // For each equipotential, set their I/O status
   function checkIOStatus(module) {
      // check that all parameters are present in module.equipotentials
      for (var i = 0; i < module.structure.params.length; i++) {
         var parameter = module.structure.params[i];
         var parameterArity = utilities.parameterArity(parameter);
         for (var j = 0; j < parameterArity; j++) {
            var signalName = utilities.parameterNameAtIndex(parameter, j);
            var equipotentialIndex = module.equipotentials["__" + signalName];
            if (equipotentialIndex === undefined) {
               return {
                  message: 'unused parameter ' + signalName,
                  location: parameter.location
               };
            }
            var equipotential = module.equipotentials[equipotentialIndex];
            if (equipotential.type === null) {
               equipotential.isInput = true;
               equipotential.isOutput = false;
            } else {
               equipotential.isInput = false;
               equipotential.isOutput = true;
            }
         }
      }
      // check that all equipotentials with type=null have an input/output status
      for (var _i4 = 0; _i4 < module.equipotentials.length; _i4++) {
         var _equipotential = module.equipotentials[_i4];
         if (_equipotential === undefined) continue; // empty slot (we cannot use forEach because we need 'return')
         if (_equipotential.isInput === undefined && _equipotential.isOutput === undefined) {
            // equipotential has not input/output status: it cannot be a parameter, they have been handled at the previous step
            if (_equipotential.type === null) {
               return {
                  message: 'signal \'' + _equipotential.name + '\' is not a parameter and is not produced',
                  location: null
               };
            } else {
               // internal equipotential
               _equipotential.isInput = false;
               _equipotential.isOutput = false;
            }
         }
      }
   }
}();

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {


var parser = __webpack_require__(663);
//const request = require('sync-request')
var utilities = __webpack_require__(95);
var _ = __webpack_require__(13);
var axios = __webpack_require__(24);

module.exports = function () {

   return {
      pegParse: pegParse,
      pegParseDeep: pegParseDeep,
      //fetchModuleTreeFromServer,

      checkStructure: checkStructure

      ///////////////////////////////////       PEG PARSING           ///////////////////////////////////

      // syntactic analysis by PegJS
   };function pegParse(moduleText) {
      try {
         var structure = parser.parse(moduleText);
         return { err: null, structure: structure };
      } catch (err) {
         return { err: err, structure: null };
      }
   }

   // Perform a peg parsing of `rootModule` and all its submodules
   // Returns a list of modules, unordered
   // Each module of the returned list has its syntactic structure set to its .structure attribute
   function pegParseDeep(rootModuleName, name2module) {
      var toCheck = [rootModuleName];
      var checked = [];
      while (toCheck.length > 0) {
         // get and remove first module from `toCheck`
         var moduleNameToCheck = toCheck[0];
         toCheck.splice(0, 1);
         // check its syntax
         var moduleToCheck = name2module[moduleNameToCheck];

         var _pegParse = pegParse(moduleToCheck.text),
             structure = _pegParse.structure,
             syntacticError = _pegParse.err;

         if (syntacticError) {
            // return error and analysed modules so far
            checked.push(moduleNameToCheck);
            return {
               err: rootModuleName === moduleNameToCheck ? syntacticError : {
                  message: '*** syntax error in submodule \'' + moduleNameToCheck + '\'',
                  location: null
               },
               moduleList: checked.map(function (name) {
                  return name2module[name];
               })
            };
         }
         // add `module` to `checked`
         moduleToCheck.structure = structure;
         checked.push(moduleNameToCheck);
         // get submodule names
         var submoduleNames = structure.instances.filter(function (instance) {
            return instance.type === 'module_instance';
         }).map(function (instance) {
            return instance.name;
         });
         // remove duplicates
         submoduleNames = _.uniq(submoduleNames);

         // add each submodule to `toCheck` 
         for (var i = 0; i < submoduleNames.length; i++) {
            var submoduleName = submoduleNames[i];
            if (name2module[submoduleName]) {
               var alreadyChecked = checked.indexOf(submoduleName) !== -1;
               if (!alreadyChecked) toCheck.push(submoduleName);
            } else {
               return {
                  err: {
                     message: '*** error: unknown module \'' + submoduleName + '\'',
                     location: null
                  },
                  moduleList: checked.map(function (name) {
                     return name2module[name];
                  })
               };
            }
         }
      }
      return {
         err: null,
         moduleList: checked.map(function (name) {
            return name2module[name];
         })
      };
   }

   ///////////////////////////////////       STRUCTURE CHECKING           ///////////////////////////////////

   function checkStructure(moduleName, name2module) {
      var structure = name2module[moduleName].structure;
      var err = void 0;
      err = checkParameters(structure.params);
      if (err) return err;
      for (var i = 0; i < structure.instances.length; i++) {
         var instance = structure.instances[i];
         if (instance.type === 'assignment') {
            err = checkAssignment(instance);
         } else if (instance.type === 'memory_point') {
            err = checkMemoryPoint(instance);
         } else if (instance.type === 'tri_state') {
            err = checkTriState(instance);
         } else if (instance.type === 'module_instance') {
            err = checkModuleInstance(instance, name2module);
         } else if (instance.type === 'predefined_module_instance') {
            err = checkPredefinedModuleInstance(instance);
         }
         if (err) return err;
      }
   }

   function checkParameters(params) {
      // check that vector start/stop are in decreasing order
      var badParam = params.find(function (param) {
         if (param.type !== 'vector') return false;
         if (param.start >= param.stop) return false;
         return true;
      });
      if (badParam) {
         return {
            message: 'indexes for vector parameter \'' + badParam.name + '\' must be in decreasing order',
            location: badParam.location
         };
      }
   }

   function checkAssignment(assignment) {
      // check that vector indexes are in decreasing order in left signal compound
      var err = checkSignalCompoundIndexOrdering(assignment.leftCompound);
      if (err) return err;
      // check right-hand sum-of-terms compound: decreasing vector indexes, same arity for all terms in sum-of-terms
      err = checkSumOfTermsCompound(assignment.rightCompound);
      if (err) return err;
      // check that arity is the same on both sides
      var leftArity = utilities.signalCompoundArity(assignment.leftCompound);
      var rightArity = utilities.sumOfTermsCompoundArity(assignment.rightCompound);
      if (leftArity !== rightArity) {
         return {
            message: 'left side of assignment has an arity of ' + leftArity + ' whereas right side has an arity of ' + rightArity,
            location: assignment.leftCompound.location
         };
      }
   }

   function checkMemoryPoint(memoryPoint) {
      // check that vector indexes are in decreasing order in left part
      var err = checkSignalCompoundIndexOrdering(memoryPoint.q);
      if (err) return err;
      // check right-hand sum-of-terms compound: decreasing vector indexes, same arity for all terms in sum-of-terms
      err = checkSumOfTermsCompound(memoryPoint.d);
      if (err) return err;
      // check that arity is the same on both sides
      var leftArity = utilities.signalCompoundArity(memoryPoint.q);
      var rightArity = utilities.sumOfTermsCompoundArity(memoryPoint.d);
      if (leftArity !== rightArity) {
         return {
            message: 'left side of memory point assignment has an arity of ' + leftArity + ' whereas right side has an arity of ' + rightArity,
            location: memoryPoint.q.location
         };
      }
      // check that arity of 'rst' is 1
      var rstArity = utilities.sumOfTermsArity(memoryPoint.rst);
      if (rstArity !== 1) {
         return {
            message: 'the signal ' + memoryPoint.rst.name + ' must be a scalar, whereas it has an arity of ' + rstArity,
            location: memoryPoint.rst.location
         };
      }
      // check that arity of 'clk' is 1
      var clkArity = utilities.sumOfTermsArity(memoryPoint.clk);
      if (clkArity !== 1) {
         return {
            message: 'the clock signal ' + memoryPoint.rst.name + ' must be a scalar, whereas it has an arity of ' + clkArity,
            location: memoryPoint.rst.location
         };
      }
      if (memoryPoint.en) {
         // check that arity of 'en' is 1
         var enArity = utilities.sumOfTermsArity(memoryPoint.en);
         if (enArity !== 1) {
            return {
               message: 'the clock signal ' + memoryPoint.rst.name + ' must be a scalar, whereas it has an arity of ' + clkArity,
               location: memoryPoint.rst.location
            };
         }
      }
   }

   function checkTriState(assignment) {
      // check that vector indexes are in decreasing order in left signal compound
      var err = checkSignalCompoundIndexOrdering(assignment.leftCompound);
      if (err) return err;
      // check right-hand sum-of-terms compound: decreasing vector indexes, same arity for all terms in sum-of-terms
      err = checkSumOfTermsCompound(assignment.rightCompound);
      if (err) return err;
      // check that arity is the same on both sides
      var leftArity = utilities.signalCompoundArity(assignment.leftCompound);
      var rightArity = utilities.sumOfTermsCompoundArity(assignment.rightCompound);
      if (leftArity !== rightArity) {
         return {
            message: 'left side of tri-state assignment has an arity of ' + leftArity + ' whereas right side has an arity of ' + rightArity,
            location: assignment.leftCompound.location
         };
      }
   }

   function checkModuleInstance(moduleInstance, name2module) {
      var arguments_ = moduleInstance.arguments;
      var parameters = name2module[moduleInstance.name].structure.params;
      if (arguments_.length !== parameters.length) {
         return {
            message: 'wrong number of arguments; there should be ' + parameters.length + ' instead of ' + arguments_.length,
            location: moduleInstance.location
         };
      }
      for (var i = 0; i < parameters.length; i++) {
         var argumentArity = utilities.argumentArity(arguments_[i]);
         var parameterArity = utilities.parameterArity(parameters[i]);
         if (argumentArity !== parameterArity) {
            return {
               message: 'argument #' + (i + 1) + ' should have an arity of ' + parameterArity + ' instead of ' + argumentArity,
               location: moduleInstance.location
            };
         }
      }
   }

   function checkPredefinedModuleInstance(moduleInstance) {
      if (moduleInstance.name === 'ram_aread_swrite') {
         return checkRamAreadSwrite(moduleInstance);
      } else if (moduleInstance.name === 'rom') {
         return undefined;
      } else {
         return {
            message: 'unknown built-in module ' + moduleInstance.name,
            location: moduleInstance.location
         };
      }
   }

   function checkRamAreadSwrite(moduleInstance) {
      // check that 1st argument (clk) has arity 1
      var clkArity = utilities.argumentArity(moduleInstance.arguments[0]);
      if (clkArity !== 1) {
         return {
            message: 'the first argument (clock) ' + moduleInstance.arguments[0] + ' must be a scalar',
            location: moduleInstance.location
         };
      }
      // check that 2nd argument (wr) has arity 1
      var wrArity = utilities.argumentArity(moduleInstance.arguments[1]);
      if (wrArity !== 1) {
         return {
            message: 'the second argument (write) ' + moduleInstance.arguments[1] + ' must be a scalar',
            location: moduleInstance.location
         };
      }
      // check that 4th argument (din) and 5th argument (dout) have same arity
      var dinArity = utilities.argumentArity(moduleInstance.arguments[3]);
      var doutArity = utilities.argumentArity(moduleInstance.arguments[4]);
      if (dinArity !== doutArity) {
         return {
            message: 'the fourth argument (data-in) ' + moduleInstance.arguments[3] + ' and the fifth argument (data-out) ' + moduleInstance.arguments[4] + ' must have same arity',
            location: moduleInstance.location
         };
      }
   }

   function checkSignalCompoundIndexOrdering(signalCompound) {
      for (var i = 0; i < signalCompound.signals.length; i++) {
         var signal = signalCompound.signals[i];
         if (signal.type === 'vector') {
            var err = checkVectorSignalIndexOrdering(signal);
            if (err) return err;
         }
      }
   }

   function checkSumOfTermsCompound(sumoftermsCompound) {
      for (var i = 0; i < sumoftermsCompound.sumofterms.length; i++) {
         var sumofterms = sumoftermsCompound.sumofterms[i];
         var err = checkSumOfTermsIndexOrdering(sumofterms);
         if (err) return err;
         err = checkSumOfTermsArities(sumofterms);
         if (err) return err;
      }
   }

   function checkSumOfTermsIndexOrdering(sumofterms) {
      for (var i = 0; i < sumofterms.terms.length; i++) {
         var term = sumofterms.terms[i];
         for (var j = 0; j < term.factors.length; j++) {
            var factor = term.factors[j];
            if (factor.type === 'sumofterms') {
               var err = checkSumOfTermsIndexOrdering(factor.sumofterms);
               if (err) return err;
            } else if (factor.type === 'maxterm') {
               if (factor.signal.type === 'vector') {
                  var _err = checkVectorSignalIndexOrdering(factor.signal);
                  if (_err) return _err;
               }
            }
         }
      }
   }

   function checkVectorSignalIndexOrdering(signal) {
      if (signal.start < signal.stop) {
         return {
            message: 'indexes for vector signal \'' + signal.name + '\' must be in decreasing order',
            location: signal.location
         };
      }
   }

   function checkSumOfTermsArities(sumofterms) {
      var firstTermArity = void 0;
      for (var i = 0; i < sumofterms.terms.length; i++) {
         var term = sumofterms.terms[i];
         if (i === 0) {
            firstTermArity = utilities.termArity(term);
         } else {
            if (utilities.termArity(term) !== firstTermArity) {
               return {
                  message: 'term arity issue',
                  location: term.location
               };
            }
         }
      }
   }
}();

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = /*
                 * Generated by PEG.js 0.10.0.
                 *
                 * http://pegjs.org/
                 */
function () {
  "use strict";

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
      literal: function literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },

      "class": function _class(expectation) {
        var escapedParts = "",
            i;

        for (i = 0; i < expectation.parts.length; i++) {
          escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
        }

        return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
      },

      any: function any(expectation) {
        return "any character";
      },

      end: function end(expectation) {
        return "end of input";
      },

      other: function other(expectation) {
        return expectation.description;
      }
    };

    function hex(ch) {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function classEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      var descriptions = new Array(expected.length),
          i,
          j;

      for (i = 0; i < expected.length; i++) {
        descriptions[i] = describeExpectation(expected[i]);
      }

      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  };

  function peg$parse(input, options) {
    options = options !== void 0 ? options : {};

    var peg$FAILED = {},
        peg$startRuleFunctions = { Line: peg$parseLine },
        peg$startRuleFunction = peg$parseLine,
        peg$c0 = "//",
        peg$c1 = peg$literalExpectation("//", false),
        peg$c2 = /^[^\n]/,
        peg$c3 = peg$classExpectation(["\n"], true, false),
        peg$c4 = function peg$c4(cmd, signal, value) {
      return { cmd: cmd, signal: signal, value: value };
    },
        peg$c5 = function peg$c5() {
      return { cmd: 'comment' };
    },
        peg$c6 = "set",
        peg$c7 = peg$literalExpectation("set", false),
        peg$c8 = "check",
        peg$c9 = peg$literalExpectation("check", false),
        peg$c10 = function peg$c10(cmd) {
      return cmd;
    },
        peg$c11 = "[",
        peg$c12 = peg$literalExpectation("[", false),
        peg$c13 = "]",
        peg$c14 = peg$literalExpectation("]", false),
        peg$c15 = function peg$c15(name, i) {
      return { "type": "vector", "name": name, "start": i, "stop": i };
    },
        peg$c16 = function peg$c16(name, i, j) {
      return { "type": "vector", "name": name, "start": i, "stop": j };
    },
        peg$c17 = function peg$c17(name) {
      return { "type": "scalar", "name": name };
    },
        peg$c18 = /^[a-zA-Z_]/,
        peg$c19 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false),
        peg$c20 = /^[a-zA-Z0-9_]/,
        peg$c21 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false),
        peg$c22 = function peg$c22(char0, chars) {
      return char0 + chars.join("");
    },
        peg$c23 = "..",
        peg$c24 = peg$literalExpectation("..", false),
        peg$c25 = ":",
        peg$c26 = peg$literalExpectation(":", false),
        peg$c27 = /^[01\-]/,
        peg$c28 = peg$classExpectation(["0", "1", "-"], false, false),
        peg$c29 = function peg$c29(value) {
      return value.join('');
    },
        peg$c30 = /^[0-9]/,
        peg$c31 = peg$classExpectation([["0", "9"]], false, false),
        peg$c32 = function peg$c32() {
      return parseInt(text(), 10);
    },
        peg$c33 = /^[ \t\n\r]/,
        peg$c34 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false),
        peg$currPos = 0,
        peg$savedPos = 0,
        peg$posDetailsCache = [{ line: 1, column: 1 }],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
    }

    function error(message, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);

      throw peg$buildSimpleError(message, location);
    }

    function peg$literalExpectation(text, ignoreCase) {
      return { type: "literal", text: text, ignoreCase: ignoreCase };
    }

    function peg$classExpectation(parts, inverted, ignoreCase) {
      return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }

    function peg$anyExpectation() {
      return { type: "any" };
    }

    function peg$endExpectation() {
      return { type: "end" };
    }

    function peg$otherExpectation(description) {
      return { type: "other", description: description };
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column
        };

        while (p < pos) {
          if (input.charCodeAt(p) === 10) {
            details.line++;
            details.column = 1;
          } else {
            details.column++;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildSimpleError(message, location) {
      return new peg$SyntaxError(message, null, null, location);
    }

    function peg$buildStructuredError(expected, found, location) {
      return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }

    function peg$parseLine() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseCommand();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parseSignal();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parseBitField();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    s8 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c0) {
                      s9 = peg$c0;
                      peg$currPos += 2;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c1);
                      }
                    }
                    if (s9 !== peg$FAILED) {
                      s10 = [];
                      if (peg$c2.test(input.charAt(peg$currPos))) {
                        s11 = input.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s11 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c3);
                        }
                      }
                      while (s11 !== peg$FAILED) {
                        s10.push(s11);
                        if (peg$c2.test(input.charAt(peg$currPos))) {
                          s11 = input.charAt(peg$currPos);
                          peg$currPos++;
                        } else {
                          s11 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c3);
                          }
                        }
                      }
                      if (s10 !== peg$FAILED) {
                        s9 = [s9, s10];
                        s8 = s9;
                      } else {
                        peg$currPos = s8;
                        s8 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s8;
                      s8 = peg$FAILED;
                    }
                    if (s8 === peg$FAILED) {
                      s8 = null;
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c4(s2, s4, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c0) {
            s2 = peg$c0;
            peg$currPos += 2;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c1);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = [];
            if (peg$c2.test(input.charAt(peg$currPos))) {
              s4 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c3);
              }
            }
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              if (peg$c2.test(input.charAt(peg$currPos))) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c3);
                }
              }
            }
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c5();
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseCommand() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 3) === peg$c6) {
        s1 = peg$c6;
        peg$currPos += 3;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c7);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 5) === peg$c8) {
          s1 = peg$c8;
          peg$currPos += 5;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c9);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c10(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseSignal() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

      s0 = peg$currPos;
      s1 = peg$parseSignalName();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 91) {
            s3 = peg$c11;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c12);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parseNaturalInteger();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 93) {
                    s7 = peg$c13;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c14);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c15(s1, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseSignalName();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 91) {
              s3 = peg$c11;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c12);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseNaturalInteger();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parse_();
                  if (s6 !== peg$FAILED) {
                    s7 = peg$parseDotDot();
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parse_();
                      if (s8 !== peg$FAILED) {
                        s9 = peg$parseNaturalInteger();
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parse_();
                          if (s10 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 93) {
                              s11 = peg$c13;
                              peg$currPos++;
                            } else {
                              s11 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$c14);
                              }
                            }
                            if (s11 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c16(s1, s5, s9);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseSignalName();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c17(s1);
          }
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseSignalName() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (peg$c18.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c19);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c20.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c21);
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          if (peg$c20.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c21);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c22(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseDotDot() {
      var s0;

      if (input.substr(peg$currPos, 2) === peg$c23) {
        s0 = peg$c23;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c24);
        }
      }
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 58) {
          s0 = peg$c25;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c26);
          }
        }
      }

      return s0;
    }

    function peg$parseBitField() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      if (peg$c27.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c28);
        }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c27.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c28);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c29(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseNaturalInteger() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c30.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c31);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            if (peg$c30.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c31);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c32();
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1;

      s0 = [];
      if (peg$c33.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c34);
        }
      }
      while (s1 !== peg$FAILED) {
        s0.push(s1);
        if (peg$c33.test(input.charAt(peg$currPos))) {
          s1 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c34);
          }
        }
      }

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail(peg$endExpectation());
      }

      throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
}();

/***/ }),
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 261,
	"./af.js": 261,
	"./ar": 268,
	"./ar-dz": 262,
	"./ar-dz.js": 262,
	"./ar-kw": 263,
	"./ar-kw.js": 263,
	"./ar-ly": 264,
	"./ar-ly.js": 264,
	"./ar-ma": 265,
	"./ar-ma.js": 265,
	"./ar-sa": 266,
	"./ar-sa.js": 266,
	"./ar-tn": 267,
	"./ar-tn.js": 267,
	"./ar.js": 268,
	"./az": 269,
	"./az.js": 269,
	"./be": 270,
	"./be.js": 270,
	"./bg": 271,
	"./bg.js": 271,
	"./bm": 272,
	"./bm.js": 272,
	"./bn": 273,
	"./bn.js": 273,
	"./bo": 274,
	"./bo.js": 274,
	"./br": 275,
	"./br.js": 275,
	"./bs": 276,
	"./bs.js": 276,
	"./ca": 277,
	"./ca.js": 277,
	"./cs": 278,
	"./cs.js": 278,
	"./cv": 279,
	"./cv.js": 279,
	"./cy": 280,
	"./cy.js": 280,
	"./da": 281,
	"./da.js": 281,
	"./de": 284,
	"./de-at": 282,
	"./de-at.js": 282,
	"./de-ch": 283,
	"./de-ch.js": 283,
	"./de.js": 284,
	"./dv": 285,
	"./dv.js": 285,
	"./el": 286,
	"./el.js": 286,
	"./en-au": 287,
	"./en-au.js": 287,
	"./en-ca": 288,
	"./en-ca.js": 288,
	"./en-gb": 289,
	"./en-gb.js": 289,
	"./en-ie": 290,
	"./en-ie.js": 290,
	"./en-il": 291,
	"./en-il.js": 291,
	"./en-nz": 292,
	"./en-nz.js": 292,
	"./eo": 293,
	"./eo.js": 293,
	"./es": 296,
	"./es-do": 294,
	"./es-do.js": 294,
	"./es-us": 295,
	"./es-us.js": 295,
	"./es.js": 296,
	"./et": 297,
	"./et.js": 297,
	"./eu": 298,
	"./eu.js": 298,
	"./fa": 299,
	"./fa.js": 299,
	"./fi": 300,
	"./fi.js": 300,
	"./fo": 301,
	"./fo.js": 301,
	"./fr": 304,
	"./fr-ca": 302,
	"./fr-ca.js": 302,
	"./fr-ch": 303,
	"./fr-ch.js": 303,
	"./fr.js": 304,
	"./fy": 305,
	"./fy.js": 305,
	"./gd": 306,
	"./gd.js": 306,
	"./gl": 307,
	"./gl.js": 307,
	"./gom-latn": 308,
	"./gom-latn.js": 308,
	"./gu": 309,
	"./gu.js": 309,
	"./he": 310,
	"./he.js": 310,
	"./hi": 311,
	"./hi.js": 311,
	"./hr": 312,
	"./hr.js": 312,
	"./hu": 313,
	"./hu.js": 313,
	"./hy-am": 314,
	"./hy-am.js": 314,
	"./id": 315,
	"./id.js": 315,
	"./is": 316,
	"./is.js": 316,
	"./it": 317,
	"./it.js": 317,
	"./ja": 318,
	"./ja.js": 318,
	"./jv": 319,
	"./jv.js": 319,
	"./ka": 320,
	"./ka.js": 320,
	"./kk": 321,
	"./kk.js": 321,
	"./km": 322,
	"./km.js": 322,
	"./kn": 323,
	"./kn.js": 323,
	"./ko": 324,
	"./ko.js": 324,
	"./ky": 325,
	"./ky.js": 325,
	"./lb": 326,
	"./lb.js": 326,
	"./lo": 327,
	"./lo.js": 327,
	"./lt": 328,
	"./lt.js": 328,
	"./lv": 329,
	"./lv.js": 329,
	"./me": 330,
	"./me.js": 330,
	"./mi": 331,
	"./mi.js": 331,
	"./mk": 332,
	"./mk.js": 332,
	"./ml": 333,
	"./ml.js": 333,
	"./mr": 334,
	"./mr.js": 334,
	"./ms": 336,
	"./ms-my": 335,
	"./ms-my.js": 335,
	"./ms.js": 336,
	"./mt": 337,
	"./mt.js": 337,
	"./my": 338,
	"./my.js": 338,
	"./nb": 339,
	"./nb.js": 339,
	"./ne": 340,
	"./ne.js": 340,
	"./nl": 342,
	"./nl-be": 341,
	"./nl-be.js": 341,
	"./nl.js": 342,
	"./nn": 343,
	"./nn.js": 343,
	"./pa-in": 344,
	"./pa-in.js": 344,
	"./pl": 345,
	"./pl.js": 345,
	"./pt": 347,
	"./pt-br": 346,
	"./pt-br.js": 346,
	"./pt.js": 347,
	"./ro": 348,
	"./ro.js": 348,
	"./ru": 349,
	"./ru.js": 349,
	"./sd": 350,
	"./sd.js": 350,
	"./se": 351,
	"./se.js": 351,
	"./si": 352,
	"./si.js": 352,
	"./sk": 353,
	"./sk.js": 353,
	"./sl": 354,
	"./sl.js": 354,
	"./sq": 355,
	"./sq.js": 355,
	"./sr": 357,
	"./sr-cyrl": 356,
	"./sr-cyrl.js": 356,
	"./sr.js": 357,
	"./ss": 358,
	"./ss.js": 358,
	"./sv": 359,
	"./sv.js": 359,
	"./sw": 360,
	"./sw.js": 360,
	"./ta": 361,
	"./ta.js": 361,
	"./te": 362,
	"./te.js": 362,
	"./tet": 363,
	"./tet.js": 363,
	"./tg": 364,
	"./tg.js": 364,
	"./th": 365,
	"./th.js": 365,
	"./tl-ph": 366,
	"./tl-ph.js": 366,
	"./tlh": 367,
	"./tlh.js": 367,
	"./tr": 368,
	"./tr.js": 368,
	"./tzl": 369,
	"./tzl.js": 369,
	"./tzm": 371,
	"./tzm-latn": 370,
	"./tzm-latn.js": 370,
	"./tzm.js": 371,
	"./ug-cn": 372,
	"./ug-cn.js": 372,
	"./uk": 373,
	"./uk.js": 373,
	"./ur": 374,
	"./ur.js": 374,
	"./uz": 376,
	"./uz-latn": 375,
	"./uz-latn.js": 375,
	"./uz.js": 376,
	"./vi": 377,
	"./vi.js": 377,
	"./x-pseudo": 378,
	"./x-pseudo.js": 378,
	"./yo": 379,
	"./yo.js": 379,
	"./zh-cn": 380,
	"./zh-cn.js": 380,
	"./zh-hk": 381,
	"./zh-hk.js": 381,
	"./zh-tw": 382,
	"./zh-tw.js": 382
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 892;

/***/ }),
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 427,
	"./af.js": 427,
	"./ar": 434,
	"./ar-dz": 428,
	"./ar-dz.js": 428,
	"./ar-kw": 429,
	"./ar-kw.js": 429,
	"./ar-ly": 430,
	"./ar-ly.js": 430,
	"./ar-ma": 431,
	"./ar-ma.js": 431,
	"./ar-sa": 432,
	"./ar-sa.js": 432,
	"./ar-tn": 433,
	"./ar-tn.js": 433,
	"./ar.js": 434,
	"./az": 435,
	"./az.js": 435,
	"./be": 436,
	"./be.js": 436,
	"./bg": 437,
	"./bg.js": 437,
	"./bm": 438,
	"./bm.js": 438,
	"./bn": 439,
	"./bn.js": 439,
	"./bo": 440,
	"./bo.js": 440,
	"./br": 441,
	"./br.js": 441,
	"./bs": 442,
	"./bs.js": 442,
	"./ca": 443,
	"./ca.js": 443,
	"./cs": 444,
	"./cs.js": 444,
	"./cv": 445,
	"./cv.js": 445,
	"./cy": 446,
	"./cy.js": 446,
	"./da": 447,
	"./da.js": 447,
	"./de": 450,
	"./de-at": 448,
	"./de-at.js": 448,
	"./de-ch": 449,
	"./de-ch.js": 449,
	"./de.js": 450,
	"./dv": 451,
	"./dv.js": 451,
	"./el": 452,
	"./el.js": 452,
	"./en-SG": 453,
	"./en-SG.js": 453,
	"./en-au": 454,
	"./en-au.js": 454,
	"./en-ca": 455,
	"./en-ca.js": 455,
	"./en-gb": 456,
	"./en-gb.js": 456,
	"./en-ie": 457,
	"./en-ie.js": 457,
	"./en-il": 458,
	"./en-il.js": 458,
	"./en-nz": 459,
	"./en-nz.js": 459,
	"./eo": 460,
	"./eo.js": 460,
	"./es": 463,
	"./es-do": 461,
	"./es-do.js": 461,
	"./es-us": 462,
	"./es-us.js": 462,
	"./es.js": 463,
	"./et": 464,
	"./et.js": 464,
	"./eu": 465,
	"./eu.js": 465,
	"./fa": 466,
	"./fa.js": 466,
	"./fi": 467,
	"./fi.js": 467,
	"./fo": 468,
	"./fo.js": 468,
	"./fr": 471,
	"./fr-ca": 469,
	"./fr-ca.js": 469,
	"./fr-ch": 470,
	"./fr-ch.js": 470,
	"./fr.js": 471,
	"./fy": 472,
	"./fy.js": 472,
	"./ga": 473,
	"./ga.js": 473,
	"./gd": 474,
	"./gd.js": 474,
	"./gl": 475,
	"./gl.js": 475,
	"./gom-latn": 476,
	"./gom-latn.js": 476,
	"./gu": 477,
	"./gu.js": 477,
	"./he": 478,
	"./he.js": 478,
	"./hi": 479,
	"./hi.js": 479,
	"./hr": 480,
	"./hr.js": 480,
	"./hu": 481,
	"./hu.js": 481,
	"./hy-am": 482,
	"./hy-am.js": 482,
	"./id": 483,
	"./id.js": 483,
	"./is": 484,
	"./is.js": 484,
	"./it": 486,
	"./it-ch": 485,
	"./it-ch.js": 485,
	"./it.js": 486,
	"./ja": 487,
	"./ja.js": 487,
	"./jv": 488,
	"./jv.js": 488,
	"./ka": 489,
	"./ka.js": 489,
	"./kk": 490,
	"./kk.js": 490,
	"./km": 491,
	"./km.js": 491,
	"./kn": 492,
	"./kn.js": 492,
	"./ko": 493,
	"./ko.js": 493,
	"./ku": 494,
	"./ku.js": 494,
	"./ky": 495,
	"./ky.js": 495,
	"./lb": 496,
	"./lb.js": 496,
	"./lo": 497,
	"./lo.js": 497,
	"./lt": 498,
	"./lt.js": 498,
	"./lv": 499,
	"./lv.js": 499,
	"./me": 500,
	"./me.js": 500,
	"./mi": 501,
	"./mi.js": 501,
	"./mk": 502,
	"./mk.js": 502,
	"./ml": 503,
	"./ml.js": 503,
	"./mn": 504,
	"./mn.js": 504,
	"./mr": 505,
	"./mr.js": 505,
	"./ms": 507,
	"./ms-my": 506,
	"./ms-my.js": 506,
	"./ms.js": 507,
	"./mt": 508,
	"./mt.js": 508,
	"./my": 509,
	"./my.js": 509,
	"./nb": 510,
	"./nb.js": 510,
	"./ne": 511,
	"./ne.js": 511,
	"./nl": 513,
	"./nl-be": 512,
	"./nl-be.js": 512,
	"./nl.js": 513,
	"./nn": 514,
	"./nn.js": 514,
	"./pa-in": 515,
	"./pa-in.js": 515,
	"./pl": 516,
	"./pl.js": 516,
	"./pt": 518,
	"./pt-br": 517,
	"./pt-br.js": 517,
	"./pt.js": 518,
	"./ro": 519,
	"./ro.js": 519,
	"./ru": 520,
	"./ru.js": 520,
	"./sd": 521,
	"./sd.js": 521,
	"./se": 522,
	"./se.js": 522,
	"./si": 523,
	"./si.js": 523,
	"./sk": 524,
	"./sk.js": 524,
	"./sl": 525,
	"./sl.js": 525,
	"./sq": 526,
	"./sq.js": 526,
	"./sr": 528,
	"./sr-cyrl": 527,
	"./sr-cyrl.js": 527,
	"./sr.js": 528,
	"./ss": 529,
	"./ss.js": 529,
	"./sv": 530,
	"./sv.js": 530,
	"./sw": 531,
	"./sw.js": 531,
	"./ta": 532,
	"./ta.js": 532,
	"./te": 533,
	"./te.js": 533,
	"./tet": 534,
	"./tet.js": 534,
	"./tg": 535,
	"./tg.js": 535,
	"./th": 536,
	"./th.js": 536,
	"./tl-ph": 537,
	"./tl-ph.js": 537,
	"./tlh": 538,
	"./tlh.js": 538,
	"./tr": 539,
	"./tr.js": 539,
	"./tzl": 540,
	"./tzl.js": 540,
	"./tzm": 542,
	"./tzm-latn": 541,
	"./tzm-latn.js": 541,
	"./tzm.js": 542,
	"./ug-cn": 543,
	"./ug-cn.js": 543,
	"./uk": 544,
	"./uk.js": 544,
	"./ur": 545,
	"./ur.js": 545,
	"./uz": 547,
	"./uz-latn": 546,
	"./uz-latn.js": 546,
	"./uz.js": 547,
	"./vi": 548,
	"./vi.js": 548,
	"./x-pseudo": 549,
	"./x-pseudo.js": 549,
	"./yo": 550,
	"./yo.js": 550,
	"./zh-cn": 551,
	"./zh-cn.js": 551,
	"./zh-hk": 552,
	"./zh-hk.js": 552,
	"./zh-tw": 553,
	"./zh-tw.js": 553
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1083;

/***/ }),
/* 1084 */,
/* 1085 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */
/***/ (function(module, exports) {

module.exports = "\n# CRAPS programmer's guide\n\nThe instruction set architecture (ISA) of CRAPS is largely inspired from 32-bit SPARC version 8.\nContrary to SPARC, there are no register windows and no floating point instructions.\n\nCRAPS is a load/store architecture: it has a large set of registers and most instructions operate solely on them.\nThere is only one instruction to read from memory (ld) and one to write into it (st). Memory is considered\nto be a slow device and the instruction set encourages to use registers as much as possible, and\nmemory as less as possible.\n\n## Examples\n\nThe following example program runs cyclicly and never stops; at each cycle it reads a 16-bit number `n` on (simulated) switches,\ncomputes the square root of `n` and displays it on the (simulated) 16 leds.\n\n```\nSW = 0x90000000 // switches I/O address\nLD = 0xB0000000 // leds I/O address\n\n           set    SW, %r8\n           set    LD, %r9\nloop:      ld     [%r8+%r0], %r1\n           umulcc %r1, %r1, %r2\n           st     %r2, [%r9+%r0]\n           ba     loop\n```\n\nThis second program computes the sum of the elements of an array of signed integers:\n\n```\ntab      =      0x100000\nn        =      3\n         \n         set    tab, %r1\n         clr    %r2\n         clr    %r3\nloop:    ld     [%r1+%r2], %r4\n         add    %r4, %r3, %r3\n         inc    %r2\n         cmp    %r2, n\n         blu    loop\nstop:    ba     stop\n\n         .org\t tab\n         .word  -1, 10, 2*n+1\n```\n\n## CRAPS memory mapping\n\n#### RAM\n[0x00000000 - 0x10000000[\n\n#### I/O addresses\n- Switches (16 bits): read at address 0x90000000\n- Leds (16 bits): write at address 0xb0000000\n\n\n## CRAPS registers\n\n#### %r0 = 0\n%r0 is a special register: you always get 0 when you read it. You can write into it, but the value is lost.  \nIt is useful in many ways; for example when performing `subcc %r1, %r2, %r0` to compare `%r1` and `%r2` (= synthetic instruction `cmp %r1, %r2`),\nwe are not interested in the result value of the subtraction, but only in the flag values, so writing the result in %r0 waste no other register.\nIt is also used for synthetic instructions `clr`, `mov`, `setq`, `tst`, `negcc`, `push`, `pop`.\n\n#### %r1-%r19: general purpose programmer's registers\nThe programmer can use them at will\n\n#### %r28: return address after a `call`\nSee synthetic instructions `call`, `ret`\n\n#### %r29 = %sp: stack pointer\nSee stack-related synthetic instructions `push` and `pop`\n\n#### %r30 = %pc: program counter\nHolds the current execution address\n\n#### %r31 = %ir: instruction register\nHolds the current instruction code being executed\n\n\n## CRAPS instructions\n\n### add\nidem\taddcc, but no flags are modified\n\n### addcc\n`addcc %rs1, %rs2, %rd`  \n`addcc %rs1, simm13, %rd`  \nAdd the two operands `%rs1` and `%rs2 / simm13` and put the result in register `%rd`. The C flag is not added to the arguments.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***\t:\tN,\tZ,\tV,\tC\n\n***Example***:\t`addcc %r1, 5, %r1`  \nAdd 5 to `%r1` and set flags N, Z, V, C\n\n### and\nidem\taddcc, but no flags are modified\n\n### andcc\n`andcc %rs1, %rs2, %rd`  \n`andcc %rs1, simm13, %rd`  \nPerforms a bit-wise AND between the two operands `%rs1` and `%rs2 / simm13` and put the result in register `%rd`.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***\t:\tN,\tZ\n\n***Example***:\t`andcc %r1, %r2, %r3`  \nPerforms a bit-wise AND between `%r1` and `%r2` and put the result in `%r3`\n\n### b(cond)\n`b(cond) label`  \nIf condition `cond` is verified, branch to `label`; otherwise proceed to next instruction.\n\n***Modified flags***\t:\tNone\n\n***General purpose conditions***\n\n| Instruction             |      Description                       | Test                       |\n|:-----------------------:|:--------------------------------------:|:--------------------------:|\n| `ba`                    |  branch always, unconditionnal branch  | 1                          |\n| `be` / `bz` / `beq`     |  branch on equal                       | `Z`                    |\n| `bne` / `bnz`           |  branch on not equal                   | `not Z`                    |\n| `bcs`                   |  branch on carry set                   | `C`                        |\n| `bcc`                   |  branch on carry clear                 | `not C`                    |\n| `bvs`                   |  branch on overflow set                | `V`                        |\n| `bvc`                   |  branch on overflow clear              | `not V`                    |\n|------------------------------------|-----------------------------------------------------------|--------------------------------------|\n\n***Signed arithmetic conditions***\n\n| Instruction             |      Description                 | Test                       |\n|:-----------------------:|:--------------------------------:|:--------------------------:|\n| `bpos` / `bnn`          |  branch on positive              | `not N`                    |\n| `bneg` / `bn`           |  branch on negative              | `N`                        |\n| `bg` / `bgt`            |  branch on greater               | `not (Z or (N xor V))`     |\n| `bge`                   |  branch on greater or equal      | `not (N xor V)`            |\n| `bl` / `blt`            |  branch on less                  | `N xor V`                  |\n| `ble`                   |  branch on less or equal         | `Z or (N xor V)`           |\n|------------------------------------|-----------------------------------------------------------|--------------------------------------|\n\n***Unsigned arithmétic conditions***\n\n| Instruction             |      Description                       | Test                       |\n|:-----------------------:|:--------------------------------------:|:--------------------------:|\n| `bgu`                   |  branch on greater unsigned            | `not (Z or (N xor V))`     |\n| `bgeu`                  |  branch on greater or equal unsigned   | `not (N xor V)`            |\n| `blu`                   |  branch on less unsigned               | `N xor V`                  |\n| `bleu`                  |  branch on less or equal unsigned      | `Z or (N xor V)`           |\n|------------------------------------|-----------------------------------------------------------|--------------------------------------|\n\n\n### call\nSee ***Synthetic instructions*** section.\n\n\n### clr\nSee ***Synthetic instructions*** section.\n\n\n### cmp\nSee ***Synthetic instructions*** section.\n\n\n### inc, incc\nSee ***Synthetic instructions*** section.\n\n\n### dec, deccc\nSee ***Synthetic instructions*** section.\n\n\n### ld\n`ld [%rs1 + %rs2], %rd`  \n`ls [%rs1 + simm13], %rd`  \nLoad the content of a memory location and copy it into register `%rd`. The address at which memory is read is\nobtained by adding `%rs1` and `%rs2` / `simm13`.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***: None\n\n***Example***:\t`ld [%r1 - 2], %r3`  \nCompute `%r1 - 2`, read memory at this address and copy memory contents into `%r3`.\n\n\n### negcc\nSee ***Synthetic instructions*** section.\n\n\n### nop\nSee ***Synthetic instructions*** section.\n\n\n### or\nidem\torcc, but no flags are modified\n\n### orcc\n`orcc %rs1, %rs2, %rd`  \n`orcc %rs1, simm13, %rd`  \nPerforms a bit-wise OR between the two operands `%rs1` and `%rs2 / simm13` and put the result in register `%rd`.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***: N, Z\n\n***Example***:\t`orcc %r1, 1, %r1`  \nSet bit #0 of `%r1` and leave all others unchanged\n\n\n### push, pop\nSee ***Synthetic instructions*** section.\n\n\n### ret\nSee ***Synthetic instructions*** section.\n\n\n### reti\n\"Return interrupt\": this instruction must be used at the end of an interrupt subprogram.\n\n***Modified flags***: None\n\n\n### sethi\n`sethi imm24, %rd`  \nSet High. This instruction is generally used through the synthetic instruction `set`.\nSets the 24 highest-order bits of `%rd` with immediate unsigned value `imm24`.  \n\n***Modified flags***: None\n\n\n### set, setq\nSee ***Synthetic instructions*** section.\n\n\n### sll\n`sll %rs1, %rs2, %rd`  \n`sll %rs1, imm5, %rd`  \nShift Logical Left. Left-shift the bit array of `%rs1` of `%rs2` (or `simm13`) positions and put the result in register `%rd`.\nZeros are inserted on the `%rs2 / imm5` lowest-order bits of `%rd`.  \nIf used, `imm5` must be in [0, 31]\n\n***Modified flags***: None\n\n***Example***:\t`sll %r1, 7, %r2`  \nShift left the bits of `%r1` and put the result in `%r2`. Zeros are inserted on the 7 lowest-order bits of `%r2`.\n\n\n### slr\n`slr %rs1, %rs2, %rd`  \n`slr %rs1, imm5, %rd`  \nShift Logical Right. Right-shift the bit array of `%rs1` of `%rs2` (or `simm13`) positions and put the result in register `%rd`.\nZeros are inserted on the `%rs2 / imm5` highest-order bits of `%rd`.  \nIf used, `imm5` must be in [0, 31]\n\n***Modified flags***: None\n\n***Example***:\t`slr %r1, 7, %r2`  \nRight-shift the bits of `%r1` and put the result in `%r2`. Zeros are inserted on the 7 highest-order bits of `%r2`.\n\n\n### st\n`st %rd, [%rs1 + %rs2]`  \n`st %rd, [%rs1 + simm13]`  \nStore `%rd` into a memory location, whose address is obtained by adding `%rs1` and `%rs2` / `simm13`.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***: None\n\n***Example***:\t`ld %r3, [%r1 + %r2]`  \nCompute `%r1 + %r2` and store at this address the value of `%r3`.\n\n\n### sub\nidem\tsubcc, but no flags are modified\n\n### subcc\n`subcc %rs1, %rs2, %rd`  \n`subcc %rs1, simm13, %rd`  \nSubtract `%rs2 or simm13` from `%rs1` and put the result in register `%rd`.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***\t:\tN,\tZ,\tV,\tC\n\n***Example***:\t`subcc %r1, 5, %r1`  \nCompute `%r1 - 5`, put the result into `%r1` and set flags N, Z, V, C\n\n\n### tst\nSee ***Synthetic instructions*** section.\n\n\n### umulcc\n`umulcc %rs1, %rs2, %rd`  \n`umulcc %rs1, simm13, %rd`  \nUnsigned multiply. Take only the 16 lowest bits of `%rs1` and `%rs2 or simm13`, perform an unsigned multiplication\nbetween them, and put the result in register `%rd`.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***\t:\tN,\tZ\n\n***Example***:\t`umulcc %r1, %r1, %r1`  \nElevate `%r1` at power 2 and set flags N, Z\n\n\n### xor\nidem\txorcc, but no flags are modified\n\n### xorcc\n`xorcc %rs1, %rs2, %rd`  \n`xorcc %rs1, simm13, %rd`  \nPerforms a bit-wise XOR between the two operands `%rs1` and `%rs2 / simm13` and put the result in register `%rd`.  \nIf used, `simm13` must be in [-4096, +4095].\n\n***Modified flags***\t:\tN,\tZ\n\n***Example***:\t`xorcc %r1, %r2, %r3`  \nPerforms a bit-wise XOR between `%r1` and `%r2` and put the result in `%r3`\n\n\n\n\n## Synthetic instructions\n\nSynthetic instructions are not real instructions; they are simpler and more legible ways to write common operations.\nFor example, comparing `%r1` and `%r2` can be written `cmp %r1, %r2`. After assembling, this synthetic instruction is actually\nreplaced by `subcc %r1, %r2, %r0`\n\nThe complete set of synthetic instructions and their equivalent is listed in the following table:\n\n| Instruction        |      Description                 | Implementation                |\n|:------------------:|:--------------------------------:|:-----------------------------:|\n| `clr %ri`          |  clear %ri                       | `orcc %r0, %r0, %ri`          |\n| `mov %ri, %rj`     |  copy %ri to %rj                 | `orcc %ri, %r0, %rj`          |\n| `inc %ri`          |  increment %ri, no flag modified | `add %ri, 1, %rj`             |\n| `inccc %ri`        |  increment %ri, flags modified   | `addcc %ri, 1, %rj`           |\n| `dec %ri`          |  decrement %ri, no flag modified | `sub %ri, 1, %rj`             |\n| `deccc %ri`        |  decrement %ri, flags modified   | `subcc %ri, 1, %rj`           |\n| `set imm32, %ri`   |  copy imm32 to %ri               | `sethi imm32[31..8], %ri`     |\n|                    |                                  | `orcc %ri, imm32[7..0], %ri`  |\n| `setq simm13 %ri`  |  copy simm13 to %ri              | `orcc %r0, simm13, %ri`       |\n| `cmp %ri, %rj`     |  compare %ri to %rj              | `subcc %ri, %rj, %r0`         |\n| `cmp %ri, simm13`  |  compare %ri to simm13           | `subcc %ri, simm13, %r0`      |\n| `tst %ri`          |  test sign and zero of %ri       | `subcc %ri, %r0, %r0`         |\n| `negcc %ri`        |  replace %ri by its opposite     | `subcc %r0, %ri, %ri`         |\n| `nop`              |  no operation                    | `sethi 0, %r0`                |\n| `call label`       |  call terminal subprogram        | `or %r0, %r30, %r28`          |\n|                    |                                  | `ba label`                    |\n| `ret`              |  return from terminal subprogram | `orcc %r30, %r0, %r28`        |\n| `push %ri`         |  push %ri into memory stack      | `sub %r29, 1, %r29`           |\n|                    |                                  | `st %ri, [%r29+%r0]`          |\n| `pop %ri`          |  pop word from memory stack      | `ld [%r29+%r0], %ri`          |\n|                    |  and put it in %ri               | `add %r29, 1, %r29`           |\n|------------------------------------|--------------------------------------------------|---------------------------------------------|\n\n"

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports = "# SHDL : Simple Harware Description Language\n\n## Introduction\n\nSHDL is a language for **describing** digital circuits in a simple and modular way. It is not a programming language;\nrather it allows for the description of the various equipotentials which compose a circuit and their combinatorial or sequential relationships.\nOnce a design has been described correctly in SHDL, it can be 'powered up' and ran by simulation or synthesis in a real FPGA circuit.\n\nHere is an example of a combinatorial module description; it performs a 1-bit addition:\n```\nmodule fulladder(a, b, cin : s, cout)\n   x = /a*b + a*/b\n   s = /x*cin + x*/cin\n   cout = /x*a + x*cin\nend module\n```\n\nHere is an example of a ripple counter. It uses sequential assignment `:=` and vectors `[1:0]`.\n```\nmodule clock2(rst, h : s[1:0])\n   s[0] := /s[0] on /h, reset when rst\n   s[1] := /s[1] on /s[0], reset when rst\nend module\n```\n\nModules can be reused, and vectors can be splitted:\n```\nmodule clock4(rst, h : s[3:0])\n   clock2(rst, h : s[1:0])\n   clock2(rst, s[1] : s[3:2])\nend module\n```\n\n\n## Equipotentials: scalars and vectors\n\nA scalar represents a single digital equipotential; it is denoted by an identifier `<signal_name>`, for example `cout`.\n\nA vector represents an ordered set of equipotentials; it is denoted by `<signal_name>[<start>:<end>]`, for example `a[3:0]`.\nIndexes *must* be in decreasing order.\nVectors can be composed using the '&' operator, for example:\n```\nc3 & c2 & data[3] & c1 & data[2:0]\n```\n\n\n## Modules\n\nA module may include instances of other submodules. Circularities in the modules hierarchy is not allowed,\nsince a modular design will eventually always be flattened out in a finite set of combinatorial and sequential assignments.\nAs in recursive and modular programming languages, modularity is essential for simplifying construction and for re-usability ;\nunlike them, self-reference and circularity is not allowed.\n\n\n### Module definition\n\n```\n/* module with 3 inputs a,b,c \n   and one output s */\nmodule xor3(a, b, c : s)\n   s = a*/b*/c + /a*b*/c + /a*/b*c + a*b*c // combinatorial equation\nend module\n```\n\n```\nmodule zero4(a[3:0] : Z)\n   Z = /a[3]*/a[2]*/a[1]*/a[0]\nend module\n```\n\nThe sign ':' in the parameters list is optional; the input/output status of a parameter is determined automatically during syntactic & semantic analysis\n\n\n### Module instanciation\n\n```\nmodule xor6(a, b, c, d, e, f, s)\n   xor3(a, b, c, s1) // instance #1 of module xor3\n   xor3(d, e, f, s2) // instance #2 of module xor3\n   s = s1*/s2 + /s1*s2 // s = xor(s1, s2)\nend module\n```\n\n```\nmodule adder4(a[3:0], b[3:0], cin : s[3:0], cout)\n   adder2(a[1:0], b[1:0], cin : s[1:0], c2)\n   adder2(a[3:2], b[3:2], c2 : s[3:2], cout)\nend module\n```\n\n## Combinatorial assignments\n\n'=' indicates a combinatorial assignment\n\n### Scalar combinatorial assignments\n\n```\n// sum of terms\nx = y*z + u*v*w\n```\n\n### Vector combinatorial assignments\n\n```\n// here, x[7] = y[7]*z[7] + u[7]*v[7]*w[7], x[6] = y[6]*z[6] + u[6]*v[6]*w[6], :.\nx[7:0] = y[7:0]*z[7:0] + u[7:0]*v[7:0]*w[7:0]\n\n// *** arity error ***\nx[7:0] = y[7:0] + z[3:0]\n\n// 'and' terms may contain scalars:  x[7] = u * y[7] * v * z[7], x[6] = u * y[6] * v * z[6],:.\nx[7:0] = u * y[7:0] * v * z[7:0]\n\n// a combinatorial expression between parenthesis is an anonymous equipotential\ny = x * (y + z)\n\n// binary constants can be used, as long as they have the proper length\nx[3:0] = \"1010\"\ns = 1\n\n// the '&' operator allows for the concatenation of vector pieces and scalars\nmessage[6:0] = c3 & c2 & data[3] & c1 & data[2:0]\ns[3:0] = \"10\" & a[1:0]\n```\n\n\n## Sequential assigments\n\n':=' indicates a sequential assignment; it creates a memory point\n\n```\n// s[3:0] memorizes and takes the value of d[3:0] on the rising edge on clk, it is synchronous on clk\n// rst is an asynchronous reset: s[3:0] is set to \"0000\" as soon as rst=1, independently of clk\ns[3:0] := d[3:0] on clk, reset when rst\n\n// any combinatorial expression is possible on the right side of ':='\nx := y * (z + t) on h, reset when rst\n\n// change occurs on the falling edge of clk, and reset when and while go=0\ns[3:0] := d[3:0] on /clk, reset when /go\n\n// the 'enabled' specification is optional\n// here, s[3:0] changes only on the rising edge of clk AND if en=1 at that instant\ns[3:0] := /t[3:0]*s[3:0] + t[3:0]*/s[3:0] on clk, reset when rst, enabled when en\n\n// initial state of memory point can be 1:\nq := d on h, set on init\n```\n\n## Built-in modules\n\nTheir name starts with a '$' sign.\n\n### ROM\n\nThe following built-in module implements a ROM of 2^p words of n bits:\n\n```\n$rom(address[p:0] : dataOut[n:0])\n```\n\n- `dataOut[n:0]` asynchronously presents the content of the ROM slot of address `address[p:0]`\n\n### RAM\n\nThe following built-in module implements a RAM of 2^p words of n bits:\n\n```\n$ram_aread_swrite(clock, write, address[p:0], dataIn[n:0] : dataOut[n:0])\n```\n\n- `dataOut[n:0]` asynchronously presents the contents of the RAM slot of address `address[p:0]`, whatever the value of `write` or `clock`\n- writing in a RAM slot occurs synchronously, if `write = 1`, on the rising edge of `clock`. The contents of the RAM location\nof address `address[p:0]` is then replaced by `dataIn[n:0]`\n\n### Memory initialization\n\nThe initial contents of RAM & ROM instances can be set with a data file, which may be used both for simulation and real FPGA synthesis.\nTo get the list and indexes of memory instances in a design, run :\n```\nshdl check <module_name> [-t <team_name>]\n```\n\nHere is an example of a file for 2 memory instances (RAM or ROM), the first 8x3, the second 16x8.\nAll or a subset of memory slots may be defined.\n```\n[\n   {\n      \"000\": \"110\",\n      \"001\": \"100\"\n   },\n   {\n      \"0000\": \"01010101\",\n      \"1000\": \"11001100\"\n   }\n]\n```\n\n## Test Vectors\n\nThey are text files, where each line is a `set` or a `check` operation. Here is an example for module `adder4`: \n\n```\n// 3 + 3 = 6\nset a[3..0] 0011\nset b[3..0] 0011\nset cin 0\ncheck s[3..0] 0110\ncheck cout 0\n\n// with a carry\nset cin 1\ncheck s[3..0] 0111\ncheck cout 0\n```\n"

/***/ }),
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1194),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1206),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c4ef2d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1184),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1012)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1170),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08c180b5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1200),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c276e21",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1220),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f32f9002",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1214),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bc9e7b86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1030)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1198),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-606d513a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1044)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1217),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb8a0c7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1221),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1016)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1011)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1168),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-001d267c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1219),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f0f0bd82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1215),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3c75b48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1186),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-480f9e4a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1175),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1212),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1202),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1177),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2701bc87",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1172),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1207),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cbebc00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1013)
}
var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1171),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fbcd904",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1182),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35c67e9d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1187),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48a25212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1211),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b6d0e94a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1196),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1218),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ee5d43f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1192),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5756e50f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1017)
}
var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1180),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-312f0258",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1033)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1203),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1024)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1188),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a222741",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1199),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1216),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d685141a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1018)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1181),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32e4339e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1205),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1190),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1025)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5751a1c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1014)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1173),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1633b551",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1020)
  __webpack_require__(1021)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e451123",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1034)
  __webpack_require__(1035)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1204),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ba440b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1201),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d32763f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1176),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1169),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1197),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6007acda",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1178),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appearing main"
  }, [_c('div', {
    staticClass: "main-container white-background"
  }, [_c('div', {
    staticClass: "main-label black-color"
  }, [_vm._v("\n         Succès\n      ")]), _vm._v(" "), _c('p', [_vm._v("La connexion avec le compte Fitbit a été réalisée avec succès")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("Cliquer ici")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.userAttributes), function(attribute) {
    return [(_vm.isVisible(attribute)) ? _c('user-attribute-chart', {
      attrs: {
        "userId": _vm.userId,
        "attribute": attribute
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "craps_doc_markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/news/buisson_jeunes_ete2008_1000x750.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("SHDL: Simple Hardware Description Language")]), _vm._v(" "), _c('div', [_vm._v("\n             SHDL is a language for describing digital circuits in a simple and modular way.\n             It is not a programming language; rather it allows for the description of the various equipotentials which compose a circuit\n             and their combinatorial or sequential relationships.\n             Once a design has been described correctly in SHDL, it can be 'powered up' and run (by simulation or by synthesis in a real FPGA circuit)\n          ")])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [(_vm.mode === 'caregiver') ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.userSurveys), function(userSurvey, index) {
    return [_c('v-list-tile', {
      key: userSurvey.id,
      class: {
        'red': userSurvey.id == _vm.selectedUserSurveyId, 'lighten-4': userSurvey.id == _vm.selectedUserSurveyId
      },
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectUserSurvey(userSurvey.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "green darken-1"
      }
    }, [_vm._v(_vm._s(_vm.isComplete(userSurvey) ? 'check_circle' : 'more_horiz'))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.surveyName(userSurvey)))]), _vm._v(" "), (!_vm.isComplete(userSurvey)) ? _c('v-list-tile-sub-title', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("À compléter (" + _vm._s(_vm.answerCount(userSurvey)) + "/ " + _vm._s(_vm.questionCount(userSurvey)) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.userSurveyToDelete = _vm.clone(userSurvey);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.userSurveys.length) ? _c('v-divider', {
      key: userSurvey.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.userSurveys.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addDialog),
      callback: function($$v) {
        _vm.addDialog = $$v
      },
      expression: "addDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Assigner des questionnaires")]), _vm._v(" "), _c('v-card-text', [_c('v-radio-group', {
    model: {
      value: (_vm.choice),
      callback: function($$v) {
        _vm.choice = $$v
      },
      expression: "choice"
    }
  }, _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', [_c('v-radio', {
      key: index,
      attrs: {
        "label": survey.name,
        "value": survey
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false;
        _vm.assignSurveys()
      }
    }
  }, [_vm._v("Assigner")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.userSurveyToDelete.name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteUserSurvey(_vm.userSurveyToDelete)
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.listCss
  }, [_c('user-survey-list', {
    attrs: {
      "title": _vm.title,
      "userId": _vm.userId,
      "selectedUserSurveyId": _vm.selectedUserSurveyId,
      "mode": _vm.mode
    },
    on: {
      "userSurveySelected": _vm.userSurveySelected,
      "addUserSurvey": _vm.addUserSurvey,
      "deleteUserSurvey": _vm.deleteUserSurvey
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.detailCss
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.attribute.name))]), _vm._v(" "), (_vm.attribute.params.type === 'bar') ? _c('bar-chart', {
    attrs: {
      "data": _vm.graphData,
      "options": _vm.options,
      "height": 120,
      "version": _vm.version
    }
  }) : _vm._e(), _vm._v(" "), (_vm.attribute.params.type === 'line') ? _c('line-chart', {
    attrs: {
      "data": _vm.graphData,
      "options": _vm.options,
      "height": 120,
      "version": _vm.version
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "7 jours",
      "value": "7d"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "30 jours",
      "value": "30d"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "3 mois",
      "value": "3m"
    }
  })], 1), _vm._v(" "), (_vm.isAcquisitionManual) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAcquisitionManual) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "dark": "",
      "color": "red",
      "disabled": !this.clickedDatedValue
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeMeasure()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("remove")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addDialog),
      callback: function($$v) {
        _vm.addDialog = $$v
      },
      expression: "addDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Ajouter une mesure")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "min-width": "290px"
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date",
      "value": _vm.moment(_vm.measureDate).format('LL'),
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    ref: "picker",
    attrs: {
      "max": _vm.moment().format(),
      "locale": "fr-FR",
      "first-day-of-week": 1,
      "scrollable": ""
    },
    model: {
      value: (_vm.defaultDate),
      callback: function($$v) {
        _vm.defaultDate = $$v
      },
      expression: "defaultDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.measureDate = _vm.defaultDate;
        _vm.menu = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Valeur",
      "error-messages": _vm.valueErrors,
      "bbbblur": "$v.measureValue.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.measureValue.$touch()
      }
    },
    model: {
      value: (_vm.measureValue),
      callback: function($$v) {
        _vm.measureValue = $$v
      },
      expression: "measureValue"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.formValid,
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false;
        _vm.addMeasure()
      }
    }
  }, [_vm._v("Ajouter")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "padded"
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.newMessage
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.messages), function(message, index) {
    return _c('div', [_c('div', {
      class: {
        'message-from-me': _vm.user.id === message.author, 'message-from-them': _vm.user.id !== message.author
      }
    }, [_c('div', {
      staticClass: "message-author"
    }, [_vm._v(_vm._s(message.author_fullname))]), _vm._v(" "), _c('div', {
      staticClass: "message-date"
    }, [_vm._v(_vm._s(_vm.formatDate(message.date)))]), _vm._v(" "), _c('div', {
      staticClass: "message-text"
    }, [_vm._v(" " + _vm._s(message.text))])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  })], 2), _vm._v(" "), (_vm.messages.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.newMessageDialog),
      callback: function($$v) {
        _vm.newMessageDialog = $$v
      },
      expression: "newMessageDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Nouveau message")]), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Destinataires",
      "multiple": "",
      "chips": "",
      "cache-items": "",
      "items": _vm.possible_targets,
      "item-text": "fullname",
      "item-value": "id",
      "blur": "$v.messageToSend.$touch(); $v.messageToSend.$touch()",
      "error-messages": _vm.targetsErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.messageToSend.$touch();
        _vm.$v.messageToSend.$touch()
      }
    },
    model: {
      value: (_vm.messageToSend.visible_by),
      callback: function($$v) {
        _vm.$set(_vm.messageToSend, "visible_by", $$v)
      },
      expression: "messageToSend.visible_by"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Texte",
      "required": "",
      "error-messages": _vm.textErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.messageToSend.$touch();
        _vm.$v.messageToSend.$touch();
        _vm.onChanged()
      }
    },
    model: {
      value: (_vm.messageToSend.text),
      callback: function($$v) {
        _vm.$set(_vm.messageToSend, "text", $$v)
      },
      expression: "messageToSend.text"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.formValidAndDirty,
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.newMessageDialog = false;
        _vm.sendMessage(_vm.messageToSend)
      }
    }
  }, [_vm._v("Envoyer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.newMessageDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 sm5"
  }, [_c('user-list', {
    attrs: {
      "title": 'Utilisateurs',
      "users": _vm.users,
      "selectedUserId": _vm.selectedUserId
    },
    on: {
      "userSelected": _vm.userSelected,
      "addUser": _vm.addUser,
      "deleteUser": _vm.deleteUser
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm7"
  }, [_c('router-view', {
    on: {
      "deleteUser": _vm.deleteUser,
      "userFormChanged": function($event) {
        _vm.selectedUserDirty = true
      },
      "userIdChanged": _vm.userIdChanged
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.confirmer.active) ? _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.confirmer.active,
      "persistent": "",
      "max-width": "600"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v(_vm._s(_vm.confirmer.title))]), _vm._v(" "), (_vm.confirmer.body) ? _c('v-card-text', [_vm._v(_vm._s(_vm.confirmer.body))]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _vm._l((_vm.confirmer.choices), function(choice, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "color": "green darken-1",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.answer(choice.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(choice.text) + "\n         ")])
  })], 2)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    staticClass: "logo-salutance",
    attrs: {
      "src": "/static/img/salutance/logo-salutance-3.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "header",
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_vm._v("\n            Grâce au programme SALUTANCE 5.0 vous serez accompagné(e), pendant 1 an,\n            par des professionnels de santé qualifiés : diététicien(ne)s, psychologues, tabacologues, enseignant(e) en activité\n            physique adaptée. Et tout cela, près de chez vous ! L’union fait la forme\n         ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/runner.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Objectifs :")]), _vm._v(" "), _c('div', [_vm._v("Se faire aider pour être en forme et en bonne santé\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/cooking.png",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("En pratique !")]), _vm._v(" "), _c('div', [_vm._v("Une année pour changer de quotidien\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/tablet.png",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Actus")]), _vm._v(" "), _c('div', [_vm._v("À compléter\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/smile.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("L'équipe")]), _vm._v(" "), _c('div', [_vm._v("Un accompagnement de qualité\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/europe.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Les villes concernées :")]), _vm._v(" "), _c('div', [_vm._v("Une aide de proximité\n               ")])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "/salutance-screening"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/salutance/velo.png",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Comment participer ?")]), _vm._v(" "), _c('div', [_vm._v("Vous avez entre 40 et 55 ans, "), _c('span', {
    staticStyle: {
      "color": "orange"
    },
    attrs: {
      "to": "/salutance-screening"
    }
  }, [_vm._v("rejoignez nous !")])])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.moduleToAddName = null;
        _vm.moduleToAddType = 'personal';
        _vm.moduleToAddTeam = null;
        _vm.addDialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Personal modules")]), _vm._v(" "), _vm._l((_vm.sorted(_vm.userModules)), function(module, index) {
    return [_c('v-list-tile', {
      key: module.id,
      class: {
        'red': module.id == _vm.selectedModuleId, 'lighten-4': module.id == _vm.selectedModuleId
      },
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectModule(module.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": _vm.iconColor(module)
      }
    }, [_vm._v(_vm._s(_vm.iconName(module)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(module.name))]), _vm._v(" "), (module.locked_date) ? _c('v-list-tile-sub-title', [_vm._v("locked on " + _vm._s(_vm.moment(module.locked_date).format('YYYY-MM-DD, HH:mm')))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "disabled": !!module.locked_date
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moduleToLock = _vm.clone(module);
          _vm.lockDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green lighten-1"
      }
    }, [_vm._v("lock")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moduleToDelete = _vm.clone(module);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.userModules.length) ? _c('v-divider', {
      key: module.id + '-'
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.userModules.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "60px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.teamModulesDict), function(teamModules, teamId) {
    return [_c('v-divider'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v(_vm._s(_vm.teamDescription(teamId)))]), _vm._v(" "), _vm._l((teamModules), function(module, index) {
      return [_c('v-list-tile', {
        key: module.id,
        class: {
          'red': module.id == _vm.selectedModuleId, 'lighten-4': module.id == _vm.selectedModuleId
        },
        attrs: {
          "ripple": ""
        },
        on: {
          "click": function($event) {
            _vm.selectModule(module.id)
          }
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "color": _vm.iconColor(module)
        }
      }, [_vm._v(_vm._s(_vm.iconName(module)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(module.name))]), _vm._v(" "), (module.locked_date) ? _c('v-list-tile-sub-title', [_vm._v("locked on " + _vm._s(_vm.moment(module.locked_date).format('YYYY-MM-DD, HH:mm')))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": "",
          "ripple": "",
          "disabled": module.locked_date
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.moduleToLock = _vm.clone(module);
            _vm.lockDialog = true
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "green lighten-1"
        }
      }, [_vm._v("lock")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": "",
          "ripple": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.moduleToDelete = _vm.clone(module);
            _vm.deleteDialog = true
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "grey lighten-1"
        }
      }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < teamModules.length) ? _c('v-divider', {
        key: module.id + '-'
      }) : _vm._e()]
    }), _vm._v(" "), (teamModules.length === 0) ? _c('v-card-text', {
      staticClass: "Aligner",
      staticStyle: {
        "height": "60px"
      }
    }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addDialog),
      callback: function($$v) {
        _vm.addDialog = $$v
      },
      expression: "addDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Add a module")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Module name",
      "required": "",
      "error-messages": _vm.nameErrors,
      "blur": "$v.moduleToAddName.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.moduleToAddName.$touch()
      }
    },
    model: {
      value: (_vm.moduleToAddName),
      callback: function($$v) {
        _vm.moduleToAddName = $$v
      },
      expression: "moduleToAddName"
    }
  }), _vm._v(" "), (_vm.teams.length > 0) ? _c('div', [_c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.moduleToAddType),
      callback: function($$v) {
        _vm.moduleToAddType = $$v
      },
      expression: "moduleToAddType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Personal",
      "value": "personal"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Team",
      "value": "team"
    }
  })], 1), _vm._v(" "), (_vm.moduleToAddType === 'team') ? _c('v-select', {
    attrs: {
      "label": "Team",
      "items": _vm.teams,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.moduleToAddTeam),
      callback: function($$v) {
        _vm.moduleToAddTeam = $$v
      },
      expression: "moduleToAddTeam"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.formValid,
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false;
        _vm.addModule()
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("Delete " + _vm._s(_vm.moduleToDelete.name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteModule(_vm.moduleToDelete)
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.lockDialog),
      callback: function($$v) {
        _vm.lockDialog = $$v
      },
      expression: "lockDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("Lock '" + _vm._s(_vm.moduleToLock.name) + "' and all its dependencies? This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lockDialog = false;
        _vm.lockModule(_vm.moduleToLock)
      }
    }
  }, [_vm._v("Lock")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lockDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": _vm.svgSize,
      "height": _vm.svgSize
    }
  }, [_c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    staticClass: "star",
    attrs: {
      "d": _vm.starPath,
      "stroke": _vm.backColor,
      "fill": _vm.backColor
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "circle",
    attrs: {
      "d": _vm.circlePath,
      "stroke": _vm.frontColor,
      "fill": _vm.backColor
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": _vm.linePath,
      "stroke": _vm.frontColor
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "mark",
    attrs: {
      "x": 11.0,
      "y": 11.5,
      "fill": _vm.frontColor
    }
  }, [_vm._v(_vm._s(_vm.mark))]), _vm._v(" "), _c('text', {
    staticClass: "mark",
    attrs: {
      "x": 12.5,
      "y": 19.0,
      "fill": _vm.frontColor
    }
  }, [_vm._v("10")])])])
},staticRenderFns: []}

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', [_c('v-card', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.question.type),
      callback: function($$v) {
        _vm.$set(_vm.question, "type", $$v)
      },
      expression: "question.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Niveau",
      "items": _vm.levels,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.question.level),
      callback: function($$v) {
        _vm.$set(_vm.question, "level", $$v)
      },
      expression: "question.level"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Diabète",
      "value": _vm.diabetesStringToList(_vm.question.diabete),
      "multiple": "",
      "chips": "",
      "items": _vm.diabetes,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": function($event) {
        _vm.onDiabetesChanged(_vm.question, $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Cholestérol",
      "value": _vm.cholesterolStringToList(_vm.question.chol),
      "multiple": "",
      "chips": "",
      "items": _vm.cholesterols,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": function($event) {
        _vm.onCholesterolChanged(_vm.question, $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.question.type !== 'intruder') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.question.type !== 'intruder') ? _c('v-textarea', {
    attrs: {
      "label": "Libellé question",
      "rules": _vm.requiredRules
    },
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.question.question),
      callback: function($$v) {
        _vm.$set(_vm.question, "question", $$v)
      },
      expression: "question.question"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Note"
    },
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.question.note),
      callback: function($$v) {
        _vm.$set(_vm.question, "note", $$v)
      },
      expression: "question.note"
    }
  })], 1), _vm._v(" "), (_vm.question.type === 'truefalse') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Images illustratives")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', [_c('img', {
      attrs: {
        "src": '/static/media/' + image.pict,
        "width": "150"
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Choix proposés")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('div', [(item.pict) ? _c('img', {
      attrs: {
        "src": '/static/media/' + item.pict,
        "width": "150"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.proposition))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.answer))]), _vm._v(" "), _c('v-spacer')], 1)
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.questionId === 0) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.dirty || !_vm.valid,
      "flat": ""
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Créer")]) : _vm._e(), _vm._v(" "), (_vm.questionId !== 0) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.dirty || !_vm.valid,
      "flat": ""
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Enregistrer")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.listCss
  }, [_c('user-list', {
    attrs: {
      "title": _vm.title,
      "users": _vm.coachedUsers,
      "selectedUserId": _vm.selectedUserId,
      "canAdd": false
    },
    on: {
      "addUser": function($event) {
        _vm.addUserDialog = true
      },
      "deleteUser": _vm.deleteUser,
      "userSelected": _vm.userSelected
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.detailCss
  }, [_c('router-view', {
    on: {
      "userIdChanged": _vm.userIdChanged
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addUserDialog),
      callback: function($$v) {
        _vm.addUserDialog = $$v
      },
      expression: "addUserDialog"
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Ajout d'un utilisateur")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Patient",
      "loading": _vm.loading,
      "cache-items": "",
      "item-text": "fullname",
      "item-value": "id",
      "required": "",
      "items": _vm.items,
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.userToAddId),
      callback: function($$v) {
        _vm.userToAddId = $$v
      },
      expression: "userToAddId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": "",
      "disabled": !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.addUserDialog = false;
        _vm.addUser()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addUserDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('img', {
    staticClass: "silhouette",
    attrs: {
      "src": "/static/img/salutance/silhouette.png"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_c('h1', [_vm._v("Indice de Masse Corporelle")]), _vm._v(" "), _c('h3', [_vm._v("Remplissez le formulaire suivant")]), _vm._v(" "), _c('v-form', {
    ref: "form1",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    ref: "weight",
    attrs: {
      "label": "Poids actuel (kg)",
      "rules": _vm.weightRules,
      "suffix": "kg",
      "required": ""
    },
    model: {
      value: (_vm.weight),
      callback: function($$v) {
        _vm.weight = $$v
      },
      expression: "weight"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "height",
    attrs: {
      "label": "Taille (cm)",
      "rules": _vm.heightRules,
      "suffix": "cm",
      "required": ""
    },
    model: {
      value: (_vm.height),
      callback: function($$v) {
        _vm.height = $$v
      },
      expression: "height"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [(_vm.valid) ? _c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h1', [_vm._v("Résultat")])]), _vm._v(" "), _c('v-card-text', [_c('v-list', [_c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("IMC")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.bmi))])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    attrs: {
      "cclass": "fullscreen appearing main global--background"
    }
  }, [_c('div', {
    staticClass: "main-container",
    class: {
      'white-background': _vm.isConnection, 'black-background': _vm.isSignUp
    },
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'black-color': _vm.isConnection, 'white-color': _vm.isSignUp
    }
  }, [_vm._v("\n         " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.isConnection) ? _c('v-text-field', {
    attrs: {
      "name": "username",
      "label": "Identifiant",
      "rules": _vm.usernameRules,
      "dark": _vm.isSignUp,
      "required": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isConnection) ? _c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Mot de passe",
      "autocomplete": "new-password",
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.hiddenPassword ? 'visibility' : 'visibility_off',
      "type": _vm.hiddenPassword ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.hiddenPassword = !_vm.hiddenPassword); }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "name": "username_signup",
      "label": "Identifiant",
      "rules": _vm.usernameRules,
      "dark": "",
      "required": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "email",
      "label": "email",
      "rules": _vm.emailRules,
      "autocomplete": "new-password",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "first_name",
      "label": "Prénom",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "last_name",
      "label": "Nom",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.last_name),
      callback: function($$v) {
        _vm.last_name = $$v
      },
      expression: "last_name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "tag",
      "label": "Tag",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submit-block"
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.valid,
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.debouncedSubmit
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "err-msg"
  }, [_vm._v("\n         " + _vm._s(_vm.errMsg) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password-block"
  }, [(_vm.isConnection) ? _c('a', {
    staticClass: "forgot-password connection",
    attrs: {
      "href": "/forgot_password"
    }
  }, [_vm._v("\n            Mot de passe oublié ?\n         ")]) : _vm._e()])], 1), _vm._v(" "), (_vm.platform === 'shdl' || !_vm.isProduction) ? _c('div', {
    staticClass: "sign-up-block"
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.onModeButtonTap
    }
  }, [_vm._v(_vm._s(_vm.modeButtonText))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": _vm.svgSize,
      "height": _vm.svgSize
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "clipPath"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.basesize,
      "height": _vm.basesize
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.basesize,
      "height": _vm.basesize,
      "fill": "white",
      "stroke": "white",
      "stroke-width": "1px"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-red clippath-url",
    attrs: {
      "d": _vm.redPath,
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-orange clippath-url",
    attrs: {
      "d": _vm.orangePath,
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-green clippath-url",
    attrs: {
      "d": _vm.greenPath,
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-white clippath-url",
    attrs: {
      "d": _vm.whitePath,
      "stroke": "white",
      "stroke-width": "4px"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-gray clippath-url",
    attrs: {
      "d": _vm.grayPath,
      "stroke": "gray",
      "stroke-width": "1px"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-black clippath-url",
    attrs: {
      "d": _vm.blackPath,
      "stroke": "black",
      "stroke-width": "6px"
    }
  }), _vm._v(" "), _c('rect', {
    style: (_vm.style),
    attrs: {
      "x": "0",
      "y": _vm.basesize * 0.75,
      "width": _vm.basesize,
      "height": _vm.basesize * 0.25,
      "stroke": "none",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "text-anchor-middle",
    attrs: {
      "x": _vm.basesize * 0.5,
      "y": _vm.basesize * 0.93,
      "font-family": "Verdana",
      "font-size": "46",
      "fill": "black"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.name) + "\n      ")]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.basesize,
      "height": _vm.basesize,
      "fill": "none",
      "stroke": "gray",
      "stroke-width": "1px"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mymd",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "red darken-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.user.fullname) + " " + _vm._s(_vm.$v.dirty ? '*' : ''))])], 1), _vm._v(" "), _c('v-form', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Identifiant",
      "disabled": _vm.userId > 0,
      "error-messages": _vm.usernameErrors,
      "blur": "$v.user.username.$touch(); $v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.username.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "name": "email",
      "error-messages": _vm.emailErrors,
      "blur": "$v.user.email.$touch(); $v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.email.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Rôles",
      "loading": _vm.loading,
      "disabled": _vm.loggedInUserRoles.hasOwnProperty('salutance-user') || _vm.loggedInUserRoles.hasOwnProperty('diamond-user'),
      "multiple": "",
      "chips": "",
      "cache-items": "",
      "items": _vm.roles,
      "item-text": "params.member_name",
      "item-value": "id",
      "search-input": _vm.search,
      "blur": "$v.user.roles.$touch(); $v.user.$touch()",
      "error-messages": _vm.rolesErrors
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        _vm.$v.user.roles.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.roles),
      callback: function($$v) {
        _vm.$set(_vm.user, "roles", $$v)
      },
      expression: "user.roles"
    }
  })], 1), _vm._v(" "), (_vm.userExtras.fullname && !_vm.userExtras.firstlastname) ? _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nom complet",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.fullname),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "fullname", $$v)
      },
      expression: "user.extra.fullname"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.firstlastname) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Prénom",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "first_name", $$v)
      },
      expression: "user.first_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.firstlastname) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nom",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "last_name", $$v)
      },
      expression: "user.last_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tag",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.tag),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "tag", $$v)
      },
      expression: "user.extra.tag"
    }
  })], 1), _vm._v(" "), (_vm.userExtras.coaches) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Tuteurs",
      "loading": _vm.loading,
      "disabled": _vm.loggedInUserRoles.hasOwnProperty('salutance-user'),
      "multiple": "",
      "chips": "",
      "cache-items": "",
      "items": _vm.users,
      "item-text": "fullname",
      "item-value": "id",
      "search-input": _vm.search,
      "blur": "$v.user.$touch(); $v.user.$touch()"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        _vm.$v.user.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.coaches),
      callback: function($$v) {
        _vm.$set(_vm.user, "coaches", $$v)
      },
      expression: "user.coaches"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.nutrieduc) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sexe",
      "items": _vm.genders,
      "item-text": "name",
      "item-value": "code",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.genderErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.gender),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "gender", $$v)
      },
      expression: "user.extra.gender"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.nutrieduc) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "error-messages": _vm.birthdateErrors,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "min-width": "290px"
    },
    model: {
      value: (_vm.birthdate_menu),
      callback: function($$v) {
        _vm.birthdate_menu = $$v
      },
      expression: "birthdate_menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date de naissance",
      "value": _vm.user.extra.birthdate ? _vm.moment(_vm.user.extra.birthdate).format('LL') : '',
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    ref: "picker",
    attrs: {
      "max": new Date().toISOString().substr(0, 10),
      "locale": "fr-FR",
      "first-day-of-week": 1,
      "scrollable": "",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.birthdate_temp),
      callback: function($$v) {
        _vm.birthdate_temp = $$v
      },
      expression: "birthdate_temp"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.birthdate_menu = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.user.extra.birthdate = _vm.birthdate_temp;
        _vm.birthdate_menu = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.nutrieduc) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Fumeur",
      "items": _vm.smokers,
      "item-text": "name",
      "item-value": "code",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.smokerErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.smoker),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "smoker", $$v)
      },
      expression: "user.extra.smoker"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.heightweightbmi) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Taille (cm)",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.heightErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.height),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "height", $$v)
      },
      expression: "user.extra.height"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.heightweightbmi) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Poids (kg)",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.weightErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.weight),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "weight", $$v)
      },
      expression: "user.extra.weight"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.heightweightbmi) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "IMC",
      "value": _vm.imc,
      "disabled": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.fitbit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "href": _vm.fitbitAuthorizationURL,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.user.extra.fitbit_user_id ? "Réassocier" : "Associer") + " à un compte Fitbit")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.formValidAndDirty,
      "flat": ""
    },
    on: {
      "click": _vm.saveOrUpdate
    }
  }, [_vm._v(_vm._s(_vm.saveMessage))]), _vm._v(" "), (!_vm.creation) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.sendResetPasswordMail
    }
  }, [_vm._v("Réinitialiser le mot de passe")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 sm4"
  }, [_c('shdl-module-list', {
    attrs: {
      "user": _vm.user,
      "teams": _vm.teams,
      "selectedModuleId": _vm.selectedModuleId
    },
    on: {
      "moduleSelected": _vm.selectModule,
      "addModule": _vm.addModule,
      "deleteModule": _vm.deleteModule,
      "lockModule": _vm.lockModule
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm8"
  }, [_c('router-view', {
    on: {
      "userModuleUpdated": _vm.userModuleUpdated
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [(!_vm.isComplete) ? _c('div', [_vm._v(_vm._s(_vm.answerCount) + " / " + _vm._s(_vm.questionCount))]) : _vm._e(), _vm._v(" "), (_vm.mode === 'caregiver' && _vm.isComplete) ? _c('div', {
    staticClass: "score",
    domProps: {
      "innerHTML": _vm._s(_vm.scoreDescription)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro",
    domProps: {
      "innerHTML": _vm._s(_vm.survey.params.intro)
    }
  }), _vm._v(" "), _vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      key: index,
      staticClass: "question"
    }, [_c('div', {
      staticClass: "index"
    }, [_vm._v("Question " + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(question.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "choices"
    }, [_c('v-radio-group', {
      attrs: {
        "value": _vm.userSurvey.answers[index]
      }
    }, _vm._l((question.choices), function(choice, choiceIndex) {
      return _c('v-radio', {
        key: choiceIndex,
        attrs: {
          "label": choice.text,
          "value": choiceIndex
        },
        on: {
          "change": function($event) {
            _vm.saveAnswer(index, $event)
          }
        }
      })
    }))], 1), _vm._v(" "), (index + 1 < _vm.questions.length) ? _c('v-divider', {
      key: 1000,
      staticClass: "separ"
    }) : _vm._e()], 1)
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-text-field', {
    attrs: {
      "placeholder": "rechercher...",
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    on: {
      "click": _vm.openFilterDialog
    }
  }, [_vm._v("Filtrage")]), _vm._v(" "), _c('v-card-text', [_c('div', [_vm._v(_vm._s(_vm.filteredQuestions.length) + " questions")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.addQuestion()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.filteredQuestions), function(question, index) {
    return [_c('v-list-tile', {
      key: question.id,
      class: {
        'red': question.id == _vm.selectedQuestionId, 'lighten-4': question.id == _vm.selectedQuestionId
      },
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectQuestion(question.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "pink"
      }
    }, [_vm._v(_vm._s(_vm.typeIcon(question)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(question.question))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v("Niveau : " + _vm._s(_vm.level(question)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.questionToDelete = _vm.clone(question);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.playQuestion(question)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.filteredQuestions.length) ? _c('v-divider', {
      key: question.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.filteredQuestions.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.questionToDelete.name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteQuestion(_vm.questionToDelete)
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.filterDialog),
      callback: function($$v) {
        _vm.filterDialog = $$v
      },
      expression: "filterDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Filtrage")]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "multiple": "",
      "chips": "",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.selectedTypes),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "selectedTypes", $$v)
      },
      expression: "editedFilter.selectedTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Niveau",
      "multiple": "",
      "chips": "",
      "items": _vm.levels,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.selectedLevels),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "selectedLevels", $$v)
      },
      expression: "editedFilter.selectedLevels"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Diabète : inclure",
      "multiple": "",
      "chips": "",
      "items": _vm.diabetes,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.includedDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "includedDiabetes", $$v)
      },
      expression: "editedFilter.includedDiabetes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Diabète : exclure",
      "multiple": "",
      "chips": "",
      "items": _vm.diabetes,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.excludedDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "excludedDiabetes", $$v)
      },
      expression: "editedFilter.excludedDiabetes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Hypercholestérolémie : inclure",
      "multiple": "",
      "chips": "",
      "items": _vm.cholesterols,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.includedCholesterols),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "includedCholesterols", $$v)
      },
      expression: "editedFilter.includedCholesterols"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Hypercholestérolémie : exclure",
      "multiple": "",
      "chips": "",
      "items": _vm.cholesterols,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.excludedCholesterols),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "excludedCholesterols", $$v)
      },
      expression: "editedFilter.excludedCholesterols"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Régime sans sel : inclure",
      "multiple": "",
      "chips": "",
      "items": _vm.sssels,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.includedSSsels),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "includedSSsels", $$v)
      },
      expression: "editedFilter.includedSSsels"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Régime sans sel : exclure",
      "multiple": "",
      "chips": "",
      "items": _vm.sssels,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.excludedSSsels),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "excludedSSsels", $$v)
      },
      expression: "editedFilter.excludedSSsels"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.filterDialog = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dddddisabled": !_vm.dirty || !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.filterDialog = false;
        _vm.setFilter()
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.playDialog),
      callback: function($$v) {
        _vm.playDialog = $$v
      },
      expression: "playDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "display-1"
  }, [_vm._v("\n               " + _vm._s(_vm.playTitle) + "    "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("(question à " + _vm._s(_vm.playPoints) + ")")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n               " + _vm._s(_vm.questionToPlay.question) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, _vm._l((_vm.questionToPlayImages), function(image) {
    return _c('div', [(image.pict) ? _c('img', {
      attrs: {
        "src": '/static/media/' + image.pict,
        "width": "150"
      }
    }) : _vm._e()])
  })), _vm._v(" "), _vm._l((_vm.questionToPlayItems), function(item) {
    return _c('div', [_c('v-btn', {
      attrs: {
        "block": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.questionAnswered(item)
        }
      }
    }, [_vm._v(_vm._s(item.proposition))])], 1)
  })], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.answerDialog),
      callback: function($$v) {
        _vm.answerDialog = $$v
      },
      expression: "answerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "display-1"
  }, [_vm._v("\n               " + _vm._s(_vm.answeredItem.success ? "Bonne réponse !" : "Mauvaise réponse !") + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n               " + _vm._s(_vm.answeredItem.answer) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.answerDialog = false;
        _vm.playDialog = false
      }
    }
  }, [_vm._v("Fermer")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "red darken-4",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), (_vm.canAdd) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.displayedUsers), function(user, index) {
    return [_c('v-list-tile', {
      key: user.id,
      class: {
        'red': user.id == _vm.selectedUserId, 'lighten-4': user.id == _vm.selectedUserId
      },
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectUser(user.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      }
    }, [(_vm.noPasswordUser(user)) ? _c('v-icon', {
      attrs: {
        "slot": "activator",
        "color": "pink"
      },
      slot: "activator"
    }, [_vm._v("error")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("L'utilisateur n'a pas encore activé son compte")])], 1), _vm._v(" "), _c('v-badge', {
      attrs: {
        "right": "",
        "color": "brown"
      }
    }, [(_vm.unreadMessageCount(user.id) > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.unreadMessageCount(user.id)))]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.displayName(user)))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(user.extra.tag))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.userToDelete = _vm.clone(user);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.users.length) ? _c('v-divider', {
      key: user.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.users.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.displayName(_vm.userToDelete)) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteUser(_vm.userToDelete)
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    ref: "app",
    class: {
      'is-waiting': _vm.isWaiting
    },
    attrs: {
      "id": "app"
    }
  }, [_vm._l((_vm.loggedInUserRealms), function(realm) {
    return _c('div', [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": realm.params.style.logo
      }
    })])
  }), _vm._v(" "), (_vm.isToolbarVisible) ? _c('div', [_c('v-toolbar', {
    attrs: {
      "color": _vm.mainColor,
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    on: {
      "click": function($event) {
        _vm.home()
      }
    }
  }, [_vm._v("\n               " + _vm._s(_vm.title) + "\n            ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.platform === 'shdl' ? "Université de Toulouse - INPT - ENSEEIHT - JCB" : "Hôpitaux de Toulouse") + "\n         ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n            v1.13.2\n         ")]), _vm._v(" "), (_vm.isAuthenticated) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("\n               " + _vm._s(_vm.loggedInUserDescription) + "\n            ")]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Déconnexion")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("\n            Connexion\n         ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('v-tabs', {
    attrs: {
      "icons-and-text": "",
      "centered": "",
      "dark": "",
      "color": _vm.mainColor
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _vm._l((_vm.authorizedActivities), function(activity) {
    return (activity.tab) ? _c('v-tab', {
      key: activity.uid,
      attrs: {
        "to": {
          path: activity.url
        },
        "router": ""
      }
    }, [_vm._v("\n            " + _vm._s(activity.tab.name) + "\n            "), _c('v-badge', {
      attrs: {
        "right": "",
        "color": "brown"
      }
    }, [(activity.uid === 'messages' && _vm.unreadMessageCount > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.unreadMessageCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(activity.tab.icon))])], 1)], 1) : _vm._e()
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-content', {
    class: {
      'global--background-shrink': _vm.shrink
    },
    attrs: {
      "ccccccclass": "global--background"
    }
  }, [_c('router-view', {
    on: {
      "onLogin": _vm.onLogin,
      "onLogout": _vm.onLogout
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.invitationDialog),
      callback: function($$v) {
        _vm.invitationDialog = $$v
      },
      expression: "invitationDialog"
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Envoi d'une invitation")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": _vm.mainColor,
      "flat": "",
      "disabled": !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.invitationDialog = false;
        _vm.inviteCoach()
      }
    }
  }, [_vm._v("Envoyer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": _vm.mainColor,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.invitationDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarOptions.timeout,
      "top": true,
      "bottom": false,
      "right": false,
      "left": false,
      "color": _vm.snackbarOptions.color,
      "multi-line": true,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarOptions.text) + "\n   ")]), _vm._v(" "), _c('confirm-dialog')], 2)
},staticRenderFns: []}

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "sm12"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "color": _vm.errorMsg ? 'red' : 'green',
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_c('h6', [_vm._v(_vm._s(_vm.footerMsg))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "sm12"
  }, [_c('craps-code-mirror', {
    ref: "editor",
    attrs: {
      "value": _vm.moduleCopy.text,
      "selectedline": _vm.selectedline,
      "styleactiveline": _vm.styleactiveline
    },
    on: {
      "change": _vm.codeChanged
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12"
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-1",
      "dark": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_c('h4', [_vm._v("Choisissez le repas à éditer")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.pickerDateModal),
      callback: function($$v) {
        _vm.pickerDateModal = $$v
      },
      expression: "pickerDateModal"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.displayDate))]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "locale": "fr-FR",
      "first-day-of-week": 1,
      "max": new Date().toISOString().substr(0, 10)
    },
    model: {
      value: (_vm.pickerDate),
      callback: function($$v) {
        _vm.pickerDate = $$v
      },
      expression: "pickerDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pickerDateModal = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeDate(_vm.pickerDate);
        _vm.pickerDateModal = false
      }
    }
  }, [_vm._v("Choisir")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openFractionningDialog($event)
      }
    }
  }, [_vm._v("Fractionnement...")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12"
  }, [_c('v-tabs', {
    attrs: {
      "grow": "",
      "dark": "",
      "color": "brown lighten-1"
    },
    model: {
      value: (_vm.currentIndex),
      callback: function($$v) {
        _vm.currentIndex = $$v
      },
      expression: "currentIndex"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _vm._l((_vm.mealTypes), function(type, index) {
    return _c('v-tab', {
      key: index,
      attrs: {
        "router": "",
        "disabled": !_vm.isMealPresent(index)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.changeIndex(index)
        }
      }
    }, [_vm._v("\n                     " + _vm._s(_vm.mealNames[index]) + "\n                  ")])
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12"
  }, [_c('router-view', {
    attrs: {
      "name": "mealAssessment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm8"
  }, [_c('router-view', {
    attrs: {
      "name": "mealElements"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm4"
  }, [_c('router-view', {
    attrs: {
      "name": "favorites"
    },
    on: {
      "addFavorite": _vm.addFavorite
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.fractionningDialog) ? _c('fractionning-dialog', {
    attrs: {
      "title": "Fractionnement de la journée",
      "value": _vm.editedFractionning
    },
    on: {
      "close": function($event) {
        _vm.fractionningDialog = false
      },
      "input": _vm.setFractionning,
      "cancel": _vm.cancelFractionning
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', [_vm._l((_vm.events), function(event) {
    return [_c('v-list-tile', {
      key: event.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(event.message.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.eventAuthorName(event)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n               " + _vm._s(_vm.formatDate(event.timestamp)) + "\n            ")])], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), (_vm.events.length === 0) ? _c('v-card', [_c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card no-block memory-editor"
  }, [_c('div', [_c('v-select', {
    attrs: {
      "flat": "",
      "items": _vm.bases,
      "label": "Registers"
    },
    on: {
      "change": _vm.update
    },
    model: {
      value: (_vm.base),
      callback: function($$v) {
        _vm.base = $$v
      },
      expression: "base"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "memory-editor-body",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('code-mirror', {
    attrs: {
      "value": _vm.textContent,
      "options": _vm.editorOptions
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "sm12"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "color": _vm.err ? 'red' : 'green',
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_c('h6', [_vm._v(_vm._s(_vm.toolbarMessage))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "sm12"
  }, [_c('shdl-code-mirror', {
    ref: "editor",
    attrs: {
      "value": _vm.editedText,
      "readOnly": _vm.readOnly,
      "selectedline": _vm.selectedline,
      "styleactiveline": _vm.styleactiveline
    },
    on: {
      "change": _vm.codeChanged
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea')
},staticRenderFns: []}

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "imc"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/tools/imc.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Indice de masse corporelle")]), _vm._v(" "), _c('div')])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "imc-weightloss-calc"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/tools/bariatric.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("IMC et perte de poids après chirurgie")]), _vm._v(" "), _c('div')])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Relevés de suivi alimentaire")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.addFractionningDialog
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.fractionnings), function(fractionning, index) {
    return [_c('v-subheader', {
      key: fractionning.id
    }, [_vm._v("\n                  " + _vm._s(_vm.fractionningDescription(fractionning)) + "\n                  "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.editFractionningDialog(fractionning.date)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.surveyMeals[fractionning.date]), function(meal, index) {
      return [_c('v-list-tile', {
        key: fractionning.id + ',' + meal.id,
        class: {
          'red': meal.id === _vm.selectedMealId, 'lighten-4': meal.id === _vm.selectedMealId
        },
        attrs: {
          "avatar": "",
          "ripple": ""
        },
        on: {
          "click": function($event) {
            _vm.selectMeal(meal.id)
          }
        }
      }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("restaurant")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.mealIndexName(meal)))])], 1)], 1)]
    })]
  })], 2), _vm._v(" "), (_vm.fractionnings.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm5"
  }, [_c('router-view', {
    attrs: {
      "name": "mealElements"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm3"
  }, [_c('router-view', {
    attrs: {
      "name": "favorites"
    },
    on: {
      "addFavorite": _vm.addFavorite
    }
  })], 1), _vm._v(" "), (_vm.fractionningDialog) ? _c('fractionning-dialog', {
    attrs: {
      "title": "Journée de relevé alimentaire",
      "disableDate": _vm.disableFractionningDate,
      "value": _vm.editedFractionning
    },
    on: {
      "input": _vm.setFractionning,
      "close": function($event) {
        _vm.fractionningDialog = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea')
},staticRenderFns: []}

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('img', {
    staticClass: "silhouette",
    attrs: {
      "src": "/static/img/salutance/silhouette.png"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_c('h1', [_vm._v("IMC et perte de poids après chirurgie")]), _vm._v(" "), _c('h3', [_vm._v("Remplissez le formulaire suivant")]), _vm._v(" "), _c('v-form', {
    ref: "form1",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    ref: "weight",
    attrs: {
      "label": "Poids actuel (kg)",
      "rules": _vm.weightRules,
      "suffix": "kg",
      "required": ""
    },
    model: {
      value: (_vm.weight),
      callback: function($$v) {
        _vm.weight = $$v
      },
      expression: "weight"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "weightBefore",
    attrs: {
      "label": "Poids avant la chirurgie (kg)",
      "rules": _vm.weightRules,
      "suffix": "kg",
      "required": ""
    },
    model: {
      value: (_vm.weightBefore),
      callback: function($$v) {
        _vm.weightBefore = $$v
      },
      expression: "weightBefore"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "height",
    attrs: {
      "label": "Taille (cm)",
      "rules": _vm.heightRules,
      "suffix": "cm",
      "required": ""
    },
    model: {
      value: (_vm.height),
      callback: function($$v) {
        _vm.height = $$v
      },
      expression: "height"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [(_vm.valid) ? _c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h1', [_vm._v("Résultat")])]), _vm._v(" "), _c('v-card-text', [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Perte d'excés de poids (%)")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.excessWeightloss))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("IMC actuel")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.bmi))])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.barStatus > 0) ? _c('v-flex', {
    staticClass: "sm12"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "color": _vm.barStatus === 1 ? 'orange' : _vm.barStatus === 2 ? 'green' : 'red',
      "dark": ""
    }
  }, [(_vm.barStatus >= 2) ? _c('span', [_vm._v(" " + _vm._s(_vm.barStatusText) + " ")]) : _vm._e(), _vm._v(" "), (_vm.barStatus === 1) ? _c('span', [_vm._v("\n            TEST VECTOR\n            "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onTestFileChange
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.barStatus === 1 && _vm.getMemoryInstanceArray().length > 0) ? _c('span', [_vm._v("\n            MEMORY CONTENTS\n            "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onMemFileChange
    }
  })]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.onBarButtonClick
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.barStatus === 0 ? 'keyboard_arrow_down' : 'keyboard_arrow_up'))])], 1), _vm._v(" "), (_vm.otherGroups.length > 0) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "bottom": "",
      "left": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.showOthers = !_vm.showOthers
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showOthers ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.parameterGroups), function(signalGroup) {
    return [_c('v-list-tile', [_c('v-list-tile-action', [(signalGroup.isInput || signalGroup.isOutput) ? _c('v-icon', {
      attrs: {
        "color": _vm.inputOutputIconColor(signalGroup)
      },
      on: {
        "click": function($event) {
          _vm.clear(signalGroup)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.inputOutputIcon(signalGroup)) + "\n                     ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v(_vm._s(signalGroup.name))]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_vm._l((signalGroup.equipotentialIndexes), function(index) {
      return [_c('v-icon', {
        attrs: {
          "disabled": !signalGroup.isInput
        },
        on: {
          "click": function($event) {
            _vm.onIconClick(index)
          }
        }
      }, [_vm._v(_vm._s(_vm.checkIcon(index, signalGroup.isInput)))])]
    })], 2)])], 1)]
  })], 2)], 1), _vm._v(" "), (_vm.showOthers) ? _c('v-card', [_c('v-divider'), _vm._v(" "), _vm._l((_vm.otherGroups), function(signalGroup) {
    return [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon')], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v(_vm._s(signalGroup.name))]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_vm._l((signalGroup.equipotentialIndexes), function(index) {
      return [_c('v-icon', {
        attrs: {
          "disabled": true
        }
      }, [_vm._v(_vm._s(_vm.checkIcon(index, false)))])]
    })], 2)])], 1)]
  })], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "color": "deep-orange darken-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.user.fullname) + " " + _vm._s(_vm.activeItem ? ' - ' + _vm.activeItem.name : ''))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('v-navigation-drawer', {
    staticClass: "left-element deep-orange lighten-5",
    attrs: {
      "mini-variant": "",
      "ini-variant-width": "100",
      "permanent": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      staticClass: "yellow--text",
      attrs: {
        "value": _vm.activeItem,
        "to": _vm.baseRoute + item.path,
        "active-class": "red--text"
      },
      on: {
        "click": function($event) {
          _vm.activeItem = item
        }
      }
    }, [_c('v-list-tile-action', [_c('v-badge', {
      attrs: {
        "right": "",
        "color": "brown"
      }
    }, [(item.path === 'messages' && _vm.unreadMessageCount > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.unreadMessageCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.icon))])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('router-view', {
    staticClass: "right-element"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "global--background",
    class: {
      'global--background-shrink': _vm.shrink
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "ctdit-news"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/ctdit/logo_ctdit2.png",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("CTDIT")]), _vm._v(" "), _c('div', [_vm._v("\n             Le CTDIT, unité du Service de Diabétologie - Maladies Métaboliques- Nutrition du CHU de Toulouse, a pour missions,\n             la conception, le développement et l’expérimentation\n             d’outils de télé-éducation et de télésurveillance dans le domaine de la diabétologie, nutrition et activité physique\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "tttto": "ctdit-news",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/chu/logo_lyon3.png",
      "height": "240px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Protocole Diamond-GLP1")]), _vm._v(" "), _c('div', [_vm._v("Diamond-GLP1 est un protocole visant à évaluer un nouveau traitement stimulant la sécrétion d’insuline\n            résiduelle de certains diabétiques de type 1.\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "diamond-news",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/news/LOGO_salutance50-2.png",
      "height": "150px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Salutance 5.0")]), _vm._v(" "), _c('div', [_vm._v("Le programme SALUTANCE 5.0 a pour objectif d’aider les personnes de 45 à 55 ans en surpoids ou obèses,\n            à modifier leurs habitudes de vie et à perdre du poids\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "href": "https://www.salutance.fr",
      "target": "_blank",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "/tools"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/ctdit/calculator.jpg",
      "height": "150px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Outils divers")]), _vm._v(" "), _c('div', [_vm._v("\n            Vous trouverez ici différents outils permettant de "), _c('a', {
    attrs: {
      "href": "#/imc"
    }
  }, [_vm._v("calculer votre IMC")]), _vm._v(",\n            d'évaluer votre activité physique, et bien d'autres\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/tools",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "/nutrikiosk"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/malnutrition/malnutrition.jpg",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("NutriKiosk : pour comprendre la nutrition en s'amusant")]), _vm._v(" "), _c('div', [_vm._v("\n             Cette application développée par le CTDIT permet d'enrichir ses connaissances\n             en nutrition de façon ludique\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/nutrikiosk",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/news/Icon1024x1024.png",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Educ@dom")]), _vm._v(" "), _c('div', [_vm._v("Le dispositif de télésurveillance proposé à des patients diabétiques de type 2 à leur domicile associe trois logiciels\n            d’éducation et des capteurs de données biomédicales \n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "news-educadom",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea')
},staticRenderFns: []}

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "min-width": "290px"
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date",
      "value": _vm.formattedEditedDate,
      "disabled": _vm.disableDate,
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.disableDate ? _vm.today : null,
      "max": _vm.today,
      "locale": "fr-FR",
      "first-day-of-week": 1,
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.value.date = _vm.pickerDate;
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.pickerDate),
      callback: function($$v) {
        _vm.pickerDate = $$v
      },
      expression: "pickerDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.mealTypes,
      "item-text": "name",
      "item-value": "index",
      "attach": "",
      "chips": "",
      "label": "Repas de la journée",
      "multiple": "",
      "blur": "$v.value.mealPresenceArray.$touch()",
      "errorMessages": _vm.mealPresenceArrayErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.value.mealPresenceArray.$touch()
      }
    },
    model: {
      value: (_vm.value.mealPresenceArray),
      callback: function($$v) {
        _vm.$set(_vm.value, "mealPresenceArray", $$v)
      },
      expression: "value.mealPresenceArray"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Relevé alimentaire"
    },
    model: {
      value: (_vm.isSurvey),
      callback: function($$v) {
        _vm.isSurvey = $$v
      },
      expression: "isSurvey"
    }
  })], 1), _vm._v(" "), (_vm.isSurvey) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type de relevé",
      "items": _vm.surveyTypes,
      "item-text": "name",
      "item-value": "index",
      "blur": "$v.value.surveyIndex.$touch()",
      "errorMessages": _vm.surveyIndexErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.value.surveyIndex.$touch()
      }
    },
    model: {
      value: (_vm.value.surveyIndex),
      callback: function($$v) {
        _vm.$set(_vm.value, "surveyIndex", $$v)
      },
      expression: "value.surveyIndex"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": "",
      "disabled": !_vm.formValid
    },
    nativeOn: {
      "click": function($event) {
        _vm.close();
        _vm.emitValue()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.close();
        _vm.emitCancel()
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 sm5"
  }, [_c('qculist', {
    attrs: {
      "questions": _vm.questions,
      "selectedQuestionId": _vm.selectedQuestionId
    },
    on: {
      "updatedList": _vm.updatedList,
      "addQuestion": _vm.addQuestion,
      "questionSelected": _vm.questionSelected,
      "deleteQuestion": _vm.deleteQuestion
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm7"
  }, [_c('router-view', {
    on: {
      "createQuestion": _vm.createQuestion,
      "updateQuestion": _vm.updateQuestion
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "border",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 sm8"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "ÉNERGIE",
      "size": 120,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['208']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['208'].d1,
        d2: _vm.nutrientRangeDict['208'].d2,
        dt1: _vm.nutrientRangeDict['208'].dt1,
        dt2: _vm.nutrientRangeDict['208'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['208'].d1,
        d2: _vm.nutrientDict['208'].d2,
        dt1: _vm.nutrientDict['208'].dt1,
        dt2: _vm.nutrientDict['208'].dt2,
        h: 0
      }
    }
  }), _vm._v(" "), _c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "LIPIDES",
      "size": 100,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['204']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['204'].d1,
        d2: _vm.nutrientRangeDict['204'].d2,
        dt1: _vm.nutrientRangeDict['204'].dt1,
        dt2: _vm.nutrientRangeDict['204'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['204'].d1,
        d2: _vm.nutrientDict['204'].d2,
        dt1: _vm.nutrientDict['204'].dt1,
        dt2: _vm.nutrientDict['204'].dt2,
        h: 0
      }
    }
  }), _vm._v(" "), _c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "GLUCIDES",
      "size": 100,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['205']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['205'].d1,
        d2: _vm.nutrientRangeDict['205'].d2,
        dt1: _vm.nutrientRangeDict['205'].dt1,
        dt2: _vm.nutrientRangeDict['205'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['205'].d1,
        d2: _vm.nutrientDict['205'].d2,
        dt1: _vm.nutrientDict['205'].dt1,
        dt2: _vm.nutrientDict['205'].dt2,
        h: 0
      }
    }
  }), _vm._v(" "), _c('galva', {
    staticClass: "left-element",
    attrs: {
      "name": "PROTIDES",
      "size": 100,
      "domain": {
        inf: 0.,
        sup: _vm.nutrientLimSupDict['203']
      },
      "norm": {
        d1: _vm.nutrientRangeDict['203'].d1,
        d2: _vm.nutrientRangeDict['203'].d2,
        dt1: _vm.nutrientRangeDict['203'].dt1,
        dt2: _vm.nutrientRangeDict['203'].dt2,
        h: 0
      },
      "value": {
        d1: _vm.nutrientDict['203'].d1,
        d2: _vm.nutrientDict['203'].d2,
        dt1: _vm.nutrientDict['203'].dt1,
        dt2: _vm.nutrientDict['203'].dt2,
        h: 0
      }
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm4"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('badge', {
    staticClass: "right-element",
    attrs: {
      "mark": _vm.mealMark,
      "size": 120,
      "backColor": "#8c6e64",
      "frontColor": "white"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.mealNames[_vm.index]) + ", " + _vm._s(_vm.displayDate))])], 1), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.addMealElement
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.mealElements), function(mealElement, index) {
    return [_c('v-list-tile', {
      key: mealElement.id,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [(mealElement.food_pict) ? _c('v-btn', {
      attrs: {
        "icon": "",
        "large": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.mealElementToZoomIn = mealElement;
          _vm.zoomImage = true
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.pictPath(mealElement.food_pict)
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(mealElement.food_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.mealElementQuantityDescription(mealElement)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.editMealElement(mealElement)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.mealElementToDelete = _vm.clone(mealElement);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.mealElements.length) ? _c('v-divider', {
      key: mealElement.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.mealElements.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.zoomImage),
      callback: function($$v) {
        _vm.zoomImage = $$v
      },
      expression: "zoomImage"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pictPath(_vm.mealElementToZoomIn.food_pict)
    }
  })]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.zoomImage = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.mealElementToDelete.food_name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteMealElement()
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-form', [_c('v-card', [(_vm.create) ? _c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Nouvel aliment")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(!_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Aliment (taper une partie du nom)",
      "loading": _vm.foodSearchLoading,
      "cache-items": "",
      "item-text": "shrt_desc",
      "required": "",
      "items": _vm.foodItems,
      "search-input": _vm.foodSearchInput,
      "return-object": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.foodSearchInput = $event
      }
    },
    model: {
      value: (_vm.choosenFood),
      callback: function($$v) {
        _vm.choosenFood = $$v
      },
      expression: "choosenFood"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.choosenFood.shrt_desc))])]) : _vm._e(), _vm._v(" "), (_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeFood()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && (_vm.choosenFoodPortion || _vm.choosenFoodPortions.length === 1)) ? _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.pictPath(_vm.choosenFoodPortion.pict),
      "height": "150"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && (_vm.choosenFoodPortion || _vm.choosenFoodPortions.length === 1)) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.choosenFoodPortion.longuest_desc))])]) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && (_vm.choosenFoodPortion || _vm.choosenFoodPortions.length === 1)) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [(_vm.choosenFoodPortions.length > 1) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeFoodPortion($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && !_vm.choosenFoodPortion && _vm.choosenFoodPortions.length > 1) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.choosenFoodPortions), function(foodPortion) {
    return _c('div', [_c('a', {
      on: {
        "click": function($event) {
          _vm.chooseFoodPortion(foodPortion)
        }
      }
    }, [_c('img', {
      staticClass: "portionImg",
      attrs: {
        "src": _vm.pictPath(foodPortion.pict),
        "height": "110"
      }
    })])])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && _vm.choosenFoodPortion) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "tick-labels": _vm.tickLabels,
      "ttthumb-label": "",
      "always-dirty": "",
      "max": 5,
      "min": 0.25,
      "step": "0.25",
      "ticks": "always",
      "tick-size": "1"
    },
    on: {
      "change": function($event) {
        _vm.$v.choosenWeight.$touch();
        _vm.onSliderChange($event)
      }
    },
    model: {
      value: (_vm.choosenFoodPortionCount),
      callback: function($$v) {
        _vm.choosenFoodPortionCount = $$v
      },
      expression: "choosenFoodPortionCount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Poids (g)",
      "error-messages": _vm.choosenWeightErrors,
      "blur": "$v.choosenWeight.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.choosenWeight.$touch();
        _vm.onWeightChangeDebounced(_vm.choosenWeight)
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedCreateOrUpdate($event)
      }
    },
    model: {
      value: (_vm.choosenWeight),
      callback: function($$v) {
        _vm.choosenWeight = $$v
      },
      expression: "choosenWeight"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": "",
      "disabled": !_vm.formValid
    },
    nativeOn: {
      "click": function($event) {
        _vm.debouncedCreateOrUpdate()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Aliments favoris")])], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.favorites), function(favorite, index) {
    return [_c('v-list-tile', {
      key: favorite.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addFavorite(favorite)
        }
      }
    }, [_c('v-list-tile-avatar', [(favorite.portion_pict) ? _c('v-btn', {
      attrs: {
        "icon": "",
        "large": "",
        "ripple": ""
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.pictPath(favorite.portion_pict)
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(favorite.food_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.favoritePortionDescription(favorite)))])], 1)], 1), _vm._v(" "), (index + 1 < _vm.favorites.length) ? _c('v-divider', {
      key: favorite.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.favorites.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.moduleToAddName = null;
        _vm.moduleToAddType = 'personal';
        _vm.moduleToAddTeam = null;
        _vm.addDialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Personal modules")]), _vm._v(" "), _vm._l((_vm.sorted(_vm.userModules)), function(module, index) {
    return [_c('v-list-tile', {
      key: module.id,
      class: {
        'red': module.id == _vm.selectedModuleId, 'lighten-4': module.id == _vm.selectedModuleId
      },
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectModule(module.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": _vm.iconColor(module)
      }
    }, [_vm._v(_vm._s(_vm.iconName(module)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(module.name))]), _vm._v(" "), (module.locked_date) ? _c('v-list-tile-sub-title', [_vm._v("locked on " + _vm._s(_vm.moment(module.locked_date).format('YYYY-MM-DD, HH:mm')))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "disabled": !!module.locked_date
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moduleToLock = _vm.clone(module);
          _vm.lockDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green lighten-1"
      }
    }, [_vm._v("lock")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moduleToDelete = _vm.clone(module);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.userModules.length) ? _c('v-divider', {
      key: module.id + '-'
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.userModules.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "60px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.teamModulesDict), function(teamModules, teamId) {
    return [_c('v-divider'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v(_vm._s(_vm.teamDescription(teamId)))]), _vm._v(" "), _vm._l((teamModules), function(module, index) {
      return [_c('v-list-tile', {
        key: module.id,
        class: {
          'red': module.id == _vm.selectedModuleId, 'lighten-4': module.id == _vm.selectedModuleId
        },
        attrs: {
          "ripple": ""
        },
        on: {
          "click": function($event) {
            _vm.selectModule(module.id)
          }
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "color": _vm.iconColor(module)
        }
      }, [_vm._v(_vm._s(_vm.iconName(module)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(module.name))]), _vm._v(" "), (module.locked_date) ? _c('v-list-tile-sub-title', [_vm._v("locked on " + _vm._s(_vm.moment(module.locked_date).format('YYYY-MM-DD, HH:mm')))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": "",
          "ripple": "",
          "disabled": module.locked_date
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.moduleToLock = _vm.clone(module);
            _vm.lockDialog = true
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "green lighten-1"
        }
      }, [_vm._v("lock")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": "",
          "ripple": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.moduleToDelete = _vm.clone(module);
            _vm.deleteDialog = true
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "grey lighten-1"
        }
      }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < teamModules.length) ? _c('v-divider', {
        key: module.id + '-'
      }) : _vm._e()]
    }), _vm._v(" "), (teamModules.length === 0) ? _c('v-card-text', {
      staticClass: "Aligner",
      staticStyle: {
        "height": "60px"
      }
    }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addDialog),
      callback: function($$v) {
        _vm.addDialog = $$v
      },
      expression: "addDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Add a module")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Module name",
      "required": "",
      "error-messages": _vm.nameErrors,
      "blur": "$v.moduleToAddName.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.moduleToAddName.$touch()
      }
    },
    model: {
      value: (_vm.moduleToAddName),
      callback: function($$v) {
        _vm.moduleToAddName = $$v
      },
      expression: "moduleToAddName"
    }
  }), _vm._v(" "), (_vm.teams.length > 0) ? _c('div', [_c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.moduleToAddType),
      callback: function($$v) {
        _vm.moduleToAddType = $$v
      },
      expression: "moduleToAddType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Personal",
      "value": "personal"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Team",
      "value": "team"
    }
  })], 1), _vm._v(" "), (_vm.moduleToAddType === 'team') ? _c('v-select', {
    attrs: {
      "label": "Team",
      "items": _vm.teams,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.moduleToAddTeam),
      callback: function($$v) {
        _vm.moduleToAddTeam = $$v
      },
      expression: "moduleToAddTeam"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.formValid,
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false;
        _vm.addModule()
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("Delete " + _vm._s(_vm.moduleToDelete.name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteModule(_vm.moduleToDelete)
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.lockDialog),
      callback: function($$v) {
        _vm.lockDialog = $$v
      },
      expression: "lockDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("Lock '" + _vm._s(_vm.moduleToLock.name) + "' ? This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lockDialog = false;
        _vm.lockModule(_vm.moduleToLock)
      }
    }
  }, [_vm._v("Lock")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lockDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appearing main"
  }, [_c('div', {
    staticClass: "main-container white-background"
  }, [_c('div', {
    staticClass: "main-label black-color"
  }, [_vm._v("\n         " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mot de passe",
      "error-messages": _vm.passwordErrors,
      "blur": "$v.password.$touch()",
      "append-icon": _vm.hiddenPassword ? 'visibility' : 'visibility_off',
      "type": _vm.hiddenPassword ? 'password' : 'text'
    },
    on: {
      "input": function($event) {
        _vm.$v.password.$touch()
      },
      "click:append": function () { return (_vm.hiddenPassword = !_vm.hiddenPassword); }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mot de passe (confirmation)",
      "error-messages": _vm.passwordConfirmedErrors,
      "blur": "$v.passwordConfirmed.$touch()",
      "append-icon": _vm.hiddenPassword ? 'visibility' : 'visibility_off',
      "type": _vm.hiddenPassword ? 'password' : 'text'
    },
    on: {
      "input": function($event) {
        _vm.$v.passwordConfirmed.$touch()
      },
      "click:append": function () { return (_vm.hiddenPassword = !_vm.hiddenPassword); }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.passwordConfirmed),
      callback: function($$v) {
        _vm.passwordConfirmed = $$v
      },
      expression: "passwordConfirmed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-block"
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.formValidAndDirty,
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.debouncedSubmit
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))])], 1)], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.errMsg))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "centered": "",
      "dark": "",
      "color": "brown lighten-1"
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _c('v-tab', {
    key: "editor",
    attrs: {
      "to": _vm.baseRoute + 'editor',
      "router": ""
    }
  }, [_vm._v("\n            Editor\n         ")]), _vm._v(" "), _c('v-tab', {
    key: "simulator",
    attrs: {
      "to": _vm.baseRoute + 'simulator',
      "disabled": !_vm.parseInfo || !_vm.parseInfo.isOk,
      "router": ""
    }
  }, [_vm._v("\n            Simulator\n         ")])], 1), _vm._v(" "), _c('div', [_c('router-view', {
    attrs: {
      "moduleId": _vm.moduleId
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-actions', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('v-icon', [_vm._v("stop")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.inError
    },
    on: {
      "click": function($event) {
        _vm.runStop()
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.stop ? 'play_arrow' : 'pause'))])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.inError || !_vm.stop
    },
    on: {
      "click": function($event) {
        _vm.step()
      }
    }
  }, [_c('v-icon', [_vm._v("redo")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.cycleCount) + " cycles")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.sendIT
    }
  }, [_vm._v("IT")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "subheading",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.flagArray),
      callback: function($$v) {
        _vm.flagArray = $$v
      },
      expression: "flagArray"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Z")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("V")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("C")])], 1)], 1)], 1), _vm._v(" "), (_vm.showIO) ? _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("Leds")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.leds), function(value, index) {
    return _c('v-icon', {
      key: 'led' + index
    }, [_vm._v("\n                  " + _vm._s(_vm.leds[15 - index] ? 'radio_button_checked' : 'radio_button_unchecked') + "\n               ")])
  }))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("Switches")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.switches), function(value, index) {
    return _c('v-icon', {
      key: 'sw' + index,
      on: {
        "click": function($event) {
          _vm.swClick(15 - index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.switches[15 - index] ? 'check_box' : 'check_box_outline_blank') + "\n               ")])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('craps-memory-editor', {
    staticClass: "memory-editor",
    attrs: {
      "title": 'Memory',
      "memorydict": _vm.memoryDict,
      "currentaddress": _vm.currentAddress,
      "breakpoints": _vm.breakpoints,
      "version-no": _vm.versionNo
    },
    on: {
      "breakpoint": _vm.onBreakpointChange
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('craps-registers-editor', {
    staticClass: "memory-editor",
    attrs: {
      "title": 'Registers',
      "registerValues": _vm.registerValues
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sd-8": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_c('h1', [_vm._v("Nutri-Kiosk")]), _vm._v(" "), _c('p', [_vm._v("Pour comprendre la nutrition en s'amusant")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sd-4": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_c('h1', [_vm._v("Nutri-Kiosk")]), _vm._v(" "), _c('p', [_vm._v("Pour comprendre la nutrition en s'amusant")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.msgText.length > 0) ? _c('v-card', {
    staticClass: "carte",
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.msgText))])])], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick()
      }
    }
  }, [_vm._v("OK")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "centered": "",
      "dark": "",
      "color": "brown lighten-1"
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _c('v-tab', {
    key: "editor",
    attrs: {
      "to": _vm.baseRoute + 'editor',
      "router": ""
    }
  }, [_vm._v("\n            Editor\n         ")]), _vm._v(" "), _c('v-tab', {
    key: "simulator",
    attrs: {
      "to": _vm.baseRoute + 'simulator',
      "disabled": !_vm.parseInfo || !_vm.parseInfo.isOk,
      "router": ""
    }
  }, [_vm._v("\n            Simulator\n         ")])], 1), _vm._v(" "), _c('div', [_c('router-view', {
    attrs: {
      "moduleId": _vm.moduleId
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 sm4"
  }, [_c('craps-module-list', {
    attrs: {
      "user": _vm.user,
      "teams": _vm.teams,
      "selectedModuleId": _vm.selectedModuleId
    },
    on: {
      "moduleSelected": _vm.selectModule,
      "addModule": _vm.addModule,
      "deleteModule": _vm.deleteModule,
      "lockModule": _vm.lockModule
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm8"
  }, [_c('router-view', {
    on: {
      "userModuleUpdated": _vm.userModuleUpdated
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(574);
module.exports = __webpack_require__(573);


/***/ })
]),[1257]);


// WEBPACK FOOTER //
// static/js/app.c8359ab0fa5338a443e8.js